webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  data: {
    messages: {
      'total': 0,
      'ids': []
    },
    incidents: {
      'total': 0,
      'ids': []
    },
    violations: {
      'total': 0,
      'ids': []
    },
    trips: {
      'total': 0,
      'ids': []
    },
    boarding: {},
    bus_numbers: {},
    recorded: []
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAzCAYAAADVY1sUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTQ1MzRFMDQ3NjU5MTFFNTlBQjA4ODk4QTM1MDNEMTciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTQ1MzRFMDM3NjU5MTFFNTlBQjA4ODk4QTM1MDNEMTciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NUY2RTBERjQ3MDlDMTFFNUJCQkM4ODAxQzhDNjdDNkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NUY2RTBERjU3MDlDMTFFNUJCQkM4ODAxQzhDNjdDNkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6e/ocDAAAKN0lEQVR42sxZC3BUVxn+72t37z6SEBIoSguhFAo14DhlwD6AKrV2dKAOMrS1pSIVdFREqCM4tU6nMjaUAi3igFD6BiymtEUwBaqxUEkDBQ3PhkcgkITmQTabfd7de4//uXtuctzcZHdpEjwz3+zd+zr/d/73uUKoYhJkOXIQExGjEDew/3QEEPWI04hDiCD045AzvE9AfAMxDzENMSDN/S2IvYiNiL/3BxExg3vuRRxHlCFmZUCCjoGIBxEfID5BTL6eRByI1xB7EGM/xxxfQfwTsYFptl+JFCGqEI/24lzzmWZv6i8iYxAViNF9MB/V7IeIEX1NpADxDmJQH5rzMDaHsy+j1iYWVvt6FCNeRjyc7YNGnIBzkAOUAgUAj+2IUBuekbVKmU4NI2syDyF2I97I9AGSIOAt9sL7O5ugtPQKFBY4OvMDS4h5iGOIoRm9EBdCQgIurwG6JoBIY5FEIBoSwcguNNUwv4lmMqdnhAonDgXgh0s/hYPHg7Y+MidTEkBf6DHANUCHqtMO+NGqATB3RT5U1yigDtLBrRrWbZmMokzMi+gEXHkyXD4Zgrm/7EqCJ/JYJiui4Kq7C3UIR0VYsTkX5iABRcZzTgLffy4f1mzOAX9QBHe+Dk68l2TGZk66GzxDnLD/X3648Z5KOHQq2K2zT2BJq2ct5OkAugBv7/bC+l0ecCoGrFzQBtNuR6sQCbz3oRtWlfrgrx+rsGRmEO6fEsaXGxD2S+lsjdZtIxFn7TQhuXCti1So2hhOG7XuSLciqovA6TMO2FzmgaNnHfBNFH7+jCD4cOU1KihKOv3rYZg6Pgab/uaBF97xQPkxB8yeGobiojgkcAF60I4LcU8qEUrCk6+AJguwdmk1PLP+UloiY+zMyIXmIiEAbb7uggLL38yBS00S/OSBIMya1Q7QKEO4ObnaVEa9VYQcnwGLF/hh2A1eeHJTLgTQ+dctagXFh9qMCxALi0gKH+mqoVu6kBioAFFEeHlzHfy8pCatz1Eiw7ucRPna0NYbaiVz0qY2ER6ZFoa3D6jQ0IIX8Vo4InSYjMCcOxoVwIX31l6R4csjNXjwa2GoOqeY131uAkNQgzRc22ino2wxkIQXSYBLggfmVKHJtmacEHNSTzoxKq171wc7UPBcHwEH3uVxGXC+XoYJozXTVyjBVIFMXhi0nAqBRjS5DTu9EAgn2WoJAZ6b74fxt2oQbu9SGeXRVwmUxM1uXBEDpn+vCnZ+1JpxHJdZlfu/wuBbL6LpjLs5AYu+045CUCIAy7f4oC0kmtddKgGBmp7RGf90KrQh4D0C3FiYgN8+GjAJNPpFePr1XGhGbYFkK4dE53UPV+HjfS2w5Pka+Ohoe9YlSsg2Y+ObvSjsLVQDdLkcaLcuL8SRFOCKX7yowKla2RTUrPkxDE8co0F+AQYA9Aefh0DRbfgs3u/GHCMJJJk4SdeIKIgQUkd64K1X62D24tPXXGvZhgNqOjo6JqHZGlddQiK6kczogFHs1T1uKN2vwk2YV6iJ1XwmwxIMAvNmB0CSks9SXwIkGsW8Q1Ut2IVhg4A6zF237bU6eOgaSVhEGrJ+CgmF0bEnj9Pgd3PbTHIL/5AHV65KpuDZdE9uTHY7tjU0fx4SFpFwumZd6OaCiOaSh5GI1lkyQhJJRzju4nfdMpGg6kw4nlJp2BhgeiKf2l2gpuF00ZRugEgdmuYVnEZB/4AcwwzRps2jb1CYbqTQOGuY/mJWxVhUUh9R3aJJxiBd8xV1c1kWjrFTChfNeRgcIdIdEdqx+VkF3LEuMl75x7+dsHDFQFMAGVebOvfFRglaniqAw9UK+o4AT6zKN23/bJ0CLW14bflAOHFRhmBEhEXLC0z/CscA6jH/mP4l8hUD/mmIXS2vbPsPi54eGwK6zTFJJUWJXEactEoV8wqW5rOwVlLRwWMayxl4egqWIDoK78c8MLlYMzXS2p40nPuwbEkYyUR6+6i4KfTVAGpCAjMPzbs/BLcNj4MR6jQ0EYlcqIkc2X80QGNtIdOIJTRhgtPjBAP9H+fOk9TGajtfc4Uwa0/AUDpprNap1Ex2vkj3RScN2XRRIhgkBCu758iwfW/LwZhmtmX53BssMpYWKDRGQuOOO7RiEdmXGno1nFAUodcGwdxiJHNGslJ04kFQj+yr8FcwbagpRFLNyyIRSwkKprlZRI6zncF7+UXUDeizIWGj9EmFv3LPQX8N29DjA1wqIYOZHYXEEegwMX7NX+mvfVrTrLA831LWXMZW2QoDVrS3/ksMMiPhZGW/iwUHydIOT2QHoro/iHh8EjSej5zZuruZbqnmZuB9PCkelvwCTyTCtmj6fuQosHVX07sNzVojC7m9vkH3J0RjX5qUW5UgXB+tW/Nm/U6mjUw90S6SWSGYpBK5yjab+24MVuCV9xr/cqE+Rp3cl3l11yVyxbkEabv3u5Z9sOl1bXgwb7Sfj1xa/Ub9DpY3hAy0oHMkYqw2zIhIE+KZXt9kpjNhyF39ev1LZ2ujtbQSS1MMEo5IjPlwmP1GGRGjJyJ0rGffNHpHGzidOtgBxyvbDvx+U10pS4BCBgQsLUQZiRAjorGSpbNEoe2lfV0sLDSa4oejVzUl2Yheu0mpKu2DQVtccn5VNG5orEAlaUgkGAmLSIQd8yQ6iTz+45O2AjQ0aVXLHh/65F1TBpQEryQLxGsyKdq3oDZWv1i7dm9F2xG2NUu6IWCkaMIiEeXqK92unO9RvDuKfVC+dVyZIgn3hVrjmHWyY0NrKy92gJUHWssnPlK1gEWp7moqq8LlzSnGaUHvjgRAd3sabFxq1KD6XOTgd2cMmu0ggleLE/u+29YvCHgLHBDyJ+pmLTr1i4bmeJAzKZKSF3gN8E4dsSFhX7ulE+jEuXCroBlHpk4vfAwCullIpiNDnZuGWvDI8PDCkz/9oLKNfo8ckrKiBucHmk1UinGRyUjX7qYjYtY55YcD57/0BVdT8Z0DvmUEEslyXOjeuV3o3GKhA5b+5syvN5Z+tpuRMDjh4wxRzpF5ApZDGz21t1lpxPKj7e83H5owwi2OnZA7hQTtyZifHhyi+VmsZEVNydMbLr9EcznnxAkuM0dTtBDjCOqZEsiGiJVvyJZdTeWTRrnVWyfm3UVSNENJOJwCOAY7Yd0fL61Z/PyFlZD8qCpwXV0kRQu8QyfsWtjeJiKwfsB4q6x538QRqjL67vzJgGTMjThkoaI/yENdsPaFCyt/9mzNs5D8QixwgvPC8zkhbrOp0GfDanjMZkbGBPnnklFPkIapJHr4q0SvupPQ46cWDF3Gaij64WY0+7Q2lGkmn22Yu9l7ZLaQAlyHIXItJyz7wRdnknOTDVJ9d2zOtwtnsg7uJoYhrBTJZXWVi2tVxZ72/vqTjLmadAPhyLbxi1/8VdFCdm0QM6k8Lvnxqy/2pclcq5kJ6OiC6hQTmFuEmGa4ud6hx820/xciqYQI11MbNoKT/jAToZffQa6Xvf9XgAEAQDNI7Xxo7qoAAAAASUVORK5CYII="

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(311)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(308)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(313)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(305)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(309)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(310)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(307)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MasterDashboard__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MasterDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MasterDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_school_Student__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_school_Student___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_school_Student__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_school_Guardian__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_school_Guardian___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_school_Guardian__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_transportation_Bus__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_transportation_Bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_transportation_Bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_transportation_Driver__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_transportation_Driver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_transportation_Driver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_transportation_Supervisor__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_transportation_Supervisor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_transportation_Supervisor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_transportation_Route__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_transportation_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_transportation_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_report_Incident__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_report_Incident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_report_Incident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_report_Violation__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_report_Violation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_report_Violation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_report_Report__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_report_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_report_Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_report_Message__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_report_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_report_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_report_Trip__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_report_Trip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_report_Trip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_attendance_Absence__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_attendance_Absence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_attendance_Absence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_attendance_Gate__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_attendance_Gate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_attendance_Gate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_User__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_admin_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_Role__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_Role___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_admin_Role__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_Log__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_Log___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_admin_Log__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_school_StudentManage__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_school_StudentManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_school_StudentManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_school_GuardianManage__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_school_GuardianManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_school_GuardianManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_transportation_BusManage__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_transportation_BusManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_transportation_BusManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_transportation_DriverManage__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_transportation_DriverManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_transportation_DriverManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_transportation_SupervisorManage__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_transportation_SupervisorManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_transportation_SupervisorManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_transportation_RouteManage__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_transportation_RouteManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_transportation_RouteManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_admin_UserManage__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_admin_UserManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_admin_UserManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_school_ConfigurationManage__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_school_ConfigurationManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_school_ConfigurationManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_report_TripManage__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_report_TripManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_report_TripManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Login__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_403__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_403___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_403__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_404__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ResetPassword__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_ResetPassword__);


































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Login___default.a
  }, {
    path: '/user/password/:id',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_32__components_ResetPassword___default.a
  }, {
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/403',
    name: '403',
    component: __WEBPACK_IMPORTED_MODULE_30__components_403___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_31__components_404___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/master',
    name: 'MasterDashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_MasterDashboard___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/school/student',
    name: 'Student',
    component: __WEBPACK_IMPORTED_MODULE_4__components_school_Student___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/school/guardian',
    name: 'Guardian',
    component: __WEBPACK_IMPORTED_MODULE_5__components_school_Guardian___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/bus',
    name: 'Manage Buses',
    component: __WEBPACK_IMPORTED_MODULE_6__components_transportation_Bus___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/driver',
    name: 'Manage Drivers',
    component: __WEBPACK_IMPORTED_MODULE_7__components_transportation_Driver___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/supervisor',
    name: 'Manage Supervisors',
    component: __WEBPACK_IMPORTED_MODULE_8__components_transportation_Supervisor___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/route',
    name: 'Manage Routes',
    component: __WEBPACK_IMPORTED_MODULE_9__components_transportation_Route___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/report',
    name: 'report',
    component: __WEBPACK_IMPORTED_MODULE_12__components_report_Report___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/report/incident',
    name: 'Incidents',
    component: __WEBPACK_IMPORTED_MODULE_10__components_report_Incident___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/report/violation',
    name: 'Violations',
    component: __WEBPACK_IMPORTED_MODULE_11__components_report_Violation___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/report/message/:id?',
    name: 'Messages',
    component: __WEBPACK_IMPORTED_MODULE_13__components_report_Message___default.a,
    meta: { requiresAuth: true, optional: true }
  }, {
    path: '/report/Trip',
    name: 'Trips',
    component: __WEBPACK_IMPORTED_MODULE_14__components_report_Trip___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/attendance/absence',
    name: 'Manage Absences',
    component: __WEBPACK_IMPORTED_MODULE_15__components_attendance_Absence___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/attendance/absence/:id',
    name: 'Manage Absence',
    component: __WEBPACK_IMPORTED_MODULE_15__components_attendance_Absence___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/attendance/gate',
    name: 'Manage Gates',
    component: __WEBPACK_IMPORTED_MODULE_16__components_attendance_Gate___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/user',
    name: 'Manage Users',
    component: __WEBPACK_IMPORTED_MODULE_17__components_admin_User___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/role',
    name: 'Manage Roles',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_Role___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/role/:id',
    name: 'Manage Role',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_Role___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/log',
    name: 'Manage Logs',
    component: __WEBPACK_IMPORTED_MODULE_19__components_admin_Log___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/school/student/:id',
    name: 'Manage Student',
    component: __WEBPACK_IMPORTED_MODULE_20__components_school_StudentManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/school/guardian/:id',
    name: 'Manage Guardian',
    component: __WEBPACK_IMPORTED_MODULE_21__components_school_GuardianManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/school/configuration',
    name: 'Manage Configuration',
    component: __WEBPACK_IMPORTED_MODULE_27__components_school_ConfigurationManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/bus/:id',
    name: 'Manage Bus',
    component: __WEBPACK_IMPORTED_MODULE_22__components_transportation_BusManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/driver/:id',
    name: 'Manage Driver',
    component: __WEBPACK_IMPORTED_MODULE_23__components_transportation_DriverManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/supervisor/:id',
    name: 'Manage Supervisor',
    component: __WEBPACK_IMPORTED_MODULE_24__components_transportation_SupervisorManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/transportation/route/:id',
    name: 'Manage Route',
    component: __WEBPACK_IMPORTED_MODULE_25__components_transportation_RouteManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/user/:id',
    name: 'Manage User',
    component: __WEBPACK_IMPORTED_MODULE_26__components_admin_UserManage___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/report/trip/:id',
    name: 'Trip',
    component: __WEBPACK_IMPORTED_MODULE_28__components_report_TripManage___default.a,
    meta: { requiresAuth: true }
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

var self = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype;
Object.defineProperty(self, '$permissions', {
  get: function get() {
    if (self._permissions !== undefined) return self._permissions;
    if (localStorage.getItem('userData') === null) return;
    self._permissions = {};
    var permissions = JSON.parse(localStorage.getItem('userData')).permissions;
    for (var index in router.options.routes) {
      var route = router.options.routes[index];
      if (route.meta === undefined) continue;
      var path = route.path.substr(1).split('/', 2);
      for (var module in permissions) {
        var permission = permissions[module];
        if (module === path[0] && permission[path[1]] !== undefined) {
          if (self._permissions[module] === undefined) self._permissions[module] = {};
          route.meta.permissons = permission[path[1]];
          permissions[module][path[1]] = permission[path[1]];
        }
      }
    }
    return self._permissions = permissions;
  },
  set: function set(permissions) {
    self._permissions = permissions;
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.length === 0) return next({ path: '/404' });
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (localStorage.getItem('userData') === null) return next({ path: '/login' });
    // if ((to.path !== '/master' && window.location.pathname === '/') || window.location.pathname === to.path) return next({path: '/master'})
    if (to.meta.permissons === undefined) return next();
    var pathTo = to.path.split('/');
    pathTo.splice(0, 1);
    next();
  } else {
    next();
  }
});

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

function loaded() {
  window.print();
  window.close();
}
loaded;

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af-ZA": 100,
	"./af-ZA.js": 100,
	"./ar": 101,
	"./ar.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./ca": 103,
	"./ca.js": 103,
	"./cz": 104,
	"./cz.js": 104,
	"./da": 105,
	"./da.js": 105,
	"./de": 106,
	"./de.js": 106,
	"./ee": 107,
	"./ee.js": 107,
	"./el": 108,
	"./el.js": 108,
	"./en": 109,
	"./en.js": 109,
	"./es": 110,
	"./es.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fr": 113,
	"./fr.js": 113,
	"./he": 114,
	"./he.js": 114,
	"./id": 115,
	"./id.js": 115,
	"./it": 116,
	"./it.js": 116,
	"./ja": 117,
	"./ja.js": 117,
	"./ko": 118,
	"./ko.js": 118,
	"./lv": 119,
	"./lv.js": 119,
	"./nb-NO": 120,
	"./nb-NO.js": 120,
	"./nl": 121,
	"./nl.js": 121,
	"./pl": 122,
	"./pl.js": 122,
	"./pt": 124,
	"./pt-br": 123,
	"./pt-br.js": 123,
	"./pt.js": 124,
	"./ru-RU": 125,
	"./ru-RU.js": 125,
	"./sk": 126,
	"./sk.js": 126,
	"./sl": 127,
	"./sl.js": 127,
	"./sv-SE": 128,
	"./sv-SE.js": 128,
	"./ta": 129,
	"./ta.js": 129,
	"./th": 130,
	"./th.js": 130,
	"./tk": 131,
	"./tk.js": 131,
	"./tr-TR": 132,
	"./tr-TR.js": 132,
	"./ua": 133,
	"./ua.js": 133,
	"./vi": 134,
	"./vi.js": 134,
	"./zh-CN": 67,
	"./zh-CN.js": 67,
	"./zh-TW": 135,
	"./zh-TW.js": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(306)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(312)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  "data-v-41bdebe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */,
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(9);


var countries = {
  'en': {
    'AF': 'Afghanistan',
    'AX': 'Aland Islands',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua And Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia And Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'IO': 'British Indian Ocean Territory',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos (Keeling) Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, Democratic Republic',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'CI': 'Cote D\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands (Malvinas)',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'TF': 'French Southern Territories',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GG': 'Guernsey',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HM': 'Heard Island & Mcdonald Islands',
    'VA': 'Holy See (Vatican City State)',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran, Islamic Republic Of',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IM': 'Isle Of Man',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JE': 'Jersey',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KR': 'Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Lao People\'s Democratic Republic',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libyan Arab Jamahiriya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MK': 'Macedonia',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia, Federated States Of',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'AN': 'Netherlands Antilles',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestinian Territory, Occupied',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'Reunion',
    'RO': 'Romania',
    'RU': 'Russian Federation',
    'RW': 'Rwanda',
    'BL': 'Saint Barthelemy',
    'SH': 'Saint Helena',
    'KN': 'Saint Kitts And Nevis',
    'LC': 'Saint Lucia',
    'MF': 'Saint Martin',
    'PM': 'Saint Pierre And Miquelon',
    'VC': 'Saint Vincent And Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome And Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'GS': 'South Georgia And Sandwich Isl.',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard And Jan Mayen',
    'SZ': 'Swaziland',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad And Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks And Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States',
    'UM': 'United States Outlying Islands',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Viet Nam',
    'VG': 'Virgin Islands, British',
    'VI': 'Virgin Islands, U.S.',
    'WF': 'Wallis And Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
  },
  'ar': {
    'AW': '\u0622\u0631\u0648\u0628\u0627',
    'AZ': '\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646',
    'AM': '\u0623\u0631\u0645\u064A\u0646\u064A\u0627',
    'ES': '\u0623\u0633\u0628\u0627\u0646\u064A\u0627',
    'AU': '\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627',
    'AF': '\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646',
    'AL': '\u0623\u0644\u0628\u0627\u0646\u064A\u0627',
    'DE': '\u0623\u0644\u0645\u0627\u0646\u064A\u0627',
    'AG': '\u0623\u0646\u062A\u064A\u062C\u0648\u0627 \u0648\u0628\u0631\u0628\u0648\u062F\u0627',
    'AO': '\u0623\u0646\u062C\u0648\u0644\u0627',
    'AI': '\u0623\u0646\u062C\u0648\u064A\u0644\u0627',
    'AD': '\u0623\u0646\u062F\u0648\u0631\u0627',
    'UY': '\u0623\u0648\u0631\u062C\u0648\u0627\u064A',
    'UZ': '\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646',
    'UG': '\u0623\u0648\u063A\u0646\u062F\u0627',
    'UA': '\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627',
    'IE': '\u0623\u064A\u0631\u0644\u0646\u062F\u0627',
    'IS': '\u0623\u064A\u0633\u0644\u0646\u062F\u0627',
    'ET': '\u0627\u062B\u064A\u0648\u0628\u064A\u0627',
    'ER': '\u0627\u0631\u064A\u062A\u0631\u064A\u0627',
    'EE': '\u0627\u0633\u062A\u0648\u0646\u064A\u0627',
    'IL': '\u0627\u0633\u0631\u0627\u0626\u064A\u0644',
    'AR': '\u0627\u0644\u0623\u0631\u062C\u0646\u062A\u064A\u0646',
    'JO': '\u0627\u0644\u0623\u0631\u062F\u0646',
    'EC': '\u0627\u0644\u0627\u0643\u0648\u0627\u062F\u0648\u0631',
    'AE': '\u0627\u0644\u0627\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629',
    'BS': '\u0627\u0644\u0628\u0627\u0647\u0627\u0645\u0627',
    'BH': '\u0627\u0644\u0628\u062D\u0631\u064A\u0646',
    'BR': '\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644',
    'PT': '\u0627\u0644\u0628\u0631\u062A\u063A\u0627\u0644',
    'BA': '\u0627\u0644\u0628\u0648\u0633\u0646\u0629 \u0648\u0627\u0644\u0647\u0631\u0633\u0643',
    'GA': '\u0627\u0644\u062C\u0627\u0628\u0648\u0646',
    'ME': '\u0627\u0644\u062C\u0628\u0644 \u0627\u0644\u0623\u0633\u0648\u062F',
    'DZ': '\u0627\u0644\u062C\u0632\u0627\u0626\u0631',
    'DK': '\u0627\u0644\u062F\u0627\u0646\u0645\u0631\u0643',
    'CV': '\u0627\u0644\u0631\u0623\u0633 \u0627\u0644\u0623\u062E\u0636\u0631',
    'SV': '\u0627\u0644\u0633\u0644\u0641\u0627\u062F\u0648\u0631',
    'SN': '\u0627\u0644\u0633\u0646\u063A\u0627\u0644',
    'SD': '\u0627\u0644\u0633\u0648\u062F\u0627\u0646',
    'SE': '\u0627\u0644\u0633\u0648\u064A\u062F',
    'EH': '\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629',
    'SO': '\u0627\u0644\u0635\u0648\u0645\u0627\u0644',
    'CN': '\u0627\u0644\u0635\u064A\u0646',
    'IQ': '\u0627\u0644\u0639\u0631\u0627\u0642',
    'VA': '\u0627\u0644\u0641\u0627\u062A\u064A\u0643\u0627\u0646',
    'PH': '\u0627\u0644\u0641\u064A\u0644\u0628\u064A\u0646',
    'AQ': '\u0627\u0644\u0642\u0637\u0628 \u0627\u0644\u062C\u0646\u0648\u0628\u064A',
    'CM': '\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0648\u0646',
    'CG': '\u0627\u0644\u0643\u0648\u0646\u063A\u0648 - \u0628\u0631\u0627\u0632\u0627\u0641\u064A\u0644',
    'KW': '\u0627\u0644\u0643\u0648\u064A\u062A',
    'HU': '\u0627\u0644\u0645\u062C\u0631',
    'IO': '\u0627\u0644\u0645\u062D\u064A\u0637 \u0627\u0644\u0647\u0646\u062F\u064A \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A',
    'MA': '\u0627\u0644\u0645\u063A\u0631\u0628',
    'TF': '\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0627\u062A \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629 \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629',
    'MX': '\u0627\u0644\u0645\u0643\u0633\u064A\u0643',
    'SA': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629',
    'GB': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629',
    'NO': '\u0627\u0644\u0646\u0631\u0648\u064A\u062C',
    'AT': '\u0627\u0644\u0646\u0645\u0633\u0627',
    'NE': '\u0627\u0644\u0646\u064A\u062C\u0631',
    'IN': '\u0627\u0644\u0647\u0646\u062F',
    'US': '\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A\u0629',
    'JP': '\u0627\u0644\u064A\u0627\u0628\u0627\u0646',
    'YE': '\u0627\u0644\u064A\u0645\u0646',
    'GR': '\u0627\u0644\u064A\u0648\u0646\u0627\u0646',
    'ID': '\u0627\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627',
    'IR': '\u0627\u064A\u0631\u0627\u0646',
    'IT': '\u0627\u064A\u0637\u0627\u0644\u064A\u0627',
    'PG': '\u0628\u0627\u0628\u0648\u0627 \u063A\u064A\u0646\u064A\u0627 \u0627\u0644\u062C\u062F\u064A\u062F\u0629',
    'PY': '\u0628\u0627\u0631\u0627\u062C\u0648\u0627\u064A',
    'PK': '\u0628\u0627\u0643\u0633\u062A\u0627\u0646',
    'PW': '\u0628\u0627\u0644\u0627\u0648',
    'BW': '\u0628\u062A\u0633\u0648\u0627\u0646\u0627',
    'PN': '\u0628\u062A\u0643\u0627\u064A\u0631\u0646',
    'BB': '\u0628\u0631\u0628\u0627\u062F\u0648\u0633',
    'BM': '\u0628\u0631\u0645\u0648\u062F\u0627',
    'BN': '\u0628\u0631\u0648\u0646\u0627\u064A',
    'BE': '\u0628\u0644\u062C\u064A\u0643\u0627',
    'BG': '\u0628\u0644\u063A\u0627\u0631\u064A\u0627',
    'BZ': '\u0628\u0644\u064A\u0632',
    'BD': '\u0628\u0646\u062C\u0644\u0627\u062F\u064A\u0634',
    'PA': '\u0628\u0646\u0645\u0627',
    'BJ': '\u0628\u0646\u064A\u0646',
    'BT': '\u0628\u0648\u062A\u0627\u0646',
    'PR': '\u0628\u0648\u0631\u062A\u0648\u0631\u064A\u0643\u0648',
    'BF': '\u0628\u0648\u0631\u0643\u064A\u0646\u0627 \u0641\u0627\u0633\u0648',
    'BI': '\u0628\u0648\u0631\u0648\u0646\u062F\u064A',
    'PL': '\u0628\u0648\u0644\u0646\u062F\u0627',
    'BO': '\u0628\u0648\u0644\u064A\u0641\u064A\u0627',
    'PF': '\u0628\u0648\u0644\u064A\u0646\u064A\u0632\u064A\u0627 \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629',
    'PE': '\u0628\u064A\u0631\u0648',
    'TZ': '\u062A\u0627\u0646\u0632\u0627\u0646\u064A\u0627',
    'TH': '\u062A\u0627\u064A\u0644\u0646\u062F',
    'TW': '\u062A\u0627\u064A\u0648\u0627\u0646',
    'TM': '\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646',
    'TR': '\u062A\u0631\u0643\u064A\u0627',
    'TT': '\u062A\u0631\u064A\u0646\u064A\u062F\u0627\u062F \u0648\u062A\u0648\u0628\u0627\u063A\u0648',
    'TD': '\u062A\u0634\u0627\u062F',
    'TG': '\u062A\u0648\u062C\u0648',
    'TV': '\u062A\u0648\u0641\u0627\u0644\u0648',
    'TK': '\u062A\u0648\u0643\u064A\u0644\u0648',
    'TO': '\u062A\u0648\u0646\u062C\u0627',
    'TN': '\u062A\u0648\u0646\u0633',
    'TL': '\u062A\u064A\u0645\u0648\u0631 \u0627\u0644\u0634\u0631\u0642\u064A\u0629',
    'JM': '\u062C\u0627\u0645\u0627\u064A\u0643\u0627',
    'GI': '\u062C\u0628\u0644 \u0637\u0627\u0631\u0642',
    'GD': '\u062C\u0631\u064A\u0646\u0627\u062F\u0627',
    'GL': '\u062C\u0631\u064A\u0646\u0644\u0627\u0646\u062F',
    'AX': '\u062C\u0632\u0631 \u0623\u0648\u0644\u0627\u0646',
    'AN': '\u062C\u0632\u0631 \u0627\u0644\u0623\u0646\u062A\u064A\u0644 \u0627\u0644\u0647\u0648\u0644\u0646\u062F\u064A\u0629',
    'TC': '\u062C\u0632\u0631 \u0627\u0644\u062A\u0631\u0643 \u0648\u062C\u0627\u064A\u0643\u0648\u0633',
    'KM': '\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631',
    'KY': '\u062C\u0632\u0631 \u0627\u0644\u0643\u0627\u064A\u0645\u0646',
    'MH': '\u062C\u0632\u0631 \u0627\u0644\u0645\u0627\u0631\u0634\u0627\u0644',
    'MV': '\u062C\u0632\u0631 \u0627\u0644\u0645\u0644\u062F\u064A\u0641',
    'UM': '\u062C\u0632\u0631 \u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629 \u0627\u0644\u0628\u0639\u064A\u062F\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629',
    'SB': '\u062C\u0632\u0631 \u0633\u0644\u064A\u0645\u0627\u0646',
    'FO': '\u062C\u0632\u0631 \u0641\u0627\u0631\u0648',
    'VI': '\u062C\u0632\u0631 \u0641\u0631\u062C\u064A\u0646 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A\u0629',
    'VG': '\u062C\u0632\u0631 \u0641\u0631\u062C\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A\u0629',
    'FK': '\u062C\u0632\u0631 \u0641\u0648\u0643\u0644\u0627\u0646\u062F',
    'CK': '\u062C\u0632\u0631 \u0643\u0648\u0643',
    'CC': '\u062C\u0632\u0631 \u0643\u0648\u0643\u0648\u0633',
    'MP': '\u062C\u0632\u0631 \u0645\u0627\u0631\u064A\u0627\u0646\u0627 \u0627\u0644\u0634\u0645\u0627\u0644\u064A\u0629',
    'WF': '\u062C\u0632\u0631 \u0648\u0627\u0644\u0633 \u0648\u0641\u0648\u062A\u0648\u0646\u0627',
    'CX': '\u062C\u0632\u064A\u0631\u0629 \u0627\u0644\u0643\u0631\u064A\u0633\u0645\u0627\u0633',
    'BV': '\u062C\u0632\u064A\u0631\u0629 \u0628\u0648\u0641\u064A\u0647',
    'IM': '\u062C\u0632\u064A\u0631\u0629 \u0645\u0627\u0646',
    'NF': '\u062C\u0632\u064A\u0631\u0629 \u0646\u0648\u0631\u0641\u0648\u0643',
    'HM': '\u062C\u0632\u064A\u0631\u0629 \u0647\u064A\u0631\u062F \u0648\u0645\u0627\u0643\u062F\u0648\u0646\u0627\u0644\u062F',
    'CF': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0641\u0631\u064A\u0642\u064A\u0627 \u0627\u0644\u0648\u0633\u0637\u0649',
    'CZ': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0634\u064A\u0643',
    'DO': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062F\u0648\u0645\u064A\u0646\u064A\u0643',
    'CD': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0643\u0648\u0646\u063A\u0648 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629',
    'ZA': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062C\u0646\u0648\u0628 \u0627\u0641\u0631\u064A\u0642\u064A\u0627',
    'GT': '\u062C\u0648\u0627\u062A\u064A\u0645\u0627\u0644\u0627',
    'GP': '\u062C\u0648\u0627\u062F\u0644\u0648\u0628',
    'GU': '\u062C\u0648\u0627\u0645',
    'GE': '\u062C\u0648\u0631\u062C\u064A\u0627',
    'GS': '\u062C\u0648\u0631\u062C\u064A\u0627 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629 \u0648\u062C\u0632\u0631 \u0633\u0627\u0646\u062F\u0648\u064A\u062A\u0634 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629',
    'DJ': '\u062C\u064A\u0628\u0648\u062A\u064A',
    'JE': '\u062C\u064A\u0631\u0633\u064A',
    'DM': '\u062F\u0648\u0645\u064A\u0646\u064A\u0643\u0627',
    'RW': '\u0631\u0648\u0627\u0646\u062F\u0627',
    'RU': '\u0631\u0648\u0633\u064A\u0627',
    'BY': '\u0631\u0648\u0633\u064A\u0627 \u0627\u0644\u0628\u064A\u0636\u0627\u0621',
    'RO': '\u0631\u0648\u0645\u0627\u0646\u064A\u0627',
    'RE': '\u0631\u0648\u064A\u0646\u064A\u0648\u0646',
    'ZM': '\u0632\u0627\u0645\u0628\u064A\u0627',
    'ZW': '\u0632\u064A\u0645\u0628\u0627\u0628\u0648\u064A',
    'CI': '\u0633\u0627\u062D\u0644 \u0627\u0644\u0639\u0627\u062C',
    'WS': '\u0633\u0627\u0645\u0648\u0627',
    'AS': '\u0633\u0627\u0645\u0648\u0627 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A\u0629',
    'SM': '\u0633\u0627\u0646 \u0645\u0627\u0631\u064A\u0646\u0648',
    'PM': '\u0633\u0627\u0646\u062A \u0628\u064A\u064A\u0631 \u0648\u0645\u064A\u0643\u0648\u0644\u0648\u0646',
    'VC': '\u0633\u0627\u0646\u062A \u0641\u0646\u0633\u0646\u062A \u0648\u063A\u0631\u0646\u0627\u062F\u064A\u0646',
    'KN': '\u0633\u0627\u0646\u062A \u0643\u064A\u062A\u0633 \u0648\u0646\u064A\u0641\u064A\u0633',
    'LC': '\u0633\u0627\u0646\u062A \u0644\u0648\u0633\u064A\u0627',
    'MF': '\u0633\u0627\u0646\u062A \u0645\u0627\u0631\u062A\u064A\u0646',
    'SH': '\u0633\u0627\u0646\u062A \u0647\u064A\u0644\u0646\u0627',
    'ST': '\u0633\u0627\u0648 \u062A\u0648\u0645\u064A \u0648\u0628\u0631\u064A\u0646\u0633\u064A\u0628\u064A',
    'LK': '\u0633\u0631\u064A\u0644\u0627\u0646\u0643\u0627',
    'SJ': '\u0633\u0641\u0627\u0644\u0628\u0627\u0631\u062F \u0648\u062C\u0627\u0646 \u0645\u0627\u064A\u0627\u0646',
    'SK': '\u0633\u0644\u0648\u0641\u0627\u0643\u064A\u0627',
    'SI': '\u0633\u0644\u0648\u0641\u064A\u0646\u064A\u0627',
    'SG': '\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629',
    'SZ': '\u0633\u0648\u0627\u0632\u064A\u0644\u0627\u0646\u062F',
    'SY': '\u0633\u0648\u0631\u064A\u0627',
    'SR': '\u0633\u0648\u0631\u064A\u0646\u0627\u0645',
    'CH': '\u0633\u0648\u064A\u0633\u0631\u0627',
    'SL': '\u0633\u064A\u0631\u0627\u0644\u064A\u0648\u0646',
    'SC': '\u0633\u064A\u0634\u0644',
    'CL': '\u0634\u064A\u0644\u064A',
    'RS': '\u0635\u0631\u0628\u064A\u0627',
    'CS': '\u0635\u0631\u0628\u064A\u0627 \u0648\u0627\u0644\u062C\u0628\u0644 \u0627\u0644\u0623\u0633\u0648\u062F',
    'TJ': '\u0637\u0627\u062C\u0643\u0633\u062A\u0627\u0646',
    'OM': '\u0639\u0645\u0627\u0646',
    'GM': '\u063A\u0627\u0645\u0628\u064A\u0627',
    'GH': '\u063A\u0627\u0646\u0627',
    'GF': '\u063A\u0648\u064A\u0627\u0646\u0627',
    'GY': '\u063A\u064A\u0627\u0646\u0627',
    'GN': '\u063A\u064A\u0646\u064A\u0627',
    'GQ': '\u063A\u064A\u0646\u064A\u0627 \u0627\u0644\u0627\u0633\u062A\u0648\u0627\u0626\u064A\u0629',
    'GW': '\u063A\u064A\u0646\u064A\u0627 \u0628\u064A\u0633\u0627\u0648',
    'VU': '\u0641\u0627\u0646\u0648\u0627\u062A\u0648',
    'FR': '\u0641\u0631\u0646\u0633\u0627',
    'PS': '\u0641\u0644\u0633\u0637\u064A\u0646',
    'VE': '\u0641\u0646\u0632\u0648\u064A\u0644\u0627',
    'FI': '\u0641\u0646\u0644\u0646\u062F\u0627',
    'VN': '\u0641\u064A\u062A\u0646\u0627\u0645',
    'FJ': '\u0641\u064A\u062C\u064A',
    'CY': '\u0642\u0628\u0631\u0635',
    'KG': '\u0642\u0631\u063A\u064A\u0632\u0633\u062A\u0627\u0646',
    'QA': '\u0642\u0637\u0631',
    'KZ': '\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646',
    'NC': '\u0643\u0627\u0644\u064A\u062F\u0648\u0646\u064A\u0627 \u0627\u0644\u062C\u062F\u064A\u062F\u0629',
    'HR': '\u0643\u0631\u0648\u0627\u062A\u064A\u0627',
    'KH': '\u0643\u0645\u0628\u0648\u062F\u064A\u0627',
    'CA': '\u0643\u0646\u062F\u0627',
    'CU': '\u0643\u0648\u0628\u0627',
    'KR': '\u0643\u0648\u0631\u064A\u0627 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629',
    'KP': '\u0643\u0648\u0631\u064A\u0627 \u0627\u0644\u0634\u0645\u0627\u0644\u064A\u0629',
    'CR': '\u0643\u0648\u0633\u062A\u0627\u0631\u064A\u0643\u0627',
    'CO': '\u0643\u0648\u0644\u0648\u0645\u0628\u064A\u0627',
    'KI': '\u0643\u064A\u0631\u064A\u0628\u0627\u062A\u064A',
    'KE': '\u0643\u064A\u0646\u064A\u0627',
    'LV': '\u0644\u0627\u062A\u0641\u064A\u0627',
    'LA': '\u0644\u0627\u0648\u0633',
    'LB': '\u0644\u0628\u0646\u0627\u0646',
    'LU': '\u0644\u0648\u0643\u0633\u0645\u0628\u0648\u0631\u062C',
    'LY': '\u0644\u064A\u0628\u064A\u0627',
    'LR': '\u0644\u064A\u0628\u064A\u0631\u064A\u0627',
    'LT': '\u0644\u064A\u062A\u0648\u0627\u0646\u064A\u0627',
    'LI': '\u0644\u064A\u062E\u062A\u0646\u0634\u062A\u0627\u064A\u0646',
    'LS': '\u0644\u064A\u0633\u0648\u062A\u0648',
    'MQ': '\u0645\u0627\u0631\u062A\u064A\u0646\u064A\u0643',
    'MO': '\u0645\u0627\u0643\u0627\u0648 \u0627\u0644\u0635\u064A\u0646\u064A\u0629',
    'MT': '\u0645\u0627\u0644\u0637\u0627',
    'ML': '\u0645\u0627\u0644\u064A',
    'MY': '\u0645\u0627\u0644\u064A\u0632\u064A\u0627',
    'YT': '\u0645\u0627\u064A\u0648\u062A',
    'MG': '\u0645\u062F\u063A\u0634\u0642\u0631',
    'EG': '\u0645\u0635\u0631',
    'MK': '\u0645\u0642\u062F\u0648\u0646\u064A\u0627',
    'MW': '\u0645\u0644\u0627\u0648\u064A',
    'ZZ': '\u0645\u0646\u0637\u0642\u0629 \u063A\u064A\u0631 \u0645\u0639\u0631\u0641\u0629',
    'MN': '\u0645\u0646\u063A\u0648\u0644\u064A\u0627',
    'MR': '\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627',
    'MU': '\u0645\u0648\u0631\u064A\u0634\u064A\u0648\u0633',
    'MZ': '\u0645\u0648\u0632\u0645\u0628\u064A\u0642',
    'MD': '\u0645\u0648\u0644\u062F\u0627\u0641\u064A\u0627',
    'MC': '\u0645\u0648\u0646\u0627\u0643\u0648',
    'MS': '\u0645\u0648\u0646\u062A\u0633\u0631\u0627\u062A',
    'MM': '\u0645\u064A\u0627\u0646\u0645\u0627\u0631',
    'FM': '\u0645\u064A\u0643\u0631\u0648\u0646\u064A\u0632\u064A\u0627',
    'NA': '\u0646\u0627\u0645\u064A\u0628\u064A\u0627',
    'NR': '\u0646\u0648\u0631\u0648',
    'NP': '\u0646\u064A\u0628\u0627\u0644',
    'NG': '\u0646\u064A\u062C\u064A\u0631\u064A\u0627',
    'NI': '\u0646\u064A\u0643\u0627\u0631\u0627\u062C\u0648\u0627',
    'NZ': '\u0646\u064A\u0648\u0632\u064A\u0644\u0627\u0646\u062F\u0627',
    'NU': '\u0646\u064A\u0648\u064A',
    'HT': '\u0647\u0627\u064A\u062A\u064A',
    'HN': '\u0647\u0646\u062F\u0648\u0631\u0627\u0633',
    'NL': '\u0647\u0648\u0644\u0646\u062F\u0627',
    'HK': '\u0647\u0648\u0646\u062C \u0643\u0648\u0646\u062C \u0627\u0644\u0635\u064A\u0646\u064A\u0629'
  }
};
var self = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype;
self.countries = !localStorage.getItem('lang') ? countries['en'] : countries[localStorage.getItem('lang')];
Object.defineProperty(self, '$countries', {
  get: function get() {
    return self.countries;
  }
});
__WEBPACK_IMPORTED_MODULE_1__event_bus_js__["EventBus"].$on('langEmit', function (lang) {
  self.countries = countries[lang];
});
var Countries = {};
/* harmony default export */ __webpack_exports__["a"] = (Countries);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);

var fetchGoogleMaps = __webpack_require__(530);

var self = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype;
Object.defineProperty(self, '$google', {
  get: function get() {
    return self.map;
  },
  set: function set(apiKey) {
    if (self.map !== undefined) return;
    self.map = fetchGoogleMaps({
      apiKey: apiKey,
      language: 'en',
      libraries: ['geometry', 'places']
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (self);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pusher_js__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pusher_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pusher_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(74);








__WEBPACK_IMPORTED_MODULE_4_pusher_js___default.a.Runtime.createXHR = function () {
  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;
  return xhr;
};

var pathname = window.location.pathname;
var subDomain = window.location.host.split('.')[0];
var center = subDomain;
if (pathname !== '/') center += '_' + pathname.replace('/', '');
Storage.prototype._setItem = Storage.prototype.setItem;
Storage.prototype.setItem = function (key, value) {
  key = center + '.' + key;
  localStorage._setItem(key, value);
};
Storage.prototype._getItem = Storage.prototype.getItem;
Storage.prototype.getItem = function (key) {
  key = center + '.' + key;
  return localStorage._getItem(key);
};

Storage.prototype._clear = Storage.prototype.clear;
Storage.prototype.clear = function () {
  var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(localStorage);
  for (var i in keys) {
    var key = keys[i];
    var arr = key.split('.');
    var clear = false;
    if (arr[1] !== undefined) {
      if (arr[0] === center) clear = true;
    } else {
      if (center === '') clear = true;
    }
    if (clear) localStorage.removeItem(key);
  }
};

function interceptors(http) {
  http.defaults.validateStatus = function (status) {
    return status >= 200 && status < 405;
  };
  http.interceptors.response.use(function (response) {
    // if (response.data.status === false) return Promise.reject(new Error('Session Gone'))
    if (response.status === 401) {
      var lang = localStorage.getItem('lang');
      localStorage.clear();
      localStorage.setItem('lang', lang);
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/login');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('401 error'));
    }
    if (response.status === 403) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('403 error'));
    return response;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.message);
  });
}
var self = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype;
Object.defineProperty(self, '$http', {
  get: function get() {
    var http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({ baseURL: "http://api.wiotschool.com/", withCredentials: true });
    interceptors(http);
    return http;
  }
});

Object.defineProperty(self, '$moment', {
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a;
  },
  set: function set(tz) {
    __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.setDefault(tz);
  }
});

Object.defineProperty(self, '$pusher', {
  get: function get() {
    if (self.pusher !== undefined) return self.pusher;
    console.log('INITIATING PUSHER COMMUNICATION');
    return self.pusher = new __WEBPACK_IMPORTED_MODULE_4_pusher_js___default.a(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].PUSHER_KEY, { cluster: 'ap2', encrypted: true });
  }
});

Object.defineProperty(self, '$channel', {
  get: function get() {
    if (self.channel !== undefined) return self.channel;
    console.log('INITIATING CHANNEL');
    return self.channel = self.$pusher.subscribe(localStorage.getItem('school_id'));
  }
});

var Session = {};
/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),
/* 285 */,
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(293)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"WIOT":"WIOT","STUDENT":"Student","ADD":"Add","DASHBOARD":"Dashboard","SCHOOL":"School","SCHOOLINFO":"School Info","ATTENDANCE":"Attendance","LOGS":"Logs","ALERT":"Alert","STUDENTS":"Students","GUARDIANS":"Guardians","TRANSPORTATION":"Transportation","BUSES":"Buses","DRIVERS":"Drivers","ROUTES":"Routes","ABSENCES":"Absences","ABSENCE":"Absence","GATES":"Gates","REPORTS":"Reports","USERS":"Users","USER":"User","GUARDIAN":"Guardian","DRIVER":"Driver","SUPERVISORS":"Supervisors","ADMIN":"Admin","MYPROFILE":"My Profile","SCHOOLSETTINGS":"School Settings","LANGUAGES":"Languages","ARABIC":"Arabic","LOGOUT":"Logout","NODATA":"No Data","ROUTE":"Route","ROLES":"Roles","ROLE":"Role","CANCEL":"Cancel","CONFIRM":"Confirm","PLEASEENTERYOURPASSWORD":"Please enter your password","HASBEEN":" has been ","CREATED":"created!","CANCELLED":"cancelled!","CLOSED":"closed!","YOUHAVERECEIVEDANEWMESSAGE":"You have received a new message!.","NEWINCIDENT":"New Incident","NEWVIOLATION":"New Violation","BUS":"Bus","SUPERVISOR":"Supervisor","TRIP":"Trip","C":"°C","INVALIDUSER":"Invalid user","SUCCESS":"Session Extended","DELAYED":"delayed!","violation_video_loss":"Lost video signal","violation_motion_detection":"Motion detected","violation_blind":"Camera Blocked","violation_storage":"Storage error @3 on disk @1","violation_user_1":"Smoke detected","violation_user_2":"Airflow-Sensor","violation_user_3":"Inner Temperature","violation_user_4":"Inner Humidity","violation_user_5":"Bus stalled","violation_user_6":"User alarm 6","violation_user_7":"User alarm 7","violation_user_8":"User alarm 8","violation_user_9":"User alarm 9","violation_user_10":"User alarm 10","violation_emergency":"Panic button pressed","violation_low_speed":"Low speed alarm (@1 km/h)","violation_high_speed":"High speed alarm (@1 km/h)","violation_low_voltage":"Low voltage (@1 v)","violation_acceleration":"Acceleration alarm @1","violation_inspection_failed":"Red Button Not Pressed","violation_firealarm_release":"Smoke detector off","violation_stop_buttom_pressed":"Stop Button Pressed","violation_stop_buttom_released":"Stop Button Released"},"ar":{"WIOT":"وايت","STUDENT":"طالب","ADD":"إضافة","DASHBOARD":"لوحة القيادة","SCHOOLINFO":"معلومات المدرسة","SCHOOL":"المدرسة","ATTENDANCE":"الحضور","LOGS":"السجلات","ALERT":"تحذير ","STUDENTS":"الطلاب","GUARDIANS":"أولياء اﻷمور","TRANSPORTATION":"المواصلات","BUSES":"الحافلات","DRIVERS":"السائقين","ROUTES":"خطوط السير","ABSENCES":"الغياب","ABSENCE":"غياب","GATES":"البوابات","REPORTS":"التقارير","USERS":"المستخدمين","USER":"المستخدم","GUARDIAN":"ولي الامر","DRIVER":"السائق","SUPERVISORS":"المشرفات","ADMIN":"الإدارة","MYPROFILE":"ملفي الشخصي","SCHOOLSETTINGS":"اعدادات المدرسة","LANGUAGES":"اللغات","(ARABIC)":"(عربي)","ENGLISH":"الإنجليزية","LOGOUT":"الخروج","NODATA":"لا توجد بيانات","ROUTE":"الطريق","ROLES":"أدوار المستخدمين","ROLE":"دور","CANCEL":"إلغاء","CONFIRM":"تاكيد ","PLEASEENTERYOURPASSWORD":" من فضلك أدخل رقمك السري","HASBEEN":" ","CREATED":"انجزت!","CANCELLED":"ألغيت!","CLOSED":"أغلقت!","YOUHAVERECEIVEDANEWMESSAGE":"لقد تلقيت رسالة جديدة!","NEWINCIDENT":"حادث جديد","NEWVIOLATION":"انتهاك جديد","BUS":"الحافلة","SUPERVISOR":"المشرفة","TRIP":"رحلة","C":"°س","INVALIDUSER":"المستخدم غير صالح","SUCCESS":" تم تمديد الدورة","DELAYED":"مؤجل!","violation_video_loss":"فقدت إشارة الفيديو","violation_motion_detection":"تم اكتشاف حركة","violation_blind":"عمياء {POS } الكاميرا","violation_storage":"خطأ في التخزين @ 3 على القرص @ 1","violation_user_1":"تم الكشف عن الدخان","violation_user_2":"  استشعار تدفق الهواء ","violation_user_3":"درجة الحرارة الداخلية","violation_user_4":"الرطوبة الداخلية","violation_user_5":"توقفت الحافلة ","violation_user_6":" 6 تنبيه المستخدم ","violation_user_7":"7 تنبيه المستخدم","violation_user_8":"8 تنبيه المستخدم","violation_user_9":" 9 تنبيه المستخدم","violation_user_10":" 10 تنبيه المستخدم","violation_emergency":"تم الضغط على زر الهلع","violation_low_speed":"إنذار انخفاض السرعة (@ 1 كم / ساعة)","violation_high_speed":"إنذار ارتفاع السرعة (@ 1 كم / ساعة)","violation_low_voltage":"V انخفاض الجهد (@ 1)","violation_acceleration":"1 @ تنبيه السرعة","violation_header":"اتفاقية مستوى الخدمة الانتهاكات والإنذارات","violation_inspection_failed":"زر أحمر لم تضغط","violation_firealarm_release":"Smoke detector off","violation_stop_buttom_pressed":"Stop Button Pressed","violation_stop_buttom_released":"Stop Button Released"}}')
}


/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NOTACESS":"Forbidden","LOST":"You don\u0027t have permission to access.","GOHOME":"Go Home"},"ar":{"NOTFOUND":"ممنوع","LOST":"ليس لديك إذن للوصول.","GOHOME":"اذهب للمنزل"}}')
}


/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NOTFOUND":"Not Found","LOST":"Looks like you\u0027ve got lost...","NOTEXIST":"The page you\u0027re looking for doesn\u0027t exist or has been moved.","GOHOME":"Go Home"},"ar":{"NOTFOUND":"غير معثور عليه","LOST":"يبدو أنك قد ضاعت...","NOTEXIST":"الصفحة التي تبحث عنها غير موجودة أو تم نقلها.","GOHOME":"اذهب للمنزل"}}')
}


/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MESSAGES":"Messages","DETAILS":"Details","LOADING":"Loading...","SCHOOL":"School","VIOLATION":"Violation","NODATA":"No Data","STATUS":"Status","STUDENT":"Student","VIEWMORE":"View More","STUDENTS":"Students","BUSSUPERVISOR":"Bus Supervisor","INCIDENTS":"Incidents","BUSVIOLATIONSANDALARMS":"Bus Violations And Alarms","NOMORERECORDS":"No more records","FIRSTSTOP":"First Stop","NEXTSTOP":"Next Stop","LASTSTOP":"Last Stop","NOMORESTOPS":"No More Stops","MINUTES":"Minutes","TRIPCLOSED":"Trip Closed","RESOLVED":"Resolved","REPORTED":"Reported","OPEN":"Open","BUSTRIPS":"Bus Trips","ROUTE":"Route","BUS":"Bus","STICK":"Stick","UNSTICK":"Unstick","SHOW":"Show","HIDE":"Hide","VIEWINCIDENTDETAILS":"View Incident Details","WRITEAMESSAGE":"Write a Message","violation_video_loss":"Lost video signal","violation_motion_detection":"Motion detected","violation_blind":"Camera {pos} is blind","violation_storage":"Storage error @3 on disk @1","violation_user_1":"Smoke detected","violation_user_2":"Airflow-Sensor","violation_user_3":"Inner Temperature","violation_user_4":"Inner Humidity","violation_user_5":"Bus stalled","violation_user_6":"User alarm 6","violation_user_7":"User alarm 7","violation_user_8":"User alarm 8","violation_user_9":"User alarm 9","violation_user_10":"User alarm 10","violation_emergency":"Panic button pressed","violation_low_speed":"Low speed alarm (@1 km/h)","violation_high_speed":"High speed alarm (@1 km/h)","violation_low_voltage":"Low voltage (@1 v)","violation_acceleration":"Acceleration alarm @1","violation_header":"Service Level Agreement Violations and Alarms","violation_inspection_failed":"Red Button Not Pressed","violation_firealarm_release":"Smoke detector off","violation_stop_buttom_pressed":"Stop Button Pressed","violation_stop_buttom_released":"Stop Button Released","SECONDSAGO":"{var} seconds ago","ONEMINUTEAGO":"one minute ago","MINUTESAGO":"{var} minutes ago","ANHOURAGO":"an hour ago","HOURSAGO":"{var} hours ago","YESTERDAY":"yesterday","DAYSAGO":"{var} days ago","AWEEKAGO":"a week ago","WEEKSAGO":"{var} weeks ago","AMONTHAGO":"a month ago","MONTHSAGO":"{var} months ago","ONEYEARAGO":"one year ago","YEARSAGO":"{var} years ago","NOW":"just now","NAME":"Name","PICK-UP/DROP-OFF":"Pick-up/Drop-off","SCHOOLANDBUSABSENCES":"School and Bus Absences","REASON":"Reason","SICKNESS":"Sickness","VACATION":"Vacation","EMERGENCY":"Emergency","PERSONAL":"Personal","MORNINGBUS":"Morning Bus","AFTERNOONBUS":"Afternoon Bus","NOBUS":"No Bus","DATE":"Date","SWITCHTOABSENCES":"Switch to {var} Absences","STARTEDAT":"Started at","CLOSEDAT":"Closed at","NOTCLOSINGYET":"Not closing yet","EXPECTEDTOSTART":"Expected To Start..","DELAYED":"Delayed","DURATION":"Duration","STANDING":"Standing","MISSED":"Missed","WRONGPLACE":"Wrong Place","NOVIOLATIONS":"No Violations","TRIPVIOLATIONS":"Trip Violations","TRIPALERTS":"Trip Alerts","NOALERTS":"No Alerts","OCCURED":"Occured","TYPE":"Type","MESSAGE":"Message","MOREINFO":"More Info","DELAYEDBY":"Delayed by:","HOUR":"hour | hours","MINUTE":"minute | minutes","ALERT":"Alert","INCIDENT":"Incident","VIEWALERTS":"View Alerts","VIEWINCIDENTS":"View Incidents","CHILDBEHAVIOUR":"Child Behaviour","MEDICAL":"Medical","DRIVERISSUE":"Driver Issue","BUSPROBLEM":"Bus Problem","ACCIDENT":"Accident","TRAFFIC":"Traffic","CALLPOLICE":"Call Police","CALLSCHOOL":"Call School","OTHER":"Other","ACTIVE":"Active","SWITCHTO":"Switch to {var} Trips","VIEWVIOLATIONS":"View Violations","FUELCOST":"Fuel cost is","TOTALCOST":"Total cost is","IDLECOST":"Idle cost is","AED":"AED","REPORTEDBY":"Reported-By","GUARDIAN":"Guardian","NAANI":"Supervisor"},"ar":{"MESSAGES":" رسائل","DETAILS":"تفاصيل","LOADING":"جار التحميل...","SCHOOL":"المدرسة","VIOLATION":"مخالفة","NODATA":"لا توجد بيانات","STATUS":"الحالة","STUDENT":" الطالب","VIEWMORE":"مشاهدة المزيد","STUDENTS":"الطلاب","BUSSUPERVISOR":"مشرفة الحافلة","INCIDENTS":"حوادث","BUSVIOLATIONSANDALARMS":"مخالفات وانذارات الحافلة","NOMORERECORDS":"لا مزيد من السجلات","FIRSTSTOP":"المحطة الأولى","NEXTSTOP":"المحطة التالية","LASTSTOP":" المحطة الأخيرة","NOMORESTOPS":"لا توجد أي محطة","MINUTES":"الدقائق","TRIPCLOSED":"أغلقت الرحلة","RESOLVED":" حل","REPORTED":"ذكرت","OPEN":"فتح","BUSTRIPS":"الرحلات","ROUTE":"الرحلة","BUS":"الحافلة","WRITEAMESSAGE":"اكتب رسالة","STICK":"لصق","UNSTICK":"فك","SHOW":"تبين","HIDE":"إخفاء","VIEWINCIDENTDETAILS":"عرض تفاصيل الحادث","violation_video_loss":"فقدت إشارة الفيديو","violation_motion_detection":"تم اكتشاف حركة","violation_blind":"عمياء {POS } الكاميرا","violation_storage":"خطأ في التخزين @ 3 على القرص @ 1","violation_user_1":"تم الكشف عن الدخان","violation_user_2":"  استشعار تدفق الهواء ","violation_user_3":"درجة الحرارة الداخلية","violation_user_4":"الرطوبة الداخلية","violation_user_5":"توقفت الحافلة ","violation_user_6":" 6 تنبيه المستخدم ","violation_user_7":"7 تنبيه المستخدم","violation_user_8":"8 تنبيه المستخدم","violation_user_9":" 9 تنبيه المستخدم","violation_user_10":" 10 تنبيه المستخدم","violation_emergency":"تم الضغط على زر الهلع","violation_low_speed":"إنذار انخفاض السرعة (@ 1 كم / ساعة)","violation_high_speed":"إنذار ارتفاع السرعة (@ 1 كم / ساعة)","violation_low_voltage":"V انخفاض الجهد (@ 1)","violation_acceleration":"1 @ تنبيه السرعة","violation_header":"اتفاقية مستوى الخدمة الانتهاكات والإنذارات","violation_inspection_failed":"زر أحمر لم تضغط","violation_firealarm_release":"Smoke detector off","violation_stop_buttom_pressed":"Stop Button Pressed","violation_stop_buttom_released":"Stop Button Released","SECONDSAGO":" منذ {var} ثوانى","ONEMINUTEAGO":"قبل دقيقة واحدة","MINUTESAGO":"مضت {var} دقائق","ANHOURAGO":"قبل ساعة","HOURSAGO":" منذ {var} ساعات","YESTERDAY":"في الامس","DAYSAGO":"مضت {var} أيام","AWEEKAGO":"منذ أسبوع","WEEKSAGO":"منذ  {var} أسابيع","AMONTHAGO":"قبل شهر","MONTHSAGO":"منذ {var} اشهر","ONEYEARAGO":"قبل عام واحد","YEARSAGO":"مضت {var} سنين","NOW":"الآن","NAME":"الاسم","PICK-UP/DROP-OFF":"حمل / نزل الطلاب","SCHOOLANDBUSABSENCES":"غياب المدرسة والحافلات","REASON":"السبب","SICKNESS":"المرض","VACATION":"الاجازة","EMERGENCY":"حالة طوارق","PERSONAL":"اسباب شخصية","MORNINGBUS":"حافلة الصباح","AFTERNOONBUS":"حافلة المساء","NOBUS":"لا يوجد اي حافلة","DATE":"التاريخ","SWITCHTOABSENCES":"التبديل إلى {var} الرحلات","STARTEDAT":"بدأت في","CLOSEDAT":"مغلق في","NOTCLOSINGYET":"لم يتم الإغلاق بعد","EXPECTEDTOSTART":"...من المتوقع البدء ","DELAYED":"مؤجلة","DURATION":"المدة الزمنية","STANDING":"واقفا","MISSED":"مفقود","WRONGPLACE":"المكان الخطأ","NOVIOLATIONS":"لا توجد انتهاكات","TRIPVIOLATIONS":"انتهاكات الرحلة","TRIPALERTS":"تنبيهات الرحلة","NOALERTS":"لا توجد تنبيهات","EVENT":"حدث","TYPE":"نوع","MESSAGE":"رسالة","MOREINFO":"معلومات اكثر","DELAYEDBY":":تأخر","HOUR":"ساعة | ساعات","MINUTE":"دقيقة | دقائق","ALERT":"إنذار","INCIDENT":"حادث","CHILDBEHAVIOUR":"سلوك الطفل","MEDICAL":" طبي","DRIVERISSUE":"مشكلة السائق","BUSPROBLEM":"مشكلة الحافلة","ACCIDENT":"حادث","TRAFFIC":"حركة المرور","CALLPOLICE":"اتصل بالشرطة","CALLSCHOOL":"اتصل بالمدرسة","OTHER":"آخر","VIEWALERTS":"عرض التنبيهات","VIEWINCIDENTS":"عرض الحوادث","OCCURED":"حدث","VIEWVIOLATIONS":"عرض الانتهاكات","FUELCOST":"تكلفة السفر هو","TOTALCOST":"تكلفة صيانة المركبات هي","IDLECOST":"تكلفة الوقت الضائع","AED":"درهم","REPORTEDBY":"تم عمل تقرير بواسطة","GUARDIAN":"ولي الامر","NAANI":"مشرفة"}}')
}


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"WELCOME":"Welcome back, friend","SELECTSCHOOL":"Select School","USERNAME":"Username","PASSWORD":"Password","AUTHENTICATING":"Authenticating...","LOGIN":"Login","FORGOTPASSWORD":"Forgot password?","DEFAULT":"default","PLEASEENTERYOUREMAILADDRESS":"Please enter your email address","FORGOTPASSWORDT":"Forgot Password","SUBMIT":"Submit","CANCEL":"Cancel","INVALIDEMAILADDRESS":"Invalid Email Address","USEREMAILADDRESSNOTINTHESYSTEM":"User email address not in the system","ANEMAILHASBEENSENT":"An email has been sent.","SUCCESS":"Success","INVALIDUSER":"Invalid user","SENDING":"Sending...","ISREQUIRED":"is required.","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","LOADING":"Loading..."},"ar":{"WELCOME":"مرحبا بك مرة أخرى، صديق","SELECTSCHOOL":"حدد المدرسة","USERNAME":"اسم المستخدم","PASSWORD":"كلمه السر","AUTHENTICATING":"...مصادقة ","LOGIN":"تسجيل الدخول","FORGOTPASSWORD":"هل نسيت كلمة المرور؟","DEFAULT":"الافتراضي","PLEASEENTERYOUREMAILADDRESS":"الرجاء إدخال عنوان البريد الإلكتروني الخاص بك","FORGOTPASSWORDT":"هل نسيت كلمة المرور","SUBMIT":"قدم","CANCEL":"إلغاء","INVALIDEMAILADDRESS":"عنوان البريد الإلكتروني غير صالح","USEREMAILADDRESSNOTINTHESYSTEM":"عنوان البريد الإلكتروني للمستخدم ليس في النظام","ANEMAILHASBEENSENT":".تم ارسال البريد الإلكتروني","SUCCESS":"نجاح","INVALIDUSER":"المستخدم غير صالح","SENDING":"...إرسال","ISREQUIRED":".مطلوب","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","LOADING":"جار التحميل..."}}')
}


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"CENTERS":"Schools","STUDENTS":"Students","BUSES":"Buses","DRIVERS":"Drivers","ABSENCES":"Absences","ROUTES":"Routes","SUPERVISORS":"Supervisors","TOTAL":"Total"},"ar":{"CENTERS":"مراكز","STUDENTS":"الطلاب","BUSES":"الحافلات","DRIVERS":"السائقين","ABSENCES":"غياب","ROUTES":"خط السير","SUPERVISORS":"المشرفات","TOTAL":"مجموع"}}')
}


/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NEWPASSWORD":"New Password","CONFIRMPASSWORD":"Confirm Password","CHANGEPASSWORD":"Change Password","CHANGING":"Changing..","INFOTIP":"Use at least 8 characters including <u>Lowercase, Uppercase Numbers <br/>and Special Characters</u>. Don’t use a password from another site, <br/>phrases from <u>Username</u> or something too obvious like your pet’s name.","ERROR":"Error","CLOSE":"Close","ISREQUIRED":"is required.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","DIDNOTMATCH":"did not match with confirm password.","PASSWORDVALIDATION":"seems too weak.","YOURRECORDIDNOTMATCH":"Sorry, your record did not match in our records.","CANNOTCONTAINPHRASESFROMYOURUSERNAME":"cannot contain phrases from your username.","SUCCESS":"Your password is successfully changed!"},"ar":{}}')
}


/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGELOG":"Manage Log","LOADING":"Loading...","CHOOSEFILTERBY":"Choose Filer By","FILTERBYEVENT":"Filter by event","PICKARANGE":"Pick a range","PAGE":"Page","DATEANDTIME":"Date and Time","IPADDRESS":"IP Address","EVENTTYPE":"Event Type","DATE":"Date","ABSENCE":"Absence","BUS":"Bus","CONFIGURATION":"Configuration","DRIVER":"Driver","GUARDIAN":"Guardian","INCIDENT":"Incident","LOG":"Log","MESSAGE":"Message","ROLE":"Role","ROUTE":"Route","STUDENT":"Student","SUPERVISOR":"Supervisor","USER":"User","VIOLATION":"Violation","VIEW":"View","ADD/UPDATE":"Save","CHANGESTATUS":"Change Status","DELETE":"Delete","IMPORT":"Import","SEND":"Send","REGISTRATION":"Registration","CLONE":"Clone","SAVETAG":"Save Tag","LOGIN":"Login","SAVE":"Save","STATUS":"Status","SAVE_TAG":"Save Tag","FILTERBYACTION":"Filter by action","LOGOUT":"Logout"},"ar":{"MANAGELOG":"إدارة السجل","LOADING":"جار التحميل...","CHOOSEFILTERBY":"اختر الفلتر المطلوب","FILTERBYEVENT":"تصفية حسب الحدث","PICKARANGE":" اختيار مجموعة","PAGE":"صفحة","DATEANDTIME":" التاريخ والوقت","IPADDRESS":" IP عنوان","EVENTTYPE":"نوع الحدث","DATE":"تاريخ","ABSENCE":"غياب","BUS":"حافلة","CONFIGURATION":"ترتيب","DRIVER":"سائق","GUARDIAN":"ولي الامر","INCIDENT":"حادث","LOG":"سجل","MESSAGE":"رسالة","ROLE":"وظيفة","ROUTE":"خط السير","STUDENT":"طالب","SUPERVISOR":"المشرفة","USER":"المستعمل","VIOLATION":"انتهاك","VIEW":"عاين","ADD/UPDATE":"حفظ","CHANGESTATUS":"تغيير الوضع","DELETE":"حذف","IMPORT":"استيراد","SEND":"إرسال","REGISTRATION":"التسجيل","CLONE":"نسخ","SAVETAG":"حفظ العلامة","LOGIN":"تسجيل الدخول","SAVE":"حفظ","STATUS":"الحالة","SAVE_TAG":"حفظ العلامة","FILTERBYACTION":"التصفية بحسب الإجراء","LOGOUT":"الخروج"}}')
}


/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGEROLES":"Manage Roles","ADDNEWROLE":"Add New Role","LOADING":"Loading...","NAME":"Name","ACTIONS":"Actions","EDITROLE":"Edit Role","NEWROLE":"New Role","ROLENAME":"Role Name","ROLENAME(ARABIC)":"Role Name (Arabic)","SAVE":"Save","CANCEL":"Cancel","NAMESHOULDNOTBEEMPTY":"Name should not be empty!","NAMEALREADYEXIST":"Name already exist!","ABSENCE":"Absence","BUS":"Bus","CONFIGURATION":"Configuration","DRIVER":"Driver","GUARDIAN":"Guardian","INCIDENT":"Incident","LOG":"Log","MESSAGE":"Message","ROLE":"Role","ROUTE":"Route","STUDENT":"Student","SUPERVISOR":"Supervisor","USER":"User","VIOLATION":"Violation","VIEW":"View","ADD/UPDATE":"Add/Update","CHANGESTATUS":"Change Status","DELETE":"Delete","IMPORT":"Import","SEND":"Send","CLONE":"Copy","SAVETAG":"Save Tag","REGISTRATION":"Registration","SUCCESS":"successfully saved!","ROLEASSIGNED":"This role has been assigned to user(s)","FLAG":"Flag","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format."},"ar":{"MANAGEROLES":"إدارة الأدوار","ADDNEWROLE":"إضافة دور جديد","LOADING":"جار التحميل...","NAME":"الاسم","ROLENAME":"اسم الدور","ROLENAME(ARABIC)":"اسم الدور (عربي)","ACTIONS":" اجراءات","EDITROLE":"تحرير الدور","NEWROLE":" دور جديد","SAVE":" حفظ","CANCEL":"الغاء","NAMESHOULDNOTBEEMPTY":"لا يجب أن يكون الإسم فارغا!","NAMEALREADYEXIST":"هذا الإسم موجود!","ABSENCE":"غياب","BUS":"حافلة","CONFIGURATION":"ترتيب","DRIVER":"سائق","GUARDIAN":"ولي الامر","INCIDENT":"حادث","LOG":"سجل","MESSAGE":"رسالة","ROLE":"وظيفة","ROUTE":"خط السير","STUDENT":"طالب","SUPERVISOR":"المشرفة","USER":"المستعمل","VIOLATION":"انتهاك","VIEW":"شاهد","ADD/UPDATE":"إضافة / تحديث","CHANGESTATUS":"تغيير الحالة","DELETE":"حذف","IMPORT":"استيراد","SEND":"إرسال","CLONE":"استنساخ","SAVETAG":"حفظ الشارة","REGISTRATION":"التسجيل","SUCCESS":"حفظ بنجاح!","ROLEASSIGNED":"تم تعيين هذا الدور للمستخدم (المستخدمين)","FLAG":"علم","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة"}}')
}


/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"USERS":"Users","MANAGEUSERS":"Manage Users","ADDNEWUSER":"Add New User","CHOOSEFILTERBY":"Choose Filer By","SEARCHUSERNAME":"Search user name","FILTERBYROLE":"Filter by role","SEARCHUSERID":"Search user id","LOADING":"Loading...","USERID":"User ID","NAME":"Name","ROLE":"Role","STATUS":"Status","ACTIVE":"Active","INACTIVE":"Inactive","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISUSER":"restore this user?","DEACTIVATETHISUSER":"deactivate this user?","CANCEL":"Cancel","CONFIRM":"Confirm","EDITUSER":"Edit User","DEACTIVATEUSER":"Deactivate User","ACTIVATEUSER":"Activate User","USERNAME":"User Name","USERHASBEEN":"User has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","USERCANNOTBEENDELETED":"User can not been deleted!","UPLOADCSVFILE":"Upload CSV File","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","NATIONALITY":"Nationality","FIRSTNAME":"First Name","LASTNAME":"Last Name","STUDENTID":"Student ID","USERNAME(EMAILADDRESS)":"Username (Email Address)","EMAILADDRESS":"Email Address","GENDER":"Gender","IDENTIFICATIONNUMBER":"Identification Number","IDEXPIRATIONDATE":"ID Expiration Date","MOBILEPHONE":"Mobile Phone","LANDLINEPHONE":"LandlinePhone","SENDPASSWORDLINK":"Send Password Link","EMAILHASSENT":"Email has been sent!","LEVEL":"Level"},"ar":{"USERS":"المستخدمين","MANAGEUSERS":"ادارة المستخدمين","ADDNEWUSER":"إضافة مستخدم جديد","CHOOSEFILTERBY":"اختر الفلتر المطلوب","SEARCHUSERNAME":"ابحث عن اسم المستخدم","FILTERBYROLE":"تصفية حسب الدور ","SEARCHUSERID":" المستخدم ID ابحث","LOADING":"جار التحميل...","USERID":"هوية  المستخدم","NAME":"الاسم","ROLE":"دور","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISUSER":"استعادة هذا المستخدم","DEACTIVATETHISUSER":"تعطيل هذا المستخدم","CANCEL":"الغاء","CONFIRM":"تؤكد","EDITUSER":" تحرير  المستخدم","DEACTIVATEUSER":"تعطيل المستخدم","ACTIVATEUSER":"تفعيل المستخدم","USERNAME":" اسم المستخدم","USERHASBEEN":"المستخدم","RESTORED":"رمم!","DEACTIVATED":"معطلة!","USERCANNOTBEENDELETED":"لا يمكن حذف المستخدم!","UPLOADCSVFILE":"تحميل ملف CSV","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","NATIONALITY":"الجنسية","FIRSTNAME":"الأسم الأول","LASTNAME":"اسم العائلة","STUDENTID":"هوية الطالب","EMAILADDRESS":"عنوان البريد الإلكتروني","USERNAME(EMAILADDRESS)":"اسم المستخدم (عنوان البريد الإلكتروني)","GENDER":"الجنس","IDENTIFICATIONNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","MOBILEPHONE":"الهاتف المحمول","LANDLINEPHONE":"الهاتف الثابت","SENDPASSWORDLINK":"إرسال رابط كلمة المرور","EMAILHASSENT":"تم ارسال البريد الالكتروني!","LEVEL":"مستوى"}}')
}


/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGEUSER":"Manage User","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","FIRSTNAME":"First Name","LASTNAME":"Last Name","GENDER":"Gender","LOADING":"Loading...","UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","MALE":"Male","FEMALE":"Female","IDNUMBER":"ID Number","IDEXPIRATIONDATE":"ID Expiration Date","PICKADATE":"Pick a date","NATIONALITY":"Nationality","PLEASESELECTNATIONALITY":"Please select nationality","CONTACTINFO":"Contact Info","MOBILENO":"Mobile No","EMAILADDRESS":"Email Address","LANDLINEPHONE":"Landline Phone","ACCOUNTLOGIN":"Account Login","USERNAME(EMAILADDRESS)":"Username (Email Address)","ENTERUSERNAME":"Enter username","CHANGEPASSWORD":"Change Password","ENTERPASSWORD":"Enter Password","CANNOTBEEMPTY":"Can not be empty","MUSTLOWERCASE":"must contain at least 1 lowercase alphabetical character","MUSTUPPERCASE":"must contain at least 1 uppercase alphabetical character","MUSTNUMERIC":"must contain at least 1 numeric character","MUSTSPECIAL":"must contain at least one special character","ATLEASTCHARACTERS":"must contain at least 8 characters","ROLE":"Role","PASSWORDVALIDATION":"must contain at least 6 characters long, one upper case letter, one lower case letter, and one numeric digit.","ISREQUIRED":"is required.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","ISNOTAVALIDFORMAT":"is not a valid format. Only letters, spaces and dashes are allowed.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","INVALIDPHONENO":"is invalid phone number.","ALREADYEXISTED":"already existed.","ERROR":"Error","CLOSE":"Close","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","LEVEL":"Level"},"ar":{"MANAGEUSER":"ادارة المستخدمين","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":" الاسم العائلي (عربي) ","FIRSTNAME":"الأسم الأول","LASTNAME":"الاسم العائلي","GENDER":"جنس","LOADING":"جار التحميل...","UPLOADIMAGE":"تحميل الصور","SAVEIMAGE":"احفظ الصورة","MALE":"ذكر","FEMALE":"أنثى","IDNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","PICKADATE":"اختر تاريخا","NATIONALITY":"الجنسية","PLEASESELECTNATIONALITY":"يرجى تحديد الجنسية","CONTACTINFO":"معلومات الاتصال","MOBILENO":"رقم الجوال","EMAILADDRESS":"عنوان البريد الإلكتروني","LANDLINEPHONE":"الهاتف الثابت","ACCOUNTLOGIN":"بيانات الدخول","USERNAME(EMAILADDRESS)":"اسم المستخدم (عنوان البريد الإلكتروني)","ENTERUSERNAME":"ادخل اسم المستخدم","CHANGEPASSWORD":"تغيير كلمة السر","ENTERPASSWORD":"ادخل كلمة السر","CANNOTBEEMPTY":"لا يمكن أن يكون فارغاً","MUSTLOWERCASE":"يجب أن يحتوي على حرف أبجدي صغير واحد على الأقل","MUSTUPPERCASE":"يجب أن يحتوي على حرف أبجدي كبير واحد على الأقل","MUSTNUMERIC":"يجب أن يحتوي على حرف رقمي واحد على الأقل","MUSTSPECIAL":"يجب أن يحتوي على حرف خاص واحد على الأقل","ATLEASTCHARACTERS":"يجب أن يحتوي على 8 أحرف على الأقل","ROLE":"دور","PASSWORDVALIDATION":".يجب أن يحتوي على 6 أحرف على الأقل ، حرف واحد كبير، حرف واحد صغير، ورقم واحد","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ISNOTAVALIDFORMAT":".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","INVALIDPHONENO":".رقم هاتف غير صالح","ALREADYEXISTED":".موجودة بالفعل","ERROR":"خطأ","CLOSE":"أغلق","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","LEVEL":"مستوى"}}')
}


/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"CHOOSEFILTERBY":"Choose Filter By","MANAGEABSENCES":"Manage Absences","PICK-UP/DROP-OFF":"Pick-up/Drop-off","REASON":"Reason","SICKNESS":"Sickness","VACATION":"Vacation","EMERGENCY":"Emergency","PERSONAL":"Personal","MARKABSENCE":"Mark Absence","ADDNEWABSENCE":"Add New Absence","SCHOOL":"School","BUS":"Bus","FILTERBYREASON":"Filter by reason","PICKARANGE":"Pick a range","SEARCHSTUDENTNAME":"Search student name","LOADING":"Loading...","NAME":"Name","DATE":"Date","GRADE":"Grade","CLASS":"Class","SENDMESSAGE":"Send Message","EDITABSENCE":"Edit Absence","DELETEABSENCE":"Delete Absence","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISABSENCE":"restore this absence?","DEACTIVATETHISABSENCE":"deactivate this absence?","CANCEL":"Cancel","CONFIRM":"Confirm","TO":"To","WRITEANOTE":"Write a note","SUCCESSFULLYDELETED":"Successfully deleted","OPERATIONFAILED":"Operation failed","STUDENTHASNOGUARDIAN":"Student has no guardian","MORNINGBUS":"Morning Bus","AFTERNOONBUS":"Afternoon Bus","NOBUS":"No Bus","REPORTEDBY":"Reported-By","GUARDIAN":"Guardian","NAANI":"Supervisor"},"ar":{"CHOOSEFILTERBY":"اختر الفلتر المطلوب","MANAGEABSENCES":"إدارة غياب","PICK-UP/DROP-OFF":"حمل / نزل الطلاب","REASON":"السبب","SICKNESS":"المرض","VACATION":"الاجازة","EMERGENCY":"حالة طوارق","PERSONAL":"اسباب شخصية","MARKABSENCE":" سجل غياب ","ADDNEWABSENCE":"إضافة غياب جديد","SCHOOL":"المدرسة","BUS":"حافلة","FILTERBYREASON":" تصفية حسب السبب","PICKARANGE":" اختيار مجموعة","SEARCHSTUDENTNAME":" ابحث عن اسم الطالب","LOADING":"جار التحميل...","NAME":"الاسم","DATE":"التاريخ","GRADE":"الدرجة","CLASS":"الصف","SENDMESSAGE":"إرسال رسالة","EDITABSENCE":"تحرير الغياب","DELETEABSENCE":"حذف غياب","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISABSENCE":"استعادة الغياب","DEACTIVATETHISABSENCE":"تعطيل هذا الغياب","CANCEL":"إلغاء","CONFIRM":"تؤكد","TO":"إلى","WRITEANOTE":"اكتب ملاحظة","SUCCESSFULLYDELETED":"تم حذفها بنجاح","OPERATIONFAILED":"فشل العملية","STUDENTHASNOGUARDIAN":"ليس لطالب ولي أمر","MORNINGBUS":"حافلة الصباح","AFTERNOONBUS":"حافلة المساء","NOBUS":"لا يوجد اي حافلة","REPORTEDBY":"تم عمل تقرير بواسطة","GUARDIAN":"ولي الامر","NAANI":"مشرفة"}}')
}


/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"REASON":"Reason","ABSENCEFROM":"Absence From","BUSONLY":"Bus Only","SELECTONEORBOTH":"Select One or Both","HOMETOSCHOOL":"Home to School","SCHOOLTOHOME":"School to Home","MORNINGBUS":"Morning Bus","AFTERNOONBUS":"Afternoon Bus","MORNING":"Morning","AFTERNOON":"Afternoon","FROM":"From","TILL":"Till","SICKNESS":"Sickness","VACATION":"Vacation","EMERGENCY":"Emergency","PERSONAL":"Personal","MARKABSENCE":"Mark Absence","NOMORERECORDS":"No more records","ADDNEWABSENCE":"Add new absence","SEARCHSTUDENTNAME":"Search student\u0027s name","SCHOOL":"School","CHOOSEONE":"Choose One","ENTIREDAY":"Entire day","EMPTYDAY":"Empty day","PARTIALDAY":"Partial day","DATE":"Date","CANCEL":"Cancel","SAVE":"Save","ABSENCEISRECORDED":"Absence is saved","EDITABSENCE":"Edit Absence","DELETEABSENCE":"Delete Absence","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISABSENCE":"restore this absence?","DEACTIVATETHISABSENCE":"deactivate this absence?","CONFIRM":"Confirm","WRITEANOTE":"Write a note","SUCCESSFULLYDELETED":"Successfully deleted","OPERATIONFAILED":"Operation failed","ADDING":"Adding","UPDATING":"Updating","ABSENCEON":"absence on","COPIED":"Copied","COPYTO":"Copy To","SAVING":"Saving","SUCCESSFULLYCOPIED":"Successfully copied!","SELECTALL":"Select All","DESELECTALL":"Deselect All","ABSENCEDELETED":"Absence has been deleted!"},"ar":{"REASON":"السبب","ABSENCEFROM":"غياب من","BUSONLY":"من الحافلة فقط","SELECTONEORBOTH":"اختر واحد أو كل منهما","HOMETOSCHOOL":"المنزل إلى المدرسة","SCHOOLTOHOME":"المدرسة إلى المنزل","MORNINGBUS":"حافلة الصباح","AFTERNOONBUS":"حافلة المساء","MORNING":"الصباح","AFTERNOON":"المساء","FROM":"من","TILL":"الى","SICKNESS":"المرض","VACATION":"الاجازة","EMERGENCY":"حالة طوارق","PERSONAL":"اسباب شخصية","MARKABSENCE":" سجل غياب ","NOMORERECORDS":"لا مزيد من السجلات","ADDNEWABSENCE":"إضافة غياب جديد","SEARCHSTUDENTNAME":" ابحث عن اسم الطالب","SCHOOL":"المدرسة","CHOOSEONE":"اختار واحد","ENTIREDAY":" يوم كامل","EMPTYDAY":"يوم فارغ","PARTIALDAY":"يوم جزئي","DATE":"التاريخ","CANCEL":"إلغاء","SAVE":" حفظ","ABSENCEISRECORDED":"تم حفظ الغياب","EDITABSENCE":"تحرير الغياب","DELETEABSENCE":"حذف غياب","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISABSENCE":"استعادة الغياب","DEACTIVATETHISABSENCE":"تعطيل هذا الغياب","CONFIRM":"تؤكد","WRITEANOTE":"اكتب ملاحظة","SUCCESSFULLYDELETED":"تم حذفها بنجاح","OPERATIONFAILED":"فشل العملية","ADDING":"اضافة","UPDATING":"تحديث","ABSENCEON":"غياب في","COPIED":"نسخ","COPYTO":"نسخ الى","SAVING":"حفظ","SUCCESSFULLYCOPIED":"تم نسخها بنجاح!","SELECTALL":"اختر الكل","DESELECTALL":"الغاء الكل","ABSENCEDELETED":"تم حذف الغياب!"}}')
}


/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ALERT":"Alert","SESSIONHASBEENEXPIRED":"You have been logged out. Session has been expired!!","SESSIONABOUTTOEXPIRESOON":"Session about to expire soon!","CANCEL":"Cancel","CONFIRM":"Confirm","PLEASEENTERYOURPASSWORD":"Please enter your password","REQUIREDAUTHENTICATION":"Authentication required!","AUTHENTICATING":"Authenticating...","INVALIDUSER":"Invalid user","ISREQUIRED":"is required."},"ar":{"ALERT":"تحذير ","SESSIONHASBEENEXPIRED":"لقد تم تسجيل الخروج. انتهت صلاحية الدورة!!","SESSIONABOUTTOEXPIRESOON":"دورة على وشك الانتهاء قريبا!","CANCEL":"إلغاء","CONFIRM":"تاكيد ","PLEASEENTERYOURPASSWORD":" من فضلك أدخل رقمك السري","REQUIREDAUTHENTICATION":"مطلوب المصادقة!","AUTHENTICATING":"...مصادقة ","INVALIDUSER":"المستخدم غير صالح","ISREQUIRED":".مطلوب"}}')
}


/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DOCUMENTS":"Documents","ATTACHEMENT":"Attachement","DOWNLOADFILE":"Download File","NOLABEL":"No Label"},"ar":{"DOCUMENTS":"مستندات","ATTACHEMENT":"المرفق","DOWNLOADFILE":"تحميل الملف","NOLABEL":"لا ملصق"}}')
}


/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"IMPORTDATA":"Import Data","IMPORT":"Import","REQUIREDFIELDS":"Required fields","SELECTFIELD":"Select field","SELECTFIELDVALUE":"Select field value","CANCEL":"Cancel","IMPORTINGDATA":"Importing Data...","STARTIMPORTING":"Start Importing","SUCCESSFULLYIMPORTED":"Successfully imported","FAILEDIMPORT":"Import is aborted, Please try again!","DATA":"Data","UPLOAD":"Upload","CLOSE":"Close","DATAFIELDTYPE":"Data Field Type","DATAVALUE":"Data Value","CSVCOLUMN":"CSV Column","FORMAT":"Format","N/A":"N/A","SELECTFORMAT":"Select format"},"ar":{"IMPORTDATA":"استورد البيانات","IMPORT":"استورد","REQUIREDFIELDS":"المجالات المطلوبة","SELECTFIELD":"حدد المجال","SELECTFIELDVALUE":"حدد قيمة المجال","CANCEL":"الغاء","IMPORTINGDATA":"استيراد البيانات","STARTIMPORTING":"بدء الاستيراد","SUCCESSFULLYIMPORTED":"تم استيرادها بنجاح","FAILEDIMPORT":"تم إحباط الاستيراد، يرجى المحاولة مرة أخرى! ","DATA":"البيانات","UPLOAD":"تحميل","CLOSE":"أغلق","DATAFIELDTYPE":"نوع مجال البيانات","DATAVALUE":"قيمة البيانات","CSVCOLUMN":"  CSV عمود ","FORMAT":"شكل","N/A":"غير قابل للتطبيق","SELECTFORMAT":"تحديد الشكل"}}')
}


/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"INCIDENTS":"Incidents","STUDENTSINVOLVED":"Students Involved","OPEN":"Open","REPORTTO":"Report to","POLICE":"Police","BUSCOMPANY":"Bus Company","RE-OPEN":"Re-open","RESOLVED":"Resolved","MARKRESOLVED":"Mark Resolved","MESSAGE":"Message","SUPERVISORMOBILE":"Supervisor Mobile","INCIDENTTYPE":"Incident Type","VIEWIMAGE":"View Image","SHOWMAP":"Show Map","VIEWINCIDENTDETAILS":"View Incident Details","SELECTMONITOR":"Select Monitor","ROUTE":"Route:","NOSTUDENTSINVOLVED":"No students involved","BUSNUMBER":"Bus Number","MESSAGEH":"Message:","NOMESSAGE":"No Message","RESOLUTION":"Resolution","WRITEYOURMESSAGE":"Write your message","CLOSE":"Close","SAVE":"Save","SENDING":"Sending...","SENDMESSAGE":"Send Message","REPORTINCIDENTTO":"Report incident to","PARENTS":"Parents","CANCEL":"Cancel","INCIDENTIMAGE":"Incident Image","CHILDBEHAVIOUR":"Child Behaviour","MEDICAL":"Medical","DRIVERISSUE":"Driver Issue","BUSPROBLEM":"Bus Problem","ACCIDENT":"Accident","TRAFFIC":"Traffic","CALLPOLICE":"Call Police","CALLSCHOOL":"Call School","OTHER":"Other","EMAILHASSENT":"Email has been sent!","EMAILHASNOTSEND":"Email has not send!","SUCCESS":"Message has been sent!","FAILED":"Failed to send!","MISSEDALERT":"Storage error @3 on disk @1","DELAYED":"Delayed","DURATION":"Duration","STANDING":"Standing","MISSED":"Missed","WRONGPLACE":"Wrong Place","PRINTINCIDENT":"Print Incident"},"ar":{"INCIDENTS":"احداث","STUDENTSINVOLVED":"الطلاب المعنيين","OPEN":"مفتوحة","REPORTTO":"تقرير الى","POLICE":"شرطة","BUSCOMPANY":"شركة الباصات","RE-OPEN":"إعادة فتح","RESOLVED":"حل","MARKRESOLVED":"أمر محسوم","MESSAGE":"رسالة","SUPERVISORMOBILE":"رقم جوال المشرفة","INCIDENTTYPE":"نوع الحادث","VIEWIMAGE":"عرض الصورة","SHOWMAP":"عرض الخريطة","VIEWINCIDENTDETAILS":"عرض تفاصيل الحوادث","SELECTMONITOR":"حدد المشرفة","ROUTE":"طريق","NOSTUDENTSINVOLVED":"لا طلاب متورطين","BUSNUMBER":"رقم الحافلة","MESSAGEH":"رسالة","RESOLUTION":"القرار","WRITEYOURMESSAGE":"اكتب رسالتك","CLOSE":"أغلق","SAVE":"حفظ","SENDING":"إرسال","SENDMESSAGE":"أرسل الرسالة","REPORTINCIDENTTO":"تبليغ الحادث إلى","PARENTS":"الآباء","CANCEL":"الغاء","INCIDENTIMAGE":"صورة الحادث","CHILDBEHAVIOUR":"سلوك الطفل","MEDICAL":" طبي","DRIVERISSUE":"مشكلة السائق","BUSPROBLEM":"مشكلة الحافلة","ACCIDENT":"حادث","TRAFFIC":"حركة المرور","CALLPOLICE":"اتصل بالشرطة","CALLSCHOOL":"اتصل بالمدرسة","OTHER":"الأخرى","EMAILHASSENT":"تم ارسال البريد الالكتروني!","EMAILHASNOTSEND":"لم يرسل البريد الإلكتروني!","SUCCESS":"تم ارسال الرسالة!","FAILED":"فشل فى الارسال!","DELAYED":"مؤجل","DURATION":"المدة الزمنية","STANDING":"واقفا","MISSED":"مفقود","WRONGPLACE":"المكان الخطأ","PRINTINCIDENT":"طباعة حادثة"}}')
}


/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ATTACHEMENT":"Attachement","WRITEAMESSAGE":"Write a Message","COMPOSEMESSAGE":"Compose Message","SELECTRECIPIENT":"Select Recipient","SELECTBUSROUTE":"Select Bus Route","RECIPIENT0":"All Parents","RECIPIENT1":"All Bus Monitors","RECIPIENT2":"Parents in Same Grade","RECIPIENT3":"Parents in Same Bus","RECIPIENT4":"Parents with Children Physically Present on Same Bus","RECIPIENT5":"Parents with Children Physically not Present on Same Bus","RECIPIENT6":"Specific Person: Student\u0027s Relative or Bus Monitor","SEARCHPERSONNAME":"Search person\u0027s name","CONVERSATION":"Conversation","WRITEYOURMESSAGE":"Write your message","MESSAGEFOR":"Message For","CHARACTERSREMAINING":"Characters Remaining:","SELECTGRADE":"Select Grade","SELECTCLASS":"Select Class","SELECTBUS":"Select Bus","BUSSUPERVISOR":"Bus Supervisor","PRIMARY":"Primary","NOT":"Not","LISTALLSTUDENTS":"List All Students","ATTACHMENT":"Attachment","FILESWITHASIZE":"Files with a size less than 400kb","MONITOR":"Monitor","FATHER":"Father","MOTHER":"Mother","GUARDIAN":"Guardian","CANCEL":"Cancel","SENDING":"Sending...","SEND":"Send","THISTRIPNOLONGEREXIST":"This trip no longer exist!","NOSTUDENTSMARKEDMISSING":"None of the students marked as missing!","EMAILHASSENT":"Email has been sent!","EMAILHASNOTSEND":"Email has not send!","SUCCESS":"Message has been sent!","FAILED":"Failed to send!","NOGRADESTUDENTS":"There are no students in this grade!","ERROR":"Error","CLOSE":"Close","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {len}.","TYPEERROR":"File extensions should be {len}.","ATTACHING":"Attaching..."},"ar":{"ATTACHEMENT":"مرفقات","WRITEAMESSAGE":"اكتب رسالة","COMPOSEMESSAGE":"إنشاء رسالة","SELECTRECIPIENT":"اختر المرسل إليه","SELECTBUSROUTE":"اختر خط السير","RECIPIENT0":"جميع الآباء والأمهات","RECIPIENT1":"جميع المشرفات","RECIPIENT2":"الآباء في نفس الصف","RECIPIENT3":"الآباء في نفس الحافلة","RECIPIENT4":"أباء الطلاب الموجودين على نفس الحافلة","RECIPIENT5":" أباء الطلاب الغير الموجودين على نفس الحافلة","RECIPIENT6":"شخص محدد: ولي امر الطالب أو المشرفة","SEARCHPERSONNAME":"ابحث عن اسم الشخص","CONVERSATION":" محادثة","WRITEYOURMESSAGE":" اكتب رسالتك","MESSAGEFOR":" رسالة ل","CHARACTERSREMAINING":" الحروف المتبقية","SELECTGRADE":"حدد الدرجة","SELECTCLASS":"حدد الصف","SELECTBUS":" حدد الحافلة","BUSSUPERVISOR":"المشرفات","PRIMARY":"الأساسي","NOT":"ليس","LISTALLSTUDENTS":" قائمة جميع الطلاب","ATTACHMENT":"المرفق","FILESWITHASIZE":" الملفات ذات الحجم أقل من 400 كيلوبايت","FILESWITHASIZE1":" الملفات بحجم أقل من","MONITOR":"المشرفة","FATHER":"الاب","MOTHER":"الام","GUARDIAN":"ولي الامر","CANCEL":"إلغاء","SENDING":"إرسال","SEND":"ارسل","THISTRIPNOLONGEREXIST":"لم تعد هذه الرحلة موجودة!","NOSTUDENTSMARKEDMISSING":"لا يوجد طلاب مفقودين!","EMAILHASSENT":"تم ارسال البريد الالكتروني!","EMAILHASNOTSEND":"لم يرسل البريد الإلكتروني!","SUCCESS":"تم ارسال الرسالة!","FAILED":"فشل فى الارسال!","NOGRADESTUDENTS":"لا يوجد طلاب في هذا الصف!","ERROR":"خطأ","CLOSE":"أغلق","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {len}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {len}.","ATTACHING":"تعلق..."}}')
}


/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"SUCCESS":"{component} is successfully saved!","CANCEL":"Cancel","SAVE":"Save","SAVING":"Saving..","ERROR":"Error","CLOSE":"Close"},"ar":{"SUCCESS":"تم حفظ  {component}!","CANCEL":"الغاء","SAVE":" حفظ","SAVING":"..احتفاظ","ERROR":"خطأ","CLOSE":"أغلق"}}')
}


/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"TAGSCANNER":"Tag Scanner","ERROR":"Error","TAGIDALREADYASSIGNEDTOSOMEONEELSE":"Tag ID already Assigned to someone else!","TAGHASBEENASSIGNED":"Tag has been assigned!","SUCCESS":"Success","TAGHASBEENSUCCESSFULLYDISABLED":"Tag has been successfully disabled!","INFO":"Info","TAGISNOTASSIGNED":"Tag is not assigned!","SCANTAGNOW":"Scan Tag, now!","FAILEDTOSCANTRYAGAIN":"Failed to scan, try again!","TAGID":"Tag ID","DISABLETAG":"Disable Tag","CLICKONCONFIRMTODISABLEASSIGNEDTAG":"Click on confirm to disable assigned tag!","CANCEL":"Cancel","DISABLE":"Disable","RE-SCAN":"Re-scan","CHANGE":"Change","ASSIGNTAG":"Assign Tag","CONFIRM":"Confirm","BASEBETWEEN":"Base between 2 and 36"},"ar":{"TAGSCANNER":"المسح الإلكتروني للشارة","ERROR":"خطأ","TAGIDALREADYASSIGNEDTOSOMEONEELSE":"الشارة معينة بالفعل لشخص آخر!","TAGHASBEENASSIGNED":"تم تعيين الشارة!","SUCCESS":"نجاح","TAGHASBEENSUCCESSFULLYDISABLED":"تم تعطيل الشارة بنجاح!","INFO":" معلومات","TAGISNOTASSIGNED":"شارة غير معينة ","SCANTAGNOW":"امسح الشارة، الآن!","FAILEDTOSCANTRYAGAIN":"مسح الكتروني فاشل،حاول مرة أخرى!","TAGID":"الشارة الإلكترونية","DISABLETAG":"  تعطيل الشارة الإلكترونية ","CLICKONCONFIRMTODISABLEASSIGNEDTAG":"انقر على تأكيد لتعطيل العلامة المخصصة!","CANCEL":"إلغاء","DISABLE":"تعطيل","RE-SCAN":"امسح الشارة مجددا","CHANGE":"تغيير","ASSIGNTAG":"عين الشارة","CONFIRM":"تأكد","BASEBETWEEN":"قاعدة بين 2 و36"}}')
}


/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","CANCEL":"Cancel","CLOSE":"Close","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {param}.","TYPEERROR":"File extensions should be {param}."},"ar":{"CANCEL":"الغاء","CLOSE":"أغلق","SAVEIMAGE":"احفظ الصورة","UPLOADIMAGE":"تحميل الصور","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {param}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {param}."}}')
}


/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"INCIDENTS":"Incidents","OPEN":"Open","RESOLVED":"Resolved","INCIDENTTYPE":"Incident Type","VIEWINCIDENTDETAILS":"View Incident Details","CHOOSEFILTERBY":"Choose Filter By","FILTERBYSUPERVISOR":"Filter by supervisor","FILTERBYBUS":"Filter by bus","FILTERBYTYPE":"Filter by type","FILTERBYSTATUS":"Filter by status","REPORTED":"Reported","LOADING":"Loading...","BUSSUPERVISOR":"Bus Supervisor","BUS":"Bus","STUDENTS":"Students","STATUS":"Status","TYPE":"Type","DETAILS":"Details","STICK":"Stick","UNSTICK":"Unstick","SUPERVISOR":"Supervisor","CHILDBEHAVIOUR":"Child Behaviour","MEDICAL":"Medical","DRIVERISSUE":"Driver Issue","BUSPROBLEM":"Bus Problem","ACCIDENT":"Accident","TRAFFIC":"Traffic","CALLPOLICE":"Call Police","CALLSCHOOL":"Call School","OTHER":"Other"},"ar":{"INCIDENTS":"احداث","OPEN":"مفتوحة","RESOLVED":"حل","INCIDENTTYPE":"نوع الحادث","VIEWINCIDENTDETAILS":"عرض تفاصيل الحادث","CHOOSEFILTERBY":"اختر الفلتر المطلوب","FILTERBYSUPERVISOR":"تصفية حسب المشرفة","FILTERBYBUS":"تصفية حسب الحافلة","FILTERBYTYPE":"تصفية حسب النوع","FILTERBYSTATUS":"تصفية حسب الحالة","REPORTED":" المبلغ عنها","LOADING":"جار التحميل...","BUSSUPERVISOR":"مشرفة الحافلة","BUS":"حافلة","STUDENTS":"الطلاب","STATUS":"الحالة","TYPE":"نوع","DETAILS":"تفاصيل","STICK":"لصق","UNSTICK":"فك","SUPERVISOR":"مشرفة","CHILDBEHAVIOUR":"سلوك الطفل","MEDICAL":" طبي","DRIVERISSUE":"مشكلة السائق","BUSPROBLEM":"مشكلة الحافلة","ACCIDENT":"حادث","TRAFFIC":"حركة المرور","CALLPOLICE":"اتصل بالشرطة","CALLSCHOOL":"اتصل بالمدرسة","OTHER":"آخر"}}')
}


/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MESSAGES":"Messages","LOADOLDERMESSAGES":"Load Older Messages","ATTACHEMENT":"Attachement","REPLY":"Reply","WRITEYOURMESSAGE":"Write your message","LOADING":"Loading...","FILESWITHASIZELESSTHAN":"Files with a size less than 400kb","SENDING":"Sending...","NOW":"just now","GROUPSUPERVISOR":"To: Type the name of a bus supervisor","NEWMESSAGE":"New Message","TO":"to ","SUCCESS":"Message has been sent to supervisor(s)!","ERROR":"Error","CLOSE":"Close","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {len}.","TYPEERROR":"File extensions should be {len}."},"ar":{"MESSAGES":"رسائل","LOADOLDERMESSAGES":" تحميل رسائل قديمة","ATTACHEMENT":"المرفق","REPLY":"الرد","WRITEYOURMESSAGE":"اكتب رسالتك","LOADING":"جار التحميل...","FILESWITHASIZELESSTHAN":" 400 KB الملفات بحجم أقل من","SENDING":"...إرسال","NOW":"الآن","GROUPSUPERVISOR":"إلى: اكتب اسم مشرف الحافلة","NEWMESSAGE":"رسالة جديدة","TO":"إلى ","SUCCESS":"تم إرسال رسالة إلى المشرف (المشرفين)!","ERROR":"خطأ","CLOSE":"أغلق","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {len}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {len}."}}')
}


/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"INCIDENTS":"Incidents","SUPERVISOR":"Supervisors | Supervisor","DRIVER":"Drivers | Driver","ROUTE":"Route","DIRECTION":"Direction","DATE":"Date","STOP":"# Of Stops","STUDENT":"# Of Students","COMPLETEDTIME":"Completed Time","COUNT":"Count","DATERANGE":"Date Range","BUSNUMBER":"Bus Number","MAKE":"Make","YEAR":"Year","PLATE":"Plate","NATIONALITY":"Nationality","GENDER":"Gender","BUS":"Buses | Bus","INCIDENT":"Incidents","VIOLATION":"Violations","TYPE":"Type","STATUS":"Status","LABEL":"Label","IDEXPIRATION":"ID Expiration","GRADE":"Grade","TEXT":"Text","Lng":"Longitude","Lat":"Latitude","ALARMSTATUS":"Alarm Status","REASON":"Reason","SPEED":"Speed","STUDENTNAME":"Student Name","CLASS":"Class","CAPACITY":"Capacity","EXPIRATIONDATE":"Expiration Date","BYNATIONALITY":"By Nationality","ABSENCE":"Absence","ADDRESS":"Address","ASSIGNEDBUS":"Assigned Bus","OPEN":"Open","REPORTED":"Reported","SICKNESS":"Sickness","VACATION":"Vacation","EMERGENCY":"Emergency","PERSONAL":"Personal","CHILDBEHAVIOUR":"Child Behaviour","MEDICAL":"Medical","DRIVERISSUE":"Driver Issue","BUSPROBLEM":"Bus Problem","ACCIDENT":"Accident","TRAFFIC":"Traffic","CALLPOLICE":"Call Police","CALLSCHOOL":"Call School","OTHER":"Other","SMOKEDETECTED":"Smoke detected","PANICBUTTONPRESSED":"Panic button pressed","HIGHSPEEDALARM":"High speed alarm","REPORT":"Report","GETREPORT":"Get Report","GROUPBY":"Group By","GROUPEDBY":"Grouped By","SELECTALL":"Select All","DESELECTALL":"Deselect All","SHOW":"Show","EXPORT":"Export","TRIPS":"Trips","SELECTROUTE":"Select route","SELECTDIRECTION":"Select direction","HOMETOSCHOOL":"Home To School","SCHOOLTOHOME":"School To Home","PICKARANGE":"Pick a range","NODATATOSHOW":"No data to show","MINCAPACITY":"Min Capacity","MAXCAPACITY":"Max Capacity","MINYEAR":"Min Year","MAXYEAR":"Max Year","PICKADATE":"Pick a date","UNIQUECOUNTBY":"Unique Count By","FILTERBYSUPERVISOR":"Filter By Supervisor","SELECTNATIONALITY":"Select nationality","SELECTBUS":"Select bus","FILTERBYDRIVER":"Filter By Driver","SELECTVIOLATION":"Select violation","FILTERBYINCIDENT":"Filter By Incident","SELECTONE":"Select one","SELECTMULTIPLE":"Select multiple","SELECTDRIVER":"Select driver","SELECTSUPERVISOR":"Select supervisor","SELECTTYPE":"Select type","SELECTSTATUS":"Select status","STUDENTS":"Students","SELECTREASON":"Select reason","SEARCHADDRESS":"Search address","SELECTGRADE":"Select grade","FILTERBYSTUDENT":"Filter By Student","KM":"Km","LOADING":"Loading..."},"ar":{"INCIDENTS":"حوادث","SUPERVISOR":"المشرفات | مشرفة","DRIVER":"السائقين | سائق","ROUTE":"خط السير","DIRECTION":"اتجاه","DATE":"تاريخ","STOP":"عدد التوقفات","STUDENT":"عدد الطلاب","COMPLETEDTIME":"الوقت المكتمل","COUNT":"إحصاء","DATERANGE":"نطاق التاريخ","BUSNUMBER":"رقم الحافلة","MAKE":"الصنع","YEAR":"السنة","PLATE":"رقم اللوحة","NATIONALITY":"الجنسية","GENDER":"جنس","BUS":"حافلة","INCIDENT":"حوادث","VIOLATION":"انتهاكات","TYPE":"نوع","STATUS":"الحالة","LABEL":" تسمية ","IDEXPIRATION":"انتهاء صلاحية الهوية","GRADE":"الدرجة","TEXT":"نص","Lng":"خط الطول","Lat":"خط العرض","ALARMSTATUS":"حالة التنبيه","REASON":"السبب","SPEED":"سرعة","STUDENTNAME":"أسم الطالب","CLASS":"الصف ","CAPACITY":"سعة","EXPIRATIONDATE":"تاريخ إنتهاء الصلاحية","BYNATIONALITY":"حسب الجنسية","ABSENCE":"غياب","ADDRESS":"عنوان","ASSIGNEDBUS":"الحافلة المعينة","OPEN":"فتح","REPORTED":"المبلغ عنها","SICKNESS":"المرض","VACATION":"الاجازة","EMERGENCY":"حالة طوارق","PERSONAL":"اسباب شخصية","CHILDBEHAVIOUR":"سلوك الطفل","MEDICAL":" طبي","DRIVERISSUE":"مشكلة السائق","BUSPROBLEM":"مشكلة الحافلة","ACCIDENT":"حادث","TRAFFIC":"حركة المرور","CALLPOLICE":"اتصل بالشرطة","CALLSCHOOL":"اتصل بالمدرسة","OTHER":"آخر","SMOKEDETECTED":"تم الكشف عن الدخان","PANICBUTTONPRESSED":"تم الضغط على زر الهلع","HIGHSPEEDALARM":"تنبيه السرعة العالية","REPORT":"أبلغ عن","GETREPORT":"الحصول على تقرير","GROUPBY":" صنف حسب","GROUPEDBY":"مصنفة حسب","SELECTALL":"اختر الكل","DESELECTALL":"الغاء الكل","SHOW":"عرض","EXPORT":"تصدير","TRIPS":"الرحلات","SELECTROUTE":"حدد الطريق","SELECTDIRECTION":"حدد الإتجاه","HOMETOSCHOOL":"من البيت الى المدرسة","SCHOOLTOHOME":"من المدرسة الى البيت","PICKARANGE":" اختيار مجموعة","NODATATOSHOW":"لا توجد بيانات للعرض","MINCAPACITY":"الحد الأدنى","MAXCAPACITY":" الحد الأقصى","MINYEAR":"الحد الأدنى العام","MAXYEAR":"الحد الأقصى العام","PICKADATE":"اختر تاريخا","UNIQUECOUNTBY":" احصاء منفرد حسب","FILTERBYSUPERVISOR":"تصفية حسب المشرفة","SELECTNATIONALITY":"حدد الجنسية","SELECTBUS":"حدد الحافلة","FILTERBYDRIVER":"تصفية حسب السائق","SELECTVIOLATION":"حدد الإنتهاك","FILTERBYINCIDENT":"تصفية حسب الحوادث","SELECTONE":"اختر واحد","SELECTMULTIPLE":"اختيار متعدد","SELECTDRIVER":"اختيار السائق","SELECTSUPERVISOR":"اختيار المشرفة","SELECTTYPE":"حدد النوع","SELECTSTATUS":"حدد الحالة","STUDENTS":"الطلاب","SELECTREASON":"حدد السبب","SEARCHADDRESS":"ابحث عن العنوان","SELECTGRADE":"حدد الصف","FILTERBYSTUDENT":"تصفية حسب الطالب","KM":"كم","LOADING":"جار التحميل..."}}')
}


/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DIRECTIONS":"Directions","HOMETOSCHOOL":"Home to School","SCHOOLTOHOME":"School to Home","MINUTES":"Minutes","BUSTRIPS":"Bus Trips","LOADING":"Loading...","LIST":"List","MAP":"Map","SELECTROUTE":"Select Route","UNCHECKALL":"Uncheck All","CHECKALL":"Check All","CHOOSEFILTERBY":"Choose Filter By","FILTERBYDIRECTION":"Filter by direction","FILTERBYMONITOR":"Filter by monitor","PICKARANGE":"Pick a range","CLOSEDTRIPS":"Closed Trips","LIVETRIPS":"Live Trips","NODATA":"No Data","TRIPCLOSED":"Trip Closed","DIRECTION":"Direction","SUPERVISOR":"Supervisor","DATE":"Date","FIRSTSTOP":"First Stop","SCHOOL":"School","NEXTSTOP":"Next Stop","LASTSTOP":"Last Stop","NOMORESTOPS":"No More Stops","CHILDBEHAVIOUR":"Child Behaviour","MEDICAL":"Medical","DRIVERISSUE":"Driver Issue","BUSPROBLEM":"Bus Problem","ACCIDENT":"Accident","TRAFFIC":"Traffic","CALLPOLICE":"Call Police","CALLSCHOOL":"Call School","OTHER":"Other","STARTEDAT":"Started at","CLOSEDAT":"Closed at","NOTCLOSINGYET":"Not closing yet","EXPECTEDTOSTART":"Expected To Start..","DELAYED":"Delayed","DURATION":"Duration","STANDING":"Standing","MISSED":"Missed","WRONGPLACE":"Wrong Place","NOVIOLATIONS":"No Violations","TRIPVIOLATIONS":"Trip Violations","TRIPALERTS":"Trip Alerts","NOALERTS":"No Alerts","OCCURED":"Occured","TYPE":"Type","MESSAGE":"Message","MOREINFO":"More Info","DELAYEDBY":"Delayed by:","HOUR":"hour | hours","MINUTE":"minute | minutes","ALERT":"Alert","INCIDENT":"Incident","VIEWALERTS":"View Alerts","VIEWINCIDENTS":"View Incidents","VIEWVIOLATIONS":"View Violations","NOANYCLEANTRIPS":"No clear trips","NOANYWARNTRIPS":"No flagged trips","FUELCOST":"Fuel cost is","TOTALCOST":"Total cost is","IDLECOST":"Idle cost is","AED":"AED"},"ar":{"DIRECTIONS":"الاتجاهات","HOMETOSCHOOL":"من البيت الى المدرسة","SCHOOLTOHOME":"من المدرسة الى البيت","MINUTES":"دقائق","BUSTRIPS":"الرحلات","LOADING":"جار التحميل...","LIST":"قائمة","MAP":"خريطة","SELECTROUTE":"حدد الطريق","UNCHECKALL":"الغاءالكل","CHECKALL":"تحقق من الكل","CHOOSEFILTERBY":"اختر الفلتر المطلوب","FILTERBYDIRECTION":"تصفية حسب الاتجاه","FILTERBYMONITOR":"تصفية حسب المشرفة","PICKARANGE":" اختيار مجموعة","CLOSEDTRIPS":"رحلات مغلقة","LIVETRIPS":"رحلات على المباشر","NODATA":"لايوجد بيانات","TRIPCLOSED":"أغلقت الرحلة","DIRECTION":"اتجاه","SUPERVISOR":"المشرفة","DATE":"تاريخ","FIRSTSTOP":"المحطة الأولى","SCHOOL":"المدرسة","NEXTSTOP":" المحطة التالية","LASTSTOP":" المحطة الأخيرة","NOMORESTOPS":"لا مزيد من توقف","CHILDBEHAVIOUR":"سلوك الطفل","MEDICAL":" طبي","DRIVERISSUE":"مشكلة السائق","BUSPROBLEM":"مشكلة الحافلة","ACCIDENT":"حادث","TRAFFIC":"حركة المرور","CALLPOLICE":"اتصل بالشرطة","CALLSCHOOL":"اتصل بالمدرسة","OTHER":"آخر","STARTEDAT":"بدأت في","CLOSEDAT":"مغلق في","NOTCLOSINGYET":"لم يتم الإغلاق بعد","EXPECTEDTOSTART":"...من المتوقع البدء ","DELAYED":"مؤجل","DURATION":"المدة الزمنية","STANDING":"واقفا","MISSED":"مفقود","WRONGPLACE":"المكان الخطأ","NOVIOLATIONS":"لا توجد انتهاكات","TRIPVIOLATIONS":"انتهاكات الرحلة","TRIPALERTS":"تنبيهات الرحلة","NOALERTS":"لا توجد تنبيهات","EVENT":"حدث","TYPE":"نوع","MESSAGE":"رسالة","MOREINFO":"معلومات اكثر","DELAYEDBY":":تأخر","HOUR":"ساعة | ساعات","MINUTE":"دقيقة | دقائق","ALERT":"إنذار","INCIDENT":"حادث","VIEWVIOLATIONS":"عرض الانتهاكات","NOANYCLEANTRIPS":"لا رحلات سلسة","NOANYWARNTRIPS":"لا رحلات مع التنبيهات","FUELCOST":"تكلفة السفر هو","TOTALCOST":"تكلفة صيانة المركبات هي","IDLECOST":"تكلفة الوقت الضائع","AED":"درهم"}}')
}


/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ROUTETRIP":"Route Trip:","STOP":"Stop","TO":"To","SCHOOL":"School","HOME":"Home","ESTIMATEDARRIVALTIME":"Estimated arrival time:","MIN":"min","CHECKEDINAT":"Checked in at","CHECKEDOUTAT":"Checked out at","ABSENTAT":"Absent at","ABSENT":"Absent","NOSTUDENTSADDEDTOTHISSTOP":"No students added to this stop","ROUTE":"Route","SUPERVISOR":"Supervisor","DRIVER":"Driver","LOADING":"Loading...","BASEBETWEEN":"Base between 2 and 36","STARTEDAT":"Started at","CLOSEDAT":"Closed at","EXPECTEDTOSTART":"Expected To Start..","FUELCOST":"Fuel Cost","TOTALCOST":"Total Cost","IDLECOST":"Idle Cost","AED":"AED","FACTORS":"Factors","COST":"Cost","TIME":"Time","FORMULA":"Formula","RESULT":"Result","INSURANCE":"Insurance","VECHICLEPAYMENTS":"Vechicle Payments","REGISTRATION":"Registration","INSPECTION":"Inspection","VEHICLEPERMIT":"Vehicle Permit","VEHICLEDEPRECIATION":"Vehicle Depreciation","FUELCONSUMPTION":"Fuel Consumption","OILCHANGE":"Oil Change","IDLING":"Idling","TIRES":"Tires","WEARTEAR":"Wear / Tear","MAP":"Map","EXPENDITURE":"Expense","TRIPDISTANCE":"Trip Distance:","TRIPIDLING":"Trip Idling:","COMPLETEDTRIPS":"Completed Trips:","TRIP":"trip | trips","GUARDIAN":"Guardian","NAANI":"Supervisor","REPORTEDBY":"Reported-By"},"ar":{"ROUTETRIP":":خط السير","STOP":"توقف","TO":"إلى","SCHOOL":"المدرسة","HOME":"البيت","ESTIMATEDARRIVALTIME":"الوقت المتوقع للوصول","MIN":"دقيقة","CHECKEDINAT":"تسجيل الوصول في","CHECKEDOUTAT":"تسجيل الخروج في","ABSENTAT":"متغيب في","ABSENT":"متغيب","NOSTUDENTSADDEDTOTHISSTOP":"لم يتم اضافة أي طالب لهذا التوقف","ROUTE":"خط السير","SUPERVISOR":"المشرفة","DRIVER":"سائق","LOADING":"جار التحميل...","BASEBETWEEN":"Base between 2 and 36","STARTEDAT":"بدأت في","CLOSEDAT":"مغلق في","NOTCLOSINGYET":"لم يتم الإغلاق بعد","EXPECTEDTOSTART":"...من المتوقع البدء ","FUELCOST":"تكلفة السفر هو","TOTALCOST":"التكلفة الإجمالية","IDLECOST":"تكلفة الوقت الضائع","AED":"درهم","FACTORS":"عوامل","COST":"التكلفة","TIME":"الزمن","FORMULA":"صيغة","RESULT":"النتيجة","INSURANCE":"التامين","VECHICLEPAYMENTS":"تسديدات المركبة","REGISTRATION":"التسجيل","INSPECTION":"التفتيش","VEHICLEPERMIT":"ترخيص المركبات","VEHICLEDEPRECIATION":"نقص قيمة المركبات","FUELCONSUMPTION":"استهلاك الوقود","OILCHANGE":"تغيير الزيت","IDLING":"فتور المحرك","TIRES":"الإطارات","WEARTEAR":"استهلاك القيمة بالاستعمال","MAP":"خريطة","EXPENDITURE":"المصروفات","TRIPDISTANCE":":مسافة الرحلة","TRIPIDLING":" فترات فتور المحرك","COMPLETEDTRIPS":":رحلات المكتملة","TRIP":"رحلة | الرحلات","GUARDIAN":"ولي الامر","NAANI":"مشرفة","REPORTEDBY":"تم عمل تقرير بواسطة"}}')
}


/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"VIOLATIONTYPE":"Violation Type","VIOLATIONS":"Violations","CHOOSEFILTERBY":"Choose Filter By","FILTERBYBUS":"Filter by bus","FILTERBYTYPE":"Filter by type","PICKARANGE":"Pick a range","LOADING":"Loading...","ROUTE":"Route","DRIVER":"Driver","BUS":"Bus","VIOLATION":"Violation","STICK":"Stick","UNSTICK":"Unstick","SHOW":"Show","HIDE":"Hide","DATE":"Date","SMOKEDETECTED":"Smoke detected","PANICBUTTONPRESSED":"Panic button pressed","HIGHSPEEDALARM":"High speed alarm","violation_video_loss":"Lost video signal","violation_motion_detection":"Motion detected","violation_blind":"Camera {pos} is blind","violation_storage":"Storage error @3 on disk @1","violation_user_1":"Smoke detected","violation_user_2":"Airflow-Sensor","violation_user_3":"Inner Temperature","violation_user_4":"Inner Humidity","violation_user_5":"Bus stalled","violation_user_6":"User alarm 6","violation_user_7":"User alarm 7","violation_user_8":"User alarm 8","violation_user_9":"User alarm 9","violation_user_10":"User alarm 10","violation_emergency":"Panic button pressed","violation_low_speed":"Low speed alarm (@1 km/h)","violation_high_speed":"High speed alarm (@1 km/h)","violation_low_voltage":"Low voltage (@1 v)","violation_acceleration":"Acceleration alarm @1","violation_header":"Service Level Agreement Violations and Alarms"},"ar":{"VIOLATIONTYPE":"نوع الانتهاك","VIOLATIONS":"الانتهاكات","CHOOSEFILTERBY":"اختر الفلتر المطلوب","FILTERBYBUS":"تصفية حسب الحافلة","FILTERBYTYPE":"تصفية حسب النوع","PICKARANGE":" اختيار مجموعة","LOADING":"جار التحميل...","ROUTE":"طريق","DRIVER":"سائق","BUS":"حافلة","VIOLATION":"انتهاك","STICK":"لصق","UNSTICK":"فك","SHOW":"عرض","HIDE":"إخفاء","DATE":"تاريخ","SMOKEDETECTED":"تم الكشف عن الدخان","PANICBUTTONPRESSED":"تم الضغط على زر الهلع","HIGHSPEEDALARM":"تنبيه السرعة العالية","VIEWINCIDENTDETAILS":"عرض تفاصيل الحادث","WRITEAMESSAGE":"اكتب رسالة","violation_video_loss":"فقدت إشارة الفيديو","violation_motion_detection":"تم اكتشاف حركة","violation_blind":"عمياء {POS } الكاميرا","violation_storage":"خطأ في التخزين @ 3 على القرص @ 1","violation_user_1":"تم الكشف عن الدخان","violation_user_2":"  استشعار تدفق الهواء ","violation_user_3":"درجة الحرارة الداخلية","violation_user_4":"الرطوبة الداخلية","violation_user_5":"توقفت الحافلة ","violation_user_6":" 6 تنبيه المستخدم ","violation_user_7":"7 تنبيه المستخدم","violation_user_8":"8 تنبيه المستخدم","violation_user_9":" 9 تنبيه المستخدم","violation_user_10":" 10 تنبيه المستخدم","violation_emergency":"تم الضغط على زر الهلع","violation_low_speed":"( إنذار انخفاض السرعة ( @ 1 كم / ساعة","violation_high_speed":"(@ 1 كم / ساعة) إنذار ارتفاع السرعة ","violation_low_voltage":"( V انخفاض الجهد (@ 1","violation_acceleration":"1 @ تنبيه السرعة","violation_header":"اتفاقية مستوى الخدمة الانتهاكات والإنذارات"}}')
}


/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"LOADING":"Loading...","SCHOOLCONFIGURATION":"School Configuration","UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","TYPESOFSCHOOL":"Types of School","PUBLIC":"Public","PRIVATE":"Private","GENDERDIVERSITY":"Gender Diversity","MALE":"Male","FEMALE":"Female","MIXED":"Mixed","NAME":"Name","NAME(ARABIC)":"Name (Arabic)","COUNTRY":"Country","TIMEZONE":"Time Zone","PLEASESELECTYOURZONE":"please select your zone","PLEASESELECTYOURTIMEZONE":"please select your time zone","DATEFORMAT":"Date Format","DAYMONTHYEAR":"Day/Month/Year","MONTHDAYYEAR":"Month/Day/Year","SELECTDATEFORMAT":"Select Date Format","ADDRESS":"Address","SEARCHADDRESS":"Search Address","COORDINATES":"Coordinates","LATITUDE":"Latitude","LONGITUDE":"Longitude","CONFIRM":"Confirm","BUILDINGNUMBER":"Building Number","STREETADDRESS":"Street Address","AREA":"Area","ZONE":"Zone","SECTOR":"Sector","CITY":"City","STATE":"State","ZIPCODE":"Zip Code","CONTACTS":"Contacts","SEARCHUSERSNAME":"Search user\u0027s name","BUSCOMPANYEMAIL":"Bus Company Email","BUSCOMPANYPHONENUMBER":"Bus Company Phone Number","LOCALPOLICEEMAIL":"Local Police Email","LOCALPOLICEPHONENUMBER":"Local Police Phone Number","SCHOOLEMAIL":"School Email","SCHOOLPHONENUMBER":"School Phone Number","GRADES":"Grades","GRADE":"Grade","AGE":"Age","ADDGRADE":"Add Grade","ADDNEWCLASS":"Add New Class","AVERAGEAGE":"Average Age","EDITGRADE":"Edit Grade","TIMINGS":"Timings","GATEOPENTIME":"Gate Open Time","CLASSSTARTTIME":"Class Start Time","LATEARRIVALTIME":"Late Arrival Time","SELECTMINUTES":"Select Minutes","MIN":"min","EARLYDEPARTURETIME":"Early Departure Time","CLASSENDTIME":"Class End Time","GATECLOSETIME":"Gate Close Time","ACADEMICTERMS":"Academic Terms","ADDNEXTACADEMICYEAR":"Add Next Academic Year","TERMNAME":"Term Name","STARTDATE":"Start Date","ENDDATE":"End Date","ADDNEWTERM":"Add new term","YEAR":"Year","STARTINGDATE":"Starting Date","ENDINGDATE":"Ending Date","SHOWNOTIFICATIONS":"Show Notifications","ENABLE":"Enable","DISABLE":"Disable","NOTIFICATIONS":"Notifications","ACTIVITIES":"Activities","ACTIVITYNAME":"Activity Name","ADDACTIVITY":"Add Activity","EDITACTIVITY":"Edit Activity","SUNDAY":"Sunday","MONDAY":"Monday","TUESDAY":"Tuesday","WEDNESDAY":"Wednesday","THURSDAY":"Thursday","FRIDAY":"Friday","SATURDAY":"Saturday","PICKADATE":"Pick a date","DAYSINSERVICE":"Days in Service","STARTTIME":"Start time","ENDTIME":"End time","DELETEACTIVITY":"Delete Activity","SELECTDAYS":"Select Days","DELETEGRADE":"Delete Grade","GRADEASSIGNEDTOSTUDENT":"This grade has been assigned to student(s)","ACTIVITYASSIGNEDTOSTUDENT":"This activity has been assigned to student(s)","ERROR":"Error","CLOSE":"Close","ISREQUIRED":"is required.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","ALREADYEXISTED":"already existed.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","INVALIDPHONENO":"is invalid phone number.","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","THRESHOLD":"Threshold For","EXTRAFEATURES":"Extra Features","INCLUDEWIOTBOX":"WIOT Box","DELAYEDSTARTTIME":"Delayed Start Time","MAXIMUMDURATION":"Maximum Duration","STANDINGINFRONTCHILDHOUSE":"Standing Infront of Child House","DROPPEDOFINWRONGPLACE":"Dropped-of In Wrong Place","METER":"Meter","SELECTMETERS":"Select Meters","PARENTMESSAGES":"Parent App Messages","CHECKALL":"Check all","MESSAGES":"Messages","MSGTOPARENT":"Message to Parents","REPORTABSENCE":"Report Absence","EMAILTEACHER":"Email Teacher","CALLDRIVER":"Call Driver","CALLNAANY":"Call Nanny","MSGTONAANY":"Message to Nanny","CALLSCHOOL":"Call School","EMAILSCHOOL":"Email School"},"ar":{"LOADING":"جار التحميل...","SCHOOLCONFIGURATION":"تكوين المدرسة","UPLOADIMAGE":"تحميل الصور","SAVEIMAGE":"احفظ الصورة","TYPESOFSCHOOL":"نوع المدارس","PUBLIC":"عامة","PRIVATE":"خاصة","GENDERDIVERSITY":"التنوع بين الجنسين","MALE":" ذكر","FEMALE":"أنثى","MIXED":"مختلط","NAME":"الإسم","NAME(ARABIC)":"الإسم (عربي)","COUNTRY":"البلد","TIMEZONE":"المناطق الزمنية","PLEASESELECTYOURZONE":"الرجاء تحديد منطقتك","PLEASESELECTYOURTIMEZONE":"يرجى تحديد المنطقة الزمنية","DATEFORMAT":"صيغة التاريخ","DAYMONTHYEAR":" يوم/شهر/سنة","MONTHDAYYEAR":" شهر/ يوم /سنة","SELECTDATEFORMAT":"حدد تنسيق التاريخ","ADDRESS":"العنوان","SEARCHADDRESS":"بحث العنوان","COORDINATES":"إحداثيات","LATITUDE":"الخط العامودي","LONGITUDE":"الخط الطولي","CONFIRM":"تأكد","BUILDINGNUMBER":"رقم المبنى","STREETADDRESS":"عنوان الشارع","STREETNUMBER":"رقم الشارع","AREA":"النطقة","ZONE":"الحوض","SECTOR":"القسم","CITY":"المدينة","STATE":"الامارة","ZIPCODE":"الرمز البريدي","CONTACTS":"جهات الاتصال","SEARCHUSERSNAME":"ابحث عن إسم المستخدم","BUSCOMPANYEMAIL":"البريد الإلكتروني لشركة الحافلات","BUSCOMPANYPHONENUMBER":"رقم هاتف شركة الحافلات","LOCALPOLICEEMAIL":"البريد الإلكتروني للشرطة المحلية","LOCALPOLICEPHONENUMBER":"رقم هاتف الشرطة المحلية","SCHOOLEMAIL":"البريد الإلكتروني للمدرسة","SCHOOLPHONENUMBER":"رقم هاتف المدرسة","GRADES":"درجات","GRADE":"درجة","AGE":"السن","ADDGRADE":"إضافة الصف","ADDNEWCLASS":"إضافة صف جديد","AVERAGEAGE":"متوسط ​​العمر","EDITGRADE":"تحرير الصف","TIMINGS":"توقيت","GATEOPENTIME":"وقت فتح البوابة","CLASSSTARTTIME":"وقت بداية الصف","LATEARRIVALTIME":"وقت الوصول المتأخر","SELECTMINUTES":"حدد الوقت","MIN":"الدقائق","EARLYDEPARTURETIME":"وقت المغادرة المبكر","CLASSENDTIME":"وقت نهاية الصف","GATECLOSETIME":"وقت إغلاق البوابة","ACADEMICTERMS":"السنة الأكاديمية","ADDNEXTACADEMICYEAR":"إضافة السنة الدراسية التالية","TERMNAME":"إسم الفترة الدراسية","STARTDATE":"تاريخ البدء","ENDDATE":"تاريخ الانتهاء","ADDNEWTERM":"إضافة موسم جديد","YEAR":"عام","STARTINGDATE":"تاريخ البدء","ENDINGDATE":"تاريخ الانتهاء","SHOWNOTIFICATIONS":"إظهار الإشعارات","ENABLE":"مكن","DISABLE":"تعطيل","NOTIFICATIONS":"إشعارات","ACTIVITIES":"أنشطة","ACTIVITYNAME":"اسم النشاط","ADDACTIVITY":"إضافة نشاط","EDITACTIVITY":"تحرير نشاط","SUNDAY":"الأحد","MONDAY":"الإثنين","TUESDAY":"الثلاثاء","WEDNESDAY":"الأربعاء","THURSDAY":"الخميس","FRIDAY":"الجمعة","SATURDAY":" السبت","PICKADATE":"اختر تاريخا","DAYSINSERVICE":"أيام الخدمة","STARTTIME":"بداية الخدمة","ENDTIME":"نهاية الخدمة","DELETEACTIVITY":"حذف نشاط","SELECTDAYS":"حدد الأيام","DELETEGRADE":"حذف الدرجة","GRADEASSIGNEDTOSTUDENT":" تم تعيين هذا الصف للطالب","ACTIVITYASSIGNEDTOSTUDENT":"تم تعيين هذا النشاط للطالب","ERROR":"خطأ","CLOSE":"أغلق","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","INVALIDPHONENO":".رقم هاتف غير صالح","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","EXTRAFEATURES":"ميزات اضافية","INCLUDEWIOTBOX":"WIOT Box","PARENTMESSAGES":"رسائل تطبيق اولياء الامور","CHECKALL":"تحقق من الكل","MESSAGES":"الرسائل","MSGTOPARENT":"رسالة إلى أولياء الأمور","REPORTABSENCE":"تقرير الغياب","EMAILTEACHER":"أرسل رسالة إلى المعلم","CALLDRIVER":"اتصل بالسائق","CALLNAANY":"اتصل بالمشرفة","MSGTONAANY":"رسالة إلى المشرفة","CALLSCHOOL":"اتصل بالمدرسة","EMAILSCHOOL":"البريد الإلكتروني للمدرسة"}}')
}


/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"GUARDIANS":"Guardians","MANAGEGUARDIAN":"Manage Guardian","CHOOSEFILTERBY":"Choose Filter By","NAME":"Name","RELATION":"Relation","FATHER":"Father","MOTHER":"Mother","GUARDIAN":"Guardian","PERSONID":"Person ID","STUDENTS":"Students","EDITPERSON":"Edit Person","ADDNEWGUARDIAN":"Add New Guardian","SEARCHGUARDIAN":"Search Guardian","SEARCHBYRELATION":"Search By Relation","LOADING":" Loading...","MANAGEGUARDIANS":"Manage Guardians","UPLOADCSVFILE":"Upload CSV File","SEARCHBYSTATUS":"Search by status","ACTIVE":"Active","INACTIVE":"Inactive","STATUS":"Status","SENDMESSAGE":"Send Message","ACTIVATEPERSON":"Activate Person","DEACTIVATEPERSON":"Deactivate Person","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISSTUDENT":"restore this student?","DEACTIVATETHISSTUDENT":"deactivate this student?","CANCEL":"Cancel","CONFIRM":"Confirm","GUARDIANNAME":"Guardian Name","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","NATIONALITY":"Nationality","FIRSTNAME":"First Name","LASTNAME":"Last Name","STUDENTID":"Student ID","EMAILADDRESS":"Email Address","GENDER":"Gender","IDENTIFICATIONNUMBER":"Identification Number","IDEXPIRATIONDATE":"ID Expiration Date","MOBILEPHONE":"Mobile Phone","LANDLINEPHONE":"LandlinePhone","GUARDIANCANNOTBEDELETED":"Guardian cannot be deleted, has assigned students!","GUARDIANHASNOSTUDENTS":"Guardian has no students","GUARDIANHASBEEN":"Guardian has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","GUARDIANCANNOTBEENDELETED":"Guardian cannot been deleted!","PRIMARYCONTACT":"Primary Contact","MOBILENO":"Mobile No","SEARCHPERSONID":"Search PersonID","SEARCHMOBILENO":"Search Mobile No"},"ar":{"GUARDIANS":"ولي الامر","MANAGEGUARDIAN":"ادارة أولياء الامور","CHOOSEFILTERBY":"اختر الفلتر المطلوب","NAME":"الاسم","RELATION":"الصلة","FATHER":"الاب","MOTHER":"الام","GUARDIAN":"ولي الامر","PERSONID":"الرقم الشخصي","STUDENTS":"الطلاب","EDITPERSON":"تحديث الشخص","ADDNEWGUARDIAN":"اضافة ولي الامر جديد","SEARCHGUARDIAN":"ابحث عن ولي الامر","SEARCHBYRELATION":"البحث بالصلة","LOADING":"جار التحميل...","MANAGEGUARDIANS":"إدارة الأولياء","UPLOADCSVFILE":"تحميل ملف CSV","SEARCHBYSTATUS":"البحث حسب الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","STATUS":"الحالة","SENDMESSAGE":"إرسال رسالة","ACTIVATEPERSON":"تفعيل الشخص","DEACTIVATEPERSON":"إلغاء تفعيل الشخص","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISSTUDENT":"استعادة هذا الطالب؟","DEACTIVATETHISSTUDENT":"إلغاء تفعيل هذا الطالب ؟","CANCEL":"إلغاء","CONFIRM":" تاكيد ","GUARDIANNAME":"إسم ولي الأمر","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","NATIONALITY":"الجنسية","FIRSTNAME":"الأسم الأول","LASTNAME":"اسم العائلة","STUDENTID":"هوية الطالب","EMAILADDRESS":"عنوان البريد الإلكتروني","GENDER":"الجنس","IDENTIFICATIONNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","MOBILEPHONE":"الهاتف المحمول","LANDLINEPHONE":"الهاتف الثابت","GUARDIANCANNOTBEDELETED":"لا يمكن حذف ولي الأمر،له طلاب معينين!","GUARDIANHASNOSTUDENTS":"ليس لولي الأمر أي طلاب","GUARDIANHASBEEN":"وكان الجارديان","RESTORED":"رمم!","DEACTIVATED":"معطلة!","GUARDIANCANNOTBEENDELETED":"الجارديان لا يمكن حذف!","PRIMARYCONTACT":"Primary Contact"}}')
}


/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"GUARDIANS":"Guardians","MANAGEGUARDIAN":"Manage Guardian","CHOOSEFILTERBY":"Choose Filter By","NAME":"Name","RELATION":"Relation","FATHER":"Father","MOTHER":"Mother","GUARDIAN":"Guardian","PERSONID":"Person ID","FIRSTNAME":"First Name","FATHERNAME":"Father Name","LASTNAME":"Last Name","STUDENTSRELATIONSHIP":"Students Relationship","LOADING":"Loading...","UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","IDNUMBER":"Id Number","IDEXPIRATIONDATE":"ID Expiration Date","PICKADATE":"Pick a date","NATIONALITY":"Nationality","PLEASESELECTNATIONALITY":"Please Select Nationality","MOBILEPHONE":"Mobile No","CONTACTINFO":"Contact Info","EMAILADDRESS":"Email Address","LANDLINEPHONE":"Landline Phone","SEARCHSTUDENTNAME":"Search Student Name","MAKESUREYOUSELECTEDRELATION":"Make sure you selected relation!","PRIMARYCONTACT":"Primary Contact","PRIMARY":"Primary","NOT":"Not","MESSAGES":"Messages","ERROR":"Error","CLOSE":"Close","STUDENT":"Student","ALREADYINTHELIST":"is already in the list","AVATARPICTUREMUSTBEJPGFORMAT":"Avatar picture must be JPG format!","AVATARPICTURESIZECANNOTEXCEED":"Avatar picture size can not exceed 2MB!","ISREQUIRED":"is required.","ISNOTAVALIDFORMAT":"is not a valid format. Only letters, spaces and dashes are allowed.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","ALREADYEXISTED":"already existed.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","ISREQUIREDTOADDSTUDENT":"is required to add at least 1 student.","INVALIDPHONENO":"is invalid phone number.","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","MOBILENO":"Mobile No"},"ar":{"GUARDIANS":"ولي الامر","MANAGEGUARDIAN":"ادارة أولياء الامور","CHOOSEFILTERBY":"اختر الفلتر المطلوب","NAME":"الاسم","RELATION":"الصلة","FATHER":"الاب","MOTHER":"الام","GUARDIAN":"ولي الامر","PERSONID":"الرقم الشخصي","FIRSTNAME":"الاسم الاول","FATHERNAME":"اسم الاب","LASTNAME":"الاسم العائلي","STUDENTSRELATIONSHIP":"صلة القرابة للطالب","LOADING":"جار التحميل...","UPLOADIMAGE":"تحميل الصور","SAVEIMAGE":"احفظ الصورة","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":" الاسم العائلي (عربي) ","IDNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","PICKADATE":"اختر تاريخا","NATIONALITY":"الجنسية","PLEASESELECTNATIONALITY":"يرجى تحديد الجنسية","MOBILEPHONE":"الهاتف المحمول","CONTACTINFO":"معلومات الاتصال","EMAILADDRESS":"عنوان البريد الإلكتروني","LANDLINEPHONE":"الهاتف الثابت","SEARCHSTUDENTNAME":"ابحث عن إسم الطالب","MAKESUREYOUSELECTEDRELATION":"تأكد من أنك اخترت الصلة","PRIMARYCONTACT":" المسؤول الرئيسي","PRIMARY":"الأساسي","NOT":"غير","MESSAGES":"رسائل","ERROR":"خطأ","CLOSE":"أغلق","STUDENT":"طالب","ALREADYINTHELIST":"بالفعل في القائمة","AVATARPICTUREMUSTBEJPGFORMAT":" JPG يجب أن تكون الصورة الرمزية على شكل ","AVATARPICTURESIZECANNOTEXCEED":"2M حجم الصورة الرمزية لا يمكن أن يتجاوز","ISNOTAVALIDFORMAT":".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","ALREADYEXISTED":".موجودة بالفعل","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ISREQUIREDTOADDSTUDENT":".مطلوب إضافة طالب واحد على الأقل","INVALIDPHONENO":".رقم هاتف غير صالح","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","MOBILENO":"رقم المحمول"}}')
}


/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","NATIONALITY":"Nationality","DATEOFBIRTH":"Date of Birth","STUDENTS":"Students","MANAGESTUDENTS":"Manage Students","CHOOSEFILERBY":"Choose Filer By","NAME":"Name","STATUS":"Status","GRADE":"Grade","CLASS":"Class","ADDNEWSTUDENT":"Add New Student","FIRSTNAME":"First Name","LASTNAME":"Last Name","IDCARD":"ID Card","PRINTCARDS":"Print Cards","ACTIVE":"Active","INACTIVE":"Inactive","MARKABSENCE":"Mark Absence","SENDMESSAGE":"Send Message","EDITSTUDENT":"Edit Student","ISSUEATTENDANCETAG":"Issue Attendance Tag","DEACTIVATESTUDENT":"Deactivate Student","CANCEL":"Cancel","UPLOADCSVFILE":"Upload CSV File","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISSTUDENT":"restore this student?","DEACTIVATETHISSTUDENT":"deactivate this student?","PRINTALLCARDS":"Print All Cards","CHECKTAGID":"Check Tag ID","SEARCHSTUDENTNAME":"Search student name","SEARCHSTUDENTID":"Search student id","FILTERBYROUTE":"Filter by route","FILTERBYGRADE":"Filter by grade","FILTERBYCLASS":"Filter by class","FILTERBYSTATUS":"Filter by status","LOADING":"Loading...","STUDENTID":"Student ID","ROUTENAME":"Route Name","ACTIVATESTUDENT":"Activate Student","CONFIRM":"Confirm","STUDENTIDCARD":"Student ID Card","SCHOOLCONTACT":"School Contact","PRINT":"Print","STUDENTHASBEENASSIGNEDTOROUTE":"Student has been assigned to route","STUDENTHASNOGUARDIAN":"Student has no guardian","STUDENTNAME":"Student Name","AREA":"Area","ZONE":"Zone","SECTOR":"Sector","CITY":"City","STATE":"State","ZIPCODE":"Zip Code","LAT":"Latitude","LNG":"Longitude","SET":"Set","HOUSENUMBER":"House Number","GENDER":"Gender","ADDRESS":"Address","STUDENTHASBEEN":"Student has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","STUDENTCANNOTBEENDELETED":"Student cannot been deleted!","ASSIGNEDTOBUS":"Assigned to bus","ASSIGNED":"Assigned","NOTASSIGNED":"Not assigned"},"ar":{"FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":" الاسم العائلي (عربي) ","NATIONALITY":"الجنسية","DATEOFBIRTH":"تاريخ الميلاد","STUDENTS":"الطلاب","MANAGESTUDENTS":"ادارة الطلاب","CHOOSEFILERBY":"اختر الفلتر المطلوب","NAME":"الاسم","STATUS":"الحالة","GRADE":"الدرجة","CLASS":"الصف","ADDNEWSTUDENT":"اضافة طالب جديد","FIRSTNAME":"الأسم الأول","LASTNAME":"اسم العائلة","IDCARD":"بطاقة التعريف","PRINTCARDS":" طبع البطاقات ","ACTIVE":"مفعل","INACTIVE":"غير مفعل","MARKABSENCE":"تسجيل الغياب","SENDMESSAGE":" إرسال رسالة","EDITSTUDENT":"تحرير الطالب","ISSUEATTENDANCETAG":"إصدار بطاقة الحضور ","DEACTIVATESTUDENT":"إيقاف التفعيل","CANCEL":"الغاء","UPLOADCSVFILE":"تحميل ملف CSV","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISSTUDENT":" استعد هذا الطالب","DEACTIVATETHISSTUDENT":"تعطيل هذا الطالب","PRINTALLCARDS":" طباعة جميع البطاقات ","CHECKTAGID":"التحقق من الشارة","SEARCHSTUDENTNAME":" ابحث عن اسم الطالب","SEARCHSTUDENTID":" ابحث عن رقم الطالب","FILTERBYROUTE":"اختر حسب خط السير","FILTERBYGRADE":" اختر حسب الدرجة","FILTERBYCLASS":"اختر حسب الصف","FILTERBYSTATUS":" اختر حسب الحالة","LOADING":"جار التحميل...","STUDENTID":" هوية الطالب","ROUTENAME":"اسم المسار","ACTIVATESTUDENT":" تفعيل الطالب","CONFIRM":" تاكيد ","STUDENTIDCARD":" بطاقة هوية الطالب","SCHOOLCONTACT":" الاتصال بالمدرسة","PRINT":" طبع","STUDENTHASBEENASSIGNEDTOROUTE":" تم تعيين الطالب إلى الطريق","STUDENTHASNOGUARDIAN":"ليس لطالب ولي أمر","STUDENTNAME":" أسم الطالب","AREA":" المنطقة","ZONE":"الحوض","SECTOR":"القسم","CITY":"المدينة","STATE":"الامارة","ZIPCODE":"الرمز البريدي","LAT":"الخط العامودي","LNG":"الخط الطولي","SET":"تثبيت","HOUSENUMBER":"رقم المنزل","GENDER":"الجنس","ADDRESS":" العنوان","STUDENTHASBEEN":"كان الطالب","RESTORED":"رمم!","DEACTIVATED":"معطلة!","STUDENTCANNOTBEENDELETED":"لا يمكن حذف الطالب!","ASSIGNEDTOBUS":"مشارك في الحافلة","ASSIGNED":"مشارك","NOTASSIGNED":"غيرمشارك"}}')
}


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"STUDENTS":"Students","MANAGESTUDENT":"Manage Student","NAME":"Name","STATUS":"Status","GRADE":"Grade","CLASS":"Class","ADDNEWSTUDENT":"Add New Student","FIRSTNAME":"First Name","LASTNAME":"Last Name","IDCARD":"ID Card","ACTIVE":"Active","INACTIVE":"Inactive","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","NATIONALITY":"Nationality","DATEOFBIRTH":"Date of Birth","STUDENTSCHOOLID":"Student School ID","ATTENDANCETAGID":"Attendance Tag ID","RELATION":"Relation","PRIMARYCONTACT":"Primary Contact","SEARCHADDRESS":"Search Address","LAT":"Latitude","LNG":"Longitude","SET":"Set","HOUSENUMBER":"House Number","STREETNUMBER":"Street Number","AREA":"Area","ZONE":"Zone","SECTOR":"Sector","CITY":"City","STATE":"State","ZIPCODE":"Zip Code / Postal Code","STUDENTADDRESSLOCATION":"Student Address Location","NORELATIVESHASBEENADDED":"No relatives has been added","STREETADDRESS":"Street Address","LOADING":"Loading...","SAVING":"Saving..","GENDER":"Gender","MALE":"Male","FEMALE":"Female","SAVEIMAGE":"Save Image","UPLOADIMAGE":"Upload Image","PICKADATE":"Pick a date","SELECTNATIONALITY":"Select Nationality","SELECTGRADE":"Select Grade","SELECTCLASS":"Select Class","CLICKONSCAN":"Click on scan","SCAN":"Scan","ADDRESS":"Address","CONFIRM":"Confirm","GUARDIANS":"Guardians","SEARCHGUARDIANNAME":"Search guardian name","COORDINATES":"Coordinates","MESSAGES":"Messages","ROUTES":"Routes","ABSENCES":"Absences","ERROR":"Error","CLOSE":"Close","BASEBETWEEN":"Base between 2 and 36","PERSONALREADYINTHELIST":"Person already in the list","STUDENTCANNOTHAVEFATHERSORMOTHERS":"Student can not have 2 fathers or mothers","OK":"Ok","AVATARPICTUREMUSTBEJPGFORMAT":"Avatar picture must be JPG format!","AVATARPICTURESIZECANNOTEXCEED":"Avatar picture size can not exceed 2MB!","ISREQUIRED":"is required.","ISREQUIREDLATLNG":"is required latitude & longitude.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","ISNOTAVALIDFORMAT":"is not a valid format. Only letters, spaces and dashes are allowed.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","MUSTBEDECIMAL":"must be decimal.","MUSTBENUMERIC":"must be numeric.","ALREADYEXISTED":"already existed.","MONITOR":"Monitor","FATHER":"Father","MOTHER":"Mother","GUARDIAN":"Guardian","FILEISTOOLARGERMAXFILEIS":"File is too larger max file is {size}","BUSNUMBER":"Bus Number","DRIVER":"Driver","SUPERVISOR":"Supervisor","EDITROUTE":"Edit Route","ACTIVITIES":"Activities","ACTIVITYNAME":"Activity Name","ADDACTIVITY":"Add Activity","EDITACTIVITY":"Edit Activity","DELETEACTIVITY":"Delete Activity","SELECTACTIVITY":"Select Activity","SEEMSTOIDENTICAL":"Seems that location is identical to center location."},"ar":{"STUDENTS":"الطلاب","MANAGESTUDENT":"ادارة ","NAME":"الاسم","STATUS":"الحالة","GRADE":"الدرجة","CLASS":"الصف","ADDNEWSTUDENT":"اضافة طالب جديد","FIRSTNAME":"الإسم الأول","LASTNAME":"اسم العائلة","IDCARD":"بطاقة التعريف","ACTIVE":"مفعل","INACTIVE":"غير مفعل","FIRSTNAME(ARABIC)":"الإسم الأول (عربي)","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":" إسم الأب (عربي)","LASTNAME(ARABIC)":" إسم العائلة (عربي)","NATIONALITY":"الجنسية","DATEOFBIRTH":"تاريخ الميلاد","STUDENTSCHOOLID":"رقم الطالب المدرسي","ATTENDANCETAGID":"رقم البطاقة الاكترونية","RELATION":"الصلة","PRIMARYCONTACT":"ولي الامر الرئيسي","SEARCHADDRESS":"بحث العنوان","LAT":"الخط العامودي","LNG":"الخط الطولي","SET":"تثبيت","HOUSENUMBER":"رقم المنزل","STREETNUMBER":"رقم الشارع","AREA":"النطقة","ZONE":"الحوض","SECTOR":"القسم","CITY":"المدينة","STATE":"الامارة","ZIPCODE":"الرمز البريدي","STUDENTADDRESSLOCATION":" موقع عنوان الطالب","NORELATIVESHASBEENADDED":"ولم يضف أي أقارب","STREETADDRESS":"عنوان الشارع","LOADING":"جار التحميل...","SAVING":"احتفاظ","GENDER":"جنس","MALE":"ذكر","FEMALE":"أنثى","SAVEIMAGE":"احفظ الصورة","UPLOADIMAGE":"تحميل الصور","PICKADATE":"اختر تاريخا","SELECTNATIONALITY":"اختيار الجنسية","SELECTGRADE":"حدد الصف","SELECTCLASS":"حدد الدرجة","CLICKONSCAN":"انقر على المسح الضوئي","SCAN":"تفحص","ADDRESS":"العنوان","CONFIRM":"تأكد","GUARDIANS":"أولياء الأمور","SEARCHGUARDIANNAME":"ابحث عن إسم الولي","COORDINATES":"إحداثيات","MESSAGES":"رسائل","ROUTES":"خطوط السير","ABSENCES":"الغياب","ERROR":"خطأ","CLOSE":"أغلق","BASEBETWEEN":"قاعدة بين 2 و36","PERSONALREADYINTHELIST":"شخص موجود بالفعل في القائمة","STUDENTCANNOTHAVEFATHERSORMOTHERS":"الطالب لا يمكن أن يكون له أبوين أو 2 أمهات","OK":"حسنا","AVATARPICTUREMUSTBEJPGFORMAT":" JPG يجب أن تكون الصورة الرمزية على شكل ","AVATARPICTURESIZECANNOTEXCEED":"2M حجم الصورة الرمزية لا يمكن أن يتجاوز","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ISNOTAVALIDFORMAT":".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","MUSTBEDECIMAL":"يجب أن يكون عشري","MUSTBENUMERIC":"يجب أن تكون رقمية","ALREADYEXISTED":".موجودة بالفعل","MONITOR":"مراقب","FATHER":"الاب","MOTHER":"الام","GUARDIAN":"ولي الامر","FILEISTOOLARGERMAXFILEIS":"الملف أكبر من الحد الأقصى للملف {size}","BUSNUMBER":"رقم الحافلة","DRIVER":"السائق","SUPERVISOR":"المشرفة","EDITBUS":"تحرير الحافلة","ACTIVITIES":"أنشطة","ACTIVITYNAME":"اسم النشاط","ADDACTIVITY":"إضافة نشاط","EDITACTIVITY":"تحرير نشاط","DELETEACTIVITY":"حذف نشاط","SELECTACTIVITY":"اختيار نشاط","SEEMSTOIDENTICAL":".يبدو أن الموقع مطابق لموقع المدرسة","ISREQUIREDLATLNG":".مطلوب خطوط الطول والعرض","EDITROUTE":"تحرير خط السير"}}')
}


/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"BUSES":"Buses","MANAGEBUSES":"Manage Buses","ADDNEWBUS":"Add New Bus","BUSNUMBER":"Bus Number","MAKE":"Make","MODEL":"Model","YEAR":"Year","PLATENUMBER":"Plate Number","EXPIRATIONDATE":"Expiration Date","DOCUMENTS":"Documents","LABEL":"Label","EDITBUS":"Edit Bus","VIEW":"View","UPLOADCSVFILE":"Upload CSV File","CHOOSEFILTERBY":"Choose Filer By","SEARCHMODEL":"Search Model","SEARCHPLATE":"Search Plate","SEARCHBUS":"Search Bus","LOADING":"Loading...","SEATS":"Seats","STATUS":"Status","ACTIVE":"Active","INACTIVE":"Inactive","DEACTIVATEBUS":"Deactivate Bus","ACTIVATEBUS":"Activate Bus","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISBUS":"restore this bus?","DEACTIVATETHISBUS":"deactivate this bus?","CANCEL":"Cancel","CONFIRM":"Confirm","BUSCANNOTBEDEACTIVATED":"Bus cannot be deactivated! Already assigned to a route.","BUSHASBEEN":"Bus has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","BUSCANNOTBEENDELETED":"Bus cannot been deleted!","ASSIGNEDTOBUS":"Assigned to route","ASSIGNED":"Assigned","NOTASSIGNED":"Not assigned","ROUTENAME":"Route Name","FILTERBYROUTE":"Filter by route"},"ar":{"BUSES":"الحافلات","MANAGEBUSES":"إدارة الحافلات","ADDNEWBUS":"إضافة ا حافلة جديدة","BUSNUMBER":"رقم الحافلة","MAKE":"الصنع","MODEL":"النوع","YEAR":"السنة","PLATENUMBER":"رقم الوحة","EXPIRATIONDATE":"تاريخ الإنتهاء","DOCUMENTS":"الوثائق","LABEL":"الاسم","EDITBUS":"تحرير الحافلة","VIEW":"عرض","UPLOADCSVFILE":"تحميل ملف CSV","CHOOSEFILTERBY":"اختر الفلتر المطلوب","SEARCHMODEL":"ابحث عن النوع","SEARCHPLATE":"ابحث عن لوحة الترخيص","SEARCHBUS":"ابحث عن الحافلة","LOADING":"جار التحميل...","SEATS":"مقاعد","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","DEACTIVATEBUS":" تعطيل الحافلة ؟","ACTIVATEBUS":" تفعيل الحافلة ","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISBUS":"استعادة هذا الحافلة","DEACTIVATETHISBUS":"إلغاء تنشيط هذا الحافلة؟","CANCEL":"الغاء","CONFIRM":"تأكد","BUSCANNOTBEDEACTIVATED":" .لا يمكن تعطيل !الحافلة لديها طريق مخصص","BUSHASBEEN":"وكانت الحافلة","RESTORED":"رمم!","DEACTIVATED":"معطلة!","BUSCANNOTBEENDELETED":"لا يمكن حذف الحافلة!","ASSIGNEDTOBUS":"مشارك في الطريق","ASSIGNED":"مشارك","NOTASSIGNED":"غيرمشارك","ROUTENAME":"اسم المسار","FILTERBYROUTE":"اختر حسب خط السير"}}')
}


/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"BUSES":"Buses","MANAGEBUS":"Manage Bus","BUSNUMBER":"Bus Number","MAKE":"Make","MODEL":"Model","YEAR":"Year","PLATENUMBER":"Plate Number","SEATINGCAPACITY":"Seating Capacity","EXPIRATIONDATE":"Expiration Date","DOCUMENTS":"Documents","REGISTRATIONEXPIRATIONDATE":"Registration Expiration Date","LABEL":"Label","EDITBUS":"Edit Bus","VIEW":"View","LOADING":"Loading...","PICKADATE":"Pick a date","PICKAYEAR":"Pick a year","DROPFILEHEREOR":"Drop file here or","CLICKTOUPLOAD":"click to upload","JPGPNGFILES":"jpg/png files with a size less than 400kb","REGISTRATION":"Registration","INSURANCE":"Insurance","OTHER":"Other","DOCUMENTTYPE":"Document Type","NAME":"Name","FILE":"File","PREVIEW":"Preview","DELETEDOCUMENT":"Delete Document","TRIPS":"Trips","VIOLATIONS":"Violations","ISREQUIRED":"is required.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","ROUTES":"Routes","DRIVER":"Driver","SUPERVISOR":"Supervisor","EDITROUTE":"Edit Route","ERROR":"Error","CLOSE":"Close","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {len}.","TYPEERROR":"File extensions should be {len}.","EXPENSES":"Expenses","GASRATE":"Fuel Rate","OILRATE":"Oil Rate","IDLERATE":"Idling Rate","TIRERATE":"Tire Rate","ENTERRATE":"Enter rate","INAED":"(In AED)","VEHICLEPRICE":"Vehicle Price","FINANCIAL":"Financial","INSPECTION":"Inspection","VEHICLEDEPRECIATION":"Vehicle Depreciation","VEHICLEPERMIT":"Vehicle Permit","WEARTEAR":"Wear/Tear","COST":"Cost"},"ar":{"BUSES":"الحافلات","MANAGEBUS":"إدارة الحافلات","ADDNEWBUS":"إضافة ا حافلة جديدة","BUSNUMBER":"رقم الحافلة","MAKE":"الصنع","MODEL":"النوع","YEAR":"السنة","PLATENUMBER":"رقم اللوحة","SEATINGCAPACITY":"عدد المقاعد","EXPIRATIONDATE":"تاريخ الإنتهاء","DOCUMENTS":"الوثائق","REGISTRATIONEXPIRATIONDATE":"تاريخ انتهاء تسجيل الحافلة","LABEL":"الاسم","EDITBUS":"تحرير الحافلة","VIEW":"عرض","LOADING":"جار التحميل...","PICKADATE":"اختر تاريخا","PICKAYEAR":"اختيار السنة","DROPFILEHEREOR":"نزل الملف هنا أو","CLICKTOUPLOAD":"اظغط للتحميل","JPGPNGFILES":"ملفات PNG/JPG بحجم أقل من 400","ERROR":"خطأ","CLOSE":"أغلق","REGISTRATION":" التسجيل ","INSURANCE":"التامين ","OTHER":"آخر","DOCUMENTTYPE":"نوع الوثيقة","NAME":"الاسم","FILE":"الملف","PREVIEW":"معاينة","DELETEDOCUMENT":"حذف المستند","TRIPS":" رحلات","VIOLATIONS":"انتهاكات","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","ROUTES":"خطوط السير","DRIVER":"السائق","SUPERVISOR":"المشرفة","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {len}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {len}.","EDITROUTE":"تحرير خط السير","EXPENSES":"نفقات","GASRATE":"معدل استهلاك الوقود","OILRATE":"معدل النفط","IDLERATE":"معدل الوقت الضائع","TIRERATE":"معدل الاطارات","ENTERRATE":"أدخل معدل","INAED":"(بالدرهم)","VEHICLEPRICE":"سعر السيارة","FINANCIAL":"الأمور المالية","INSPECTION":"تفتيش","VEHICLEDEPRECIATION":"استهلاك المركبات","VEHICLEPERMIT":"تصريح المركبة","WEARTEAR":"استهلاك ناتج عن الاستعمال ","COST":"تكلفة"}}')
}


/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DRIVERS":"Drivers","MANAGEDRIVERS":"Manage Drivers","DRIVERID":"Driver ID","LICENCE":"Licence","EDITDRIVER":"Edit Driver","ADDNEWDRIVER":"Add New Driver","UPLOADCSVFILE":"Upload CSV File","CHOOSEFILTERBY":"Choose Filer By","SEARCHNAME":"Search Name","SEARCHID":"Search ID","SERACHBYNATIONALITY":"Serach By Nationality","LOADING":"Loading...","NAME":"Name","LICENSEEXPIRATION":"License Expiration","NATIONALITY":"Nationality","STATUS":"Status","ACTIVE":"Active","INACTIVE":"Inactive","DEACTIVATEDRIVER":"Deactivate Driver","ACTIVATEDRIVER":"Activate Driver","ID":"ID","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISDRIVER":"restore this driver?","DEACTIVATETHISDRIVER":"deactivate this driver?","CANCEL":"Cancel","CONFIRM":"Confirm","LICENCEIMAGE":"Licence Image","CLOSE":"Close","DRIVERNAME":"Driver Name","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","FIRSTNAME":"First Name","LASTNAME":"Last Name","EMAILADDRESS":"Email Address","GENDER":"Gender","IDENTIFICATIONNUMBER":"Identification Number","IDEXPIRATIONDATE":"ID Expiration Date","MOBILEPHONE":"Mobile Phone","LANDLINEPHONE":"LandlinePhone","DRIVERCANNOTBEDEACTIVATED":"Driver cannot be deactivated! Already assigned to a route.","DRIVERHASBEEN":"Driver has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","DRIVERHASNOTBEENDELETED":"Driver has not been deleted!","ASSIGNEDTOBUS":"Assigned to bus","ASSIGNED":"Assigned","NOTASSIGNED":"Not assigned","ROUTENAME":"Route Name","FILTERBYROUTE":"Filter by route","SENDREGISTRATIONCODE":"Send Registration Code","REGISTRATIONHASBEENSENT":"Registration has been sent!!"},"ar":{"DRIVERS":"السائقين","MANAGEDRIVERS":"إدارة السائقين","DRIVERID":"تعريف السائق","LICENCE":" رخصة","EDITDRIVER":"تحرير السائق","ADDNEWDRIVER":"اضافة سائق جديد","UPLOADCSVFILE":"تحميل ملف CSV","CHOOSEFILTERBY":"اختر الفلتر المطلوب","SEARCHNAME":"ابحث عن الإسم","SEARCHID":" ابحث عن الهوية","SERACHBYNATIONALITY":"البحث حسب الجنسية","LOADING":"جار التحميل...","NAME":"الاسم","LICENSEEXPIRATION":"انتهاء صلاحية الرخصة","NATIONALITY":"الجنسية","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","DEACTIVATEDRIVER":"تعطيل السائق","ACTIVATEDRIVER":"تفعيل السائق","ID":"الهوية","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISDRIVER":"استعادة هذا السائق؟","DEACTIVATETHISDRIVER":"تعطيل هذا السائق؟","CANCEL":"الغاء","CONFIRM":"تأكد","LICENCEIMAGE":"صورة الرخصة","CLOSE":"أغلق","DRIVERNAME":"اسم السائق","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","FIRSTNAME":"الأسم الأول","LASTNAME":"اسم العائلة","STUDENTID":"هوية الطالب","EMAILADDRESS":"عنوان البريد الإلكتروني","GENDER":"الجنس","IDENTIFICATIONNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","MOBILEPHONE":"الهاتف المحمول","DRIVERCANNOTBEDEACTIVATED":".لا يمكن تعطيل !السائق لديه طريق مخصص","DRIVERHASBEEN":"كان السائق","RESTORED":"رمم!","DEACTIVATED":"معطلة!","DRIVERHASNOTBEENDELETED":"لم يتم حذف برنامج التشغيل!","ASSIGNEDTOBUS":"مشارك في الحافلة","ASSIGNED":"مشارك","NOTASSIGNED":"غيرمعتمد","ROUTENAME":"اسم المسار","FILTERBYROUTE":"اختر حسب خط السير","SENDREGISTRATIONCODE":"ارسل رمز التسجيل","REGISTRATIONHASBEENSENT":"تم إرسال  رمز التسجيل!!"}}')
}


/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DRIVERS":"Drivers","MANAGEDRIVER":"Manage Driver","DRIVERID":"Driver ID","LICENCE":"Licence","EDITDRIVER":"Edit Driver","ADDNEWDRIVER":"Add New Driver","DRIVERSLICENSE":"Driver\u0027s License","DRIVERNAME":"Driver Name","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","FIRSTNAME":"First Name","LASTNAME":"Last Name","GENDER":"Gender","LOADING":"Loading...","UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","MALE":"Male","FEMALE":"Female","IDNUMBER":"ID Number","IDEXPIRATIONDATE":"ID Expiration Date","PICKADATE":"Pick a date","NATIONALITY":"Nationality","PLEASESELECTNATIONALITY":"Please select nationality","CONTACTINFO":"Contact Info","MOBILENO":"Mobile No","EMAILADDRESS":"Email Address","LANDLINEPHONE":"Landline Phone","CLICKTOUPLOAD":"Click to upload","JPGPNGFILES":"jpg/png files with a size less than 400kb","LICENSEEXPIRATIONDATE":"License Expiration Date","TRIPS":"Trips","VIOLATION":"Violation","ERROR":"Error","CLOSE":"Close","LICENCEIMAGE":"Licence Image","ISREQUIRED":"is required.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","ISNOTAVALIDFORMAT":"is not a valid format. Only letters, spaces and dashes are allowed.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","ALREADYEXISTED":"already existed.","ROUTES":"Routes","BUSNUMBER":"Bus Number","NAME":"Name","SUPERVISOR":"Supervisor","EDITROUTE":"Edit Route","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {len}.","TYPEERROR":"File extensions should be {len}.","LICENSEIMAGE":"License Image"},"ar":{"DRIVERS":"السائقين","MANAGEDRIVER":"إدارة السائقين","DRIVERID":"رقم السائق","LICENCE":" رخصة","EDITDRIVER":"تحرير السائق","ADDNEWDRIVER":"اضافة سائق جديد","DRIVERSLICENSE":"رخصة السياقة","DRIVERNAME":"اسم السائق","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","FIRSTNAME":"الأسم الأول","LASTNAME":"الإسم العائلي","GENDER":"جنس","LOADING":"جار التحميل...","UPLOADIMAGE":"تحميل الصور","SAVEIMAGE":"احفظ الصورة","MALE":" ذكر","FEMALE":"أنثى","IDNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","PICKADATE":"اختر تاريخا","NATIONALITY":"الجنسية","PLEASESELECTNATIONALITY":"يرجى تحديد الجنسية","CONTACTINFO":"معلومات الاتصال","MOBILENO":"رقم الجوال","EMAILADDRESS":"عنوان البريد الإلكتروني","LANDLINEPHONE":"الهاتف الثابت","CLICKTOUPLOAD":"اظغط للتحميل","JPGPNGFILES":" .  KB بحجم  اقل من 400 JPG/PNG ملفات ","LICENSEEXPIRATIONDATE":"تاريخ انتهاء الرخصة","TRIPS":" رحلات","VIOLATIONS":"انتهاكات","ERROR":"خطأ","CLOSE":"أغلق","LICENCEIMAGE":"صورة الرخصة","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ISNOTAVALIDFORMAT":".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","ALREADYEXISTED":".موجودة بالفعل","ROUTES":"خطوط السير","BUSNUMBER":"رقم الحافلة","NAME":"الاسم","SUPERVISOR":"المشرفة","EDITBUS":"تحرير الحافلة","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {len}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {len}.","EDITROUTE":"تحرير خط السير","LICENSEIMAGE":"صورة الترخيص"}}')
}


/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGEROUTES":"Manage Routes","BUSNUMBER":"Bus Number","NAME":"Name","DRIVER":"Driver","SUPERVISOR":"Supervisor","TOTALSTUDENTS":"Total Students","ADDNEWROUTE":"Add New Route","CHOOSEFILTERBY":"Choose Filer By","LOADING":"Loading...","SEARCHROUTENAME":"Search Route Name","SEARCHBUS":"Search Bus","SEARCHDRIVER":"Search Driver","SEARCHSUPERVISOR":"Search Supervisor","TOTALSTOPS":"Total Stops","EDITROUTE":"Edit Route","ROUTENAME":"Route Name","BUSNAME":"Bus Name","DRIVERNAME":"Driver Name","SUPERVISORNAME":"Supervisor Name","ACTIVE":"Active","INACTIVE":"Inactive","STATUS":"Status"},"ar":{"MANAGEROUTES":"ادارة خطوط السير","BUSNUMBER":"رقم الحافلة","NAME":"الاسم","DRIVER":"السائق","SUPERVISOR":"المشرفة","TOTALSTUDENTS":"إجمالي الطلاب","ADDNEWROUTE":"اضافة خط سير جديد","CHOOSEFILTERBY":"اختر الفلتر المطلوب","LOADING":"جار التحميل...","SEARCHROUTENAME":"ابحث عن خط سير","SEARCHBUS":"ابحث عن الحافلة","SEARCHDRIVER":"ابحث عن السائق","SEARCHSUPERVISOR":"ابحث عن المشرفة","TOTALSTOPS":"اجمالي التوقفات","EDITROUTE":"تحرير خط السير","ROUTENAME":"اسم خط السير","BUSNAME":"اسم الحافلة","DRIVERNAME":"اسم السائق","SUPERVISORNAME":"اسم المشرفة","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل"}}')
}


/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","ROUTES":"Routes","BUSNUMBER":"Bus Number","NAME":"Name","DRIVER":"Driver","SUPERVISOR":"Supervisor","MANAGEROUTE":"Manage Route","DESCRIPTION":"Description","SELECTDRIVER":"Select Driver","SELECTSUPERVISOR":"Select Supervisor","CANCEL":"Cancel","SAVING":"Saving","SAVE":"Save","INFORMATION":"Information","DIRECTION":"Direction","SELECTDIRECTION":"Select Direction","SELECTSERVICEDATE":"Select Service Date","SELECTTERM":"Select Term","SELECTTYPE":"Select Type","ACADEMICYEAR":"Academic Year","CUSTOMDATE":"Custom Date","SELECTACADEMICTERM":"Select Academic Term","SERVICESTARTENDDATE":"Service Start & End Date","SERVICESTARTDATE":"Service Start Date","SERVICEENDDATE":"Service End Date","PICKADATE":"Pick a date","DAYSINSERVICE":"Days in Service","CHECKALL":"Check all","HOMETOSCHOOLSERVICETIME":"Home to School Service Time","STARTTIME":"Start time","ENDTIME":"End time","SCHOOLTOHOMESERVICETIME":"School to Home Service Time","PLEASEINPUT":"Please input","ROUTECOLOR":"Route Color","STOPS":"Stops","ADDSTUDENTTOASTOP":"Add student to a stop","TOSCHOOL":"To School","TOHOME":"To Home","LINE-THROUGH":"line-through","NONE":"none","STOP":"Stop","GPSLATITUDE":"GPS Latitude","GPSLONGITUDE":"GPS Longitude","USEGOOGLEMAPDURATION":"Use google map duration","YES":"Yes","NO":"No","PREVIOUSWAITING":"Previous waiting","STOPWAITING":"Stop waiting","CONFIRM":"Confirm","NOSTUDENTSADDEDTOTHISSTOP":"No students added to this stop","REGISTRATION":"Registration","STUDENTS":"Students","SENDING":"Sending...","SENDREGISTRATIONCODE":"Send Registration Code","SETTINGS":"Settings","STATUS":"Status","ACTIVE":"Active","INACTIVE":"Inactive","COPYROUTE":"Copy Route","NAMEYOURROUTE":"Name your route","CLONING":"Cloning...","COPYING":"Copying...","MAKEACOPY":"Make a Copy","LOADING":"Loading...","OVERVIEW":"Overview","BUS":"Bus","TRIPS":"Trips","VIOLATIONS":"Violations","INCIDENTS":"Incidents","SELECTBUS":"Select Bus","SELECTEDBUS":"Selected Bus","AVAILABLEBUSES":"Available Buses","BUSALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":"Bus already existed in the following route(s):","PLEASECONFIRMIFYOUWOULDTOADDITTOTHISROUTE":"Please confirm if you would to add it to this route!","SELECTEDDRIVER":"Selected Driver","AVAILABLEDRIVERS":"Available Drivers","DRIVERALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":"Driver already existed in the following route(s):","PLEASECONFIRMIFYOUWOULDTOADDHIM/HERTOTHISROUTE":"Please confirm if you would to add him/her to this route!","SELECTEDSUPERVISOR":"Selected Supervisor","AVAILABLESUPERVISORS":"Available Supervisors","SUPERVISORALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":"Supervisor already existed in the following route(s):","ISREQUIRED":"is required.","ERROR":"Error","CLOSE":"Close","SUNDAY":"Sunday","MONDAY":"Monday","TUESDAY":"Tuesday","WEDNESDAY":"Wednesday","THURSDAY":"Thursday","FRIDAY":"Friday","SATURDAY":"Saturday","HOMETOSCHOOL":"Home to School","SCHOOLTOHOME":"School to Home","BOTH(ROUNDTRIP)":"Both (Round Trip)","SWITCHTOPICK-UP":"Switch to Pick-up","SWITCHTODROP-OFF":"Switch to Drop-off","FARTHEST":"Farthest","CLOSEST":"Closest","PICK-UP":"Pick-up","DROP-OFF":"Drop-off","STUDENT":"Student","CANNOTBEADDEDTOTHEROUTE":"cannot be added to the route. Please check if is disabled or has no primary guardian!","ADD":"Add","ALREADYEXISTEDINSTOP#":"already existed in stop#:","ALREADYEXISTEDINROUTE":"already existed in route:","WOULDYOULIKETOADDTHISSTUDENTTOTHISROUTE":"Would you like to add this student to this route?","SUCCESSFULLYBEENASSIGNEDTOSTOP":"successfully been assigned to stop #","SUCCESS":"Route successfully saved!","DEACTIVATED":"Deactivated","RESTORED":"Restored","ROUTESUCCESSFULLYCLONED":"Route successfully cloned","NATIONALITY":"Nationality","LICENSEEXPIRATION":"License Expiration","ASSIGN":"Assign","ASSIGNING":"Assigning...","PLEASECONFIRM":"Please confirm","NOTASSIGNED":"Not assigned","MAKE":"Make","MODEL":"Model","YEAR":"Year","SEATS":"Seats","STOPMESSAGE1":"Student {name} cannot be added to the route. Please check if is disabled or has no primary guardian!","STOPMESSAGE2":"{name} already existed in route:  {route}. Cannot be added during scheduled time!","STOPMESSAGE3":"Student {name} already existed in stop#:  {stop}.","STOPMESSAGE4":"Student {name} successfully been assigned to stop#:  {stop}.","STOPMESSAGE5":"Seems that {name} has located at school location, Please reassign the actual location of student first!","ROUTESUCCESSFULLY":"Route successfully","UPLOADCSVFILE":"Upload CSV File","GENERATEROUTE":"Generate Route","STUDENTID":"Student ID","INPROGRESS":"In Progress","ROUTEISOTIMIZED":"Route is Optimized","DELAYEDTHRESHOLD":"Delayed Threshold","FILLINFORMATION":"Please fill the Information tab first"},"ar":{"CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ROUTES":"خط السير","BUSNUMBER":"رقم الحافلة","NAME":"الاسم","DRIVER":"السائق","SUPERVISOR":"المشرفة","MANAGEROUTE":"ادارة خطوط السير","DESCRIPTION":"الوصف","SELECTDRIVER":"اختر السائق","SELECTSUPERVISOR":"اختر المشرفة","CANCEL":"الغاء","SAVING":"احتفاظ","SAVE":" حفظ","INFORMATION":"معلومات","DIRECTION":"اتجاه","SELECTDIRECTION":"تحديد الاتجاه","SELECTSERVICEDATE":"حدد تاريخ الخدمة","SELECTTERM":"حدد الفترة الدراسية","SELECTTYPE":"اختر صنف","ACADEMICYEAR":"السنة الدراسية","CUSTOMDATE":"تعديل التاريخ","SELECTACADEMICTERM":"حدد الفترة الدراسية","SERVICESTARTENDDATE":"تاريخ بدء الخدمة وانتهائها","SERVICESTARTDATE":"تاريخ بدء الخدمة","SERVICEENDDATE":"تاريخ انتهاء الخدمة","PICKADATE":"اختر تاريخا","DAYSINSERVICE":"أيام الخدمة","CHECKALL":"تحقق من الكل","HOMETOSCHOOLSERVICETIME":"وقت الخدمة من البيت الى المدرسة","STARTTIME":"بداية الخدمة","ENDTIME":"نهاية الخدمة","SCHOOLTOHOMESERVICETIME":"وقت الخدمة من المدرسة الى البيت","PLEASEINPUT":"الرجاء إدخال","ROUTECOLOR":"لون خط السير","STOPS":"توقفات","ADDSTUDENTTOASTOP":"إضافة الطالب للتوقف","TOSCHOOL":"الى المدرسة","TOHOME":"إلى البيت","LINE-THROUGH":"عبر الخط","NONE":"لا شيء","STOP":"توقف","GPSLATITUDE":"GPSخط العرض بنظام ","GPSLONGITUDE":"GPS خط الطول بنظام ","USEGOOGLEMAPDURATION":" GOOGLE استخدام مدة خريطة","YES":"نعم","NO":"لا","PREVIOUSWAITING":"الانتظار السابق","STOPWAITING":"الانتظار في التوقف ","CONFIRM":"تؤكد","NOSTUDENTSADDEDTOTHISSTOP":"لم يضاف أي طالب إلى هذا التوقف","REGISTRATION":"التسجيل","STUDENTS":"الطلاب","SENDING":"...إرسال","SENDREGISTRATIONCODE":"ارسل رمز التسجيل","SETTINGS":"إعدادات","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","COPYROUTE":"نسخ خط السير","NAMEYOURROUTE":"حدد اسم خط السير","CLONING":"...استنساخ","COPYING":"...نسخ ","MAKEACOPY":"اعمل نسخة","LOADING":"...جار التحميل","OVERVIEW":"نظرة عامة","BUS":"حافلة","TRIPS":"رحلات","VIOLATIONS":"انتهاكات","INCIDENTS":"حوادث","SELECTBUS":"حدد الحافلة","SELECTEDBUS":" حافلة محددة","AVAILABLEBUSES":" الحافلات المتوفرة","BUSALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":":الحافلة موجودة بالفعل في المسار (الطرق) التالية","PLEASECONFIRMIFYOUWOULDTOADDITTOTHISROUTE":"يرجى تأكيد ما إذا كنت تريد إضافته إلى هذا الطريق!","SELECTEDDRIVER":"حدد السائق","AVAILABLEDRIVERS":"السائقين المتوفرين","DRIVERALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":":السائق موجود بالفعل في المسار (الطرق) التالي","PLEASECONFIRMIFYOUWOULDTOADDHIM/HERTOTHISROUTE":"يرجى تأكيد ما إذا كنت ترغب في إضافته / ها إلى هذا الطريق!","SELECTEDSUPERVISOR":"المشرفة المحددة","AVAILABLESUPERVISORS":"المشرفات المتوفرات","SUPERVISORALREADYEXISTEDINTHEFOLLOWINGROUTE(S)":":المشرفة موجودة بالفعل في المسار (الطرق) التالي","ISREQUIRED":".مطلوب","ERROR":"خطأ","CLOSE":"أغلق","SUNDAY":"الأحد","MONDAY":"الإثنين","TUESDAY":"الثلاثاء","WEDNESDAY":"الأربعاء","THURSDAY":"الخميس","FRIDAY":"الجمعة","SATURDAY":" السبت","HOMETOSCHOOL":"من البيت إلى المدرسة","SCHOOLTOHOME":"من المدرسة إلى البيت","BOTH(ROUNDTRIP)":"كلا (رحلة ذهابا وإيابا)","SWITCHTOPICK-UP":"انتقل إلى التحميل","SWITCHTODROP-OFF":"انتقل إلى الإنزال","FARTHEST":"الأبعد","CLOSEST":"الأقرب","PICK-UP":"تحميل","DROP-OFF":"إنزال","STUDENT":"طالب","CANNOTBEADDEDTOTHEROUTE":"لا يمكن إضافته إلى المسار. يرجى التحقق مما إذا كان معطلا أو ليس لديه ولي أمر أساسي","ADD":"إضافة","ALREADYEXISTEDINSTOP#":"موجود بالفعل في التوقف رقم","ALREADYEXISTEDINROUTE":":موجود بالفعل في خط السير","WOULDYOULIKETOADDTHISSTUDENTTOTHISROUTE":"هل ترغب في إضافة هذا الطالب إلى هذا المسار؟","SUCCESSFULLYBEENASSIGNEDTOSTOP":"تم تعيينه بنجاح للتوقف رقم","SUCCESS":"تم حفظ الطريق بنجاح!","DEACTIVATED":"معطل","RESTORED":"استعادة","ROUTESUCCESSFULLYCLONED":"تم استنساخ الطريق بنجاح!","NATIONALITY":"الجنسية","LICENSEEXPIRATION":"انتهاء صلاحية الرخصة","ASSIGN":"تعيين","ASSIGNING":"تعيين ...","PLEASECONFIRM":"يرجى تأكيد","NOTASSIGNED":"غيرمشارك","MAKE":"الصنع","MODEL":"النوع","YEAR":"السنة","SEATS":"مقاعد","STOPMESSAGE1":"طالب {name} لا يمكن إضافتها إلى المسار. يرجى التحقق مما إذا كان معطلا أو ليس لديه ولي أمر أساسي","STOPMESSAGE2":"{name} :موجود بالفعل في خط السير {route}. لا يمكن إضافة أثناء الوقت المحدد!","STOPMESSAGE3":"طالب  {name} #موجود بالفعل في التوقف رقم {stop}","STOPMESSAGE4":"طالب {name} {stop} # تم تعيينه بنجاح للتوقف \u0027","STOPMESSAGE5":"يبدو أن {name} يقع في موقع المدرسة ، يرجى إعادة تعيين الموقع الفعلي للطلاب أولاً!","ROUTESUCCESSFULLY":"الطريق بنجاح","UPLOADCSVFILE":"تحميل ملف CSV","GENERATEROUTE":"توفير الطريق","STUDENTID":"هوية الطالب","INPROGRESS":"في تَقَدم","DELAYEDTHRESHOLD":"عتبة متاخرة","ROUTEISOTIMIZED":"الطريق محسنة","FILLINFORMATION":"يرجى ملء علامة التبويب المعلومات أولاً"}}')
}


/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGESUPERVISORS":"Manage Supervisors","ADDNEWSUPERVISOR":"Add New Supervisor","SUPERVISORID":"Supervisor ID","SENDREGISTRATIONCODE":"Send Registration Code","EDITSUPERVISOR":"Edit Supervisor","UPLOADCSVFILE":"Upload CSV File","CHOOSEFILTERBY":"Choose Filer By","SEARCHNAME":"Search Name","SEARCHID":"Search ID","SERACHBYNATIONALITY":"Serach By Nationality","LOADING":"Loading...","NAME":"Name","NATIONALITY":"Nationality","STATUS":"Status","ACTIVE":"Active","INACTIVE":"Inactive","DEACTIVATESUPERVISOR":"Deactivate Supervisor","ACTIVATESUPERVISOR":"Activate Supervisor","ID":"ID","AREYOUSUREYOUWANTTO":"Are you sure you want to","RESTORETHISSUPERVISOR":"restore this supervisor?","DEACTIVATETHISSUPERVISOR":"deactivate this supervisor?","CANCEL":"Cancel","CONFIRM":"Confirm","SUPERVISORS":"Supervisors","SUPERVISORNAME":"Supervisor Name","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","FIRSTNAME":"First Name","LASTNAME":"Last Name","EMAILADDRESS":"Email Address","GENDER":"Gender","IDENTIFICATIONNUMBER":"Identification Number","IDEXPIRATIONDATE":"ID Expiration Date","MOBILEPHONE":"Mobile Phone","LANDLINEPHONE":"LandlinePhone","SUPERVISORCANNOTBEDEACTIVATED":"Supervisor cannot be deactivated! Already assigned to a route.","REGISTRATIONHASBEENSENT":"Registration has been sent!!","SUPERVISORHASBEEN":"Supervisor has been","RESTORED":"restored!","DEACTIVATED":"deactivated!","SUPERVISORHASNOTBEENDELETED":"Supervisor has not been deleted!","ASSIGNEDTOBUS":"Assigned to bus","ASSIGNED":"Assigned","NOTASSIGNED":"Not assigned","ROUTENAME":"Route Name","FILTERBYROUTE":"Filter by route"},"ar":{"MANAGESUPERVISORS":"ادارة المشرفات","ADDNEWSUPERVISOR":"اضافة مشرف جديد","SUPERVISORID":"هوية المشرفة ","SENDREGISTRATIONCODE":"ارسل رمز التسجيل","EDITSUPERVISOR":" تحرير المشرفة","UPLOADCSVFILE":"تحميل ملف CSV","CHOOSEFILTERBY":"اختر الفلتر المطلوب","SEARCHNAME":"ابحث عن الإسم","SEARCHID":" ابحث عن الهوية","SERACHBYNATIONALITY":"البحث حسب الجنسية","LOADING":"جار التحميل...","NAME":"الاسم","NATIONALITY":"الجنسية","STATUS":"الحالة","ACTIVE":"مفعل","INACTIVE":"غير مفعل","DEACTIVATESUPERVISOR":"تعطيل المشرفة","ACTIVATESUPERVISOR":"تفعيل المشرفة","ID":"الهوية","AREYOUSUREYOUWANTTO":"هل أنت متأكد أنك تريد","RESTORETHISSUPERVISOR":"استعادة  المشرفة","DEACTIVATETHISSUPERVISOR":"تعطيل المشرفة؟","CANCEL":"الغاء","CONFIRM":"تأكد","SUPERVISORS":"المشرفات","SUPERVISORNAME":" اسم المشرفة","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","FIRSTNAME":"الأسم الأول","LASTNAME":"اسم العائلة","STUDENTID":"هوية الطالب","EMAILADDRESS":"عنوان البريد الإلكتروني","GENDER":"الجنس","IDENTIFICATIONNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","MOBILEPHONE":"الهاتف المحمول","SUPERVISORCANNOTBEDEACTIVATED":" .لا يمكن تعطيل !المشرفة لديها طريق مخصص","REGISTRATIONHASBEENSENT":"تم إرسال  رمز التسجيل!!","SUPERVISORHASBEEN":"المشرف كان","RESTORED":"رمم!","DEACTIVATED":"معطلة!","SUPERVISORHASNOTBEENDELETED":"لم يتم حذف المشرف!","ASSIGNEDTOBUS":"مشارك في الحافلة","ASSIGNED":"مشارك","NOTASSIGNED":"غيرمشارك","ROUTENAME":"اسم المسار","FILTERBYROUTE":"اختر حسب خط السير"}}')
}


/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MANAGESUPERVISOR":"Manage Supervisor","FIRSTNAME(ARABIC)":"First Name (Arabic)","FATHERNAME":"Father Name","FATHERNAME(ARABIC)":"Father Name (Arabic)","LASTNAME(ARABIC)":"Last Name (Arabic)","FIRSTNAME":"First Name","LASTNAME":"Last Name","GENDER":"Gender","LOADING":"Loading...","UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","MALE":"Male","FEMALE":"Female","IDNUMBER":"ID Number","IDEXPIRATIONDATE":"ID Expiration Date","PICKADATE":"Pick a date","NATIONALITY":"Nationality","PLEASESELECTNATIONALITY":"Please select nationality","CONTACTINFO":"Contact Info","MOBILENO":"Mobile No","EMAILADDRESS":"Email Address","LANDLINEPHONE":"Landline Phone","MESSAGES":"Messages","ERROR":"Error","CLOSE":"Close","ISREQUIRED":"is required.","MUSTBEATLEASTCHARACTERSINLENGTH":"must be at least {len} characters in length.","CANNOTEXCEEDCHARACTERSINLENGTH":"cannot exceed {len} characters in length.","INVALIDPHONENO":"is invalid phone number.","MUSTCONTAINAVALIDEMAILADDRESS":"must contain a valid email address.","ISNOTAVALIDFORMAT":"is not a valid format. Only letters, spaces and dashes are allowed.","ISNOTAVALIDARABICFORMAT":"is not a valid arabic format.","ALREADYEXISTED":"already existed.","ROUTES":"Routes","BUSNUMBER":"Bus Number","NAME":"Name","DRIVER":"Driver","EDITROUTE":"Edit Route"},"ar":{"MANAGESUPERVISOR":"ادارة المشرفات","FIRSTNAME(ARABIC)":"الاسم الأول (عربي) ","FATHERNAME":"اسم الاب","FATHERNAME(ARABIC)":"اسم الأب (عربي) ","LASTNAME(ARABIC)":"الإسم العائلي(عربي) ","FIRSTNAME":"الأسم الأول","LASTNAME":"الإسم العائلي","GENDER":"جنس","LOADING":"جار التحميل...","UPLOADIMAGE":"تحميل الصور","SAVEIMAGE":"احفظ الصورة","MALE":" ذكر","FEMALE":"أنثى","IDNUMBER":"رقم الهوية","IDEXPIRATIONDATE":"انتهاء صلاحية الهوية","PICKADATE":"اختر تاريخا","NATIONALITY":"الجنسية","PLEASESELECTNATIONALITY":"يرجى تحديد الجنسية","CONTACTINFO":"معلومات الاتصال","MOBILENO":"رقم الجوال","EMAILADDRESS":"عنوان البريد الإلكتروني","LANDLINEPHONE":"الهاتف الثابت","MESSAGES":"رسائل","ERROR":"خطأ","CLOSE":"أغلق","ISREQUIRED":".مطلوب","MUSTBEATLEASTCHARACTERSINLENGTH":".يجب أن تكون على الأقل {len} حرفا","MUSTCONTAINAVALIDEMAILADDRESS":".يجب أن يحتوي على عنوان بريد إلكتروني صالح","INVALIDPHONENO":".رقم هاتف غير صالح","CANNOTEXCEEDCHARACTERSINLENGTH":".لا يمكن أن يتجاوز {len} حرفا","ISNOTAVALIDFORMAT":".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات","ISNOTAVALIDARABICFORMAT":".ليست صيغة عربية صحيحة","ALREADYEXISTED":".موجودة بالفعل","ROUTES":"خطوط السير","BUSNUMBER":"رقم الحافلة","NAME":"الاسم","DRIVER":"السائق","EDITBUS":"تحرير الحافلة","EDITROUTE":"تحرير خط السير"}}')
}


/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme_index_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_index_rtl_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_index_rtl_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__theme_index_rtl_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_font_awesome_css_font_awesome_min_css__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_font_css__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_styles_font_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_idle_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__google_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__countries_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__session_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__event_bus_js__ = __webpack_require__(9);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__google_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__countries_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__session_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_idle_vue___default.a, { eventEmitter: __WEBPACK_IMPORTED_MODULE_14__event_bus_js__["EventBus"], idleTime: 60000 * 15 });
window.EventBus = __WEBPACK_IMPORTED_MODULE_14__event_bus_js__["EventBus"]; // Temporarily added for dubugging...
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: {}
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].END_POINT = "http://api.wiotschool.com/";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].AWS_ASSETS = "https://s3.ap-south-1.amazonaws.com/wiot-demo-assets/";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].PUSHER_KEY = "775c4f2c93539aef7e9a";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$google = "AIzaSyBw2bsy3ktGq4UuCHd8bRWaDtsSVulY7gc";

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].AWS_FOLDERS = {
  student: '/pictures/students/thumbnails/',
  guardian: '/pictures/guardians/thumbnails/',
  configuration: '/pictures/configuration/thumbnails/',
  bus: '/documents/buses/',
  driver: '/pictures/drivers/thumbnails/',
  supervisor: '/pictures/supervisors/thumbnails/',
  user: '/pictures/users/thumbnails/',
  license: '/pictures/licenses/thumbnails/',
  incident: '/pictures/incidents/',
  message: '/attachments/messages/'
};

function renderVue() {
  return new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    i18n: i18n,
    router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
  });
}

var host = window.location.host.toUpperCase();
var domain = host.split('.');
if (domain.length > 1) {
  var AccessCode = domain[0];
  if (domain.length === 4) AccessCode += '.' + domain[1];
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://axpgdtejj8.execute-api.ap-south-1.amazonaws.com/api/" + '/' + AccessCode + '-WEB').then(function (response) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].END_POINT = response.data.app_config.endpoint;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].AWS_ASSETS = response.data.app_config.asset_path;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].PUSHER_KEY = response.data.app_config.pusher_key;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$google = response.data.app_config.google_api;
    renderVue();
  }).catch(function (response) {
    renderVue();
  });
} else {
  renderVue();
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// set cropbox size in image
var CROPBOX_PERCENT = 75;
var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
var areaWidth = window.innerWidth - 60;
var areaHeight = window.innerHeight - 110;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ResizeBar: __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default.a,
    RotateBar: __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default.a
  },
  props: {
    ratio: {
      type: String,
      default: '1:1'
    },
    minWidth: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: Number,
      default: 50
    },
    isResize: {
      type: [Boolean],
      default: false
    },
    isRotate: {
      type: [Boolean],
      default: true
    }
  },

  data: function data() {
    return {
      src: __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default.a,
      width: 24,
      height: 24,
      initWidth: 24,
      initHeight: 24,
      left: 0,
      top: 0,
      cropCSS: {}
    };
  },


  methods: {
    setImage: function setImage(src, w, h) {
      this.src = src;
      if (!this.originSrc) {
        this.setOriginalSrc(this.src);
      }
      if (this.ratio.indexOf(':') > 0) {
        this.ratioW = this.ratio.split(':')[0];
        this.ratioH = this.ratio.split(':')[1];
        this.ratioVal = this.ratioW / this.ratioH;
      } else {
        this.ratioW = 1;
        this.ratioH = 1;
        this.ratioVal = this.ratio;
      }
      this.natrualWidth = w;
      this.natrualHeight = h;
      this.setLayout(w, h);
      var resizeBar = this.$refs.resizeBar;
      if (this.isResize) {
        resizeBar.setProgress(100);
      } else {
        resizeBar.setProgress(50);
      }
      return this.imgChangeRatio;
    },
    setOriginalSrc: function setOriginalSrc(src) {
      this.originSrc = src;
    },
    resizeImage: function resizeImage(progress) {
      var w = void 0,
          h = void 0;
      if (this.isResize) {
        w = this.natrualWidth * this.imgChangeRatio * progress;
        h = this.natrualHeight * this.imgChangeRatio * progress;
      } else {
        w = this.initWidth + progress * (this.natrualWidth - this.initWidth);
        h = this.initHeight + progress * (this.natrualHeight - this.initHeight);
      }
      if (w <= this.minWidth || h < this.minHeight) {
        return;
      }
      this.left += (this.width - w) / 2;
      this.top += (this.height - h) / 2;
      this.width = w;
      this.height = h;
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    rotateImage: function rotateImage(degress) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default.a.rotate2(this.originSrc, degress, function (data, w, h) {
        _this.setImage(data, w, h);
      });
      //this.src = src;
    },
    setLayout: function setLayout(w, h) {
      var H = areaHeight,
          W = areaWidth,
          width = w,
          height = h,
          marginLeft = 0,
          marginTop = 0;
      // caculate the image ratio
      var R = width / height;
      var Rs = W / H;
      if (R > Rs) {
        height = H;
        width = H * R;
        marginLeft = (W - H * R) / 2;
      } else {
        width = H * R, height = H;
        marginLeft = (W - H * R) / 2;
      }
      this._setStyle(width, height, marginLeft, marginTop, R, true);
    },
    _setStyle: function _setStyle(w, h, ml, mt, r, isInit) {
      var $container = this.$el.querySelector('.g-crop-image-principal');
      if (!isInit) {
        this.marginLeft = this.marginLeft + (this.width - w) / 2;
        this.marginTop = this.marginTop + (this.height - h) / 2;
      }
      $container.style.cssText = 'width:' + w + 'px;height:' + h + 'px;margin-left:' + ml + 'px;' + 'margin-top:' + mt + 'px';
      this.setCropBox(w, h);
      if (this.isResize) {
        this.width = w;
        this.height = h;
      } else {
        if (r >= this.cropCSS.width / this.cropCSS.height) {
          this.height = this.cropCSS.height;
          this.width = this.height * r;
        } else {
          this.width = this.cropCSS.width;
          this.height = this.width / r;
        }
        this.initWidth = this.width;
        this.initHeight = this.height;
        this.left = (w - this.width) / 2;
        this.top = (h - this.height) / 2;
      }
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    setCropBox: function setCropBox(w, h, r) {
      if (this.isResize) {
        return;
      }
      var $selectCropBox = this.__find('.crop-box');
      var $wrap = this.$el;
      var imageWidth = w,
          imageHeight = h,
          ratioW = this.ratioW,
          ratioH = this.ratioH;
      var cropWidth = imageWidth;
      if (areaWidth < w) {
        cropWidth = areaWidth;
      }
      var baseCropWidth = cropWidth / 100 * CROPBOX_PERCENT;
      var CSSObj = {
        width: baseCropWidth,
        height: baseCropWidth / ratioW * ratioH
      };
      CSSObj.left = (imageWidth - baseCropWidth) / 2;
      CSSObj.top = (imageHeight - CSSObj.height) / 2;
      $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      if (CSSObj.height > imageHeight) {
        var baseCropHeight = imageHeight / 100 * CROPBOX_PERCENT;
        CSSObj.height = baseCropHeight;
        CSSObj.width = CSSObj.height * ratioW / ratioH;
        CSSObj.left = (imageWidth - CSSObj.width) / 2, CSSObj.top = (imageHeight - CSSObj.height) / 2, $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      };
      this.cropCSS = CSSObj;
    },
    getCropData: function getCropData() {
      // keep compatible with old api
      if (this.isResize) {
        return {
          imgChangeRatio: this.imgChangeRatio,
          toCropImgX: 0,
          toCropImgY: 0,
          toCropImgW: this.natrualWidth,
          toCropImgH: this.natrualHeight
        };
      }
      return {
        toCropImgX: (this.cropCSS.left - this.left) / this.imgChangeRatio,
        toCropImgY: (this.cropCSS.top - this.top) / this.imgChangeRatio,
        toCropImgW: this.cropCSS.width / this.imgChangeRatio,
        toCropImgH: this.cropCSS.height / this.imgChangeRatio
      };
    },
    getCropImage: function getCropImage() {
      return this.$refs['crop-image'];
    },
    __find: function __find(str) {
      var dq = this.$el;
      return dq.querySelector(str);
    },

    // resize and drag move
    resize: function resize(e) {
      e.stopPropagation();
      if (!this.ratio.indexOf(':')) {
        return;
      }
      var $el = e.target.parentElement;
      var $container = this.__find('.g-crop-image-principal');
      if (this._$container) {
        this._$container = container;
      }
      var self = this;
      var coor = {
        x: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientX : e.clientX,
        y: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientY : e.clientY,
        w: $el.offsetWidth,
        h: $el.offsetHeight
      };
      this.el = $el;
      this.container = $container;
      var maxCoor = this._getMaxCropAreaWidth();
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_1__lib_resize___default()(ev, self.el, $container, coor, self.ratioVal);
        if (newCropStyle && (newCropStyle.width <= maxCoor.maxWidth || newCropStyle.height <= maxCoor.maxHeight)) {
          self.cropCSS.width = newCropStyle.width;
          self.cropCSS.height = newCropStyle.height;
        }
      };
      var end = function end(ev) {
        this.el = null;
        if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', end, false);
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', end, false);
      };
      if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', end, false);
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', end, false);
    },
    _getMaxCropAreaWidth: function _getMaxCropAreaWidth() {
      var $cropBox = this.__find('.crop-box');
      if (this.width > this.height) {
        return {
          maxWidth: this.height * this.ratioW / this.ratioH,
          maxHeight: this.height
        };
      }
      return {
        maxWidth: this.width,
        maxHeight: this.width * this.ratioH / this.ratioW
      };
    },
    drag: function drag(e) {
      e.preventDefault();
      var $el = this.__find('.image-wrap');
      this.el = $el;
      var $cropBox = this.__find('.crop-box');
      var $container = e.currentTarget;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: $cropBox.offsetLeft,
        maxTop: $cropBox.offsetTop,
        minLeft: $cropBox.offsetWidth + $cropBox.offsetLeft - $el.offsetWidth,
        minTop: $cropBox.offsetHeight + $cropBox.offsetTop - $el.offsetHeight
      };
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_0__lib_drag___default()(ev, self.el, coor);
        if (newCropStyle) {
          self.left = newCropStyle.left;
          self.top = newCropStyle.top;
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_drag__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    minProgress: {
      type: [Number, String],
      default: 0
    }

  },
  data: function data() {
    return {
      progress: 100,
      left: 100
    };
  },


  methods: {
    setProgress: function setProgress(num) {
      this.left = num;
    },
    drag: function drag(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = e.target;
      this.el = $el;
      var $container = this.$el.parentElement;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_0__lib_helper___default.a.isMobile;
      var width = 200;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: width,
        maxTop: parseInt($container.style.height) - parseInt($el.style.height),
        minLeft: 0,
        minTop: 0
      };
      var move = function move(ev) {
        var newCoor = __WEBPACK_IMPORTED_MODULE_1__lib_drag___default()(ev, self.el, coor);
        if (newCoor) {
          if (newCoor.left / width < self.minProgress) {
            return;
          }
          self.progress = (newCoor.left - width / 2) / width;
          self.left = newCoor.left / width * 100;

          self.$emit('resize', self.progress);
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rotateDegree: 0
    };
  },


  methods: {
    rotateRight: function rotateRight() {
      this.rotateDegree += 90;
      this.$emit('rotate', this.rotateDegree);
    },
    rotateLeft: function rotateLeft() {
      this.rotateDegree -= 90;
      this.$emit('rotate', this.rotateDegree);
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_image_xhr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__crop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var overflowVal = '';
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Crop: __WEBPACK_IMPORTED_MODULE_8__crop_vue___default.a,
    ResizeBar: __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default.a
  },
  props: __WEBPACK_IMPORTED_MODULE_7__props___default.a,
  data: function data() {
    return {
      files: [],
      hasImage: false,
      options: this.props,
      uploading: false,
      formID: (Math.random() * 10000 + '').split('.')[0],
      image: {
        src: __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default.a,
        width: 24,
        height: 24,
        minProgress: 0.05
      }
    };
  },


  computed: {
    name: function name() {
      if (this.multiple) {
        return this.inputOfFile + '[]';
      }
      return this.inputOfFile;
    }
  },

  methods: {
    __dispatch: function __dispatch(name, res, data) {
      this.$emit && this.$emit(name, res, data);
    },
    __find: function __find(str) {
      var dq = document.querySelector('#vciu-modal-' + this.formID);
      return dq.querySelector(str);
    },
    dragover: function dragover() {
      var element = this.$refs.container;
      element.classList.add('is-dragover');
    },
    dragleave: function dragleave() {
      var element = this.$refs.container;
      element.classList.remove('is-dragover');
    },
    change: function change(e) {
      var _this = this;

      var fileVal = document.querySelector('#g-core-upload-input-' + this.formID).value.replace(/C:\\fakepath\\/i, "");
      var fileExt = fileVal.substring(fileVal.lastIndexOf(".") + 1);
      var extensionsArr = this.extensions.split(',');
      if (extensionsArr.length > 1) {
        var reg = new RegExp('^[' + extensionsArr.join('|') + ']+$', 'i');
        if (!reg.test(fileExt)) {
          return this.__dispatch('errorhandle', 'TYPE ERROR');
        }
      }
      if (e.target.files[0].size > this.maxFileSize) {
        var formatSize;
        if (parseInt(this.maxFileSize / 1024 / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024 / 1024).toFixed(2) + 'MB';
        } else if (parseInt(this.maxFileSize / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024).toFixed(2) + 'kB';
        } else {
          formatSize = options.maxFileSize.toFixed(2) + 'Byte';
        }
        console.warn('FILE IS TOO LARGER MAX FILE IS ' + formatSize);
        return this.__dispatch('errorhandle', 'FILE IS TOO LARGER MAX FILE IS ' + formatSize);
      }

      this.files = e.target.files;
      if (this.crop || this.resize) {
        this.__showImage();
        return;
      }
      this.__dispatch('imagechanged', this.files.length > 1 ? this.files : this.files[0]);
      if (this.compress && this.files[0]['type'] !== 'image/png' && this.files[0]['type'] !== 'image/gif') {
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.compress(this.files[0], 100 - this.compress, function (code) {
          _this.tryAjaxUpload('', true, code);
        });
      } else {
        this.tryAjaxUpload();
      }
    },
    __showImage: function __showImage() {
      this.hasImage = true;
      this.__readFiles();
    },
    __readFiles: function __readFiles() {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var src = e.target.result;
        overflowVal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        self.__initImage(src);
      };
      reader.readAsDataURL(this.files[0]);
    },


    // set the image size
    __initImage: function __initImage(src) {
      var pic = new Image();
      var self = this;
      pic.src = src;
      var cropBox = this.$refs.cropBox;
      pic.onload = function () {
        self.image.minProgress = self.minWidth / pic.naturalWidth;
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.init(src, function (src) {
          self.imgChangeRatio = cropBox.setImage(src, pic.naturalWidth, pic.naturalHeight);
        });
      };
    },
    resizeImage: function resizeImage(progress) {
      var cropBox = this.$refs.cropBox;
      cropBox.resizeImage(progress);
    },
    doRotate: function doRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, 1, function (src) {
        self.__initImage(src);
      });
    },
    doReverseRotate: function doReverseRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, -1, function (src) {
        self.__initImage(src);
      });
    },
    doCrop: function doCrop(e) {
      var _this2 = this;

      this.__setData('crop');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.crop === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.crop(targetImage, this.data, function (code) {
          upload(code);
          _this2.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    doResize: function doResize(e) {
      var _this3 = this;

      this.__setData('resize');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.resize === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.resize(targetImage, this.data, function (code) {
          upload(code);
          _this3.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    __setData: function __setData(type) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) !== 'object') {
        this.data = {};
      }
      this.data["request"] = type;
      var cropBox = this.$refs.cropBox;
      var newCSSObj = cropBox.getCropData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newCSSObj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          this.data[k] = newCSSObj[k];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.maxWidth) {
        this.data['maxWidth'] = this.maxWidth;
      }
      if (this.maxHeight) {
        this.data['maxHeight'] = this.maxHeight;
      }
      if (this.minWidth) {
        this.data['minWidth'] = this.minWidth;
      }
    },
    __setUpload: function __setUpload(btn) {
      var _this4 = this;

      btn.value = btn.value + '...';
      btn.disabled = true;
      var upload = function upload(code) {
        _this4.tryAjaxUpload(function () {
          btn.value = btn.value.replace('...', '');
          btn.disabled = false;
        }, code ? true : false, code);
      };
      return upload;
    },
    cancel: function cancel() {
      this.hasImage = false;
      document.body.style.overflow = overflowVal;
      this.files = '';
      var cropBox = this.$refs.cropBox;
      cropBox.setOriginalSrc(null);
      document.querySelector('#g-core-upload-input-' + this.formID).value = '';
    },


    // use ajax upload  IE10+
    tryAjaxUpload: function tryAjaxUpload(callback, isBinary, base64Code) {
      var self = this;
      this.__dispatch('imageuploading', this.files[0]);
      var done = function done(res) {
        if (typeof callback === 'function') {
          callback();
        }
        self.uploading = false;
        self.cancel();
        self.__dispatch('imageuploaded', res, self.data);
      };
      var errorUpload = function errorUpload(err) {
        self.__dispatch('errorhandle', err);
      };
      if (!this.isXhr) {
        if (this.crop) {
          this.hasImage = false;
        }
        return typeof callback === 'function' && callback();
      }
      var data = void 0;
      if (isBinary) {
        data = {
          type: this.files[0]['type'],
          filename: this.files[0]['name'],
          filed: this.inputOfFile,
          base64Code: base64Code
        };
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, data);
        }
      } else {
        data = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          data.append(this.name, this.files[i]);
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          for (var k in this.data) {
            if (this.data[k] !== undefined) {
              data.append(k, this.data[k]);
            }
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default()('POST', this.url, this.headers, data, done, errorUpload, isBinary, this.credentials);
    }
  }

});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Auth__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_no_photo_jpg__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_no_photo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_no_photo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_no_school_png__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_no_school_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_no_school_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_bus_js__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var userData = null;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
  data: function data() {
    return {
      URL: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].END_POINT,
      BASEURL: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].BASE_URL,
      AWS_ASSETS: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AWS_ASSETS,
      AWS_FOLDERS: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AWS_FOLDERS,
      API_KEY: null,
      SCHOOL_ID: null,
      USER_LEVEL: null
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem('userData') === null) return;
    this.API_KEY = localStorage.getItem('api_key');
    this.SCHOOL_ID = localStorage.getItem('school_id');
    this.USER_LEVEL = parseInt(localStorage.getItem('user_level'));
  },

  methods: {
    isAllowed: function isAllowed(action, path) {
      if (this.USER_LEVEL === 1 && !isNaN(this.USER_LEVEL) || this.$permissions.length === 0) return true;
      if (this.$route.params.id !== undefined && this.$route.params.id === localStorage.getItem('user_id') && this.$route.path.split('/')[2] === 'user') return true;
      if (path !== undefined) {
        var _path = path.split('/');
        if (this.$permissions[_path[0]] !== undefined && this.$permissions[_path[0]][_path[1]] !== undefined) return this.$permissions[_path[0]][_path[1]].includes(action);
        return false;
      }
      return this.$route.meta.permissons !== undefined && this.$route.meta.permissons.includes(action);
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    dateFormat: function dateFormat(date) {
      return new Date(date.replace(/-/g, '/'));
    },
    getAsset: function getAsset(image, folder) {
      var logo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (folder === undefined) folder = this.$route.path.split('/')[2];
      var school = localStorage.getItem('school_id');
      var path = this.AWS_ASSETS + school + this.AWS_FOLDERS[folder];
      if (image === undefined || image === null || image === 'no-photo.jpg') return logo ? __WEBPACK_IMPORTED_MODULE_9__assets_img_no_school_png___default.a : __WEBPACK_IMPORTED_MODULE_8__assets_img_no_photo_jpg___default.a;
      return path + image;
    },
    nameValidation: function nameValidation(rule, value, callback) {
      var arregex = /^[a-zA-Z\s-]*$/;
      var message = this.$t('ISNOTAVALIDFORMAT');
      if (rule.field.split('_')[1] === 'AR') {
        message = this.$t('ISNOTAVALIDARABICFORMAT');
        arregex = /^[\u0621-\u064A\u0660-\u0669\s-]*$/;
      }
      if (value && !arregex.test(value)) callback(message);
      callback();
    },
    sessionExtended: function sessionExtended(data) {
      if (!data.error) {
        this.$message({ type: 'success', message: this.$t(data.message) });
      }
    },
    setBodyAttributes: function setBodyAttributes(docBody) {
      docBody.setAttribute('id', 'rtl');
      docBody.setAttribute('dir', 'rtl');
    },
    removeBodyAttributes: function removeBodyAttributes(docBody) {
      docBody.removeAttribute('id');
      docBody.setAttribute('dir', 'ltr');
    },
    switchLanguage: function switchLanguage() {
      var _this = this;

      var translator = this.$i18n;
      var language = localStorage.getItem('lang');
      var localeLang = __webpack_require__(99)("./" + language);
      var docBody = document.getElementsByTagName('body')[0];
      __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$on('langEmit', function (lang) {
        localeLang = __webpack_require__(99)("./" + lang);
        translator.locale = lang;
        _this.school_name = lang === 'en' ? userData.school_name : userData.school_name_ar;
        _this.full_name = lang === 'en' ? userData.full_name : userData.full_name_ar;
        __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(localeLang.default);
        if (typeof _this.side_bar_menu === 'function') {
          _this.sideBarSize();
          _this.side_bar_menu();
          _this.allowed_create();
        }
        if (lang === 'ar') return _this.setBodyAttributes(docBody);
        if (docBody.hasAttribute('id')) _this.removeBodyAttributes(docBody);
        _this.lang = lang;
      });
      var lang = localStorage.getItem('lang');
      translator.locale = lang;
      __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(localeLang.default);
      this.lang = lang;
      if (lang === 'ar') return this.setBodyAttributes(docBody);
      if (docBody.hasAttribute('id')) this.removeBodyAttributes(docBody);
    },
    _FullName: function _FullName(row) {
      var name = row.NameEN;
      if (localStorage.getItem('lang') === 'ar') name = row.NameAR;
      return name;
    },
    alignDirection: function alignDirection(align) {
      if (localStorage.getItem('lang') === 'en') return align;
      return align === 'left' ? 'right' : 'left';
    }
  }
});
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-incident-dialog': __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default.a, 'el-absence-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default.a, 'el-auth-dialog': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Auth___default.a },
  name: 'app',
  data: function data() {
    return {
      activeIndex: '0',
      subMenuActive: null,
      handleSelect: '',
      channel: null,
      privateChannel: null,
      active_nav: 0,
      school: null,
      sideBarHeight: 0,
      school_name: null,
      full_name: null,
      username: null,
      profile_photo: null,
      datenow: null,
      school_location: {},
      loggedin_id: null,
      incidentBox: false,
      incident: {},
      absence: { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 },
      absenceBox: false,
      session_expiration: null,
      password: null,
      closeSession: null,
      sessionDialog: false,
      timer: '0',
      school_id: null,
      key: null,
      temp: null,
      lang: 'en',
      permissions: [],
      navigations: [],
      user_level: null,
      wiot_box: null,
      TIME: null,
      navigation_map: {},
      allowed_add: []
    };
  },

  computed: {
    hide_sidebar: function hide_sidebar() {
      if (this.$route.name !== 'Login' && this.$route.name !== 'ResetPassword') return true;
      return false;
    }
  },
  onIdle: function onIdle() {
    console.log('idle mode detected');
  },
  onActive: function onActive() {
    console.log('active mode detected');
  },
  mounted: function mounted() {
    if (!localStorage.getItem('lang')) localStorage.setItem('lang', 'en');
    this.switchLanguage();
    this.clockAndDate();
    if (localStorage.getItem('userData') === null && this.$route.name === 'ResetPassword') return this.$router.push({ name: 'ResetPassword', params: { id: this.$route.params.id }, query: { rh: this.$route.query.rh } });
    if (localStorage.getItem('userData') === null && this.$route.name !== 'login') return this.$router.push('login');
    if (this.$route.path === '/login' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(this.session_expiration)) this.$router.push('/');
    this.sideBarSize();
    this.onLoading();
    this.side_bar_menu();
    this.allowed_create();
  },
  created: function created() {
    var _this2 = this;

    if (localStorage.getItem('userData') !== null) {
      userData = JSON.parse(localStorage.getItem('userData'));
      this.loadUserData(userData);
    }
    __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$on('userData', function (passedData) {
      userData = passedData;
      localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(userData));
      _this2.loadUserData(userData);
      _this2.switchLanguage();
      _this2.loggedIn();
    });
  },

  methods: {
    allowed_create: function allowed_create() {
      var actions = [{
        name: this.$t('STUDENT'),
        command: 'student',
        module: 'school',
        divide: false
      }, {
        name: this.$t('GUARDIAN'),
        command: 'guardian',
        module: 'school',
        divide: false
      }, {
        name: this.$t('ABSENCE'),
        command: 'absence',
        module: 'attendance',
        divide: false
      }, {
        name: this.$t('BUS'),
        command: 'bus',
        module: 'transportation',
        divide: true
      }, {
        name: this.$t('DRIVER'),
        command: 'driver',
        module: 'transportation',
        divide: false
      }, {
        name: this.$t('SUPERVISOR'),
        command: 'supervisor',
        module: 'transportation',
        divide: false
      }, {
        name: this.$t('ROUTE'),
        command: 'route',
        module: 'transportation',
        divide: false
      }, {
        name: this.$t('USER'),
        command: 'user',
        module: 'admin',
        divide: true
      }];
      if (this.user_level === 1) return this.allowed_add = actions;
      for (var item in actions) {
        var path = actions[item].module + '/' + actions[item].command;
        if (this.isAllowed('save', path)) this.allowed_add.push(actions[item]);
      }
      return this.allowed_add;
    },
    loggedIn: function loggedIn() {
      this.sideBarSize();
      this.onLoading();
      this.side_bar_menu();
      this.allowed_create();
    },
    active_trips: function active_trips() {
      return __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.total;
    },
    active_incidents: function active_incidents() {
      return __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].incidents.total;
    },
    active_messages: function active_messages() {
      return __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].messages.total;
    },
    active_violations: function active_violations() {
      return __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].violations.total;
    },
    sideBarSize: function sideBarSize() {
      this.$nextTick(function () {
        this.sideBarHeight = window.innerHeight - this.$refs.logo.offsetHeight - this.$refs.header.offsetHeight;
        if (this.$refs.menuScroll === undefined) return;
        this.$refs.menuScroll.update();
        if (this.lang === 'ar') {
          this.$refs.menuScroll.$refs.wrap.style.marginLeft = '-15px';
          this.$refs.menuScroll.$refs.wrap.style.marginRight = '';
        } else {
          this.$refs.menuScroll.$refs.wrap.style.marginRight = '-15px';
          this.$refs.menuScroll.$refs.wrap.style.marginLeft = '';
        }
      });
    },
    openMenu: function openMenu(index, keypath) {
      var navigation = this.navigations;
      // if (this.activeIndex !== index) this.subMenuActive = null
      this.activeIndex = index;
      this.sideBarSize();
      if (navigation[index].target === null) return;
      this.$router.push(navigation[index].target);
    },
    side_bar_menu: function side_bar_menu() {
      var navigation = [{
        name: this.$t('DASHBOARD'),
        target: '/',
        module: null,
        icon: 'fa fa-dashboard',
        menu: []
      }, {
        name: this.$t('SCHOOL'),
        target: null,
        module: 'school',
        icon: 'fa fa-university',
        menu: [{ name: this.$t('STUDENTS'), target: '/school/student', controller: 'student' }, { name: this.$t('GUARDIANS'), target: '/school/guardian', controller: 'guardian' }, { name: this.$t('SCHOOLINFO'), target: '/school/configuration', controller: 'configuration' }]
      }, {
        name: this.$t('TRANSPORTATION'),
        target: null,
        module: 'transportation',
        icon: 'fa fa-road',
        menu: [{ name: this.$t('BUSES'), target: '/transportation/bus', controller: 'bus' }, { name: this.$t('DRIVERS'), target: '/transportation/driver', controller: 'driver' }, { name: this.$t('SUPERVISORS'), target: '/transportation/supervisor', controller: 'supervisor' }, { name: this.$t('ROUTES'), target: '/transportation/route', controller: 'route' }]
      }, {
        name: this.$t('ATTENDANCE'),
        target: null,
        module: 'attendance',
        icon: 'fa fa-list-alt',
        menu: [{ name: this.$t('ABSENCES'), target: '/attendance/absence', controller: 'absence' }]
      }, {
        name: this.$t('REPORTS'),
        target: '/report',
        module: 'report',
        icon: 'fa fa-bar-chart',
        menu: []
      }, {
        name: this.$t('ADMIN'),
        target: null,
        icon: 'fa fa-user',
        module: 'admin',
        menu: [{ name: this.$t('USERS'), target: '/admin/user', controller: 'user' }, { name: this.$t('ROLES'), target: '/admin/role', controller: 'role' }, { name: this.$t('LOGS'), target: '/admin/log', controller: 'log' }]
      }];
      if (this.user_level === 1) return this.navigations = navigation;
      var _navigation = [];
      var i = 0;
      var k = 0;
      for (var item in navigation) {
        var module = navigation[item].module;
        if (this.permissions[module] !== undefined || module === null) {
          _navigation[k] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, navigation[item]);
          _navigation[k].menu = [];
          for (var _item in navigation[item].menu) {
            var controller = navigation[i].menu[_item].controller;
            if (this.permissions[module][controller] !== undefined) {
              _navigation[k].menu.push(navigation[i].menu[_item]);
            }
          }
          k++;
        }
        i++;
      }
      this.navigations = _navigation;
    },
    onLoading: function onLoading() {
      if (localStorage.getItem('userData') === null) return;
      this.weather();
      this.liveCounts();
      this.school = this.school_id;
      if (this.school === null) return;

      this.subscribeToMessage();
      this.subscribeToIncident();
      this.subscribeToAlert();
      this.subscribeToViolation();
      this.subscribeToTrip();
    },
    clockAndDate: function clockAndDate() {
      var direction = localStorage.getItem('lang') === 'en' ? 'ltr' : 'rtl';
      var textTimeF = ' [<span dir="' + direction + '">][<i class="fa fa-calendar-o"></i>] MMM.';
      var textTimeL = ' D, YYYY [</span>][<span  style="margin:0 10px;" dir="' + direction + '">][<i class="fa fa-clock-o"></i>] HH:mm:ss [</span>]';
      var localLocale = this.$moment();
      if (this.$route.path !== '/login' && isNaN(this.session_expiration)) return this.clearSessionData();
      this.datenow = localLocale.format(textTimeF) + this.$moment().format(textTimeL);
      setTimeout(this.clockAndDate, 1000);
      this.session_expiration = parseInt(localStorage.getItem('session_expiration'));
      var currentTime = this.$moment().unix();
      if (this.session_expiration - currentTime < 0) return this.clearSessionData();
      var time = this.session_expiration - currentTime;
      var duration = this.$moment.duration(time * 1000);
      this.timer = this.$moment.utc(duration.asMilliseconds()).format('mm:ss');
      this.TIME = this.$moment().unix();
      if (this.session_expiration === null) return;
      if (time === 1800 || time === 1000) this.sessionDialog = true;
      if (time === 100) return this.handleCommand('logout');
    },
    weather: function weather() {
      var self = this;
      var params = { key: '34c5088e6e7542daaba85722170506', q: this.school_location.Lat + ',' + this.school_location.Lng, lang: this.lang };
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('https://api.apixu.com/v1/forecast.json', { params: params }).then(function (response) {
        self.temp = response.data.current.temp_c;
      }).catch(function (response) {});
    },
    loadUserData: function loadUserData(userData) {
      var lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      this.session_expiration = userData.session_expiration;
      this.school_name = lang === 'en' ? userData.school_name : userData.school_name_ar;
      this.full_name = lang === 'en' ? userData.full_name : userData.full_name_ar;
      this.username = userData.username;
      this.profile_photo = userData.profile_photo;
      this.school_id = userData.school_id;
      this.API_KEY = userData.key;
      this.USER_LEVEL = userData.user_level;
      this.school_location = userData.school_location;
      this.loggedin_id = userData.user_id;
      this.permissions = userData.permissions;
      this.user_level = userData.user_level;
      this.wiot_box = userData.wiot_box;
      document.title = 'WIOT - ' + (lang === 'en' ? userData.school_name : userData.school_name_ar);
      localStorage.setItem('session_expiration', userData.session_expiration);
      localStorage.setItem('notification', userData.notification);
      localStorage.setItem('wiot_box', userData.wiot_box);
      localStorage.setItem('school_id', userData.school_id);
      localStorage.setItem('api_key', userData.key);
      localStorage.setItem('user_level', userData.user_level);
      localStorage.setItem('user_id', userData.user_id);
      localStorage.setItem('locale', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'country': userData.school_location.country, 'timeZone': 'N/A' }));
    },
    liveCounts: function liveCounts() {
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.all([this.latestIncidents(), this.latestMessages(), this.latestViolations(), this.latestTrips()]).then(__WEBPACK_IMPORTED_MODULE_10_axios___default.a.spread(function (incidents, messages, violations, trips) {
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].incidents.total = incidents.data;
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].messages.total = messages.data;
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].violations.total = violations.data;
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.total = trips.data;
      }));
    },
    handleCommand: function handleCommand(command) {
      if (command === undefined) return;
      var path = null;
      switch (command) {
        case 'logout':
          this.logout();
          break;
        case 'en':
        case 'ar':
          this.lang = command;
          localStorage.setItem('lang', command);
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('langEmit', command);
          path = this.$route.path;
          break;
        case 'student':
          path = '/school/student/create';
          break;
        case 'guardian':
          path = '/school/guardian/create';
          break;
        case 'absence':
          this.absenceBox = true;
          path = this.$route.path;
          break;
        case 'bus':
          path = '/transportation/bus/create';
          break;
        case 'driver':
          path = '/transportation/driver/create';
          break;
        case 'supervisor':
          path = '/transportation/supervisor/create';
          break;
        case 'route':
          path = '/transportation/route/create';
          break;
        case 'user':
          path = '/admin/user/create';
          break;
        case 'school':
          path = '/school/configuration';
          break;
        case 'profile':
          path = '/admin/user/' + this.loggedin_id;
          break;
        case 'message':
        case 'incident':
        case 'violation':
        case 'trip':
          var c = command + 's';
          if (command !== 'trip') this.$set(__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$data[c], 'total', 0);
          path = '/report/' + command;
          break;
        default:
      }
      if (path !== null) this.$router.push(path);
    },
    subscribeToMessage: function subscribeToMessage() {
      var self = this;
      this.$channel.bind('message', function (data) {
        self.getMonitorInfo(data);
      });
    },
    subscribeToIncident: function subscribeToIncident() {
      var self = this;
      this.$channel.bind('incident', function (data) {
        self.getIncidentInfo(data);
      });
    },
    subscribeToAlert: function subscribeToAlert() {
      this.$channel.bind('alert', function (data) {
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('alert', data);
      });
    },
    getIncidentInfo: function getIncidentInfo(data) {
      var self = this;
      var _data = data;
      this.$http.get('/incident/info?BusID=' + data.BusID + '&BusMonitorID=' + data.BusMonitorID + '').then(function (response) {
        _data.status = 'open';
        _data.statusColor = 2;
        _data.IsSticky = false;
        _data.bus = response.data.bus;
        _data.monitor = response.data.supervisor;
        if (__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].bus_numbers[data.BusID] !== undefined) __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].bus_numbers[data.BusID] = _data.bus.Label;
        if (!__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].incidents.ids.includes(data.incident_id)) {
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].incidents.ids.push(parseInt(data.incident_id));
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('incident', _data);
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].incidents.total++;
          self.newIncident(_data);
        }
      }).catch(function (response) {});
    },
    getMonitorInfo: function getMonitorInfo(data) {
      var self = this;
      var _data = data;
      this.$http.get('/supervisor/' + data.SenderID).then(function (response) {
        _data.monitor = response.data.person;
        if (!__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].messages.ids.includes(data.MessageID)) {
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].messages.ids.push(parseInt(data.MessageID));
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('message', _data);
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].messages.total++;
          self.newMessage(_data);
        }
      }).catch(function (response) {});
    },
    getBusInfo: function getBusInfo(data, type) {
      var _data = data;
      var self = this;
      if (__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].bus_numbers[data.BusID] !== undefined && type === 'violation') {
        _data.busNumber = __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].bus_numbers[data.BusID];
        return __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit(type, _data);
      }
      this.$http.get('/bus/info?BusID=' + data.BusID).then(function (response) {
        _data.busNumber = response.data.Label;
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].bus_numbers[data.BusID] = response.data.Label;
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit(type, _data);
        if (data.Db_Date !== null && data.Db_Date !== undefined) self.subscribeToBoarding(data.TripID);
      }).catch(function (response) {});
    },
    subscribeToBoarding: function subscribeToBoarding(TripID) {
      this.$channel.bind('boarding-' + TripID, function (boarding) {
        __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('boarding', { TripID: TripID, data: boarding });
      });
    },
    subscribeToViolation: function subscribeToViolation() {
      var self = this;
      this.$channel.bind('violation', function (data) {
        var ViolationID = parseInt(data.ViolationID);
        if (!__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].violations.ids.includes(ViolationID)) {
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].violations.ids.push(ViolationID);
          self.getBusInfo(data, 'violation');
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].violations.total++;
          self.newViolation(data);
        }
      });
    },
    subscribeToTrip: function subscribeToTrip() {
      var _this3 = this;

      this.$channel.bind('trip', function (data) {
        if (data.Direction === null) return;
        var message = _this3.$t('TRIP') + ' ' + data.TourName + _this3.$t('HASBEEN');
        var TripID = parseInt(data.TripID);
        if (data.IsClosed === 0) {
          if (data.Db_Date !== null && !__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.ids.includes(TripID)) {
            __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.ids.push(TripID);
            __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.total++;
            message += _this3.$t('CREATED');
          } else if (data.Db_Date === null) message += _this3.$t('DELAYED');else return;
          _this3.getBusInfo(data, 'trip');
        } else {
          if (data.IsClosed !== 1) return;
          if (__WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.total !== 0) __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].trips.total--;
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["EventBus"].$emit('trip', data);
          message += data.IsCancelled === 1 ? _this3.$t('CANCELLED') : _this3.$t('CLOSED');
        }
        _this3.newTrip(message);
      });
    },
    latestIncidents: function latestIncidents() {
      return this.$http.get('/incident/latest?limit=5&offset=0');
    },
    latestMessages: function latestMessages() {
      return this.$http.get('/message/latest?limit=5&offset=0');
    },
    latestViolations: function latestViolations() {
      return this.$http.get('/violation/latest?limit=5&offset=0');
    },
    latestTrips: function latestTrips() {
      return this.$http.get('/trip/onTransit?limit=5&offset=0');
    },
    handleOpen: function handleOpen(key, keyPath) {},
    handleClose: function handleClose(key, keyPath) {},
    newMessage: function newMessage() {
      this.$message({
        message: this.$t('YOUHAVERECEIVEDANEWMESSAGE'),
        iconClass: 'fa fa-envelope'
      });
    },
    newTrip: function newTrip(message) {
      this.$message({
        message: message,
        iconClass: 'fa fa-bus'
      });
    },
    newIncident: function newIncident(data) {
      if (localStorage.getItem('notification') !== '1') return;
      var self = this;
      this.$notify({
        iconClass: 'fa fa-exclamation-triangle fa-2x icon-incident',
        title: self.$t('NEWINCIDENT'),
        message: data.Text,
        duration: 0,
        onClick: function onClick() {
          self.showIncident(data);
          this.close();
        }
      });
    },
    newViolation: function newViolation(data) {
      if (localStorage.getItem('notification') !== '1') return;
      this.$notify({
        iconClass: 'fa fa-tachometer fa-2x icon-violation',
        title: this.$t('NEWVIOLATION'),
        message: this.$t(data.Label),
        duration: 0
      });
    },
    showIncident: function showIncident(incident) {
      this.incident = incident;
      this.incidentBox = true;
    },
    logout: function logout() {
      var self = this;
      this.$http.post('/user/logout', { lang: this.lang }).then(function (response) {
        self.clearSessionData();
      }).catch(function (response) {});
    },
    clearSessionData: function clearSessionData() {
      if (this.$route.name === 'ResetPassword') return;
      this.$permissions = undefined;
      this.$pusher.unsubscribe(localStorage.getItem('school_id'));
      delete __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.channel;
      var lang = localStorage.getItem('lang');
      localStorage.clear();
      this.$message({ type: 'success', message: 'LOGINGOUT' });
      localStorage.setItem('lang', lang);
      userData = null;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cardHeight: 0
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53;
    });
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cardHeight: 0
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53;
    });
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar___default.a, 'el-message-dialog': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message___default.a, 'el-absence-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default.a, 'el-incident-dialog': __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default.a },
  data: function data() {
    return {
      incidents: [],
      incident: { incident_type: null, bus: {}, monitor: {}, Lat: null, Lng: null },
      messages: [],
      message: { text: null },
      violations: [],
      trips: {},
      students: {},
      absence_student: {},
      status: { 0: 'success', 1: 'warning', 2: 'danger' },
      incident_loading: true,
      message_loading: true,
      violation_loading: true,
      absence_loading: true,
      trip_loading: true,
      dialogIncident: false,
      sendReport: false,
      messageBox: false,
      absenceBox: false,
      reportTo: null,
      channel: {},
      distance: 0,
      incidentBox: false,
      stops: {},
      total: 0,
      wiot_box: null,
      absence: {},
      absences: { 'bus': [], 'school': [] },
      absenceFrom: 'bus',
      prevIndex: 0,
      sendingEvent: null,
      notifyAlert: false,
      event: {},
      started_mode: true,
      delayed_trips: 0
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.wiot_box = parseInt(localStorage.getItem('wiot_box'));
    this.getIncidents();
    this.getViolations();
    this.getMessages();
    this.getTrips();
    this.notificationEvents();
  },

  computed: {
    listAbsences: function listAbsences() {
      return this.absences[this.absenceFrom];
    },
    listMessages: function listMessages() {
      var sorted = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.messages).sort(function (a, b) {
        return self.messages[b].MessageID - self.messages[a].MessageID;
      }).map(function (id, key) {
        if (key < 4) sorted.push(self.messages[id]);
      });
      return sorted;
    },
    delayedCount: function delayedCount() {
      if (this.delayed_trips > 4) return '4+';
      return this.delayed_trips;
    },
    sortedTrips: function sortedTrips() {
      var _trips = [];
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.trips)) return _trips;
      var i = 0;
      var trips = this.tripSort(this.trips);
      for (var trip in trips) {
        var TripID = parseInt(trips[trip]);
        var _trip = null;
        if (i === 4) break;
        if (this.started_mode && this.trips[TripID].Db_Date !== null) {
          _trip = this.trips[TripID];
        }
        if (!this.started_mode && this.trips[TripID].Db_Date === null) {
          _trip = this.trips[TripID];
        }
        if (_trip !== null) {
          _trips.push(_trip);
          i++;
        }
      }
      return _trips;
    },
    reportStatus: function reportStatus() {
      var reportStatus = { 0: this.$t('RESOLVED'), 1: this.$t('REPORTED'), 2: this.$t('OPEN') };
      return reportStatus;
    }
  },
  methods: {
    subscribeToBoarding: function subscribeToBoarding(TripID) {
      this.$channel.bind('boarding-' + TripID, function (boarding) {
        __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$emit('boarding', { TripID: TripID, data: boarding });
      });
    },
    arrayOfAlerts: function arrayOfAlerts(alerts) {
      var results = [];
      for (var key in alerts) {
        results.push(alerts[key]);
      }
      return results;
    },
    showCost: function showCost(trip) {
      if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true;
      return false;
    },
    showAbsence: function showAbsence(absence) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(absence)) return;
      this.absence = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(absence, ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA']);
      this.absence_student = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(absence, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath']);
      this.absence.Completed = true;
      this.absence.Excluded = false;
      this.absenceBox = true;
    },
    updateAbsence: function updateAbsence(data) {
      var absence = data[0];
      var absenceFrom = absence.OnlyFromBus ? 'bus' : 'school';
      if (!absence.Updated) return;
      var absences = this.absences[absenceFrom];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(absences).map(function (key) {
        if (absences[key].AbsentDate === absence.AbsentDate) {
          self.absences[absenceFrom][key] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(absences[key], absence);
          self.updateDirection(self.absences[self.absenceFrom][key]);
        }
      });
    },
    updateDirection: function updateDirection(absence) {
      switch (absence.Trip) {
        case 1:
          absence.Direction.icon = 'morning-icon';
          absence.Direction.title = 'MORNINGBUS';
          break;
        case 2:
          absence.Direction.icon = 'evening-icon';
          absence.Direction.title = 'AFTERNOONBUS';
          break;
        case 3:
          absence.Direction.icon = 'from-bus';
          absence.Direction.title = 'NOBUS';
          break;
      }
    },
    selectedConversation: function selectedConversation(currentRow, oldCurrentRow) {
      var BusMonitorID = currentRow.SenderID;
      this.$router.push({ path: '/report/message/' + BusMonitorID });
    },
    showActivity: function showActivity(activity) {
      if (activity.total_alerts !== 0 || activity.total_violations !== 0) return true;
      return false;
    },
    ballDirection: function ballDirection(trip) {
      var direction = localStorage.getItem('lang') === 'en' ? 'left' : 'right';
      var css = {};
      var width = this.progressWidth(trip);
      // css[direction] = (this.progressWidth(trip) - 2) + '%'
      if (width === 100) css[direction === 'left' ? 'right' : 'left'] = 0 + '%';else css[direction] = width + (width > 2 ? trip.Boarding === 0 ? 0 : -2 : 0) + '%';
      return css;
    },
    date_format: function date_format(date) {
      if (date === null) return;
      return this.$moment(date).format('DD/MM/YYYY');
    },
    incident_date: function incident_date(date) {
      if (date === null) return;
      return this.$moment(date).format('DD/MM/YYYY hh:mm');
    },
    tripSort: function tripSort(trips) {
      var dateSorted = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(trips).sort(function (a, b) {
        return trips[b].UpdatedAt - trips[a].UpdatedAt;
      });
      if (this.started_mode) {
        return dateSorted.sort(function (a, b) {
          return trips[a].IsClosed - trips[b].IsClosed;
        });
      } else {
        return dateSorted;
      }
    },
    tripTime: function tripTime(time) {
      return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A');
    },
    notificationEvents: function notificationEvents() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('incident', function (incident) {
        if (_this.trips[incident.TripID] !== undefined) {
          _this.trips[incident.TripID].UpdatedAt = _this.$moment().unix();
          var obj = {};
          obj.Event = 'INCIDENT';
          obj.EntityID = null;
          obj.EventID = incident.incident_id;
          obj.EventType = incident.incident_type;
          obj.Sent = incident.Timestamp;
          obj.Text = incident.Text;
          if (_this.trips[incident.TripID].activity.alerts[incident.incident_id] === undefined) {
            _this.trips[incident.TripID].activity.alerts[incident.incident_id] = obj;
            _this.trips[incident.TripID].activity.total_alerts++;
          }
        }
        _this.incidents.unshift(incident);
        if (_this.incidents.length > 4) _this.incidents.pop();
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('violation', function (violation) {
        _this.violations.unshift(violation);
        // if (this.violations.length > 4) this.violations.pop()
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('message', function (message) {
        _this.$set(_this.messages, message.SenderID, message);
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('trip', function (trip) {
        var IsClosed = trip.IsClosed;
        if (_this.trips[trip.TripID] !== undefined) {
          if (trip.Expected) {
            _this.trips[trip.TripID].Db_Date = trip.Db_Date === undefined ? null : trip.Db_Date;
            _this.trips[trip.TripID].BusDriverID = trip.BusDriverID === undefined ? null : trip.BusDriverID;
            _this.trips[trip.TripID].BusMonitorID = trip.BusMonitorID === undefined ? null : trip.BusMonitorID;
          }
          _this.total--;
          _this.trips[trip.TripID].UpdatedAt = trip.UpdatedAt;
          if (trip.IsCancelled === 1) {
            if (trip.NewTripID !== undefined) {
              _this.trips[trip.TripID].TripID = trip.NewTripID;
              _this.trips[trip.TripID].Boarding = 0;
              _this.trips[trip.TripID].checked_stop = 0;
              _this.assignNewTrip(_this.trips[trip.TripID]);
              _this.$delete(_this.stops, trip.TripID);
            }
            _this.$delete(_this.trips, trip.TripID);
          } else {
            if (trip.TotalCost !== undefined) {
              _this.trips[trip.TripID].TotalCost = trip.TotalCost;
              _this.trips[trip.TripID].TravelCost = trip.TravelCost;
              _this.trips[trip.TripID].VehicleCost = trip.TotalCost;
              _this.trips[trip.TripID].IdleCost = trip.IdleCost;
            }
            _this.trips[trip.TripID].CompletedIn = trip.CompletedIn;
            _this.trips[trip.TripID].IsClosed = IsClosed;
          }
          return;
        }
        if (trip.IsClosed === 1) return;
        _this.total++;
        _this.assignNewTrip(trip);
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('alert', function (alert) {
        if (_this.trips[alert.TripID] === undefined) return;
        _this.trips[alert.TripID].UpdatedAt = _this.$moment().unix();
        if (_this.trips[alert.TripID].activity.alerts[alert.EventID] === undefined) {
          _this.trips[alert.TripID].activity.alerts[alert.EventID] = alert;
          _this.trips[alert.TripID].activity.total_alerts++;
        }
      });
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('boarding', function (boarding) {
        var TripID = boarding.TripID;
        var _bording = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, boarding.data);
        if (_bording.IsMissing !== undefined) return;
        if (_bording.CheckOut === undefined) _this.trips[TripID].Boarding = _bording.Boarding;
        if (_bording.CheckOut !== undefined) _this.trips[TripID].checked_out = _bording.CheckOut;
        if (_this.trips[TripID].Direction === 1 && _bording.CheckOut !== undefined) _bording.Stop = _this.trips[TripID].student_stops;
        _this.trips[TripID].checked_stop = parseInt(_bording.Stop);
      });
    },
    assignNewTrip: function assignNewTrip(trip) {
      var obj = {};
      obj[trip.TripID] = trip;
      this.trips = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, this.trips);
      this.stopsPoint(trip);
    },
    readMore: function readMore(text) {
      if (text.length <= 60) return text;
      var textCut = text.substring(0, 50);
      var spaces = textCut.split(' ');
      spaces.pop();
      var newText = spaces.join(' ');
      return newText + '.....';
    },
    getIncidents: function getIncidents() {
      var self = this;
      this.$http.get('/incident?ref=dashboard&limit=5&offset=0&flagged=1').then(function (response) {
        self.incidents = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(response.data.incidents) ? [] : response.data.incidents;
        self.incident_loading = false;
      }).catch(function (response) {
        self.incident_loading = false;
      });
    },
    getMessages: function getMessages() {
      var self = this;
      this.$http.get('/message?ref=dashboard&limit=4&offset=0').then(function (response) {
        self.messages = !response.data ? [] : response.data;
        self.message_loading = false;
      }).catch(function (response) {
        self.message_loading = false;
      });
    },
    getViolations: function getViolations() {
      var self = this;
      if (this.wiot_box !== 1) return this.getAbsences();
      this.$http.get('/violation?ref=dashboard&limit=5&offset=0').then(function (response) {
        self.violations = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(response.data.violations) ? [] : response.data.violations;
        self.violation_loading = false;
        self.absence_loading = false;
      }).catch(function (response) {
        self.violation_loading = false;
        self.absence_loading = false;
      });
    },
    getTrips: function getTrips() {
      var self = this;
      this.$http.get('/trip?ref=dashboard&limit=4&offset=0&key=1').then(function (response) {
        self.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data).length;
        if (self.total === 0) return self.trip_loading = false;
        var trips = response.data.trips;
        for (var trip in trips) {
          self.stopsPoint(trips[trip]);
          self.$set(self.trips, trip, trips[trip]);
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].boarding[trip] = trips[trip].Boarding;
          if (trips[trip].IsClosed === 0) self.subscribeToBoarding(trip);
        }
        self.delayed_trips = response.data.total_pending;
        self.trip_loading = false;
      }).catch(function (response) {
        self.trip_loading = false;
      });
    },
    getAbsences: function getAbsences() {
      var self = this;
      if (self.absences[self.absenceFrom].length !== 0) return;
      this.$http.get('/absence?ref=dashboard&type=' + self.absenceFrom + '&limit=5&offset=0').then(function (response) {
        self.$set(self.absences, self.absenceFrom, response.data.absences);
        self.absence_loading = false;
        self.violation_loading = false;
      }).catch(function (response) {
        self.absence_loading = false;
        self.violation_loading = false;
      });
    },
    switchTo: function switchTo() {
      this.absenceFrom = this.absenceFrom === 'bus' ? 'school' : 'bus';
      this.getAbsences();
    },
    progressWidth: function progressWidth(trip) {
      var stop = trip.checked_stop;
      if (trip.skip_stops < stop) stop -= trip.skip_stops;
      if (stop === 0 || trip.IsClosed === 1) return 0;
      if (trip.Direction === 2 && trip.checked_out == null) return 0;
      if (trip.Direction === 1 && trip.checked_out !== null) stop = trip.student_stops + 1;
      return this.stops[trip.TripID].sizes[stop - 1];
    },
    nextStop: function nextStop(trip) {
      var num = 1;
      var stop = trip.checked_stop;
      if (trip.skip_stops < stop) stop -= trip.skip_stops;
      if (trip.Direction === 2 && trip.checked_out !== null) num = 0;
      if (stop === 0 || trip.Direction === 2 && trip.checked_out === null) return this.$t('FIRSTSTOP');
      if (trip.Direction === 1 && trip.checked_out !== null) return this.$t('SCHOOL');
      if (stop !== this.stops[trip.TripID].sizes.length - num) return this.$t('NEXTSTOP') + ' ' + (stop + 1);
      if (stop === this.stops[trip.TripID].sizes.length) return this.$t('LASTSTOP');
      return trip.Direction === 1 && this.trips[trip.TripID].checked_out !== null ? this.$t('SCHOOL') : this.$t('NOMORESTOPS');
    },
    stopsPoint: function stopsPoint(trip) {
      if (this.stops[trip.TripID] !== undefined) return;
      var points = [];
      var distance = 0;
      var percentage = null;
      if (trip.IsClosed === 1) return 0;
      var stops = trip.stops;
      for (var stop in stops) {
        distance += parseInt(stops[stop].Distance);
        points.push(distance);
      }
      distance = parseFloat(distance / 1000).toFixed(2);
      if (trip.Direction === 1) distance *= 2;
      var sizes = [];
      for (var item in points) {
        var value = parseFloat(points[item] / 1000).toFixed(2);
        percentage = value * 100 / distance;
        sizes.push(percentage);
      }
      if (trip.Direction === 1) sizes.push(100);
      this.stops[trip.TripID] = { sizes: sizes, checked_stop: trip.checked_stop, Direction: trip.Direction };
    },
    showMessageModal: function showMessageModal(student) {
      this.messageBox = true;
      this.student = student;
    },
    goTo: function goTo(TripID) {
      this.$router.push({ path: '/report/trip/' + TripID });
    },
    showIncident: function showIncident(incident) {
      this.incident = incident;
      this.incidentBox = true;
    },
    hideItem: function hideItem(item, index, type) {
      item.IsHidden = !item.IsHidden;
      var idName = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(type)) + 'ID';
      var postData = { id: item[idName], type: 'hidden', flag: item.IsHidden ? 1 : 0, name: type };
      var self = this;
      this.$http.post('/report/flag', postData).then(function (response) {
        if (item.IsHidden) type === 'violation' ? self.violations.splice(index, 1) : self.messages.splice(index, 1);
      }).catch(function (response) {});
    },
    flagItem: function flagItem(item, index, type) {
      item.IsSticky = !item.IsSticky;
      var idName = type === 'incident' ? 'incident_id' : 'ViolationID';
      var self = this;
      var postData = { id: item[idName], type: 'sticky', flag: item.IsSticky ? 1 : 0, name: type };
      this.$http.post('/report/flag', postData).then(function (response) {
        if (type === 'incident') {
          if (item.statusColor === 0 && item.IsSticky === false) self.getIncidents();
        }
      }).catch(function (response) {});
    },
    deleteIncident: function deleteIncident(incident) {
      if (incident.statusColor === 0 && incident.show) this.getIncidents();
    },
    viewMore: function viewMore(path) {
      var target = '/report/';
      switch (path) {
        case 'message':
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].messages.total = 0;
          break;
        case 'incident':
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].incidents.total = 0;
          break;
        case 'violation':
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].violations.total = 0;
          break;
        case 'absence':
          target = '/attendance/';
          break;
      }
      target += path;
      this.$router.push(target);
    },
    delayed_time: function delayed_time(trip) {
      var time = trip.Direction === 1 ? trip.Time_AM_In : trip.Time_PM_In;
      time = time.split(':');
      var display = '';
      var diff = this.$moment().subtract({ hours: time[0], minutes: time[1] });
      if (diff.hour() > 0) display += diff.hour() + this.$tc('HOUR', diff.hour() === 1 ? 1 : 2);
      if (diff.hour() > 0 && diff.minute() > 0) display += ',';
      if (diff.minute() > 0) display += diff.minute() + this.$tc('MINUTE', diff.minute() === 1 ? 1 : 2);
      this.$root.$children[0].TIME;
      return display;
    },
    activity_time: function activity_time(date) {
      return this.$moment(date).format('MM-DD-YYYY, h:mm a');
    },
    activityInfo: function activityInfo(obj, index) {
      this.notifyAlert = obj.Event === 'ALERT';
      if (obj.data !== undefined) {
        this.incident = obj.data;
        this.incidentBox = true;
        return;
      }
      this.sendingEvent = obj.EventID;
      var self = this;
      this.eventResource(obj.EventID, this.notifyAlert).then(function (result) {
        self.sendingEvent = null;
        var StudentID = result.data.student_id;
        if (self.notifyAlert) {
          result.data.student_id = [];
          result.data.student_id.push(StudentID);
        }
        self.incident = obj.data = result.data;
        self.incidentBox = true;
      }).catch(function () {
        self.sendingEvent = null;
      });
    },
    eventResource: function eventResource(EventID, alert) {
      return this.$http.get('/incident/event_info?EventID=' + EventID + '&IsAlert=' + alert);
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: { username: null, password: null, school: 'default' },
      schools: [],
      sending: false,
      loading: false,
      lang: null,
      main_school: {},
      logo: null,
      loading_logo: true,
      is_center: false,
      show_dropdown: false
    };
  },

  computed: {
    referrer: function referrer() {
      if (document.referrer !== undefined) return document.referrer;
    }
  },
  mounted: function mounted() {
    console.log('mounted in login..');
    if (!localStorage.getItem('lang')) localStorage.setItem('lang', 'en');
    this.getSchools();
    this.lang = localStorage.getItem('lang', 'en');
  },

  methods: {
    selectSchool: function selectSchool(val) {
      if (!this.is_center) return;
      this.schools = [];
      window.location.pathname = val.split('_')[1];
    },
    getSchools: function getSchools() {
      var self = this;
      if (localStorage.getItem('userData')) return self.$router.push('/');
      if (self.schools.length !== 0) return;
      this.$http.get('/schools').then(function (response) {
        self.schools = response.data;
        self.detectSubDomain();
      }).catch(function (response) {});
    },
    detectSubDomain: function detectSubDomain() {
      var host = window.location.host;
      var subDomain = host.split('.')[0];
      var school = null;
      if (window.location.pathname !== '/') {
        school = subDomain + '_' + window.location.pathname.replace('/', '');
        this.is_center = true;
      }
      for (var key in this.schools) {
        if (school === null) {
          if (this.schools[key].SubDomain === subDomain && key === subDomain) {
            this.main_school = this.schools[key];
            this.logo = this.AWS_ASSETS + this.main_school.SchoolID + '/logo.png';
            return this.user.school = key;
          }
        } else {
          if (school === key) {
            this.main_school = this.schools[key];
            return this.user.school = school;
          }
        }
      }
      this.show_dropdown = true;
    },
    auth: function auth() {
      var self = this;
      if (self.validateInput()) return;
      self.loading = true;
      this.$http.post('/auth', self.user).then(function (response) {
        var type = 'error';
        if (!response.data.error) {
          type = 'success';
          var userData = response.data.user_data;
          var locale = { 'country': userData.school_location.country, 'timeZone': 'N/A' };
          var lang = userData.lang;
          localStorage.setItem('lang', lang);
          localStorage.setItem('locale', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(locale));
          __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["EventBus"].$emit('userData', userData);
          self.$router.push('/');
        }
        self.$message({ message: self.$t(response.data.message), type: type, showClose: response.data.error });
        if (type === 'error') self.loading = false;
      }).catch(function (response) {});
    },
    keyHandler: function keyHandler(e) {
      console.log(e.key);
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    },
    passwordReset: function passwordReset() {
      var _this = this;

      this.$prompt(this.$t('PLEASEENTERYOUREMAILADDRESS'), this.$t('FORGOTPASSWORDT'), {
        confirmButtonText: this.$t('SUBMIT'),
        cancelButtonText: this.$t('CANCEL'),
        inputPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        inputErrorMessage: this.$t('INVALIDEMAILADDRESS'),
        beforeClose: function beforeClose(action, instance, done) {
          if (action !== 'confirm') return done();

          var self = _this;
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = _this.$t('SENDING');
          _this.$http.post('/user/reset', { school: self.user.school, email: instance.inputValue }).then(function (response) {
            var type = 'success';
            if (response.data.error) {
              type = 'error';
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = self.$t('SUBMIT');
            }
            self.$message({
              type: type,
              message: self.$t(response.data.message)
            });
            if (!response.data.error) {
              instance.confirmButtonLoading = false;
              done();
            }
          }).catch(function (response) {});
        }
      });
    },
    validateInput: function validateInput() {
      var regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.user.username || !this.user.password) return true;
      if (!regEmail.test(this.user.username)) return true;
      return false;
    },
    loadingLogo: function loadingLogo() {
      if (this.logo === null) return;
      var image = new Image();
      var self = this;
      image.onload = function () {
        self.loading_logo = false;
      };
      image.onerror = function () {
        self.loading_logo = false;
        throw new Error('logo not found');
      };
      return image.src = this.logo;
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (window.location.pathname !== '/') {
      var center = window.location.pathname.replace('/', '');
      window.location.href = location.protocol + '//' + window.location.host + '/' + center;
      return;
    }
    next();
  },
  data: function data() {
    return {
      schools: {},
      activeNames: [0],
      summary: {},
      cardHeight: 0,
      lang: 'en',
      links: {
        'STUDENTS': { link: 'school/student', color: '#FA7D82' },
        'BUSES': { link: 'transportation/bus', color: '#FCB225' },
        'SUPERVISORS': { link: 'transportation/supervisor', color: '#FE5E41' },
        'DRIVERS': { link: 'transportation/driver', color: '#C5D86D' },
        'ABSENCES': { link: 'attendance/absence', color: '#00798C' },
        'ROUTES': { link: 'transportation/route', color: '#1D1A31' }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.switchLanguage();
    this.lang = localStorage.getItem('lang');
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - 20;
    });
    this.loadData();
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["EventBus"].$on('langEmit', function (lang) {
      _this.lang = lang;
    });
  },

  methods: {
    url_target: function url_target(target) {
      var hq = target.split('_')[0];
      var center = target.split('_')[1];
      var subdomain = window.location.host.split('.')[0];
      var host = window.location.host.replace(subdomain, hq);
      return location.protocol + '//' + host + '/' + center;
    },
    loadData: function loadData() {
      var self = this;
      this.$http.get('dashboard/counts').then(function (response) {
        self.schools = response.data.schools;
        self.summary = response.data.summary;
      }).catch(function (error) {
        console.log(error);
      });
    },
    clickEvent: function clickEvent(name, key) {
      var url = this.url_target(name);
      if (key !== undefined) url += '#/' + this.links[key].link;
      window.open(url, '_blank');
    },
    center_name: function center_name(center) {
      return this.lang === 'en' ? center.SCHOOL.Name_EN : center.SCHOOL.Name_AR;
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})');
var mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})');
var strength = [{ text: '', percentage: 0, status: '' }, { text: 'Strong', percentage: 100, status: 'success' }, { text: 'Medium', percentage: 60, status: '' }, { text: 'Weak', percentage: 20, status: 'exception' }];
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    var _this = this;

    var valPass = function valPass(rule, value, callback) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(value)) callback(new Error('Please input the password'));else {
        if (!new RegExp('(?=.*[a-z])').test(value)) callback(new Error('The password must contain at least 1 lowercase alphabetical character'));else if (!new RegExp('(?=.*[A-Z])').test(value)) callback(new Error('The password must contain at least 1 uppercase alphabetical character'));else if (!new RegExp('(?=.*[0-9])').test(value)) callback(new Error('The password must contain at least 1 numeric character'));else if (!new RegExp('(?=.*[!@#\\$%\\^&\\*])').test(value)) callback(new Error('The password must contain at least one special character'));
        if (!new RegExp('(?=.{8,})').test(value)) callback(new Error('Please use at least 8 characters'));else if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(_this.ruleForm.checkPass)) _this.$refs.ruleForm.validateField('checkPass');
        callback();
      }
    };
    var valConfirmPass = function valConfirmPass(rule, value, callback) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(value)) {
        callback(new Error('Please input the password again'));
      } else {
        if (value !== _this.ruleForm.pass) {
          callback(new Error('Two inputs don\'t match!'));
        }
        callback();
      }
    };
    return {
      ruleForm: {
        pass: null,
        checkPass: null
      },
      school: [],
      email: null,
      rules: {
        pass: [{ validator: valPass, trigger: 'change' }],
        checkPass: [{ validator: valConfirmPass, trigger: 'change' }]
      },
      currentStrength: {},
      message: null,
      changing: false,
      error: false
    };
  },

  watch: {
    'ruleForm.pass': function ruleFormPass(val) {
      this.analyze(val);
    }
  },
  mounted: function mounted() {
    this.currentStrength = strength[0];
    this.$refs.meter.$el.children[1].innerHTML = this.currentStrength.text;
  },

  methods: {
    passwordReset: function passwordReset(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) return _this2.doReset();
        return false;
      });
    },
    printError: function printError(message) {
      var error = message.split(' ');
      return error[0] + ' ' + error[1] + '</br>';
    },
    doReset: function doReset() {
      this.changing = true;
      var postData = { pass: this.ruleForm.pass, checkPass: this.ruleForm.checkPass, schoolID: this.$route.params.id, rh: this.$route.query.rh };
      var self = this;
      this.$http.post('/user/password', postData).then(function (response) {
        var data = response.data;
        self.changing = false;
        self.message = data.message;
        self.error = data.error;
        if (!self.error) {
          var userData = data.user_data;
          localStorage.setItem('lang', userData.lang);
          __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["EventBus"].$emit('userData', userData);
          self.$router.push('/');
          return self.$message({ message: 'Your password is successfully changed!', type: 'success' });
        }
      }).catch(function () {});
    },
    analyze: function analyze(value) {
      if (strongRegex.test(value)) this.currentStrength = strength[1];else if (mediumRegex.test(value)) this.currentStrength = strength[2];else this.currentStrength = strength[3];
      this.$refs.meter.$el.children[1].innerHTML = '<b>' + this.currentStrength.text + '</b>';
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a },
  data: function data() {
    return {
      filter: null,
      users: [],
      userID: '',
      loggedInUserID: 1,
      active_filter: 'date',
      logs: {},
      events: [],
      banned: [],
      loading: true,
      new_page: false,
      filteredRoles: [],
      currentRow: null,
      Controller: '',
      Action: '',
      tableHeight: 0,
      listHeight: 0,
      totalLogs: 0,
      currentPage: 1,
      visitedPage: [1],
      date: [null, null],
      limit: 50,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() >= Date.now();
        }
      }
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.listHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.tableHeight = this.listHeight - this.$refs.filter.offsetHeight - this.$refs.pagination.offsetHeight;
    this.loadInitialData();
  },

  computed: {
    listLogs: function listLogs() {
      return this.logs[this.currentPage - 1];
    },
    options: function options() {
      var options = [{
        value: 'event',
        label: this.$t('EVENTTYPE')
      }, {
        value: 'date',
        label: this.$t('DATE')
      }];
      return options;
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getUserLogs(this.userID);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.logs = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getUserLogs(this.userID);
    },
    logPage: function logPage(controller, method) {
      if (localStorage.getItem('lang') === 'en') return this.$t(controller.toUpperCase()) + ' ' + this.$t(method.toUpperCase());
      return this.$t(method.toUpperCase()) + ' ' + this.$t(controller.toUpperCase());
    },
    getUserLogs: function getUserLogs(userID) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.userID = userID;
      var self = this;
      if (filter) {
        self.currentPage = 1;
        self.visitedPage = [1];
        self.new_page = true;
        self.logs = {};
      }
      if (self.logs[self.currentPage - 1] !== undefined) return;
      this.$http.get('/log/' + userID + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1)).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.logs, self.currentPage - 1, response.data.logs);
        self.new_page = self.loading = false;
        self.totalLogs = response.data.total;
      }).catch(function (response) {});
    },
    loadUserLogs: function loadUserLogs(userID) {
      if (this.userID === userID) return;
      this.loading = true;
      this.logs = {};
      this.getUserLogs(userID);
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      switch (this.active_filter) {
        case 'event':
          data.filters['Event'] = this.Controller.controller ? this.Controller.controller.toLowerCase() : this.Controller.controller;
          if (this.Action !== '') data.filters['Action'] = this.Action ? this.Action.toLowerCase() : this.Action;
          break;
        case 'date':
          if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.date[0]) && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.date[1])) break;
          data.filters.Date = {};
          data.filters.Date.min = this.$moment(this.date[0]).format('YYYY-MM-DD');
          data.filters.Date.max = this.$moment(this.date[1]).format('YYYY-MM-DD');
          break;
      }
      return data;
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
      var load = false;
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.date[0]) && !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.date[1])) load = true;
      if (load) {
        this.date = [null, null];
        this.getUserLogs(this.userID, true);
      }
    },
    loadInitialData: function loadInitialData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.all([this.$http.get('/user?ref=log'), this.$http.get('/role/null')]).then(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.spread(function (users, events) {
        self.users = users.data;
        self.userID = self.users[0].PersonID;
        self.getUserLogs(self.userID);
        self.events = events.data;
      })).catch(function (response) {
        console.log(response);
      });
    },
    logPath: function logPath(item) {
      if (item.Method === 'login' || item.Method === 'logout') return '#';
      var skipCtrls = ['configuration'];
      var itemValue = skipCtrls.indexOf(item.Controller) < 0 ? '/' + item.ItemValue : '';
      this.$router.push('/' + item.Module + '/' + item.Controller + itemValue);
    },
    IsBanned: function IsBanned(item) {
      if (this.banned[item.UserID].indexOf(item.IPAddress) < 0) return false;
      return true;
    },
    IpBan: function IpBan(item) {
      var IPIndex = this.banned[item.UserID].indexOf(item.IPAddress);
      var status = IPIndex < 0 ? 1 : 0;
      var self = this;
      this.$http.post('admin/log/ip_ban', { UserID: item.UserID, IPAddress: item.IPAddress, status: status }).then(function (response) {
        if (status !== 1) return self.banned[item.UserID].splice(IPIndex, 1);
        self.banned[item.UserID].push(item.IPAddress);
      }).catch(function (response) {
        console.log(response);
      });
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a },
  data: function data() {
    return {
      loading: true,
      roles: [],
      selectedRole: { id: null },
      dupValue: null,
      filteredRoles: [],
      levels: [],
      tableHeight: 0,
      listHeight: 0,
      applications: {},
      access: {},
      showConfirm: true
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + 53);
    this.listHeight = this.tableHeight - 1;
    this.getRoles();
  },

  computed: {
    listApplications: function listApplications() {
      var applications = this.applications[this.selectedRole.id];
      return applications;
    }
  },
  methods: {
    getRoles: function getRoles() {
      var self = this;
      this.$http.get('/role?exclude=1').then(function (response) {
        self.roles = response.data;
        self.loading = false;
        var role = self.$route.params.id && self.getRoleByID(self.$route.params.id) ? self.getRoleByID(self.$route.params.id) : self.roles[0];
        self.loadApplication(role);
      }).catch(function (response) {});
    },
    RoleName: function RoleName(row) {
      var name = row.name;
      if (localStorage.getItem('lang') === 'ar' && row.name_AR) name = row.name_AR;
      return name;
    },
    nameValidation: function nameValidation(rule, value, callback) {
      var arregex = /^[a-zA-Z\s-]*$/;
      var message = this.$t('ISNOTAVALIDFORMAT');
      if (rule.field.split('_')[1] === 'AR') {
        message = this.$t('ISNOTAVALIDARABICFORMAT');
        arregex = /^[0-9\u0621-\u064A\u0660-\u0669\s-]*$/;
      }
      if (value && !arregex.test(value)) callback(message);
      callback();
    },
    getRoleApplications: function getRoleApplications(role) {
      var self = this;
      this.loading = true;
      this.$http.get('/role/' + role.id).then(function (response) {
        self.$set(self.applications, role.id, response.data);
        self.loading = false;
      }).catch(function (response) {});
    },
    saveRole: function saveRole() {
      var _this = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (index !== null) _this.checkIndex(index);
        var postData = { role: _this.selectedRole, applications: _this.applications[_this.selectedRole.id] };
        var self = _this;
        _this.$http.post('/role/save', postData).then(function (response) {
          var data = response.data;
          if (self.selectedRole.id === null) {
            self.selectedRole.id = data.id;
            self.loadApplication(self.selectedRole);
            self.roles.push(self.selectedRole);
          }
          self.message = data.message;
          self.error = data.error;
          resolve(data);
          if (!self.error) {
            self.$message({ message: self.$t(self.message), type: 'success' });
            return;
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    loadApplication: function loadApplication(role) {
      if (role.id !== null) this.selectedRole = role;
      if (this.applications[role.id] === undefined) this.getRoleApplications(role);
    },
    addRole: function addRole(data) {
      var _this2 = this;

      var self = this;
      if (this.applications[data.id] === undefined) this.loadApplication(data);
      var h = this.$createElement;
      var role = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
      this.$msgbox({
        title: role.name ? this.$t('EDITROLE') : this.$t('NEWROLE'),
        message: h('el-form', { props: { labelWidth: '120px', labelPosition: 'top', model: role }, ref: 'popedForm' }, [h('el-form-item', { props: { label: this.$t('ROLENAME'), prop: 'name', rules: [{ required: true, message: this.$t('NAMESHOULDNOTBEEMPTY'), trigger: 'blur' }, { validator: this.duplicateName, trigger: 'blur' }] } }, [h('el-input', { props: { value: role.name, autofocus: true }, on: { input: function input(val) {
              role.name = val;
            } }, ref: 'name' })]), h('el-form-item', { props: { label: this.$t('ROLENAME(ARABIC)'), prop: 'name_AR', rules: [{ validator: this.nameValidation, trigger: 'blur' }, { validator: this.duplicateName, trigger: 'blur' }] } }, [h('el-input', { props: { value: role.name_AR }, on: { input: function input(val) {
              role.name_AR = val;
            } }, ref: 'name_AR' })])]),
        showCancelButton: true,
        confirmButtonText: this.$t('SAVE'),
        cancelButtonText: this.$t('CANCEL'),
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            _this2.$refs['popedForm'].validate(function (valid) {
              _this2.dupValue = null;
              if (valid) {
                for (var key in _this2.roles) {
                  if (_this2.roles[key].id !== role.id && _this2.roles[key].name.toLowerCase() === role.name.toLowerCase()) {
                    _this2.dupValue = role.name.toLowerCase();
                    _this2.$refs['popedForm'].validate();
                  } else if (_this2.roles[key].id !== role.id && _this2.roles[key].name_AR && role.name_AR && _this2.roles[key].name_AR.toLowerCase() === role.name_AR.toLowerCase()) {
                    _this2.dupValue = role.name_AR.toLowerCase();
                    _this2.$refs['popedForm'].validate();
                  }
                }
                if (_this2.dupValue === null) done(_this2.resetForm(role.id));
              }
            });
          } else {
            done(_this2.resetForm(role.id, true));
          }
        }
      }).then(function (data) {
        if (role.id == null) self.selectedRole = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, role);
        self.saveRole().then(function () {
          self.selectedRole.name = role.name;
          self.selectedRole.name_AR = role.name_AR;
        });
      }).catch(function () {});
    },
    resetForm: function resetForm(id) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.$refs['popedForm'] === undefined) return;
      if (reset) this.$refs['popedForm'].resetFields();
      this.$refs.name.setCurrentValue(id === null ? null : this.selectedRole.name);
      this.$refs.name_AR.setCurrentValue(id === null ? null : this.selectedRole.name_AR);
    },
    duplicateName: function duplicateName(rule, value, callback) {
      if (value && this.dupValue === value.toLowerCase()) callback(this.$t('NAMEALREADYEXIST'));
      callback();
    },
    disableCheckBox: function disableCheckBox(index, method) {
      if (!this.isAllowed('save')) return true;
      var id = this.selectedRole.id;
      if (this.applications[id][index].access.indexOf('index') < 0 && method !== 'index' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.applications[id][index].methods).indexOf('index') >= 0) return true;
      return false;
    },
    checkIndex: function checkIndex(index) {
      var id = this.selectedRole.id;
      if (this.applications[id][index].access.indexOf('index') < 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.applications[id][index].methods).indexOf('index') >= 0) this.applications[id][index].access = [];
    },
    getRoleByID: function getRoleByID(id) {
      for (var role in this.roles) {
        if (this.roles[role].id === id) return this.roles[role];
      }
      return false;
    },
    deleteRole: function deleteRole(key, role) {
      var self = this;
      if (parseInt(role.users) !== 0) {
        return self.$message({
          message: self.$t('ROLEASSIGNED'),
          type: 'warning',
          showClose: true
        });
      }
      var postData = { Level: role.id, Status: 0 };
      this.$http.post('/role/delete', postData).then(function (response) {
        if (response.data.error) {
          return self.$message({
            message: self.$t(response.data.message),
            type: 'warning',
            showClose: true
          });
        }
        self.$delete(self.roles, key);
        if (self.roles[key - 1] !== undefined) self.loadApplication(self.roles[key - 1]);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default.a },
  data: function data() {
    return {
      filter: null,
      active_filter: 'name',
      loggedin_id: null,
      fullName: '',
      level: '',
      ExternalPersonID: '',
      loading: true,
      users: [],
      levels: [],
      user: {},
      roles: [],
      filtered_users: [],
      currentRow: null,
      tableHeight: 0,
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      sending: null,
      import_data: {}
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.loggedin_id = userData.user_id;
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53);
    this.geRoles();
    this.getUsers();
  },

  computed: {
    filteredUsers: function filteredUsers() {
      var filtered = this.users;
      if (this.active_filter === 'name') filtered = this.filterBy(filtered, this.fullName, ['FullName_EN', 'FullName_AR']);
      if (this.active_filter === 'id') filtered = this.filterBy(filtered, this.ExternalPersonID, 'ExternalPersonID');
      if (this.active_filter === 'role') filtered = this.filterBy(filtered, this.level, 'Level');
      return filtered;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('USERNAME')
      }, {
        value: 'id',
        label: this.$t('USERID')
      }, {
        value: 'role',
        label: this.$t('ROLE')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null }, { label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null }, { label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null }, { label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null }, { label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null }, { label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null }, { label: this.$t('LEVEL'), field: 'Level', required: true, format: null }, { label: this.$t('GENDER'), field: 'Gender', required: true, format: null }, { label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null }, { label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null }, { label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: false, format: 'date' }, { label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null }, { label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null }, { label: this.$t('EMAILADDRESS'), field: 'EMail', required: true, format: null }];
      return fields;
    }
  },
  methods: {
    getUsers: function getUsers() {
      var self = this;
      this.$http.get('/user').then(function (response) {
        if (response.data.denied !== undefined) {
          self.loading = false;
          return self.accessDenied();
        }
        for (var user in response.data) {
          response.data[user].Deleted = false;
        }
        self.users = response.data;
        self.loading = false;
      }).catch(function (response) {});
    },
    reCall: function reCall() {
      this.loading = true;
      this.getUsers();
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('(?:^|\\s)' + search, 'ig');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    geRoles: function geRoles() {
      var self = this;
      this.$http.get('/role').then(function (response) {
        self.roles = response.data;
      }).catch(function (response) {});
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    invokeFilter: function invokeFilter(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          if (new RegExp(search, 'i').test(el[delimiter[0]]) || new RegExp(search, 'i').test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search + '$';
          if (new RegExp(search).test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { PersonID: self.users[index].PersonID, Status: self.users[index].Status };
      this.$http.post('/user/delete', postData).then(function (response) {
        self.users[index].Deleted = false;
        self.users[index].DeletedAT = self.users[index].DeletedAT !== null ? null : '';
        self.users[index].Status = self.users[index].Status === '1' ? '0' : '1';
        self.users = [];
        self.getUsers();
        self.$message({
          message: response.data.error ? self.$t('USERCANNOTBEENDELETED') : self.$t('USERHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    },
    clearInput: function clearInput() {
      this.fullName = this.ExternalPersonID = '';
      this.filteredUsers;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    },
    sendPasswordLink: function sendPasswordLink(user) {
      var self = this;
      this.sending = user.UserID;
      this.$http.post('/user/reset', { email: user.UserID }).then(function (response) {
        self.sending = null;
        self.$message({
          message: self.$t('EMAILHASSENT'),
          type: 'success',
          showClose: true
        });
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save___default.a },
  data: function data() {
    return {
      person: { IDExpiration: null, Gender: null, Nationality: null, ImagePath: null },
      user: { Level: null },
      contact: { MobilePhone: null, EMail: null, LandlinePhone: null },
      logs: [],
      loggedInUserID: null,
      levels: [],
      applications: [],
      banned: [],
      school: {},
      address: {},
      relatives: [],
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      loading: false,
      editPassword: true,
      message: null,
      error: false,
      date_format: 'dd/MM/yyyy',
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      alreadyExisted: { ID: false, Email: false }
    };
  },

  computed: {
    renderPwd: {
      get: function get() {
        if (this.editPassword) return 'Password';
        return this.user.Password;
      },
      set: function set(password) {
        this.user.Password = password;
      }
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.loggedInUserID = userData.user_id;
    this.date_format = userData.date_format;
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getLevels();
    this.getUser();
  },

  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    phoneValidation: function phoneValidation(rule, value, callback) {
      var regex = /^\+?[\d-]+$/;
      if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'));
      callback();
    },
    passwordValidation: function passwordValidation(rule, value, callback) {
      if (this.editPassword) callback();
      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(value)) callback(this.$t('CANNOTBEEMPTY'));else {
        if (!new RegExp('(?=.*[a-z])').test(value)) callback(this.$t('MUSTLOWERCASE'));else if (!new RegExp('(?=.*[A-Z])').test(value)) callback(this.$t('MUSTUPPERCASE'));else if (!new RegExp('(?=.*[0-9])').test(value)) callback(this.$t('MUSTNUMERIC'));else if (!new RegExp('(?=.*[!@#\\$%\\^&\\*])').test(value)) callback(this.$t('MUSTSPECIAL'));else if (!new RegExp('(?=.{8,})').test(value)) callback(this.$t('ATLEASTCHARACTERS'));
        callback();
      }
    },
    changePassword: function changePassword() {
      this.editPassword = !this.editPassword;
      if (this.editPassword) this.$delete(this.user, 'Password');
      this.$refs.accountForm.validateField('Password');
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.person.ImagePath = res.file_name;
    },
    getUser: function getUser() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/user/' + this.$route.params.id).then(function (response) {
        self.person = response.data.person;
        if (self.person.IDExpiration) self.person.IDExpiration = self.dateFormat(self.person.IDExpiration);
        self.user = response.data.user;
        self.contact = response.data.contact;
        self.loading = false;
      }).catch(function (response) {});
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.this.URL;
      this.dialogVisible = true;
    },
    logPath: function logPath(item) {
      if (item.Method === 'login' || item.Method === 'logout') return '#';
      var method = item.Method === 'save' || item.Method === 'delete' || item.Method === 'saveTagID' ? 'edit' : item.Method;
      return '/' + item.Module + '/' + item.Controller + '/' + method + '/' + item.ItemValue;
    },
    IsBanned: function IsBanned(item) {
      if (this.banned[item.UserID].indexOf(item.IPAddress) < 0) return false;
      return true;
    },
    IpBan: function IpBan(item) {
      var baseUrl = 'http://localhost/wathiq_web/';
      var resource = baseUrl + 'admin/log/ip_ban';
      var axios = axios.create({
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      var IPIndex = this.banned[item.UserID].indexOf(item.IPAddress);
      var status = IPIndex < 0 ? 1 : 0;
      var vm = this;
      axios.post(resource, __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({ UserID: item.UserID, IPAddress: item.IPAddress, status: status })).then(function (response) {
        if (status !== 1) return vm.banned[item.UserID].splice(IPIndex, 1);
        vm.banned[item.UserID].push(item.IPAddress);
      }).catch(function (response) {
        // error callback
      });
    },
    getLevels: function getLevels() {
      var self = this;
      this.$http.get('/role').then(function (response) {
        self.levels = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.student.ImagePath = URL.createObjectURL(file.raw);
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-absence-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Absence___default.a, 'el-message-dialog': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Message___default.a },
  data: function data() {
    return {
      filter: null,
      active_filter: 'name',
      currentPage: 1,
      loading: true,
      absences: { 'bus': [], 'school': [] },
      absenceFrom: 'bus',
      student: {},
      messageStudent: [],
      parent: {},
      currentRow: null,
      tableHeight: 0,
      absence: {},
      direction: [],
      Reason: null,
      FullName: null,
      StudentID: null,
      date: [null, null],
      messageBox: false,
      absenceBox: false,
      totalAbsences: 0,
      visitedPage: [1],
      new_page: false,
      limit: 20,
      pickedIndex: 0,
      prevIndex: 0,
      serachStudent: false,
      serverCheck: false,
      absence_status: false,
      autoSource: null
    };
  },

  computed: {
    listAbsences: function listAbsences() {
      return this.absences[this.absenceFrom][this.currentPage - 1];
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('NAME')
      }, {
        value: 'reason',
        label: this.$t('REASON')
      }, {
        value: 'date',
        label: this.$t('DATE')
      }];
      return options;
    },
    reasons: function reasons() {
      var reasons = { Sickness: this.$t('SICKNESS'), Vacation: this.$t('VACATION'), Emergency: this.$t('EMERGENCY'), Personal: this.$t('PERSONAL') };
      return reasons;
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.getAbsences();
  },

  methods: {
    getAbsences: function getAbsences() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      if (filter) {
        self.currentPage = 1;
        self.visitedPage = [1];
        self.new_page = true;
        self.absences[self.absenceFrom] = {};
      }
      if (self.absences[self.absenceFrom][self.currentPage - 1] !== undefined) return;
      this.$http.get('/absence?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(self.bindCurrentFilters()) + '&type=' + self.absenceFrom + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(self.absences[self.absenceFrom], self.currentPage - 1, response.data.absences);
        self.totalAbsences = response.data.total;
        self.new_page = self.loading = false;
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(self.absence) && self.$route.params.id) self.getAbsence();
      }).catch(function (error) {
        console.log(error);
      });
    },
    date_format: function date_format(date) {
      if (date === null) return;
      return this.$moment(date).format('DD/MM/YYYY');
    },
    getAbsence: function getAbsence() {
      var self = this;
      this.$http.get('/absence/' + this.$route.params.id).then(function (response) {
        self.showAbsence(response.data.absence);
      });
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.active_filter)) return;
      switch (this.active_filter) {
        case 'reason':
          data.filters['Reason'] = this.Reason;
          break;
        case 'name':
          data.filters['StudentID'] = this.StudentID;
          break;
        case 'date':
          if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(this.date[0]) && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(this.date[1])) break;
          data.filters['minDate'] = this.$moment(this.date[0]).format('YYYY-MM-DD');
          data.filters['maxDate'] = this.$moment(this.date[1]).format('YYYY-MM-DD');
          break;
      }
      return data;
    },
    changeFilter: function changeFilter() {
      this.Reason = '';
    },
    switchTo: function switchTo() {
      this.absenceFrom = this.absenceFrom === 'bus' ? 'school' : 'bus';
      this.currentPage = 1;
      this.visitedPage = [1];
      this.new_page = true;
      this.absences[this.absenceFrom] = {};
      this.getAbsences();
    },
    addAbsence: function addAbsence() {
      this.absence = { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 };
      this.serverCheck = true;
      this.serachStudent = true;
      this.absenceBox = true;
    },
    showAbsence: function showAbsence(absence) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.pickedIndex = index;
      this.absence_status = absence.Status === 1;
      this.absence = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(absence, ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA']);
      this.student = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(absence, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath']);
      this.absence.Completed = true;
      this.absence.Excluded = false;
      this.serverCheck = false;
      this.serachStudent = false;
      this.absenceBox = true;
    },
    updateAbsence: function updateAbsence(_absences) {
      var _this = this;

      var _loop = function _loop(date) {
        var absenceFrom = _absences[date].OnlyFromBus ? 'bus' : 'school';
        if (!_absences[date].Updated || _this.absenceFrom !== absenceFrom) return 'continue';
        var absences = _this.absences[_this.absenceFrom][_this.currentPage - 1];
        var self = _this;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(absences).map(function (key) {
          if (absences[key].AbsentDate === _absences[date].AbsentDate) {
            self.absences[self.absenceFrom][self.currentPage - 1][key] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(absences[key], _absences[date]);
            self.updateDirection(self.absences[self.absenceFrom][self.currentPage - 1][key]);
          }
        });
      };

      for (var date in _absences) {
        var _ret = _loop(date);

        if (_ret === 'continue') continue;
      }
    },
    updateDirection: function updateDirection(absence) {
      switch (absence.Trip) {
        case 1:
          absence.Direction.icon = 'morning-icon';
          absence.Direction.title = 'MORNINGBUS';
          break;
        case 2:
          absence.Direction.icon = 'evening-icon';
          absence.Direction.title = 'AFTERNOONBUS';
          break;
        case 3:
          absence.Direction.icon = 'from-bus';
          absence.Direction.title = 'NOBUS';
          break;
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.absences[this.absenceFrom] = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getAbsences();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      if (isNaN(val)) return;
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getAbsences();
    },
    preDelete: function preDelete(index) {
      var self = this;
      self.listAbsences[self.prevIndex].Deleted = false;
      self.prevIndex = index;
      self.listAbsences[self.prevIndex].Deleted = true;
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { AbsentID: self.listAbsences[index].AbsentID, StudentID: self.listAbsences[index].StudentID, Status: self.listAbsences[index].Status, DeleteNote: self.listAbsences[index].DeleteNote === null ? '' : self.listAbsences[index].DeleteNote };
      this.$http.post('/absence/delete', postData).then(function (response) {
        self.listAbsences[index].Deleted = false;
        self.listAbsences[index].DeletedAt = self.listAbsences[index].DeletedAt !== null ? null : '';
        self.listAbsences[index].Status = self.listAbsences[index].Status === 1 ? 0 : 1;
        if (!response.data.error) self.getAbsences(true);
        self.$message({
          message: !response.data.error ? self.$t('SUCCESSFULLYDELETED') : self.$t('OPERATIONFAILED'),
          type: !response.data.error ? 'success' : 'error',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    showMessageModal: function showMessageModal(student) {
      var self = this;
      self.messageStudent = [];
      this.$http.get('/student/relation?StudentID=' + student.StudentID).then(function (response) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(response.data)) {
          return self.$message({
            message: self.$t('STUDENTHASNOGUARDIAN'),
            type: 'warning',
            showClose: true
          });
        } else {
          self.messageStudent.push(student);
          self.parent = response.data;
          self.messageBox = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(self.FullName)) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findStudent(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findStudent: function findStudent(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
      return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=route', { cancelToken: this.autoSource.token });
    },
    searchStudent: function searchStudent(data) {
      this.StudentID = data.student.StudentID;
      this.getAbsences(true);
    },
    removeNameFilter: function removeNameFilter() {
      this.FullName = null;
      this.StudentID = null;
      this.getAbsences(true);
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
      var load = false;
      if (this.FullName !== null || this.Reason !== null || this.date[0] !== null && this.date[1] !== null) load = true;
      if (load) {
        this.FullName = this.Reason = null;
        this.date = [null, null];
        this.getAbsences(true);
      }
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchText: '',
      loading: false,
      gates: [],
      filteredGates: [],
      currentPage: 1,
      visitedPage: [1],
      currentRow: null,
      tableHeight: 0,
      new_page: false,
      limit: 20,
      total: 0
    };
  },
  mounted: function mounted() {
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.getGates();
  },

  computed: {},
  methods: {
    getGates: function getGates() {
      var self = this;
      this.loading = true;
      this.$http.get('/gate?limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1)).then(function (response) {
        self.gates = response.data.activity;
        self.total = response.data.total;
        console.log(response.data.total);
        self.new_page = self.loading = false;
      }).catch(function (response) {});
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getGates();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.gates = [];
      this.visitedPage = [1];
      this.getGates();
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElAbsenceDialog',
  componentName: 'ElAbsenceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {
        return { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 };
      }
    },
    selectedStudent: {
      type: Object,
      default: function _default() {
        return { FullName_EN: null, FullName_AR: null, ImagePath: null };
      }
    },
    serverCheck: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      this.updateVisible();
    },
    visible: function visible() {
      this.switchLanguage();
      this.dialogVisible = this.visible;
      this.student = '';
      this.searchString = '';
      this.absence = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.data));
      if (this.dialogVisible && !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.data)) this.loadAbsence();
    },

    absence: {
      handler: function handler(item) {
        var trip = item.Trip;
        switch (trip) {
          case 1:
            this.direction = [true, false];
            break;
          case 2:
            this.direction = [false, true];
            break;
          case 3:
            this.direction = [true, true];
            break;
          default:
            this.direction = [false, false];
        }
      },

      deep: true
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      direction: [false, false],
      absence: { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 },
      absences: {},
      existed_absences: {},
      date: [],
      student: {},
      searchString: '',
      message: '',
      error: false,
      saving: false,
      autoSource: null,
      completed_absences: 0,
      CopiedDate: [],
      SelectAll: true,
      scrollHeight: 305
    };
  },

  computed: {
    disableInputs: function disableInputs() {
      if (this.date[0] !== undefined && this.date[0] === null || this.date.length === 0 || this.student.StudentID === undefined) return true;
      return false;
    },
    nonCompletedDates: function nonCompletedDates() {
      var emptyAbsence = { StudentID: this.student.StudentID, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0, Excluded: false, Deleted: false, Completed: false };
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.absences).filter(function (date) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.omit(self.absences[date], ['AbsentID', 'AbsentDate'])) === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(emptyAbsence)) return date;
      });
    },
    checkUp: function checkUp() {
      var self = this;
      if (!this.doValidation() && this.completed_absences !== 0 && this.completed_absences === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.absences).filter(function (date) {
        if (!self.absences[date].Deleted) return date;
      }).length) return false;
      return true;
    },

    copied_date: {
      get: function get() {
        return this.CopiedDate;
      },
      set: function set(val) {
        if (val.indexOf(0) > -1) val.splice(val.indexOf(0), 1);
        this.CopiedDate = val;
      }
    }
  },
  methods: {
    loadAbsence: function loadAbsence() {
      if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.absence.Direction)) {
        var icon = this.absence.Direction.icon;
        switch (icon) {
          case 'morning-icon':
            this.direction = [true, false];
            this.absence.Trip = 1;
            break;
          case 'evening-icon':
            this.direction = [false, true];
            this.absence.Trip = 2;
            break;
          case 'from-bus':
            this.direction = [true, true];
            this.absence.Trip = 3;
            break;
        }
      }
      if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.absence.StudentID)) this.student = this.selectedStudent;
      if (this.absence.AbsentID === null) return;
      var date = this.$moment(this.absence.AbsentDate);
      var absence = this.absence;
      this.absences[date.format('DD/MM/YYYY')] = absence;
      this.$nextTick(function () {
        this.absences[date.format('DD/MM/YYYY')] = absence;
      });
      this.existed_absences[date.format('DD/MM/YYYY')] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.omit(absence, ['Excluded']));
      this.completed_absences++;
      this.date = [date, date];
    },
    hideTag: function hideTag() {
      this.$refs.copyto.$el.firstChild.hidden = true;
    },
    absentFrom: function absentFrom(fromBus) {
      this.absence.OnlyFromBus = fromBus;
      if (fromBus) return;
      this.direction[0] = this.direction[1] = true;
      this.absence.Trip = 3;
    },
    busTrip: function busTrip(key) {
      this.direction[key] = !this.direction[key];
      if (this.direction[0] && !this.direction[1]) this.absence.Trip = 1;
      if (!this.direction[0] && this.direction[1]) this.absence.Trip = 2;
      if (this.direction[0] && this.direction[1]) this.absence.Trip = 3;
      this.updateDirection(this.absence.Trip);
    },
    selectAll: function selectAll() {
      var dates = [];
      if (this.SelectAll) dates = this.nonCompletedDates;
      this.CopiedDate = dates;
      this.SelectAll = !this.SelectAll;
    },
    date_format: function date_format(date) {
      if (date === null) return;
      return this.$moment(date).format('DD/MM/YYYY');
    },
    updateDirection: function updateDirection(trip) {
      if (this.absence.Direction === undefined) return;
      switch (trip) {
        case 1:
          this.absence.Direction.icon = 'morning-icon';
          this.absence.Direction.title = 'MORNINGBUS';
          break;
        case 2:
          this.absence.Direction.icon = 'evening-icon';
          this.absence.Direction.title = 'AFTERNOONBUS';
          break;
        case 3:
          this.absence.Direction.icon = 'from-bus';
          this.absence.Direction.title = 'NOBUS';
          break;
      }
    },
    updateVisible: function updateVisible() {
      this.$emit('update:visible', this.dialogVisible);
    },
    saveAbsence: function saveAbsence() {
      var self = this;
      self.saving = true;
      var postData = self.filterApiData();
      this.$http.post('/absence/save', { absence: postData }).then(function (response) {
        var data = response.data;
        self.saving = false;
        self.dialogVisible = false;
        self.message = data.message;
        self.error = data.error;
        if (!data.error) {
          self.$emit('update', postData);
          self.$message({ message: self.$t('ABSENCEISRECORDED'), type: 'success' });
          return;
        }
      }).catch(function () {});
    },
    copy: function copy(date) {
      if (date.length === 0) return;
      var absence = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.absences[date]);
      this.CopiedDate.push(date);
      absence.AbsentDate = this.absence.AbsentDate;
      absence.AbsentID = null;
      if (!this.absence.Completed) this.completed_absences++;
      this.absences[this.$moment(absence.AbsentDate).format('DD/MM/YYYY')] = this.absence = absence;
    },
    copiesTo: function copiesTo() {
      if (this.CopiedDate.length === 0) return;
      var obj = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.omit(this.absence, ['AbsentID', 'AbsentDate']);
      var self = this;
      this.CopiedDate.map(function (item) {
        var source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(self.absences[item], ['AbsentID', 'AbsentDate']));
        self.completed_absences++;
        self.absences[item] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(source, obj);
      });
      this.CopiedDate = [];
      this.$message({ message: this.$t('SUCCESSFULLYCOPIED') });
    },
    filterApiData: function filterApiData() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.absences).filter(function (date) {
        var Deleted = self.absences[date].Deleted;
        self.absences[date] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.omit(self.absences[date], ['Excluded']);
        for (var existed in self.existed_absences) {
          if (existed === date && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.absences[date]) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.existed_absences[existed])) self.absences[date].Updated = true;
        }
        if (!Deleted) return date;
      }).map(function (date) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.omit(self.absences[date], ['Completed', 'Deleted']);
      });
    },
    cancelPopover: function cancelPopover(key) {
      this.$refs[key][0].showPopper = false;
    },
    preDelete: function preDelete(key) {
      this.absence = this.absences[key];
      if (this.absences[key].AbsentID === null && !this.absences[key].Deleted) {
        if (this.absence.Completed) this.completed_absences--;
        return this.absences[key].Deleted = true;
      } else if (this.absences[key].AbsentID === null && this.absences[key].Deleted) {
        if (this.absence.Completed) this.completed_absences++;
        return this.absences[key].Deleted = false;
      }
    },
    doValidation: function doValidation() {
      if (this.absence['Deleted']) return false;
      var absence = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(this.absence, ['StudentID', 'AbsentDate', 'OnlyFromBus', 'Reason']);
      for (var key in absence) {
        if (this.absence[key] === null) return true;
      }
      if (!this.absence.Completed) {
        this.completed_absences++;
        this.absence.Completed = true;
      }
      return false;
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findStudent(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findStudent: function findStudent(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken.source();
      return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=absence', { cancelToken: this.autoSource.token });
    },
    addStudent: function addStudent(data) {
      this.student = data.student;
    },
    clearInput: function clearInput() {
      this.clearData();
      this.dialogVisible = true;
    },
    clearDates: function clearDates() {
      this.completed_absences = 0;
      this.SelectAll = true;
      this.CopiedDate = [];
      this.absences = this.existed_absences = {};
      this.absence = { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 };
      this.scrollHeight = 0;
      this.$nextTick(this.$refs.dateScroll.update);
    },
    clearData: function clearData() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    reportedAbsences: function reportedAbsences(start) {
      if (this.disableInputs || !this.serverCheck) return;
      var self = this;
      this.$http.get('/absence?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({ filters: { minDate: this.$moment(this.date[0]).format('YYYY-MM-DD'), maxDate: this.$moment(this.date[1]).format('YYYY-MM-DD'), StudentID: this.student.StudentID } })).then(function (response) {
        var absences = response.data.absences;
        for (var key in absences) {
          absences[key] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(absences[key], ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA', 'Deleted']);
          var date = self.$moment(absences[key].AbsentDate).format('DD/MM/YYYY');
          absences[key].Completed = true;
          self.completed_absences++;
          self.existed_absences[date] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, absences[key]);
          self.absences[date] = absences[key];
          self.absences[date].Excluded = false;
        }
        self.absence = self.absences[self.$moment(start).format('DD/MM/YYYY')];
      }).catch(function (error) {
        console.log(error);
      });
    },
    setDate: function setDate(value) {
      if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(value)) return this.clearDates();
      if (this.dialogVisible === false) return;
      if (this.disableInputs) return this.date = [];
      var start = this.$moment(this.date[0]).format();
      var end = this.$moment(this.date[1]).format();
      var absences = {};
      for (var m = this.$moment(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
        var date = m.format('DD/MM/YYYY');
        if (this.absences[date] === undefined && date !== undefined) {
          absences[date] = { AbsentID: null, StudentID: this.student.StudentID, AbsentDate: m.format('YYYY-MM-DD'), Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0, Excluded: false, Deleted: false, Completed: false };
        } else {
          absences[date] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.absences[date]);
        }
      }
      this.reportedAbsences(start);
      this.absences = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, absences);
      this.scrollHeight = 305;
      this.$nextTick(this.$refs.dateScroll.update);
    },
    toggleStatus: function toggleStatus(index) {
      var postData = { AbsentID: this.absence.AbsentID, StudentID: this.absence.StudentID, DeleteNote: this.absence.DeleteNote === null ? '' : this.absence.DeleteNote, Status: this.absence.Deleted };
      var self = this;
      this.$http.post('/absence/toggle', postData).then(function (response) {
        self.$refs[index][0].showPopper = false;
        self.$nextTick(function () {
          self.$refs[index][0].showPopper = false;
        });
        var Deleted = !self.absence.Deleted;
        self.absences[index].Deleted = Deleted;
        !Deleted ? self.completed_absences++ : self.completed_absences--;
        self.$message({
          message: !response.data.error ? 'Operation completed' : self.$t('OPERATIONFAILED'),
          type: !response.data.error ? 'success' : 'error',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var userData = null;



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElAuthDialog',
  componentName: 'ElAuthDialog',
  props: {
    sessionExpiration: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'SESSIONABOUTTOEXPIRESOON'
    },
    timer: {
      type: String,
      default: null
    },
    configuration: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itSelf: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    sessionDialog: function sessionDialog() {
      this.$emit('update:visible', this.sessionDialog);
    },
    visible: function visible() {
      this.switchLanguage();
      userData = JSON.parse(localStorage.getItem('userData'));
      this.sessionDialog = this.visible;
    }
  },
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('ISREQUIRED')));
      }
      callback();
    };
    return {
      rules: { pass: { validator: validatePass, trigger: 'blur' } },
      session: { pass: '' },
      sessionDialog: false,
      loading: false
    };
  },
  updated: function updated() {},

  methods: {
    submitForm: function submitForm() {
      var self = this;
      this.$refs.session.validate(function (valid) {
        if (valid) return self.extendSession();
        return false;
      });
    },
    showTimer: function showTimer() {
      if (!this.itSelf) return false;
      if (this.sessionExpiration === null) return false;
      return true;
    },
    extendSession: function extendSession() {
      var data = userData;
      var postData = !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.configuration) ? { user: { username: data.username, password: this.session.pass, school: data.school_access, lang: localStorage.getItem('lang') } } : { username: data.username, password: this.session.pass, school: data.school_access, lang: localStorage.getItem('lang') };
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.configuration)) postData.configuration = this.configuration;
      var self = this;
      self.loading = true;
      var endpoint = 'auth';
      if (!this.itSelf) endpoint = self.$route.path.split('/')[2] + '/save';
      this.$http.post('/' + endpoint, postData).then(function (response) {
        self.loading = false;
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(response.data, 'user_data')) {
          if (response.data.error) return self.$message({ type: 'warning', message: self.$t(response.data.message) });
          userData = response.data.user_data;
          var locale = { 'country': userData.school_location.country, 'timeZone': 'N/A' };
          localStorage.setItem('lang', userData.lang);
          localStorage.setItem('locale', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(locale));
          __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["EventBus"].$emit('userData', userData);
        }
        self.$emit('authBack', response.data);
        self.session.pass = null;
        self.sessionDialog = false;
      }).catch(function (response) {});
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElDocDialog',
  componentName: 'ElDocDialog',
  props: {
    document: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'DOCUMENTS'
    },
    subFolder: {
      type: String,
      default: 'documents'
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      this.$emit('update:visible', this.dialogVisible);
    },
    visible: function visible() {
      this.switchLanguage();
      this.dialogVisible = this.visible;
      this.height = 300;
      this.doResize(0);
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      fileType: { 'pdf': 'fa-file-pdf-o red-color', 'doc': 'fa-file-word-o blue-color', 'docx': 'fa-file-word-o blue-color' },
      height: 300
    };
  },
  updated: function updated() {},

  methods: {
    getDoc: function getDoc(image) {
      // return this.getAsset(image, 'bus')
    },
    filterExtension: function filterExtension(value) {
      var ext = value.split('.');
      if (this.fileType[ext[1]] !== undefined) return this.fileType[ext[1]];
      return false;
    },
    doResize: function doResize(index) {
      if (this.$refs.caroItem === undefined || !this.visible) return;
      this.$nextTick(function () {
        var image = this.$refs.caroItem[index].$el.children[0].children[0];
        if (image === undefined) return;
        if (image.clientHeight !== 0) {
          this.height = image.clientHeight + 50;
          if (this.height < 300) this.height = 300;
          return;
        }
        var self = this;
        image.addEventListener('load', function () {
          self.height = this.height + 50;
          if (self.height < 300) self.height = 300;
        });
      });
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElImportDialog',
  componentName: 'ElImportDialog',
  props: {
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    CSVReader: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    CSVFile: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    uri: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      this.$emit('update:visible', this.dialogVisible);
    },
    visible: function visible() {
      this.switchLanguage();
      this.dialogVisible = this.visible;
      this.required_fields = this.fields.filter(function (obj) {
        return obj.required;
      }).length;
      this.csv_reader = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(this.CSVReader);
      this.csv_file = this.CSVFile;
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      importing: false,
      importValue: null,
      importValues: {},
      registredFields: [],
      importedData: {},
      importData: [],
      importField: null,
      required_fields: null,
      csv_reader: null,
      csv_file: '',
      formats: {}
    };
  },
  mounted: function mounted() {
    var date = this.$moment().set({ 'month': 12, 'date': 31 });
    this.formats = { date: [{ format: 'm-d-y', value: date.format('MM-DD-YY') }, { format: 'm-d-Y', value: date.format('MM-DD-YYYY') }, { format: 'd-m-y', value: date.format('DD-MM-YY') }, { format: 'd-m-Y', value: date.format('DD-MM-YYYY') }, { format: 'y-m-d', value: date.format('YY-MM-DD') }, { format: 'Y-m-d', value: date.format('YYYY-MM-DD') }, { format: 'y-d-m', value: date.format('YY-DD-MM') }, { format: 'Y-d-m', value: date.format('YYYY-DD-MM') }, { format: 'M-d-y', value: date.format('MMM-DD-YY') }, { format: 'M-d-Y', value: date.format('MMM-DD-YYYY') }, { format: 'j-M-y', value: date.format('DD-MMM-YY') }, { format: 'j-M-Y', value: date.format('DD-MMM-YYYY') }, { format: 'y-d-M', value: date.format('YY-DD-MMM') }, { format: 'Y-d-M', value: date.format('YYYY-DD-MMM') }] };
  },

  methods: {
    cancelImport: function cancelImport() {
      this.dialogVisible = false;
      this.csv_file = this.importField = this.importValue = null;
      this.importValues = this.csv_reader = {};
      this.registredFields = this.importData = [];
    },
    resetValue: function resetValue(key) {
      var item = this.importValues[key];
      if (item.required) this.required_fields++;
      var index = this.registredFields.indexOf(item.csv_field);
      this.$delete(this.registredFields, index);
      this.$delete(this.importValues, key);
      this.importedFields();
    },
    isSet: function isSet(key, value) {
      if (value === undefined) {
        if (this.importValues[key] === undefined) return true;
        return false;
      }
      if (this.registredFields.indexOf(key) < 0) return true;
      return false;
    },
    setValue: function setValue(fill) {
      if (this.importField === null) return;
      if (this.importField.required) this.required_fields--;
      this.importValues[this.importField.field] = { field: this.importField.field, name: this.importField.label, format: this.importField.format, required: this.importField.required, format_value: 'd-m-Y', value: this.csv_reader[fill], csv_field: fill };
      this.registredFields.push(fill);
      this.importField = this.importValue = null;
      this.importedFields();
    },
    importedFields: function importedFields() {
      var data = [];
      for (var item in this.importValues) {
        data.push(this.importValues[item]);
      }
      this.importData = data;
    },
    startImporting: function startImporting() {
      this.importing = true;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.importedData).length === 0) return this.import();
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.csv_reader = response.fields;
      this.csv_file = response.file_name;
    },
    import: function _import() {
      var self = this;
      var postData = { cvs_file: self.csv_file, cvs_fields: self.importValues };
      this.$http.post('/' + self.uri, postData).then(function (response) {
        self.cvs_file = self.importField = self.importValue = null;
        self.importValues = self.csv_reader = {};
        self.registredFields = [];
        self.importing = false;
        self.$alert(self.$t('SUCCESSFULLYIMPORTED') + ' ' + self.title + ' ' + self.$t('DATA'), {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: self.$t('CLOSE'),
          callback: function callback(action) {
            self.$emit('reCall', {});
            self.importData = [];
            self.dialogVisible = false;
          }
        });
      }).catch(function (error) {
        self.$alert(self.$t('FAILEDIMPORT'), {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: self.$t('CLOSE'),
          callback: function callback(action) {
            self.importing = false;
            self.cancelImport();
          }
        });
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElIncidentDialog',
  componentName: 'ElIncidentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    incident: {
      type: Object,
      default: function _default() {
        return { incident_type: null, bus: {}, monitor: {}, Lat: null, Lng: null };
      }
    },
    alert: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      this.$emit('update:visible', this.dialogVisible);
    },
    visible: function visible() {
      this.switchLanguage();
      if (this.visible) this.loadIncident();
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      sendReport: false,
      popperVisible: false,
      loadingSend: false,
      message: { Recipient: null, RecipientID: 0, hasAttachment: false, Text: '' },
      center: { lat: 0, lng: 0 },
      school: { lat: 0, lng: 0 },
      marker: { lat: 0, lng: 0, icon: { url: __webpack_require__(21) } },
      maps: null,
      map: null,
      total: 0,
      imageVisible: false
    };
  },

  methods: {
    loadIncident: function loadIncident() {
      var userData = JSON.parse(localStorage.getItem('userData'));
      this.school = this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
      this.getIncident();
    },
    sendIncidentReport: function sendIncidentReport() {
      this.sendReport = false;
      this.incident.statusColor = 1;
    },
    markResolved: function markResolved() {
      var status = '';
      if (this.incident.statusColor === 0) status = 'Reopen';
      this.resolve(status);
    },
    loadMap: function loadMap() {
      var self = this;
      self.dialogVisible = self.visible;
      this.$google.then(function (Maps) {
        console.log('LOADED');
        self.maps = Maps;
        self.map = new Maps.Map(document.getElementById('gmap-incident'), {
          center: self.center,
          zoom: 15
        });
        if (self.incident.Lat === null) return;
        var position = new Maps.LatLng(parseFloat(self.incident.Lat), parseFloat(self.incident.Lng));
        var infoWindow = new Maps.InfoWindow();
        infoWindow.setContent(self.$refs.student.$el.innerHTML);
        var marker = new Maps.Marker({
          position: position,
          icon: {
            path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
            fillColor: 'red',
            fillOpacity: 1,
            strokeColor: 'red'
          },
          map: self.map
        });
        self.map.setCenter(position);
        Maps.event.addListener(marker, 'click', function () {
          infoWindow.open(self.map, marker);
        });
        Maps.event.addListenerOnce(self.map, 'tilesloaded', function () {
          infoWindow.open(self.map, marker);
        });
      });
    },
    getIncident: function getIncident() {
      this.total = this.incident.students.length;
      var students = this.incident.student_id;
      if (this.total > 0 || students.length === 0) return this.loadMap();
      var self = this;
      var promises = [];
      for (var student in students) {
        var StudentID = this.incident.student_id[student];
        promises.push(this.getStudent(StudentID));
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (results) {
        for (var result in results) {
          var data = results[result].data;
          if (data.student !== null) {
            self.incident.students.push(data.student);
          }
        }
        self.total = self.incident.students.length;
      }).then(function () {
        self.loadMap();
      });
    },
    getStudent: function getStudent(StudentID) {
      return this.$http.get('/student/' + StudentID);
    },
    reportIncident: function reportIncident() {
      this.message.Text = '';
      if (this.incident.statusColor === 0) {
        this.popperVisible = true;
      } else this.sendReport = true;
    },
    resolve: function resolve(to) {
      var status = 0;
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(to)) status = 1;
      if (to === 'Reopen') status = 2;
      var postData = { IncidentID: this.incident.incident_id, status: this.incident.statusColor, IncidentStatus: status };
      this.$http.post('/incident/status', postData).then(function (response) {
        self.incident.status = response.data.status;
        self.incident.statusColor = response.data.statusColor;
        self.popperVisible = false;
        self.$message({
          message: to !== 'Reopen' ? self.$t('RESOLVED') : self.$t('RE-OPENED'),
          type: 'success',
          showClose: true
        });
      }).catch(function () {});
    },
    deleteIncident: function deleteIncident() {
      this.$emit('deleteIncident', { statusColor: this.incident.statusColor, show: !this.incident.IsSticky });
      this.dialogVisible = false;
    },
    reportTo: function reportTo() {
      var self = this;
      self.loadingSend = true;
      switch (this.message.Recipient) {
        case 6:
          this.message.RecipientID = this.incident.student_id;
          break;
        case 7:
        case 8:
          this.message.incident = this.incident;
          break;
      }
      var postData = { message: this.message };
      this.$http.post('/message/send', postData).then(function (response) {
        self.$message({
          message: self.$t(response.data.message),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
        self.loadingSend = false;
        if (!response.data.error) {
          setTimeout(function () {
            self.sendReport = false;
          }, 1500);
        }
      }).catch(function () {});
    },
    hideParentsOption: function hideParentsOption() {
      if (this.incident.student_id === undefined) return;
      if (this.incident.student_id.length > 0) return true;
      return false;
    },
    printIncident: function printIncident() {
      this.$nextTick(function () {
        var card = this.$refs.printIncident.innerHTML;
        var w = window.open();
        w.document.write('<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>Print it!</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/element-ui/1.4.9/theme-default/index.css"><style> @media print {.gm-style .gmnoprint:not(img), .gmnoprint:not(img){display: none;}}@media screen{.gm-style .gmnoscreen, .gmnoscreen {display:none}}@media print{body{-webkit-print-color-adjust: exact;}} .el-dialog--tiny{width: 60%;} .img-circle{width: 50px;float: left;margin-right: 10px;border-radius: 50%;} .el-dialog__body{padding:15px 0} .el-dialog__footer, .el-dialog__header button{display: none;}</style></head><body>');
        var s = w.document.createElement('script');
        s.type = 'text/javascript';
        s.src = __webpack_require__(80);
        w.document.write(card);
        w.document.body.appendChild(s);
        w.document.write('</body></html>');
        w.setTimeout(function () {
          w.print();
          w.close();
        }, 1000);
      });
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElMessageDialog',
  componentName: 'ElMessageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    studentList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      messageBox: false,
      compose: { Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: { Filename: null }, parentID: null, threadID: null, groupTextID: null },
      message: '',
      grades: [],
      grade: {},
      classes: [],
      buses: { 4: [], 5: [] },
      classID: null,
      loadingSend: false,
      person: '',
      personName: '',
      students: [],
      maxLimit: 256,
      errorMessage: null,
      error: false,
      attached: null,
      autoSource: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('boarding', function (boarding) {
      var TripID = boarding.TripID;
      if (__WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].recorded.indexOf(TripID) >= 0) return;
      _this.getBoardedTrips();
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].recorded.push(TripID);
    });
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('trip', function (trip) {
      if (trip.IsClosed !== 1) return;
      var index = __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].recorded.indexOf(trip.TripID);
      if (index < 0) return;
      _this.getBoardedTrips();
      _this.$delete(__WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].recorded, index);
    });
  },

  computed: {
    Grade: {
      get: function get() {
        return this.grade;
      },
      set: function set(Grade) {
        this.grade = Grade;
        this.compose.RecipientID = Grade.Name;
      }
    }
  },
  watch: {
    messageBox: function messageBox() {
      this.updateVisible();
    },
    visible: function visible() {
      this.switchLanguage();
      this.messageBox = this.visible;
      if (!this.showRemove && !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.studentList)) {
        this.compose.Recipient = 6;
        if (this.studentList.length === 1) this.compose.RecipientID = this.studentList[0].StudentID;
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(parent)) this.getRelation();else this.person = this.parent;
        this.students = this.studentList;
      } else this.loadDropDownData();
    }
  },
  methods: {
    updateVisible: function updateVisible() {
      this.$emit('update:visible', this.messageBox);
    },
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    sendMessage: function sendMessage() {
      this.compose.ClassID = this.classID;
      var postData = { message: this.compose };
      var self = this;
      self.loadingSend = true;
      this.$http.post('/message/send', postData).then(function (response) {
        self.loadingSend = false;
        if (response.data.error && (self.compose.Recipient === '4' || self.compose.Recipient === '5')) self.getBoardedTrips();
        self.$message({
          message: self.$t(response.data.message),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
        self.messageBox = false;
      }).catch(function () {});
    },
    loadDropDownData: function loadDropDownData() {
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.grades) || !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.buses[4])) return;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.$http.get('/configuration/grade'), this.$http.get('/bus/assigned'), this.$http.get('/bus/boarded_trips')]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (grades, assigned, boarded) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(self.buses, 4, assigned.data);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(self.buses, 5, boarded.data);
        self.grades = grades.data;
      })).catch(function (response) {
        console.log(response);
      });
    },
    getBoardedTrips: function getBoardedTrips() {
      var self = this;
      this.$http.get('/bus/boarded_trips').then(function (response) {
        if (response.data) __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(self.buses, 5, response.data);
      }).catch(function (response) {});
    },
    clearInput: function clearInput() {
      delete this.compose.PersonID;
      this.person = '';
      this.students = [];
      this.compose.RecipientID = null;
      this.personName = '';
    },
    clearCompose: function clearCompose() {
      this.person = '';
      this.attached = null;
      this.students = [];
      this.personName = '';
      this.compose = { Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: { Filename: null }, parentID: null, threadID: null, groupTextID: null };
    },
    getMonitor: function getMonitor(id) {
      var self = this;
      this.$http.get('/supervisor/' + id + '').then(function (response) {
        self.person = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addPerson: function addPerson(data) {
      this.person = data.person;
      this.personName = data.value;
      this.compose.RecipientID = this.person.BusMonitorID;
      this.students = [];
      this.getStudents(this.person.PersonID);
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (self.student === null) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findPerson(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findPerson: function findPerson(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
      return this.$http.get('/message/find?term=' + queryString + '&lang=' + localStorage.getItem('lang'), { cancelToken: this.autoSource.token });
    },
    getStudents: function getStudents(GuardianID) {
      var self = this;
      this.$http.get('/guardian/' + GuardianID + '').then(function (response) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(response.data.students)) return;
        self.students = response.data.students;
        if (self.students.length === 1) self.compose.RecipientID = self.students[0].StudentID;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getRelation: function getRelation() {
      var self = this;
      self.students = [];
      self.person = '';
      this.$http.get('/student/relation?StudentID=' + this.student[0].StudentID).then(function (response) {
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(response.data)) self.person = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    validateInput: function validateInput() {
      var AntiID = ['0', '1'];
      if (this.attached !== null && !this.attached) return true;
      if (this.compose.Recipient === null) return true;
      if (AntiID.indexOf(this.compose.Recipient) < 0) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.compose.RecipientID)) return true;
      }
      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.compose.Text)) return true;
      return false;
    },
    textLimit: function textLimit() {
      if (this.compose.Text === null) return this.maxLimit;
      return this.maxLimit - this.compose.Text.length;
    },
    updateFile: function updateFile(response, file, fileList) {
      this.compose.hasAttachment = this.attached = true;
      this.compose.Attachment.Filename = response.file_name;
      this.compose.Attachment.type = file.raw.type;
    },
    handleRemove: function handleRemove() {
      this.attached = null;
      this.compose.hasAttachment = false;
      this.compose.Attachment = {};
    },
    limitFile: function limitFile(event, file, fileList) {
      this.attached = false;
      if (fileList.length > 1) fileList.splice(0, 1);
    },
    showStudentsList: function showStudentsList(StudentID) {
      var expand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (expand && this.students.length === 1) return false;
      if (!expand && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.compose.RecipientID)) return true;
      if (this.compose.RecipientID === StudentID) return true;
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text';
      var isLt2KB = file.size / 1024 < 400;
      this.errorMessage = {};
      if (!isJPG) {
        this.errorMessage['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt';
      }
      if (!isLt2KB) {
        this.errorMessage['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errorMessage).length !== 0) this.error = true;
      return isJPG && isLt2KB;
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Auth__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Auth__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-auth-dialog': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Auth___default.a },
  name: 'WiSave',
  componentName: 'WiSave',
  props: {
    data: {
      required: true,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    form: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    redirect: {
      type: Boolean,
      default: true
    },
    auth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      saving: false,
      messageBox: false,
      sessionDialog: false,
      message: [],
      error: false,
      fields: {}
    };
  },

  computed: {},
  mounted: function mounted() {
    this.switchLanguage();
  },

  methods: {
    printError: function printError(message) {
      if (this.saving === null) return message + '</br>';
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    formValidated: function formValidated() {
      var _this = this;

      var errors = [];
      var forms = {};
      var data = {};
      var ref = this.$parent.$parent.$refs;
      this.form.forEach(function (form) {
        forms[form] = ref[form];
      });
      this.saving = null;
      for (var form in forms) {
        var _loop = function _loop(field) {
          var fields = forms[form].fields;
          var formField = fields[field].prop;
          var label = fields[field].label === undefined ? fields[field].$parent.labelSuffix : fields[field].label;
          _this.fields[formField] = { rules: fields[field].rules, name: form };
          forms[form].validateField(formField, function (errorMessage) {
            if (errorMessage === '') return;
            if (errorMessage.indexOf(label) >= 0) errors.push(errorMessage);else errors.push(label + ' ' + errorMessage);
          });
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(fields[field].rules) === 'object' && fields[field].rules.type === 'date') {
            for (var key in _this.data) {
              if (data[key] === undefined) data[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.data[key]);
              if (data[key][formField] !== undefined) data[key][formField] = _this.$moment(fields[field].fieldValue).format('YYYY-MM-DD');
            }
          }
        };

        for (var field in forms[form].fields) {
          _loop(field);
        }
      }
      if (errors.length === 0) return data;
      this.message = errors;
      this.error = true;
      return false;
    },
    save: function save() {
      var data = this.formValidated();
      if (!data) return;
      if (this.auth) return this.sessionDialog = true;
      var self = this;
      self.saving = true;
      var path = self.$route.path.split('/');
      this.$http.post('/' + path[2] + '/save', data).then(function (response) {
        var data = response.data;
        self.saving = false;
        self.error = data.error;
        if (!self.error) return self.success(data);
        var ref = self.$parent.$parent.$refs;
        self.message = [];
        self.saving = null;

        var _loop2 = function _loop2(_message) {
          var form = self.fields[_message];
          var field = ref[form.name].fields.filter(function (field) {
            return field.prop === _message;
          })[0];
          var rule = field.rules.filter(function (rule) {
            return rule.validate === true;
          })[0];
          if (rule) {
            rule.validator = function (rule, value, callback) {
              callback('');
            };
          }
          ref[form.name].validateField(_message, function (error) {
            self.message.push(error);
          });
        };

        for (var _message in data.message) {
          _loop2(_message);
        }
      }).catch(function () {});
    },
    success: function success(data) {
      var path = this.$route.path.split('/');
      delete path.splice(-1, 1);
      if (this.redirect) this.$router.push({ path: path.join('/') });
      this.$message({ message: this.$t(data.message, { component: this.title.split(' ')[1] }), type: 'success', showClose: true });
      return;
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElTagDialog',
  componentName: 'ElTagDialog',
  props: {
    student: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    callScan: {
      type: Boolean,
      default: false
    },
    findTag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      timer: 3,
      port: 55136,
      scannedRFID: '',
      dialogVisible: false,
      RFID: false,
      saving: false,
      message: null,
      scanning: null,
      error: false,
      disableTag: false
    };
  },

  watch: {
    callScan: function callScan() {
      this.switchLanguage();
      if (this.callScan) return this.scanRFID(this.student);
      if (this.callScan && this.findTag) return this.scanRFID(this.student, this.findTag);
    },
    RFID: function RFID() {
      this.updateCallScan();
    }
  },
  computed: {
    check: function check() {
      return this.findTag;
    }
  },
  methods: {
    closeModal: function closeModal(done) {
      var self = this;
      self.RFID = false;
      self.timer = 3;
      setTimeout(function () {
        self.scannedRFID = '';
        self.message = null;
        self.disableTag = self.error = self.saving = false;
        self.scanning = 0;
      }, 1000);
    },
    reScan: function reScan() {
      if (this.disableTag) return false;
      if (this.error || this.scannedRFID !== '') return true;
      if (this.scanning === 1) return false;
      if (this.student.AssignedTagID !== null) return true;
      if (this.timer === 0 && this.error) return true;
      return false;
    },
    disable: function disable() {
      if (this.student.StudentID === null) return false;
      if (this.check) return false;
      if (this.student.AssignedTagID !== null && this.student.AssignedTagID === this.scannedRFID) return true;
      return false;
    },
    scanRFID: function scanRFID(item) {
      var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.check) this.check = check;
      this.RFID = true;
      this.error = false;
      this.message = null;
      this.timer = 3;
      if (item !== undefined) {
        this.student = item;
        this.scanning = 0;
        if (item.AssignedTagID !== null) {
          this.scannedRFID = item.AssignedTagID;
          return;
        }
      }
      if (item === undefined) {
        this.scannedRFID = '';
        this.scanning = 1;
      } else {
        if (item.AssignedTagID === null) this.scanning = 1;
      }
      var self = this;
      var timer = setInterval(function () {
        if (self.timer === 1) self.getTagID();
        if (self.timer === 0) return clearInterval(timer);
        self.timer -= 1;
      }, 1000);
    },
    confirmScan: function confirmScan() {
      if (this.disableTag) return true;
      if (this.scannedRFID !== '') {
        if (this.student.AssignedTagID !== this.scannedRFID) return true;
      }
      return false;
    },
    saveTagID: function saveTagID() {
      var self = this;
      if (self.disableTag) self.scannedRFID = null;
      self.message = null;
      self.saving = true;
      var postData = { StudentID: self.student.StudentID, AssignedTagID: self.scannedRFID };
      this.$http.post('/student/save_tag', postData).then(function (response) {
        var data = response.data;
        self.message = data.message;
        self.error = data.error;
        if (!self.error) {
          self.student.AssignedTagID = self.scannedRFID;
          setTimeout(function () {
            self.closeModal(null);
          }, 1000);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    base_convert: function base_convert(number, from, to) {
      if (number === null) return;
      if ((from && to) < 2 || (from && to) > 36) return this.$t('BASEBETWEEN');
      return parseInt(number + '', from).toString(to);
    },
    getTagID: function getTagID() {
      var self = this;
      this.$http.get('http://localhost:' + self.port + '/Home/Index').then(function (response) {
        console.log(response.data);
        if (response.data.success === 1) {
          var tagID = self.base_convert(response.data.tag, 16, 10);
          if (!self.check) return self.checkTagID(tagID);
          return self.studentTag(tagID);
        }
      }).catch(function (error) {
        console.log(error);
        if (self.scannedRFID !== '') return;
        self.error = true;
      });
    },
    studentTag: function studentTag(tagID) {
      var self = this;
      this.$http.get('/student/tag?AssignedTagID=' + tagID).then(function (response) {
        var data = response.data;
        if (!data.error) {
          self.student = data.student;
          self.scannedRFID = tagID;
          // self.scanning = null
          self.scanning = 0;
          self.disableTag = true;
          return;
        }
        self.error = data.error;
        self.message = data.message;
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkTagID: function checkTagID(tagID) {
      var self = this;
      this.$http.get('/student/tag_check?StudentID=' + self.student.StudentID + '&AssignedTagID=' + tagID).then(function (response) {
        var data = response.data;
        if (!data.error) {
          self.scannedRFID = tagID;
          // self.scanning = null
          self.scanning = 0;
          return;
        }
        self.error = data.error;
        self.message = data.message;
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateCallScan: function updateCallScan() {
      this.$emit('update:callScan', this.RFID);
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_core_image_upload__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_core_image_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VueCoreImageUpload: __WEBPACK_IMPORTED_MODULE_0_vue_core_image_upload___default.a },
  name: 'WiUpload',
  componentName: 'WiUpload',
  props: {
    person: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    logo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      messageBox: false,
      message: null,
      folder: null
    };
  },

  computed: {
    imagePath: function imagePath() {
      return this.person.ImagePath !== undefined ? this.person.ImagePath : this.person.Logo;
    }
  },
  mounted: function mounted() {
    this.folder = this.$route.path.split('/')[2];
    this.switchLanguage();
  },

  methods: {
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) {
        if (this.person.ImagePath !== undefined) this.person.ImagePath = res.file_name;
        if (this.person.Logo !== undefined) this.person.Logo = res.file_name;
      }
    },
    imageError: function imageError(res) {
      var string = res.split(' ');
      this.message = this.$t(string[0], { param: string[1] });
      this.messageBox = true;
    },
    resetUpload: function resetUpload() {}
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-incident-dialog': __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Incident___default.a },
  data: function data() {
    return {
      incidents: [],
      incident: { incident_type: null, bus: { Label: null }, monitor: {} },
      students: {},
      loading: true,
      status: { 0: 'success', 1: 'warning', 2: 'danger' },
      filter: null,
      active_filter: 'monitor',
      BusMonitorID: '',
      BusID: '',
      TypeIncidentID: '',
      Status: '',
      incidentBox: false,
      monitors: [],
      buses: [],
      totalIncidents: 0,
      currentPage: 1,
      visitedPage: [1],
      new_page: false,
      limit: 20,
      tableHeight: 0
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.getIncidents();
    this.getMonitors();
    this.incidentNotification();
  },

  computed: {
    options: function options() {
      var options = [{
        value: 'monitor',
        label: this.$t('SUPERVISOR')
      }, {
        value: 'bus',
        label: this.$t('BUS')
      }, {
        value: 'type',
        label: this.$t('INCIDENTTYPE')
      }, {
        value: 'status',
        label: this.$t('STATUS')
      }];
      return options;
    },
    incidentTypes: function incidentTypes() {
      var incidentTypes = { 1: this.$t('CHILDBEHAVIOUR'), 2: this.$t('MEDICAL'), 3: this.$t('DRIVERISSUE'), 4: this.$t('BUSPROBLEM'), 5: this.$t('ACCIDENT'), 6: this.$t('TRAFFIC'), 7: this.$t('CALLPOLICE'), 8: this.$t('CALLSCHOOL'), 9: this.$t('OTHER') };
      return incidentTypes;
    },
    reportStatus: function reportStatus() {
      var reportStatus = { 0: this.$t('RESOLVED'), 1: this.$t('REPORTED'), 2: this.$t('OPEN') };
      return reportStatus;
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.incidents = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getIncidents();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getIncidents();
    },
    getIncidents: function getIncidents() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      if (filter) {
        self.currentPage = 1;
        self.visitedPage = [1];
        self.new_page = true;
        self.incidents = {};
      }
      if (self.incidents[self.currentPage - 1] !== undefined) return;
      this.$http.get('/incident?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.incidents, self.currentPage - 1, response.data.incidents);
        self.totalIncidents = response.data.total;
        self.new_page = self.loading = false;
      }).catch(function (response) {});
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      switch (this.active_filter) {
        case 'monitor':
          data.filters['BusMonitorID'] = this.BusMonitorID;
          break;
        case 'bus':
          data.filters['BusID'] = this.BusID;
          break;
        case 'type':
          data.filters['TypeIncidentID'] = this.TypeIncidentID;
          break;
        case 'status':
          data.filters['Status'] = this.Status;
          break;
      }
      return data;
    },
    showIncident: function showIncident(incident) {
      this.incident = incident;
      this.incidentBox = true;
    },
    changeFilter: function changeFilter() {
      this.BusMonitorID = this.BusID = this.Status = '';
      switch (this.active_filter) {
        case 'monitor':
          this.getMonitors();
          break;
        case 'bus':
          this.getBuses();
          break;
      }
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.incidents = {};
      this.getIncidents();
    },
    getMonitors: function getMonitors() {
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(self.monitors)) return;
      this.$http.get('/supervisor?ref=incident').then(function (response) {
        self.monitors = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getBuses: function getBuses() {
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(self.buses)) return;
      this.$http.get('/bus').then(function (response) {
        self.buses = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
      if (val === 'bus') this.getBuses();
    },
    flagItem: function flagItem(item) {
      item.IsSticky = !item.IsSticky;
      var postData = { id: item.incident_id, type: 'sticky', flag: item.IsSticky ? 1 : 0, name: 'incident' };
      this.$http.post('/report/flag', postData).then(function (response) {}).catch(function (response) {});
    },
    incidentNotification: function incidentNotification() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('incident', function (incident) {
        _this.incidents[0].unshift(incident);
        _this.totalIncidents += 1;
        if (_this.$route.name === 'Incidents') {
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].incidents.total--;
          _this.$http.put('/incident/timestamp', {});
        }
      });
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Doc__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_Doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default.a, lodash: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a, 'el-doc-dialog': __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Doc___default.a },
  data: function data() {
    return {
      messages: {},
      message: null,
      errorMessage: null,
      compose: { Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: { Filename: null, type: null }, parentID: null, threadID: null, groupTextID: null },
      conversation: null,
      conversations: [],
      supervisors: [],
      loading_board: true,
      currentPage: 1,
      limit: 20,
      offset: 0,
      cardHeight: 0,
      boardHeight: 0,
      loading: true,
      more: true,
      error: false,
      imageVisible: false,
      imageSrc: [],
      loadingSend: false,
      school_id: null,
      monitorInput: false,
      selectedMonitors: [],
      imageWidth: 50,
      fileList: [],
      folder: null
    };
  },

  computed: {
    sortedMessages: function sortedMessages() {
      var orderedMsgs = {};
      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.messages)) return {};
      var messages = this.messageSort(this.messages);
      for (var index in messages) {
        var key = messages[index];
        orderedMsgs[key] = this.messages[key];
      }
      return orderedMsgs;
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.folder = this.$route.path.split('/')[2];
    this.school_id = userData.school_id;
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.boardHeight = this.cardHeight - this.$refs.formCard.$el.offsetHeight;
    this.getMessages();
    this.messageNotification();
  },

  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    messageCount: function messageCount(message) {
      if (this.conversation === null) {
        this.conversation = message.SenderID;
        this.conversations = message.conversations;
      }
      if (this.conversation === message.SenderID && message.count !== 0) {
        __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["EventBus"].messages.total -= message.count;
        message.count = 0;
        return false;
      }
      if (message.count !== 0) return true;
      return false;
    },
    messageSort: function messageSort(messages) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(messages).sort(function (a, b) {
        var diff = parseInt(messages[b].count) - parseInt(messages[a].count);
        if (diff !== 0) return diff;else return messages[a].origOrder - messages[b].origOrder;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text';
      var isLt2KB = file.size / 1024 < 400;
      this.errorMessage = {};
      if (!isJPG) {
        this.errorMessage['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt';
      }
      if (!isLt2KB) {
        this.errorMessage['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errorMessage).length !== 0) this.error = true;
      return isJPG && isLt2KB;
    },
    newMessage: function newMessage() {
      if (this.monitorInput) return this.$nextTick(this.$refs.gmonitor.$el.children[1].children[1].focus());
      this.getSupervisors();
      var message = { SenderID: 0, more: false, count: 0, conversations: [], monitor: {} };
      this.selectedMonitors.length = 0;
      this.monitorInput = true;
      message.monitor.BusMonitorID = '';
      message.monitor.FullName_EN = this.$t('NEWMESSAGE', 'en');
      message.monitor.FullName_AR = this.$t('NEWMESSAGE', 'ar');
      message.monitor.ImagePath = null;
      this.$set(this.messages, 0, message);
      this.loadConversation(0);
      this.$nextTick(function () {
        this.$refs.gmonitor.$el.children[1].children[1].focus();
      });
    },
    deleteNewMessage: function deleteNewMessage() {
      this.$delete(this.messages, 0);
      this.selectedMonitors = [];
      this.loadConversation(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.messages)[0]);
      this.monitorInput = false;
    },
    validateReply: function validateReply() {
      if (this.monitorInput && this.conversation === 0) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.selectedMonitors)) return true;
      }
      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.compose.Text)) return true;
      return false;
    },
    showAttachment: function showAttachment(name, type) {
      this.imageSrc = [{ file_name: name, label: type }];
      this.imageVisible = true;
    },
    getMessages: function getMessages() {
      var endPoint = '/message?limit=' + this.limit + '&offset=0';
      if (this.$route.params.id) endPoint += '&BusMonitorID=' + this.$route.params.id;
      var self = this;
      this.$http.get(endPoint).then(function (response) {
        self.loading = false;
        self.loading_board = false;
        self.messages = response.data;
        if (self.$route.params.id) self.loadConversation(self.$route.params.id);
        self.scrollDown();
      }).catch(function (response) {});
    },
    handleSelect: function handleSelect() {
      var selectedNameEN = this.$t('NEWMESSAGE', 'en') + ' ';
      var selectedNameAR = this.$t('NEWMESSAGE', 'ar') + ' ';
      var i = 1;
      var imagePath = '';
      for (var key in this.selectedMonitors) {
        var monitor = this.selectedMonitors[key];
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(monitor)) break;
        imagePath = monitor.ImagePath;
        if (i === 1) {
          selectedNameEN += this.$t('TO', 'en');
          selectedNameAR += this.$t('TO', 'ar');
        }
        selectedNameEN += monitor.FullName_EN;
        selectedNameAR += monitor.FullName_AR;
        if (this.selectedMonitors.length !== i) {
          selectedNameEN += ', ';
          selectedNameAR += ', ';
        }
        i++;
      }
      this.$refs.gmonitor.query = '';
      if (this.messages[0] === undefined) return;
      this.messages[0].more = true;
      this.messages[0].monitor = { FullName_EN: selectedNameEN, FullName_AR: selectedNameAR, ImagePath: this.selectedMonitors.length === 1 ? imagePath : undefined };
      this.loadConversation(this.selectedMonitors.length === 1 ? this.selectedMonitors[0].BusMonitorID : 0, true);
      if (this.selectedMonitors.length !== 1) this.messages[0].more = false;
    },
    loadOlderMessages: function loadOlderMessages() {
      var counterMsg = this.messages[this.conversation].conversations.length;
      var Timestamp = this.messages[this.conversation].conversations[counterMsg - 1].Timestamp;
      var BusMonitorID = this.conversation === 0 && this.selectedMonitors.length === 1 ? this.selectedMonitors[0].BusMonitorID : this.conversation;
      var self = this;
      var params = { limit: self.limit, offset: self.offset, BusMonitorID: BusMonitorID, Timestamp: Timestamp };
      this.$http.get('/message/conversation', { params: params }).then(function (response) {
        var messages = response.data;
        if (messages.length === undefined) {
          self.messages[self.conversation].more = false;
          return;
        }
        for (var item in messages) {
          self.messages[self.conversation].conversations.push(messages[item]);
        }
        self.conversations = self.messages[self.conversation].conversations;
      }).catch(function (response) {});
    },
    loadConversation: function loadConversation(BusMonitorID) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.conversation = !from ? BusMonitorID : 0;
      if (!from) {
        if (this.messages[this.conversation].count !== 0) __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["EventBus"].messages.total -= this.messages[this.conversation].count;
        this.messages[this.conversation].count = 0;
        if (this.messages[this.conversation].conversations.length !== 0) {
          this.conversations = this.messages[this.conversation].conversations;
          this.scrollDown();
          return;
        }
      }
      if (BusMonitorID === 0) {
        this.messages[this.conversation].conversations = [];
        this.conversations = [];
        return;
      }
      this.loading_board = true;
      var self = this;
      this.$http.get('/message/conversation', { params: { BusMonitorID: BusMonitorID } }).then(function (response) {
        self.messages[self.conversation].conversations = response.data;
        self.conversations = response.data;
        self.loading_board = false;
        self.scrollDown();
      }).catch(function (response) {});
    },
    scrollDown: function scrollDown() {
      this.$nextTick(function () {
        this.$refs.msgInput.$el.children[0].focus();
        this.$refs.Scrollbar.$el.scrollTop = this.$refs.messages.offsetHeight;
        this.$refs.Scrollbar.update();
      });
    },
    messageNotification: function messageNotification() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["EventBus"].$on('message', function (message) {
        var monitorMessage = {
          ReceiverID: _this.school_id,
          Sender: message.SenderID,
          MessageID: null,
          Timestamp: message.Timestamp,
          datetime: message.datetime,
          MessageTextID: null,
          Text: message.Text,
          FullName_EN: message.monitor.FullName_EN,
          FullName_AR: message.monitor.FullName_AR,
          FileName: message.FileName,
          FileType: message.FileType,
          ImagePath: message.monitor.ImagePath };
        if (_this.messages[message.SenderID] === undefined) {
          var monitor = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pick(monitorMessage, ['ImagePath', 'FullName_EN', 'FullName_AR']);
          monitor.BusMonitorID = message.SenderID;
          _this.$set(_this.messages, message.SenderID, { SenderID: message.SenderID, more: false, count: 0, conversations: [], monitor: monitor });
        }
        if (_this.messages[message.SenderID].conversations.length !== 0) _this.messages[message.SenderID].conversations.push(monitorMessage);
        _this.messages[message.SenderID].count++;
        _this.messages = _this.sortedMessages;
      });
    },
    orderedConversations: function orderedConversations() {
      if (this.conversations.length > 0) return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.conversations, 'MessageID');
    },
    isSet: function isSet(message, property) {
      if (message === undefined) return false;
      if (property in message) return true;
      return true;
    },
    isMore: function isMore(messages) {
      if (!this.isSet(messages, 'more')) return false;
      if (messages.more) return true;
      return false;
    },
    replyConversation: function replyConversation() {
      var date = new Date();
      var Timestamp = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
      var BusMonitorID = this.conversation === 0 ? this.getSelectedSupervisors() : this.messages[this.conversation].monitor.BusMonitorID;
      var message = {
        ReceiverID: BusMonitorID,
        Sender: this.school_id,
        MessageID: null,
        Timestamp: Timestamp,
        datetime: this.$moment(date).format('DD/MM/YYYY HH:mm'),
        MessageTextID: null,
        Text: this.compose.Text,
        Attachment: this.compose.Attachment,
        HasAttachment: 0,
        FileName: this.compose.Attachment.Filename,
        FullName_EN: 'School',
        FullName_AR: 'مدرسة',
        ImagePath: null };
      this.compose.Recipient = 6;
      this.compose.RecipientID = BusMonitorID;
      var postData = { message: this.compose };
      var self = this;
      self.loadingSend = true;
      this.$http.post('/message/send', postData).then(function (response) {
        if (!response.data.error) {
          message.MessageID = response.data.MessageID;
          self.compose.Text = null;
          self.compose.Attachment.Filename = null;
          if (self.conversation === 0) self.pushGroupMessages(message, response.data.message);else self.messages[self.conversation].conversations.push(message);
        }
        self.scrollDown();
        self.loadingSend = false;
      }).catch(function () {});
    },
    getSelectedSupervisors: function getSelectedSupervisors() {
      var monitors = [];
      this.selectedMonitors.forEach(function (item) {
        monitors.push(item.BusMonitorID);
      });
      return monitors;
    },
    pushGroupMessages: function pushGroupMessages(message, response) {
      for (var key in this.selectedMonitors) {
        var monitor = this.selectedMonitors[key];
        if (this.messages[monitor.BusMonitorID] === undefined) continue;
        if (this.messages[monitor.BusMonitorID].conversations.length !== 0) {
          message.ReceiverID = monitor.BusMonitorID;
          this.messages[monitor.BusMonitorID].conversations.push(message);
        }
      }
      this.deleteNewMessage();
      return this.$message({
        message: this.$t(response),
        type: 'success',
        showClose: true
      });
    },
    getSupervisors: function getSupervisors() {
      var self = this;
      if (self.supervisors.length !== 0) return;
      this.$http.get('/supervisor').then(function (response) {
        self.supervisors = response.data;
      }).catch(function (response) {});
    },
    updateFile: function updateFile(response, file, fileList) {
      this.compose.hasAttachment = true;
      this.compose.Attachment.Filename = response.file_name;
      this.compose.Attachment.type = file.raw.type;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.compose.hasAttachment = false;
      this.compose.Attachment.Filename = file.name;
      file = [];
    },
    limitFile: function limitFile(event, file, fileList) {
      if (fileList.length > 1) fileList.splice(0, 1);
    },
    getSchoolPhoto: function getSchoolPhoto(image) {
      if (image === undefined) return this.BASEURL + 'uploads/thumbnails/no-school.png';
      image = image !== null && image !== '' ? image : 'no-school.png';
      return this.BASEURL + 'uploads/thumbnails/' + image;
    },
    getAttachment: function getAttachment(image) {
      return this.BASEURL + 'uploads/messages/' + image;
    },
    directionScroll: function directionScroll(e) {}
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentPage: { 'Trip': 1, 'Bus': 1, 'Supervisor': 1, 'Driver': 1, 'Incident': 1, 'Student': 1 },
      total: { 'Trip': 0, 'Bus': 0, 'Supervisor': 0, 'Driver': 0, 'Incident': 0, 'Student': 0 },
      limit: { 'Trip': 20, 'Bus': 20, 'Supervisor': 20, 'Driver': 20, 'Incident': 20, 'Student': 20 },
      visitedPage: { 'Trip': [1], 'Bus': [1], 'Supervisor': [1], 'Driver': [1], 'Incident': [1], 'Student': [1] },
      currentRow: null,
      SelectAll: { 'Trip': true, 'Bus': true, 'Supervisor': true, 'Driver': true, 'Incident': true, 'Student': true },
      filterKey: 'Trip',
      filterBy: { 'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': [] },
      filteredData: { 'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': [] },
      filteredCountData: { 'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': [] },
      extra: { 'Trip': false, 'Bus': false, 'Supervisor': false, 'Driver': false, 'Incident': false, 'Student': false },
      groupBy: { 'Trip': false, 'Bus': false, 'Supervisor': false, 'Driver': false, 'Incident': false, 'Student': false },
      filters: {
        'Trip': { 'TourID': null, 'Direction': null, 'dateRange': [null, null] },
        'Bus': { 'minCapacity': null, 'maxCapacity': null, 'minYear': null, 'maxYear': null, 'date': null, 'emirate': null, 'zone': null, 'sector': null },
        'Supervisor': { 'Nationality': null, 'TourID': null, 'BusID': null, 'dateRange': [null, null], 'ViolationTypeID': null },
        'Driver': { 'Nationality': null, 'TourID': null, 'BusID': null, 'dateRange': [null, null], 'ViolationTypeID': null },
        'Incident': { 'BusDriverID': null, 'BusMonitorID': null, 'BusID': null, 'IncidentTypeID': null, 'Status': null, 'dateRange': [null, null], 'ViolationTypeID': null },
        'Student': { 'Reason': null, 'radius': null, 'BusID': null, 'Grade': null, 'Status': null, 'dateRange': [null, null], 'ViolationTypeID': null, 'longitude': 0, 'latitude': 0, 'emirate': null, 'zone': null, 'sector': null }
      },
      title: { 'Trip': '', 'Bus': '', 'Supervisor': '', 'Driver': '', 'Incident': '', 'Student': '' },
      routes: [],
      buses: [],
      drivers: [],
      monitors: [],
      grades: [],
      classes: [],
      country: 'AE',
      Location: null,
      DataColumn: { 'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': [] },
      CountDataColumn: { 'Trip': [], 'Bus': [], 'Supervisor': [], 'Driver': [], 'Incident': [], 'Student': [] },
      savedQuery: { 'Trip': '', 'Bus': '', 'Supervisor': '', 'Driver': '', 'Incident': '', 'Student': '' },
      opacity: { 'Trip': 0, 'Bus': 0, 'Supervisor': 0, 'Driver': 0, 'Incident': 0, 'Student': 0 },
      multipleLimit: 0,
      loading: false,
      runTimeMethod: {
        1: function _(param) {
          return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(param);
        },
        2: function _(param) {
          return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNull(param[0]);
        },
        3: function _(param) {
          return !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(param);
        }
      },
      tableHeight: 0,
      cardHeight: 0,
      loadHeight: 0,
      initialYear: new Date().getFullYear() - 20,
      lastYear: new Date().getFullYear() + 1,
      hideOnClick: false,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() >= Date.now();
        }
      },
      multiSelectComponents: [],
      singleSelectComponent: null
      // emirates: [
      //   {
      //     value: 'Abu Dhabi',
      //     label: 'Abu Dhabi'
      //   },
      //   {
      //     value: 'Dubai',
      //     label: 'Dubai'
      //   },
      //   {
      //     value: 'Sharjah',
      //     label: 'Sharjah'
      //   },
      //   {
      //     value: 'Ajman',
      //     label: 'Ajman'
      //   },
      //   {
      //     value: 'Fujairah',
      //     label: 'Fujairah'
      //   },
      //   {
      //     value: 'Ras Al Khaimah',
      //     label: 'Ras Al Khaimah'
      //   },
      //   {
      //     value: 'Umm Al Quwain',
      //     label: 'Umm Al Quwain'
      //   }
      // ],
      // zones: [
      //   {
      //     value: 'zone1',
      //     label: 'zone1'
      //   },
      //   {
      //     value: 'zone2',
      //     label: 'zone2'
      //   },
      //   {
      //     value: 'zone3',
      //     label: 'zone3'
      //   }
      // ],
      // sectors: [
      //   {
      //     value: 'sector1',
      //     label: 'sector1'
      //   },
      //   {
      //     value: 'sector2',
      //     label: 'sector2'
      //   },
      //   {
      //     value: 'sector3',
      //     label: 'sector3'
      //   }
      // ],
      // show: {
      //   Bus: {
      //     zone: false,
      //     sector: false,
      //     others: true
      //   },
      //   Student: {
      //     zone: false,
      //     sector: false,
      //     others: true
      //   }
      // }
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53;
      this.loadHeight = window.innerHeight - document.getElementById('load-panel').offsetTop;
      this.tableHeight = this.loadHeight - 152;
      var el = this.$refs.countsBy.$el;
      el.style.width = Math.max(220, el.firstChild.firstChild.offsetWidth + 34) + 'px';
      var self = this;
      this.$google.then(function (Maps) {
        self.maps = Maps;
        var country = JSON.parse(localStorage.getItem('locale')).country;
        var autocomplete = new Maps.places.Autocomplete(document.getElementById('location'), { componentRestrictions: { country: country } });
        Maps.event.addListener(autocomplete, 'place_changed', function () {
          self.setPlace(autocomplete.getPlace());
        });
      });
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.all([this.$http.get('/route?ref=report'), this.$http.get('/bus?ref=report'), this.$http.get('/driver?ref=report'), this.$http.get('/supervisor?ref=report'), this.$http.get('/configuration/grade')]).then(__WEBPACK_IMPORTED_MODULE_5_axios___default.a.spread(function (routes, buses, drivers, monitors, levels) {
        self.routes = routes.data;
        self.buses = buses.data;
        self.drivers = drivers.data;
        self.monitors = monitors.data;
        self.grades = levels.data;
      })).catch(function (response) {
        console.log(response);
      });
    });
  },

  computed: {
    conditionalFilterBy: {
      get: function get() {
        return this.filterBy[this.filterKey];
      },
      set: function set(val) {
        this.filterBy[this.filterKey] = val;
      }
    },
    date: {
      get: function get() {
        return this.filters[this.filterKey]['date'];
      },
      set: function set(val) {
        this.filters[this.filterKey]['date'] = val;
      }
    },
    countDataColumns: function countDataColumns() {
      return {
        Trip: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { BusDriverID: this.$tc('DRIVER', 0) }, { TourName: this.$t('ROUTE') }, { Direction: this.$t('DIRECTION') }, { Date: this.$t('DATE') }, { Count: this.$t('COUNT') }],
        Bus: [{ Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }, { Count: this.$t('COUNT') }],
        Supervisor: [{
          Bus: [{ Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }, { Count: this.$t('COUNT') }],
          Nationality: [{ Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Count: this.$t('COUNT') }],
          Route: [{ TourName: this.$t('ROUTE') }, { Count: this.$t('COUNT') }],
          Incident: [{ TourName: this.$t('ROUTE') }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Count: this.$t('COUNT') }]
        }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Count: this.$t('COUNT') }],
        Driver: [{
          Bus: [{ Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }, { Count: this.$t('COUNT') }],
          Nationality: [{ Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Count: this.$t('COUNT') }],
          Route: [{ TourName: this.$t('ROUTE') }, { Count: this.$t('COUNT') }],
          Violation: [{ TourName: this.$t('ROUTE') }, { Label: this.$t('TYPE') }, { AlarmStatus: this.$t('ALARMSTATUS') }, { Count: this.$t('COUNT') }],
          Incident: [{ TourName: this.$t('ROUTE') }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Count: this.$t('COUNT') }]

        }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Count: this.$t('COUNT') }],
        Incident: [{ TourName: this.$t('ROUTE') }, { BusDriverID: this.$tc('DRIVER', 0) }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Count: this.$t('COUNT') }],
        Student: [{
          Absence: [{ Reason: this.$t('REASON') }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Count: this.$t(' COUNT') }]
        }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Grade: this.$t('GRADE') }, { Count: this.$t('COUNT') }]
      };
    },
    dataColumns: function dataColumns() {
      return {
        Trip: [{ TourName: this.$t('ROUTE') }, { BusMonitorID: this.$tc('SUPERVISOR', 0) }, { BusDriverID: this.$tc('DRIVER', 0) }, { Stops: this.$t('STOP') }, { Students: this.$t('STUDENT') }, { Direction: this.$t('DIRECTION') }, { CompletedTime: this.$t('COMPLETEDTIME') }, { Date: this.$t('DATE') }],
        Bus: [{ Label: this.$t('BUSNUMBER') }, { Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }, { Plate: this.$t('PLATE') }, { RegistrationExpiration: this.$t('EXPIRATIONDATE') }],
        Supervisor: [{
          Bus: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { BusID: this.$t('LABEL') }, { Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }],
          Nationality: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { IDExpiration: this.$t('IDEXPIRATION') }],
          Route: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { TourName: this.$t('ROUTE') }],
          Incident: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { TourName: this.$t('ROUTE') }, { Text: this.$t('TEXT') }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Lng: this.$t('Lng') }, { Lat: this.$t('Lat') }]
        }, { BusMonitorID: this.$tc('SUPERVISOR', 0) }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { IDExpiration: this.$t('IDEXPIRATION') }],
        Driver: [{
          Bus: [{ BusDriverID: this.$tc('DRIVER', 0) }, { BusID: this.$t('LABEL') }, { Make: this.$t('MAKE') }, { Year: this.$t('YEAR') }],
          Nationality: [{ BusDriverID: this.$tc('DRIVER', 0) }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { IDExpiration: this.$t('IDEXPIRATION') }],
          Route: [{ BusDriverID: this.$tc('DRIVER', 0) }, { TourName: this.$t('ROUTE') }],
          Violation: [{ BusDriverID: this.$tc('DRIVER', 0) }, { TourName: this.$t('ROUTE') }, { Label: this.$t('TYPE') }, { AlarmStatus: this.$t('ALARMSTATUS') }, { Speed: this.$t('SPEED') }, { Date: this.$t('DATE') }, { Lng: this.$t('Lng') }, { Lat: this.$t('Lat') }],
          Driver: [{ BusMonitorID: this.$tc('SUPERVISOR', 0) }, { TourName: this.$t('ROUTE') }, { Text: this.$t('TEXT') }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Lng: this.$t('Lng') }, { Lat: this.$t('Lat') }]
        }, { BusDriverID: this.$tc('DRIVER', 0) }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { IDExpiration: this.$t('IDEXPIRATION') }],
        Incident: [{ TourName: this.$t('ROUTE') }, { BusMonitorID: this.$tc('SUPERVISOR', 0) }, { BusDriverID: this.$tc('DRIVER', 0) }, { Text: this.$t('TEXT') }, { Label: this.$t('TYPE') }, { Status: this.$t('STATUS') }, { Date: this.$t('DATE') }, { Lng: this.$t('Lng') }, { Lat: this.$t('Lat') }],
        Student: [{
          Absence: [{ Date: this.$t('DATE') }, { StudentID: this.$t('STUDENTNAME') }, { Reason: this.$t('REASON') }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Grade: this.$t('GRADE') }, { Class: this.$t('CLASS') }]
        }, { StudentID: this.$t('STUDENTNAME') }, { Gender: this.$t('GENDER') }, { Nationality: this.$t('NATIONALITY') }, { Grade: this.$t('GRADE') }, { Class: this.$t('CLASS') }]
      };
    },
    mainTypes: function mainTypes() {
      return {
        Trip: [{ Route: this.$t('ROUTE') }, { Direction: this.$t('DIRECTION') }, { DateRange: this.$t('DATERANGE') }],
        Bus: [{ Capacity: this.$t('CAPACITY') }, { Year: this.$t('YEAR') }, { ExpirationDate: this.$t('EXPIRATIONDATE') }],
        Supervisor: [{ Nationality: this.$t('BYNATIONALITY') }, { Route: this.$t('ROUTE') }, { Bus: this.$tc('BUS', 0) }, { Incident: this.$t('INCIDENT') }],
        Driver: [{ Nationality: this.$t('BYNATIONALITY') }, { Route: this.$t('ROUTE') }, { Bus: this.$tc('BUS', 0) }, { Violation: this.$t('VIOLATION') }, { Incident: this.$t('INCIDENT') }],
        Incident: [{ Driver: this.$tc('DRIVER', 0) }, { Supervisor: this.$tc('SUPERVISOR', 0) }, { Bus: this.$tc('BUS', 0) }, { Type: this.$t('TYPE') }, { DateRange: this.$t('DATE') }, { Status: this.$t('STATUS') }],
        Student: [{ Absence: this.$t('ABSENCE'), radio: true }, { Address: this.$t('ADDRESS'), radio: true }, { Bus: this.$t('ASSIGNEDBUS'), radio: true }, { Grade: this.$t('GRADE') }]
      };
    },
    Statuses: function Statuses() {
      return { Open: this.$t('OPEN'), Reported: this.$t('REPORTED') };
    },
    reasons: function reasons() {
      return { Sickness: this.$t('SICKNESS'), Vacation: this.$t('VACATION'), Emergency: this.$t('EMERGENCY'), Personal: this.$t('PERSONAL') };
    },
    incidents: function incidents() {
      return { 1: this.$t('CHILDBEHAVIOUR'), 2: this.$t('MEDICAL'), 3: this.$t('DRIVERISSUE'), 4: this.$t('BUSPROBLEM'), 5: this.$t('ACCIDENT'), 6: this.$t('TRAFFIC'), 7: this.$t('CALLPOLICE'), 8: this.$t('CALLSCHOOL'), 9: this.$t('OTHER') };
    },
    violations: function violations() {
      return { 5: this.$t('SMOKEDETECTED'), 13: this.$t('PANICBUTTONPRESSED'), 15: this.$t('HIGHSPEEDALARM') };
    }
  },
  watch: {
    savedQuery: {
      handler: function handler(val, oldVal) {
        this.opacity[this.filterKey] = 1;
        if (this.savedQuery[this.filterKey] !== localStorage.getItem('savedQuery' + this.filterKey)) this.opacity[this.filterKey] = 0.5;
      },
      deep: true
    },
    DataColumn: {
      handler: function handler(val, oldVal) {
        this.savedQuery[this.filterKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filters[this.filterKey]) + this.dataColumnSerialize();
      },
      deep: true
    },
    filters: {
      handler: function handler(val, oldVal) {
        this.savedQuery[this.filterKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filters[this.filterKey]) + this.dataColumnSerialize();
      },
      deep: true
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage[this.filterKey] = val;
      if (this.visitedPage[this.filterKey].indexOf(val) >= 0) return;
      this.visitedPage[this.filterKey].push(val);
      this.search();
    },
    makeList: function makeList(lists, extra, count) {
      var data = {};
      if (extra !== undefined) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.extra, this.filterKey, true);
        data = count !== undefined ? this.countDataColumns : this.dataColumns;
        if (this.filterKey === 'Driver' || this.filterKey === 'Supervisor' || this.filterKey === 'Student') {
          if (this.filterBy[this.filterKey][0] === 'Incident') return this.makeList(data['Incident']);
          if (this.filterBy[this.filterKey].indexOf('Absence') < 0 && this.filterKey === 'Student') return this.makeList(data['Student']);
          if (this.groupBy[this.filterKey] && this.filterBy[this.filterKey].indexOf('Absence') >= 0 && this.filterKey === 'Student') return this.absenceGroupByColumns(this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][this.filterBy[this.filterKey].indexOf('Absence')]]));
          if (this.filterBy[this.filterKey].indexOf('Absence') >= 0 && this.filterKey === 'Student') return this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][this.filterBy[this.filterKey].indexOf('Absence')]]);
          if (this.filterBy[this.filterKey][0] !== undefined) return this.makeList(data[this.filterKey][0][this.filterBy[this.filterKey][0]]);
        }
      }

      var objFilters = {};
      for (var filter in lists) {
        var item = lists[filter];
        var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item)[0];
        var value = item[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item)[0]];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) !== 'object') objFilters[key] = value;
      }
      return objFilters;
    },
    pushDataColumns: function pushDataColumns(val) {
      this.hideOnClick = false;
      if (val === undefined) return;
      if (this.DataColumn[this.filterKey].indexOf(val) >= 0) this.DataColumn[this.filterKey].splice(this.DataColumn[this.filterKey].indexOf(val), 1);else this.DataColumn[this.filterKey].push(val);
    },
    pushCountDataColumns: function pushCountDataColumns(val) {
      if (val === undefined) return;
      if (this.CountDataColumn[this.filterKey].indexOf('Count') < 0) this.CountDataColumn[this.filterKey].push('Count');
      if (this.CountDataColumn[this.filterKey].indexOf(val) >= 0) this.CountDataColumn[this.filterKey].splice(this.CountDataColumn[this.filterKey].indexOf(val), 1);else this.CountDataColumn[this.filterKey].push(val);
    },
    pushFilterBy: function pushFilterBy(index, key, method) {
      var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var event = arguments[4];

      if (event === null || event === undefined) return true;
      if (reset && event !== this.filters[this.filterKey].minYear) this.filters[this.filterKey].maxYear = null;
      if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isObject(index)) {
        if (this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) < 0) return;
        if (!this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && !this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) < 0) this.filterBy[this.filterKey].push(key);
        if (this.runTimeMethod[method](this.filters[this.filterKey][index[0]]) && this.runTimeMethod[method](this.filters[this.filterKey][index[1]]) && this.filterBy[this.filterKey].indexOf(key) >= 0) this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(key), 1);
      } else {
        if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isUndefined(this.filters[this.filterKey][index])) return;
        if (this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) < 0) return;
        if (!this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) < 0) this.filterBy[this.filterKey].push(key);
        if (this.runTimeMethod[method](this.filters[this.filterKey][index]) && this.filterBy[this.filterKey].indexOf(key) >= 0) this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(key), 1);
      }
      // console.log(this.filters[this.filterKey][index] + ',' + index + ',' + key + ',' + method)
      return;
    },
    selectAll: function selectAll() {
      var columns = [];
      if (this.SelectAll[this.filterKey]) columns = !this.groupBy[this.filterKey] ? this.makeList(this.dataColumns[this.filterKey], true) : this.makeList(this.countDataColumns[this.filterKey], true, true);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.DataColumn, this.filterKey, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(columns));
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.SelectAll, this.filterKey, !this.SelectAll[this.filterKey]);
    },
    checkIndex: function checkIndex(key) {
      if (this.filterBy[this.filterKey] !== undefined && this.filterBy[this.filterKey].indexOf(key) >= 0) return true;
      return false;
    },
    switchChange: function switchChange() {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.SelectAll, this.filterKey, true);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.DataColumn, this.filterKey, []);
    },
    dateRangeAccess: function dateRangeAccess() {
      if (this.filterBy[this.filterKey].indexOf('DateRange') >= 0 || this.filterBy[this.filterKey].indexOf('Incident') >= 0 || this.filterBy[this.filterKey].indexOf('Violation') >= 0 || this.filterBy[this.filterKey].indexOf('Absence') >= 0) return true;
      return false;
    },
    resetFiltersValue: function resetFiltersValue() {
      if (typeof this.filterBy[this.filterKey] !== 'undefined') {
        switch (this.filterKey) {
          case 'Trip':
            if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null;
            if (this.filterBy[this.filterKey].indexOf('Direction') < 0) this.filters[this.filterKey].Direction = null;
            if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = [];
            break;
          case 'Bus':
            if (this.filterBy[this.filterKey].indexOf('Capacity') < 0) this.filters[this.filterKey].minCapacity = this.filters[this.filterKey].maxCapacity = null;
            if (this.filterBy[this.filterKey].indexOf('ExpirationDate') < 0) this.filters[this.filterKey].date = null;
            if (this.filterBy[this.filterKey].indexOf('Year') < 0) this.filters[this.filterKey].minYear = this.filters[this.filterKey].maxYear = null;
            break;
          case 'Supervisor':
            if (this.filterBy[this.filterKey].indexOf('Nationality') < 0) this.filters[this.filterKey].Nationality = null;
            if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null;
            if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null;
            if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = [];
            break;
          case 'Driver':
            if (this.filterBy[this.filterKey].indexOf('Nationality') < 0) this.filters[this.filterKey].Nationality = null;
            if (this.filterBy[this.filterKey].indexOf('Route') < 0) this.filters[this.filterKey].TourID = null;
            if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null;
            if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = [];
            if (this.filterBy[this.filterKey].indexOf('Violation') < 0) this.filters[this.filterKey].ViolationTypeID = null;
            break;
          case 'Incident':
            if (this.filterBy[this.filterKey].indexOf('Driver') < 0) this.filters[this.filterKey].BusDriverID = null;
            if (this.filterBy[this.filterKey].indexOf('Supervisor') < 0) this.filters[this.filterKey].BusMonitorID = null;
            if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null;
            if (this.filterBy[this.filterKey].indexOf('Type') < 0) this.filters[this.filterKey].IncidentTypeID = null;
            if (this.filterBy[this.filterKey].indexOf('Type') < 0) this.filters[this.filterKey].IncidentTypeID = null;
            if (this.filterBy[this.filterKey].indexOf('Status') < 0) this.filters[this.filterKey].Status = null;
            if (this.filterBy[this.filterKey].indexOf('DateRange') < 0) this.filters[this.filterKey].dateRange = [];
            break;
          case 'Student':
            if (this.filterBy[this.filterKey].indexOf('Absence') < 0) this.filters[this.filterKey].Reason = null;
            if (this.filterBy[this.filterKey].indexOf('Address') < 0) {
              this.filters[this.filterKey].Status = null;this.filters[this.filterKey].radius = 1;this.filters[this.filterKey].longitude = this.filters[this.filterKey].latitude = 0;
            }
            if (this.filterBy[this.filterKey].indexOf('Bus') < 0) this.filters[this.filterKey].BusID = null;
            if (this.filterBy[this.filterKey].indexOf('Grade') < 0) this.filters[this.filterKey].Grade = null;
            break;
        }
      }
      this.savedQuery[this.filterKey] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filters[this.filterKey]) + this.dataColumnSerialize();
    },
    dataColumnSerialize: function dataColumnSerialize() {
      var datacolumn = '&datacolumn=';
      for (var key in this.makeList(this.dataColumns[this.filterKey], true)) {
        if (this.DataColumn[this.filterKey].indexOf(key) >= 0) datacolumn += key + '&';
      }
      return datacolumn;
    },
    removeIndex: function removeIndex(index) {
      var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (typeof this.filterBy[this.filterKey] === 'string') __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.filterBy, this.filterKey, []);
      var passedValue = ref ? index : index.currentValue;
      var item = this.filterBy[this.filterKey].indexOf(passedValue);
      this.filterBy[this.filterKey].splice(item, ref ? 1 : 0);
      this.resetFiltersValue();
    },
    onClickStatus: function onClickStatus() {
      if (this.filterKey !== null) {
        var dataColumnLength = this.DataColumn[this.filterKey].length;
        if (dataColumnLength === 0) return true;
        switch (this.filterKey) {
          case 'Trip':
            if (this.filterBy[this.filterKey].length > 0) {
              for (var i = 0; i < this.filterBy[this.filterKey].length; i++) {
                switch (this.filterBy[this.filterKey][i]) {
                  case 'Route':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].TourID)) return true;
                    break;
                  case 'DateRange':
                    if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[0]) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[1])) return true;
                    break;
                  case 'Direction':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].Direction)) return true;
                    break;
                }
              }
            } else return true;
            break;
          case 'Bus':
            if (this.filterBy[this.filterKey].length > 0) {
              for (var j = 0; j < this.filterBy[this.filterKey].length; j++) {
                switch (this.filterBy[this.filterKey][j]) {
                  case 'Capacity':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].minCapacity) || __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].maxCapacity)) return true;
                    break;
                  case 'ExpirationDate':
                    if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].date)) return true;
                    break;
                  case 'Year':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].minYear) || __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].maxYear)) return true;
                    break;
                }
              }
            } else return true;
            break;
          case 'Supervisor':
          case 'Driver':
            if (this.filterBy[this.filterKey].length > 0) {
              switch (this.filterBy[this.filterKey][0]) {
                case 'Nationality':
                  if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].Nationality)) return true;
                  break;
                case 'Route':
                  if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].TourID)) return true;
                  break;
                case 'Bus':
                  if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].BusID)) return true;
                  break;
                case 'Incident':
                  if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[0]) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[1])) return true;
                  break;
                case 'Violation':
                  if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[0]) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[1]) || this.ViolationTypeID === null) return true;
                  break;
              }
            }
            break;
          case 'Incident':
            if (this.filterBy[this.filterKey].length > 0) {
              for (var k = 0; k < this.filterBy[this.filterKey].length; k++) {
                switch (this.filterBy[this.filterKey][k]) {
                  case 'Driver':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].BusDriverID)) return true;
                    break;
                  case 'Supervisor':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].BusMonitorID)) return true;
                    break;
                  case 'Bus':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].BusID)) return true;
                    break;
                  case 'Type':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].IncidentTypeID)) return true;
                    break;
                  case 'DateRange':
                    if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[0]) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[1])) return true;
                    break;
                  case 'Status':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].Status)) return true;
                    break;
                }
              }
            } else return true;
            break;
          case 'Student':
            if (this.filterBy[this.filterKey].length > 0) {
              for (var l = 0; l < this.filterBy[this.filterKey].length; l++) {
                switch (this.filterBy[this.filterKey][l]) {
                  case 'Date':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].dateRange)) return true;
                    break;
                  case 'Bus':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].BusID)) return true;
                    break;
                  case 'Grade':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filters[this.filterKey].Grade)) return true;
                    break;
                  case 'Absence':
                    if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[0]) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(this.filters[this.filterKey].dateRange[1])) return true;
                    break;
                  case 'Address':
                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isInteger(this.filters[this.filterKey].longitude) || __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isInteger(this.filters[this.filterKey].latitude)) return true;
                    break;
                }
              }
            } else return true;
            break;
        }
      } else return true;
    },
    search: function search() {
      this.checkCommonDataColumns();
      this.hideOnClick = true;
      if (!this.groupBy[this.filterKey]) {
        this.filteredCountData[this.filterKey].length = 0;
        this.filteredCountData[this.filterKey].splice(0);
      }
      switch (this.filterKey) {
        case 'Trip':
          this.callResource('trip', {
            TourID: this.filters[this.filterKey].TourID,
            dateRange: this.filters[this.filterKey].dateRange,
            Direction: this.filters[this.filterKey].Direction,
            minDate: null,
            maxDate: null
          });
          break;
        case 'Bus':
          this.callResource('bus', {
            maxCap: this.filters[this.filterKey].maxCapacity,
            minCap: this.filters[this.filterKey].minCapacity,
            maxYear: this.filters[this.filterKey].maxYear,
            minYear: this.filters[this.filterKey].minYear,
            date: this.filters[this.filterKey].date,
            ExpirationDate: null
          });
          break;
        case 'Supervisor':
        case 'Driver':
          this.callResource('staff', {
            TourID: this.filters[this.filterKey].TourID,
            BusID: this.filters[this.filterKey].BusID,
            ViolationTypeID: this.filters[this.filterKey].ViolationTypeID,
            dateRange: this.filters[this.filterKey].dateRange,
            minDate: null,
            maxDate: null,
            Nationality: this.filters[this.filterKey].Nationality,
            staff: this.filterKey
          });
          break;
        case 'Incident':
          this.callResource('incident', {
            DiverID: this.filters[this.filterKey].BusDriverID,
            MonitorID: this.filters[this.filterKey].BusMonitorID,
            BusID: this.filters[this.filterKey].BusID,
            IncidentTypeID: this.filters[this.filterKey].IncidentTypeID,
            Status: this.filters[this.filterKey].Status,
            dateRange: this.filters[this.filterKey].dateRange,
            minDate: null,
            maxDate: null
          });
          break;
        case 'Student':
          this.callResource('student', {
            BusID: this.filters[this.filterKey].BusID,
            longitude: this.filters[this.filterKey].longitude,
            latitude: this.filters[this.filterKey].latitude,
            radius: this.filters[this.filterKey].radius,
            Class: this.filters[this.filterKey].Class,
            Grade: this.filters[this.filterKey].Grade,
            Reason: this.filters[this.filterKey].Reason,
            requestedFor: 'Single',
            dateRange: this.filters[this.filterKey].dateRange,
            minDate: null,
            maxDate: null
          });
          break;
      }
    },
    callResource: function callResource(endPoint, data) {
      data.filtersBy = this.filterBy[this.filterKey];
      data.DataColumn = this.DataColumn[this.filterKey];
      data.groupBy = this.groupBy[this.filterKey];
      data.limit = this.limit[this.filterKey];
      data.offset = this.limit[this.filterKey] * (this.currentPage[this.filterKey] - 1);
      this.loading = true;
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(data.dateRange)) {
        if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNull(data.dateRange[0])) data.minDate = this.$moment(data.dateRange[0]).format('YYYY-MM-DD');
        if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNull(data.dateRange[1])) data.maxDate = this.$moment(data.dateRange[1]).format('YYYY-MM-DD');
        delete data.dateRange;
      }
      if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isDate(data.date)) {
        data.ExpirationDate = this.$moment(data.date).format('YYYY-MM-DD');
        delete data.date;
      }
      var self = this;
      this.$http.get('/report/' + endPoint + '?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(data)).then(function (response) {
        self.total[self.filterKey] = response.data.total;
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(!self.groupBy[self.filterKey] ? self.filteredData[self.filterKey] : self.filteredCountData[self.filterKey], self.currentPage[self.filterKey] - 1, response.data.data);
        if (self.filteredCountData[self.filterKey].length === 0) {
          self.CountDataColumn[self.filterKey].length = 0;
          self.CountDataColumn[self.filterKey].splice(0);
        }
        self.sortOrders = {};
        self.loading = false;
        var savedQuery = 'savedQuery' + self.filterKey;
        localStorage.setItem(savedQuery, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.filters[self.filterKey]) + self.dataColumnSerialize());
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(self.opacity, self.filterKey, 1);
      }).catch(function (error) {
        self.loading = false;
        console.log(error);
      });
    },
    checkCommonDataColumns: function checkCommonDataColumns() {
      var loadedColumns = !this.groupBy[this.filterKey] ? this.makeList(this.dataColumns[this.filterKey], true) : this.makeList(this.countDataColumns[this.filterKey], true, true);
      var newColumns = [];
      for (var i = 0; i < this.DataColumn[this.filterKey].length; i++) {
        if (Object.prototype.hasOwnProperty.call(loadedColumns, this.DataColumn[this.filterKey][i])) newColumns.push(this.DataColumn[this.filterKey][i]);
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.DataColumn, this.filterKey, newColumns);
    },
    uniqueColumnsCount: function uniqueColumnsCount() {
      var el = this.$refs.countsBy.$el;
      this.$nextTick(function () {
        setTimeout(function () {
          el.style.width = Math.max(220, el.firstChild.firstChild.offsetWidth + 34) + 'px';
        }, 20);
      });
      var sub = {};
      if (this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1].length !== 0 && this.CountDataColumn[this.filterKey].length !== 0) {
        for (var i = 0; i < this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1].length; i++) {
          var value = '';
          for (var index in this.CountDataColumn[this.filterKey]) {
            value += this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1][i][this.CountDataColumn[this.filterKey][index]];
          }
          if (sub[value] === undefined) sub[value] = { Count: 0 };
          for (var _index in this.CountDataColumn[this.filterKey]) {
            var column = this.CountDataColumn[this.filterKey][_index];
            if (sub[value][column] === undefined) sub[value][column] = this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1][i][column];
          }
          if (sub[value] !== undefined) sub[value].Count += 1;
        }
      }
      var subArray = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(sub).map(function (key) {
        return sub[key];
      });
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.filteredCountData[this.filterKey], this.currentPage[this.filterKey] - 1, subArray);
    },
    pick: function pick(o, fields) {
      var objFilters = {};
      for (var key in o) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(o[key]) !== 'object') {
          if (fields.indexOf(key) >= 0) objFilters[key] = o[key];
        }
      }
      return objFilters;
    },
    changeFilterKey: function changeFilterKey(tab, event) {
      this.filterKey = tab.name;
    },
    range: function range(start, stop, step) {
      if (typeof stop === 'undefined') {
        stop = start;
        start = 0;
      }
      if (typeof step === 'undefined') {
        step = 1;
      }
      if (step > 0 && start >= stop || step < 0 && start <= stop) {
        return [];
      }
      var result = [];
      for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i.toString());
      }
      return result;
    },
    handleGroupedOption: function handleGroupedOption(comp) {
      var filterBy = [];
      var neighbourLabelIndex = comp.$parent.label === this.$t('SELECTMULTIPLE') ? 0 : 1;
      if (comp.$parent.label === this.$t('SELECTMULTIPLE')) comp.$parent.$children.forEach(function (item) {
        if (item.itemSelected) return filterBy.push(item.value);
      });
      comp.$parent.$parent.$children[neighbourLabelIndex].$children.forEach(function (item) {
        if (item.itemSelected) return filterBy.push(item.value);
      });
      if (comp.itemSelected) filterBy.splice(filterBy.indexOf(comp.value), 1);else filterBy.push(comp.value);
      if (comp.$parent.label === this.$t('SELECTONE')) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.multiSelectComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var multicomp = _step.value;

            this.removeTag(multicomp);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.multiSelectComponents = [];
        if (this.singleSelectComponent !== null) this.removeTag(this.singleSelectComponent);
        this.singleSelectComponent = comp;
      }
      if (comp.$parent.label === this.$t('SELECTMULTIPLE')) {
        if (this.singleSelectComponent !== null) {
          this.removeTag(this.singleSelectComponent);
          this.singleSelectComponent = null;
        }
        this.multiSelectComponents.push(comp);
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(this.filterBy, this.filterKey, filterBy);
    },
    removeTag: function removeTag(comp) {
      this.filterBy[this.filterKey].splice(this.filterBy[this.filterKey].indexOf(comp.value), 1);
    },
    getDynamicSpan: function getDynamicSpan() {
      var columns = this.filterBy[this.filterKey].length;
      if (this.filterBy[this.filterKey].length === 1) columns = 2;
      return 24 / columns;
    },
    checkAllConditions: function checkAllConditions() {
      if ((this.filteredData[this.filterKey].length !== 0 || this.filteredCountData[this.filterKey].length !== 0) && (this.DataColumn[this.filterKey].length !== 0 || this.CountDataColumn[this.filterKey].length !== 0)) return true;
      return false;
    },
    exportToCSV: function exportToCSV() {
      var items = this.makeList(this.dataColumns[this.filterKey], true);
      var columns = {};
      for (var item in items) {
        if (this.DataColumn[this.filterKey].indexOf(item) >= 0) columns[item] = items[item];
      }
      var self = this;
      this.$http.post('/report/export', __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify({ data: this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1].length === 0 ? this.filteredData[this.filterKey][this.currentPage[this.filterKey] - 1] : this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1], columns: columns, count: this.filteredCountData[this.filterKey][this.currentPage[this.filterKey] - 1].length === 0 })).then(function (response) {
        window.location = self.BASEURL + response.data.file_path;
      }).catch(function (error) {
        console.log(error);
      });
    },
    absenceGroupByColumns: function absenceGroupByColumns(obj) {
      var prevents = ['Nationality', 'Gender'];
      var selected = {};
      for (var key in obj) {
        if (prevents.indexOf(key) < 0) selected[key] = obj[key];
      }
      return selected;
    },
    setPlace: function setPlace(place) {
      this.Location = place.formatted_address;
      this.filters[this.filterKey].longitude = place.geometry.location.lng();
      this.filters[this.filterKey].latitude = place.geometry.location.lat();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit[this.filterKey] = val;
      this.filteredData[this.filterKey].length = this.filteredCountData[this.filterKey].length = 0;
      this.currentPage[this.filterKey] = 1;
      this.visitedPage[this.filterKey] = [];
      this.search();
    },
    clearEmirate: function clearEmirate(filterKey) {
      this.show[filterKey].zone = false;
      this.show[filterKey].sector = false;
      this.show[filterKey].others = true;
      this.filters[filterKey].zone = null;
      this.filters[filterKey].sector = null;
    },
    clearZone: function clearZone(filterKey) {
      this.show[filterKey].zone = false;
      this.show[filterKey].sector = false;
      this.show[filterKey].others = true;
      this.filters[filterKey].emirate = null;
      this.filters[filterKey].sector = null;
    },
    clearSector: function clearSector(filterKey) {
      this.show[filterKey].sector = false;
      this.filters[filterKey].zone = null;
    },
    handleEmirateChange: function handleEmirateChange(filterKey) {
      this.show[filterKey].zone = true;
      this.show[filterKey].others = false;
    },
    handleZoneChange: function handleZoneChange(filterKey) {
      this.show[filterKey].sector = true;
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Incident__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Incident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Incident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar___default.a, 'el-incident-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Incident___default.a },
  data: function data() {
    return {
      infoOptions: { pixelOffset: { width: 0, height: -35 }, padding: 0 },
      trips: {},
      filtered_trips: {},
      routes: [],
      monitors: [],
      route: null,
      paths: {},
      filter: null,
      active_filter: 'date',
      date: [new Date(), new Date()],
      Direction: '',
      BusMonitorID: '',
      TourID: '',
      currentPage: 1,
      visitedPage: [1],
      loading: true,
      new_page: false,
      center: {},
      currentRow: null,
      listHeight: 0,
      mapHeight: 0,
      offset: 0,
      tab: 0,
      stops: {},
      maps: null,
      map: null,
      Polylines: {},
      bounds: {},
      live_trips: {},
      is_live: false,
      total: 0,
      routeColors: {},
      locations: {},
      MarkerWithLabel: null,
      totalTrips: 0,
      paginationHeight: 0,
      boarding: {},
      cachedDates: {},
      filtered: false,
      sendingEvent: null,
      lastFilter: '',
      prevIndex: 0,
      closedTripCount: 0,
      Limit: 0,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() >= Date.now();
        }
      },
      notifyAlert: false,
      eventVisible: false,
      event: {},
      pageSizes: [50, 80, 100, 150, 200],
      students: {}
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
    this.mapHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.$el.offsetHeight + 54);
    this.listHeight = this.mapHeight;
    var self = this;
    this.$google.then(function (Maps) {
      self.maps = Maps;
      self.map = new Maps.Map(document.getElementById('live-gmap'), {
        center: self.center,
        zoom: 14
      });
      var marker = new Maps.Marker({
        position: new Maps.LatLng(self.center),
        title: 'center',
        icon: __webpack_require__(21)
      });
      marker.setMap(self.map);
      self.MarkerWithLabel = __webpack_require__(144)(Maps);
    });
    this.getMonitors();
    this.getRoutes();
    this.eventListener();
  },

  computed: {
    listTrips: function listTrips() {
      var trips = null;
      if (this.is_live || this.filtered_trips[0] === undefined) trips = this.trips;
      if (this.filtered && !this.filtered_trips[this.currentPage - 1]) trips = [];
      if (!this.is_live && this.filtered_trips[this.currentPage - 1] !== undefined) trips = this.filtered_trips[this.currentPage - 1];
      var listTrips = { 'left': [], 'right': [] };
      if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(trips)) return listTrips;
      for (var trip in trips) {
        var TripID = parseInt(trip);
        if (trips[TripID] === undefined || this.is_live && trips[TripID].IsClosed !== 0 || !this.is_live && trips[TripID].IsClosed === 0) continue;
        if (trips[TripID].activity.total_alerts > 0 || trips[TripID].activity.total_violations > 0) listTrips['left'].push(trips[TripID]);else listTrips['right'].push(trips[TripID]);
      }
      return this.tripSort(listTrips);
    },

    limit: {
      get: function get() {
        var limit = this.active_trips();
        limit = limit + (10 - limit % 10);
        if (limit > this.pageSizes[0]) this.pageSizes = [limit, limit + 10, limit + 30, limit + 50, limit + 80];else limit = this.pageSizes[0];
        return this.Limit > limit ? this.Limit : limit;
      },
      set: function set(limit) {
        this.Limit = limit;
      }
    },
    options: function options() {
      var options = [{
        value: 'direction',
        label: this.$t('DIRECTION')
      }, {
        value: 'monitor',
        label: this.$t('SUPERVISOR')
      }, {
        value: 'date',
        label: this.$t('DATE')
      }];
      return options;
    }
  },
  methods: {
    checkToday: function checkToday() {
      if (this.date === undefined) return false;
      if (this.$moment(this.date[0]).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD') && this.$moment(this.date[1]).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD')) return false;
      return true;
    },
    active_trips: function active_trips() {
      return __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].trips.total;
    },
    arrayOfAlerts: function arrayOfAlerts(alerts) {
      var results = [];
      for (var key in alerts) {
        results.push(alerts[key]);
      }
      return results;
    },
    tripDate: function tripDate(date) {
      return this.$moment(date).locale(localStorage.getItem('lang')).format('MMMM') + this.$moment(date).format(' DD, YYYY');
    },
    tripTime: function tripTime(time) {
      return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A');
    },
    showCost: function showCost(trip) {
      if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true;
      return false;
    },
    delayed_time: function delayed_time(trip) {
      var time = trip.Direction === 1 ? trip.Time_AM_In : trip.Time_PM_In;
      time = time.split(':');
      var display = '';
      var diff = this.$moment().subtract({ hours: time[0], minutes: time[1] });
      if (diff.hour() > 0) display += diff.hour() + this.$tc('HOUR', diff.hour() === 1 ? 1 : 2);
      if (diff.hour() > 0 && diff.minute() > 0) display += ',';
      if (diff.minute() > 0) display += diff.minute() + this.$tc('MINUTE', diff.minute() === 1 ? 1 : 2);
      this.$root.$children[0].TIME;
      return display;
    },
    activity_time: function activity_time(date) {
      return this.$moment(date).format('MM-DD-YYYY, h:mm a');
    },
    ballDirection: function ballDirection(trip) {
      var direction = localStorage.getItem('lang') === 'en' ? 'left' : 'right';
      var css = {};
      var width = this.progressWidth(trip);
      if (width === 100) css[direction === 'left' ? 'right' : 'left'] = 0 + '%';else css[direction] = width + (width > 2 ? trip.Boarding === 0 ? 0 : -0.8999 : 0) + '%';
      // css[direction] = (this.progressWidth(trip) - 0.8999) + '%'
      return css;
    },
    btnGroup: function btnGroup(val) {
      if (this.is_live === val) return;
      this.is_live = val;
      if (this.is_live && this.paginationHeight === 54) {
        this.listHeight += this.paginationHeight;
        this.paginationHeight = 0;
      }
      if (!this.is_live && this.paginationHeight === 0 && (this.filtered_trips[0] !== undefined || this.totalTrips > this.limit)) {
        this.paginationHeight = 54;
        this.listHeight -= this.paginationHeight;
      }
    },
    tripSort: function tripSort(trips_) {
      var sorted = { 'left': [], 'right': [] };
      this.cachedDates = { 'left': {}, 'right': {} };
      var self = this;
      if (trips_['left'].length !== 0) {
        var trips = trips_['left'];
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trips).sort(function (a, b) {
          return trips[b].UpdatedAt - trips[a].UpdatedAt;
        }).map(function (index) {
          if (trips[index].IsClosed === 1 && self.cachedDates['left'][trips[index].Date] === undefined) self.cachedDates['left'][trips[index].Date] = trips[index].TripID;
          sorted['left'].push(trips[index]);
        });
      }
      if (trips_['right'].length !== 0) {
        var _trips = trips_['right'];
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_trips).sort(function (a, b) {
          return _trips[b].UpdatedAt - _trips[a].UpdatedAt;
        }).map(function (index) {
          if (_trips[index].IsClosed === 1 && self.cachedDates['right'][_trips[index].Date] === undefined) self.cachedDates['right'][_trips[index].Date] = _trips[index].TripID;
          sorted['right'].push(_trips[index]);
        });
      }
      return sorted;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.trips = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.pick(this.trips, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.live_trips));
      this.visitedPage = [1];
      this.loading = true;
      this.getFilteredTrips();
    },
    activityInfo: function activityInfo(obj, index) {
      this.notifyAlert = obj.Event === 'ALERT';
      if (obj.data !== undefined) {
        this.event = obj.data;
        this.eventVisible = true;
        return;
      }
      this.sendingEvent = obj.EventID;
      var self = this;
      this.eventResource(obj.EventID, this.notifyAlert).then(function (result) {
        self.sendingEvent = null;
        var StudentID = result.data.student_id;
        if (self.notifyAlert) {
          result.data.student_id = [];
          result.data.student_id.push(StudentID);
        }
        self.event = obj.data = result.data;
        self.eventVisible = true;
      }).catch(function () {
        self.sendingEvent = null;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      if (isNaN(val)) return;
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getFilteredTrips();
    },
    liveTrips: function liveTrips() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.live_trips).length;
    },
    subscribeToLocation: function subscribeToLocation(trip) {
      var _this = this;

      var TripID = trip.TripID;
      var id = TripID;
      if (trip.IMEI !== null) id = trip.BusID;
      this.$channel.bind('location-' + id, function (data) {
        if (_this.trips[TripID] === undefined) return;
        _this.trips[TripID].location = _this.trips[TripID].location.concat(data);
        var busLocation = data[data.length - 1];
        _this.setBusLocation(busLocation);
      });
    },
    subscribeToBoarding: function subscribeToBoarding(TripID) {
      this.$channel.bind('boarding-' + TripID, function (boarding) {
        __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$emit('boarding', { TripID: TripID, data: boarding });
      });
    },
    eventListener: function eventListener() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$on('trip', function (trip) {
        if (_this2.trips[trip.TripID] !== undefined) {
          _this2.total--;
          var IsClosed = trip.IsClosed;
          _this2.trips[trip.TripID].UpdatedAt = trip.UpdatedAt;
          if (trip.timestamp !== undefined) _this2.trips[trip.TripID].timestamp = trip.timestamp;
          if (trip.Expected) {
            _this2.trips[trip.TripID].Db_Date = trip.Db_Date === undefined ? null : trip.Db_Date;
            _this2.trips[trip.TripID].BusDriverID = trip.BusDriverID === undefined ? null : trip.BusDriverID;
            _this2.trips[trip.TripID].BusMonitorID = trip.BusMonitorID === undefined ? null : trip.BusMonitorID;
          }
          var TourID = _this2.trips[trip.TripID].TourID;
          _this2.$delete(_this2.live_trips, TourID);
          if (_this2.liveTrips() === 0) _this2.is_live = false;
          if (trip.IsCancelled === 1) {
            if (trip.NewTripID !== undefined) {
              _this2.trips[trip.TripID].TripID = trip.NewTripID;
              _this2.trips[trip.TripID].Boarding = 0;
              _this2.trips[trip.TripID].checked_stop = 0;
              _this2.assignNewTrip(_this2.trips[trip.TripID]);
              _this2.$delete(_this2.stops, trip.TripID);
            }
            _this2.$delete(_this2.trips, trip.TripID);
          } else {
            if (trip.TotalCost !== undefined) {
              _this2.trips[trip.TripID].TotalCost = trip.TotalCost;
              _this2.trips[trip.TripID].TravelCost = trip.TravelCost;
              _this2.trips[trip.TripID].VehicleCost = trip.TotalCost;
              _this2.trips[trip.TripID].IdleCost = trip.IdleCost;
            }
            _this2.trips[trip.TripID].CompletedIn = trip.CompletedIn;
            _this2.trips[trip.TripID].IsClosed = IsClosed;
          }
          if (trip.IsClosed === 1 && _this2.filtered_trips[_this2.currentPage - 1][trip.TripID] === undefined) _this2.$set(_this2.filtered_trips[_this2.currentPage - 1], trip.TripID, _this2.trips[trip.TripID]);
          if (_this2.locations[trip.TripID] !== undefined) {
            _this2.locations[trip.TripID].setMap(null);
            _this2.$delete(_this2.locations, trip.TripID);
          }
          return;
        }
        _this2.total++;
        _this2.assignNewTrip(trip);
      });
      __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$on('incident', function (incident) {
        if (_this2.trips[incident.TripID] === undefined) return;
        _this2.trips[incident.TripID].UpdatedAt = _this2.$moment().unix();
        var obj = {};
        obj.Event = 'INCIDENT';
        obj.EntityID = null;
        obj.EventID = incident.incident_id;
        obj.EventType = incident.incident_type;
        obj.Sent = incident.Timestamp;
        obj.Text = incident.Text;
        if (_this2.trips[incident.TripID].activity.alerts[incident.incident_id] === undefined) {
          _this2.trips[incident.TripID].activity.alerts[incident.incident_id] = obj;
          _this2.trips[incident.TripID].activity.total_alerts++;
        }
      });
      __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$on('alert', function (alert) {
        if (_this2.trips[alert.TripID] === undefined) return;
        _this2.trips[alert.TripID].UpdatedAt = _this2.$moment().unix();
        if (_this2.trips[alert.TripID].activity.alerts[alert.EventID] === undefined) {
          _this2.trips[alert.TripID].activity.alerts[alert.EventID] = alert;
          _this2.trips[alert.TripID].activity.total_alerts++;
        }
      });
      __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$on('boarding', function (boarding) {
        var TripID = boarding.TripID;
        var _bording = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, boarding.data);
        if (_bording.IsMissing !== undefined) return;
        if (_bording.CheckOut === undefined) _this2.trips[TripID].Boarding = _bording.Boarding;
        if (_bording.CheckOut !== undefined) _this2.trips[TripID].checked_out = _bording.CheckOut;
        if (_this2.trips[TripID].Direction === 1 && _bording.CheckOut !== undefined) _bording.Stop = _this2.trips[TripID].student_stops;
        _this2.trips[TripID].checked_stop = parseInt(_bording.Stop);
      });
    },
    isLive: function isLive(route) {
      var TourID = parseInt(route.TourID);
      var TripID = this.live_trips[TourID];
      if (TripID !== undefined && this.trips[TripID].Date !== null) return true;
      return false;
    },
    assignNewTrip: function assignNewTrip(trip) {
      var obj = {};
      obj[trip.TripID] = trip;
      this.trips = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(obj, this.trips);
      this.live_trips[trip.TourID] = trip.TripID;
      this.stopsPoint(trip);
    },
    selectAll: function selectAll() {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paths).length === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.live_trips).length) return true;
      return false;
    },
    getTrips: function getTrips() {
      var self = this;
      var limit = self.limit;
      if (limit < this.active_trips()) limit = this.active_trips();
      this.todayClosedTrips().then(function (coloedTrips) {
        if (coloedTrips.data.total !== undefined) {
          self.closedTripCount = parseInt(coloedTrips.data.total);
          limit += self.closedTripCount;
        }
        self.$http.get('/trip?limit=' + limit + '&offset=' + self.offset).then(function (response) {
          self.loading = false;
          if (response.data.total === undefined) return;
          self.tab = 1;
          var trips = response.data.trips;
          for (var trip in trips) {
            self.$set(self.trips, trip, trips[trip]);
            if (trips[trip].IsClosed === 0) {
              self.is_live = true;
              self.live_trips[trips[trip].TourID] = trip;
              response.data.total--;
              self.subscribeToLocation(trips[trip]);
              self.subscribeToBoarding(trip);
              self.setBusLocation(trips[trip]);
              self.stopsPoint(trips[trip]);
            }
          }
          var closedTrips = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.omit(self.trips, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(self.live_trips));
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(self.filtered_trips, self.currentPage - 1, closedTrips);
          self.totalTrips = self.total = response.data.total;
          if (!self.is_live && self.paginationHeight === 0 && (self.filtered_trips[0] !== undefined || self.totalTrips > self.limit)) {
            self.paginationHeight = 54;
            self.listHeight -= self.paginationHeight;
          }
          self.lastFilter = __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(self.bindCurrentFilters());
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    getFilteredTrips: function getFilteredTrips(val) {
      if (val !== undefined) {
        if (this.date === undefined) val = null;
        if (this.date !== undefined && this.date[0] === null && this.date[1] === null) val = null;
        if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(val)) this.clearFilter();
      }
      this.filtered = this.loading = true;
      var self = this;
      if (self.isFilterChanged()) {
        self.currentPage = 1;
        self.visitedPage = [1];
      }
      this.$http.get('/trip?' + __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
        if (self.paginationHeight === 0) {
          self.paginationHeight = 54;
          self.listHeight -= self.paginationHeight;
        }
        self.new_page = self.loading = false;
        // Still we need to controll the count to each page, currently per page count is wrong...
        var closedTrips = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.omit(response.data.trips, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(self.live_trips));
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(self.filtered_trips, self.currentPage - 1, closedTrips);
        if (self.active_filter === 'date') {
          if (self.date[0].toDateString() === new Date().toDateString() && self.date[1].toDateString() === new Date().toDateString()) {
            for (var trip in response.data.trips) {
              if (response.data.trips[trip].IsClosed === 0) response.data.total--;
            }
          }
        }
        self.totalTrips = !self.isFilterChanged() ? self.totalTrips : response.data.total;
        self.lastFilter = __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(self.bindCurrentFilters());
      }).catch(function (error) {
        console.log(error);
      });
    },
    isFilterChanged: function isFilterChanged() {
      if (this.lastFilter === __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(this.bindCurrentFilters())) return false;
      return true;
    },
    getRoutes: function getRoutes() {
      var self = this;
      this.$http.get('/route?minimized').then(function (response) {
        self.routes = response.data;
        for (var route in self.routes) {
          self.routeColors[self.routes[route].TourID] = self.routes[route].RouteColor;
        }
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        self.getTrips();
      });
    },
    getMonitors: function getMonitors() {
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(self.monitors)) return;
      this.$http.get('/supervisor').then(function (response) {
        self.monitors = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: {} };
      switch (this.active_filter) {
        case 'direction':
          if (this.Direction !== '') data.filters.Direction = this.Direction;
          break;
        case 'tour':
          if (this.TourID !== '') data.filters.TourID = this.TourID;
          break;
        case 'monitor':
          if (this.BusMonitorID !== '') data.filters.BusMonitorID = this.BusMonitorID;
          break;
        case 'date':
          if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNull(this.date[0]) && __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNull(this.date[1])) break;
          data.filters.Date = {};
          data.filters.Date.min = this.$moment(this.date[0]).format('YYYY-MM-DD');
          data.filters.Date.max = this.$moment(this.date[1]).format('YYYY-MM-DD');
          break;
      }
      return data;
    },
    goTo: function goTo(TripID) {
      this.$router.push({ path: '/report/trip/' + TripID });
    },
    progressWidth: function progressWidth(trip) {
      var stop = trip.checked_stop;
      if (trip.skip_stops < stop) stop -= trip.skip_stops;
      if (stop === 0 || trip.IsClosed === 1) return 0;
      if (trip.Direction === 2 && trip.checked_out == null) return 0;
      if (trip.Direction === 1 && trip.checked_out !== null) stop = trip.student_stops + 1;
      return this.stops[trip.TripID].sizes[stop - 1];
    },
    nextStop: function nextStop(trip) {
      var num = 1;
      var stop = trip.checked_stop;
      if (trip.skip_stops < stop) stop -= trip.skip_stops;
      if (trip.Direction === 2 && trip.checked_out !== null) num = 0;
      if (stop === 0 || trip.Direction === 2 && trip.checked_out === null) return this.$t('FIRSTSTOP');
      if (trip.Direction === 1 && trip.checked_out !== null) return this.$t('SCHOOL');
      if (stop !== this.stops[trip.TripID].sizes.length - num) return this.$t('NEXTSTOP') + ' ' + (stop + 1);
      if (stop === this.stops[trip.TripID].sizes.length) return this.$t('LASTSTOP');
      return trip.Direction === 1 && this.trips[trip.TripID].checked_out !== null ? this.$t('SCHOOL') : this.$t('NOMORESTOPS');
    },
    stopsPoint: function stopsPoint(trip) {
      if (this.stops[trip.TripID] !== undefined) return;
      var points = [];
      var distance = 0;
      var percentage = null;
      if (trip.IsClosed === 1) return 0;
      var stops = trip.stops;
      for (var stop in stops) {
        distance += parseInt(stops[stop].Distance);
        points.push(distance);
      }
      distance = parseFloat(distance / 1000).toFixed(2);
      if (trip.Direction === 1) distance *= 2;
      var sizes = [];
      for (var item in points) {
        var value = parseFloat(points[item] / 1000).toFixed(2);
        percentage = value * 100 / distance;
        sizes.push(percentage);
      }
      if (trip.Direction === 1) sizes.push(100);
      this.stops[trip.TripID] = { sizes: sizes, checked_stop: trip.checked_stop, Direction: trip.Direction };
    },
    reBound: function reBound(route) {
      this.setPulseLocation(route);
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paths).length === 0) return;
      this.bounds = new this.maps.LatLngBounds();
      for (var path in this.paths) {
        var paths = this.paths[path];
        for (var _path in paths) {
          this.bounds.extend(paths[_path]);
        }
      }
      this.map.fitBounds(this.bounds);
    },
    setBusLocation: function setBusLocation(trip) {
      if (trip.location.length === 0) return;
      trip = this.trips[trip.TripID];
      var location = trip.location[trip.location.length - 1];
      var position = new this.maps.LatLng(parseFloat(location.Lat), parseFloat(location.Lng));
      this.setPulseLocation(trip.TourID);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.locations[trip.TripID]) === 'object') this.locations[trip.TripID].setPosition(position);
    },
    setPulseLocation: function setPulseLocation(route) {
      if (this.live_trips[route] === undefined) return;
      var trip = this.trips[this.live_trips[route]];
      if (trip.location.length === 0) return;
      if (this.locations[trip.TripID] === undefined) this.locations[trip.TripID] = new this.MarkerWithLabel({ map: this.map });
      var color = this.routeColors[route];
      var labelStyle = null;
      var labelClass = 'bus fa fa-bus fa-3x';
      var poins = [14, 42];
      var icon = { path: 'M22-48h-44v43h16l6 5 6-5h16z', fillColor: color, fillOpacity: 1, strokeColor: color };
      if (this.paths[route] !== undefined) {
        icon = { path: this.maps.SymbolPath.CIRCLE };
        poins = [15, 15];
        labelStyle = { background: color, borderColor: color };
        labelClass = 'pulse';
      }
      var labelAnchor = new this.maps.Point(poins[0], poins[1]);
      this.locations[trip.TripID].setIcon(icon);
      this.locations[trip.TripID].set('labelClass', labelClass);
      this.locations[trip.TripID].set('labelAnchor', labelAnchor);
      this.locations[trip.TripID].set('labelStyle', labelStyle);
    },
    toggleCheck: function toggleCheck() {
      for (var key in this.routes) {
        if (this.isLive(this.routes[key])) this.routeChange(key);
      }
    },
    routeChange: function routeChange(val) {
      if (val === -1) return this.toggleCheck();
      if (this.routes[val] === undefined) return;
      var route = this.routes[val];
      if (this.routes !== undefined && this.route !== null) this.route = route.TourName;
      if (this.paths[route.TourID] !== undefined) {
        delete this.paths[route.TourID];
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paths).length === 0) this.route = null;
        this.Polylines[route.TourID].setMap(null);
        this.reBound(route.TourID);
        return;
      }
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      var TripID = this.live_trips[route.TourID];
      var direction = this.trips[TripID].Direction;
      var path = route.path[2 - direction];
      this.paths[route.TourID] = new this.maps.geometry.encoding.decodePath(path);
      this.Polylines[route.TourID] = new this.maps.Polyline({
        path: this.paths[route.TourID],
        strokeColor: route.RouteColor,
        strokeOpacity: 1.0,
        strokeWeight: 5
      });
      this.Polylines[route.TourID].setMap(this.map);
      this.reBound(route.TourID);
    },
    clearFilter: function clearFilter() {
      this.filtered = false;
      this.active_filter = 'date';
      this.date = [new Date(), new Date()];
      this.filtered_trips = {};
      this.listHeight += this.paginationHeight;
      this.paginationHeight = 0;
    },
    changedFilter: function changedFilter(val) {
      if (val !== null) this.active_filter = val;
      this.filter = null;
      var load = false;
      if (this.Direction !== '' || this.BusMonitorID !== '' || this.TourID !== '') load = true;
      if (load) {
        this.Direction = this.BusMonitorID = this.TourID = '';
        this.listHeight += this.paginationHeight;
        this.paginationHeight = 0;
      }
    },
    eventResource: function eventResource(EventID, alert) {
      return this.$http.get('/incident/event_info?EventID=' + EventID + '&IsAlert=' + alert);
    },
    todayClosedTrips: function todayClosedTrips() {
      return this.$http.get('trip?filters%5BDate%5D%5Bmin%5D=' + this.$moment(new Date()).format('YYYY-MM-DD') + '&filters%5BDate%5D%5Bmax%5D=' + this.$moment(new Date()).format('YYYY-MM-DD') + '&limit=1&offset=0');
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default.a },
  data: function data() {
    return {
      trips: {},
      trip: {},
      route: {},
      bus: {},
      driver: {},
      monitor: {},
      expense: {},
      stops: [],
      loading: true,
      loading_stops: true,
      cardHeight: 0,
      tabHeight: 0,
      mapHeight: 0,
      distance: 0,
      idlingTime: 0,
      center: { lat: 0, lng: 0 },
      marker: { lat: 0, lng: 0, icon: { url: __webpack_require__(546) } },
      maps: null,
      map: null,
      markers: [],
      MarkerWithLabel: null,
      pulse: null,
      path: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.mapHeight = this.cardHeight - this.$refs.staff.$el.offsetHeight - 105;
    this.tabHeight = this.cardHeight;
    var self = this;
    this.$google.then(function (Maps) {
      self.maps = Maps;
      self.map = new Maps.Map(document.getElementById('trip-gmap-live'), {
        center: new Maps.LatLng(self.center),
        zoom: 14
      });
      self.MarkerWithLabel = __webpack_require__(144)(Maps);
    });
    this.getTrips();
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$on('trip', function (trip) {
      var TripID = trip.TripID;
      if (_this.trip.TripID === TripID && trip.IsClosed === 1) {
        _this.trip.IsClosed = trip.IsClosed;
        _this.trip.UpdatedAt = trip.UpdatedAt;
        if (trip.TotalCost !== undefined) {
          _this.trip.TotalCost = trip.TotalCost;
          _this.trip.TravelCost = trip.TravelCost;
          _this.trip.TotalCost = trip.TotalCost;
          _this.trip.IdleCost = trip.IdleCost;
        }
      }
    });
  },

  computed: {
    listExpenses: function listExpenses() {
      var factors = [{ key: 'Driver', label: this.$t('DRIVER'), time: '22 days' }, { key: 'Supervisor', label: this.$t('SUPERVISOR'), time: '22 days' }, { key: 'Insurance', label: this.$t('INSURANCE'), time: '180 days' }, { key: 'Finance', label: this.$t('VECHICLEPAYMENTS'), time: '22 days' }, { key: 'Registration', label: this.$t('REGISTRATION'), time: '180 days' }, { key: 'Inspection', label: this.$t('INSPECTION'), time: '180 days' }, { key: 'Permit', label: this.$t('VEHICLEPERMIT'), time: '180 days' }, { key: 'Depreciation', label: this.$t('VEHICLEDEPRECIATION'), time: '365 days' }, { key: 'Fuel', label: this.$t('FUELCONSUMPTION'), time: '' }, { key: 'Oil', label: this.$t('OILCHANGE'), time: '' }, { key: 'Idling', label: this.$t('IDLING'), time: '60 mins' }, { key: 'Tire', label: this.$t('TIRES'), time: '' }, { key: 'Wear_Tear', label: this.$t('WEARTEAR'), time: '' }];
      for (var exp in this.expense) {
        for (var index in factors) {
          if (exp === factors[index].key) {
            factors[index].cost = this.expense[exp];
            if (factors[index].time.indexOf('days') < 0) {
              if (factors[index].key === 'Idling') {
                factors[index].calc = this.expense[exp] + ' * ' + this.idlingTime + ' ' + 'mins';
                factors[index].result = (this.expense[exp] * this.idlingTime).toFixed(3);
              } else {
                factors[index].calc = this.expense[exp] + ' * ' + this.distance + ' ' + 'km';
                factors[index].result = (this.expense[exp] * this.distance).toFixed(3);
              }
            } else {
              var doneTrips = this.expense['doneTrips'] < 2 ? 2 : this.expense['doneTrips'];
              if (factors[index].key === 'Depreciation') {
                factors[index].calc = '((' + this.expense['Price'] + ' * ' + this.expense[exp] / 100 + ')' + ' / ' + factors[index].time + ') / ' + doneTrips + ' ' + this.$tc('TRIP', doneTrips < 2 ? 1 : 2);
                factors[index].result = (this.expense['Price'] * (this.expense[exp] / 100) / factors[index].time.split(' ')[0] / doneTrips).toFixed(3);
              } else {
                factors[index].calc = '(' + this.expense[exp] + ' / ' + factors[index].time + ') / ' + doneTrips + ' ' + this.$tc('TRIP', doneTrips < 2 ? 1 : 2);
                factors[index].result = (this.expense[exp] / factors[index].time.split(' ')[0] / doneTrips).toFixed(3);
              }
            }
          }
        }
      }
      return factors;
    }
  },
  methods: {
    subscribeToRFID: function subscribeToRFID() {
      var _this2 = this;

      if (this.trip.IsClosed === 1) return;
      var id = this.trip.IMEI === null ? this.trip.TripID : this.trip.BusID;
      this.$channel.bind('rfid-' + id, function (data) {
        _this2.trip.RFIDStatus = data;
        for (var stop in _this2.stops) {
          stop = parseInt(stop);
          if (stop > 0) _this2.students_rfid(_this2.stops[stop].student);
        }
      });
    },
    subscribeToLocation: function subscribeToLocation() {
      var _this3 = this;

      if (this.trip.IsClosed === 1) return;
      var id = this.trip.IMEI === null ? this.trip.TripID : this.trip.BusID;
      this.$channel.bind('location-' + id, function (data) {
        _this3.trip.location = _this3.trip.location.concat(data);
        _this3.extendPath(data);
        _this3.setPulseLocation();
      });
    },
    showCost: function showCost(trip) {
      if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true;
      return false;
    },
    subscribeToBoarding: function subscribeToBoarding() {
      var _this4 = this;

      if (this.trip.IsClosed === 1) return;
      this.$channel.bind('boarding-' + this.trip.TripID, function (data) {
        __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('boarding', data);
        _this4.updateStudentStop(data);
      });
    },
    showMarker: function showMarker(stop) {
      if (stop === 0) return __webpack_require__(21);
      return 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_green' + stop + '.png';
    },
    tripDate: function tripDate(date) {
      if (date === null) return this.$t('EXPECTEDTOSTART');
      return this.$moment(date).locale(localStorage.getItem('lang')).format('MMMM') + this.$moment(date).format(' DD, YYYY');
    },
    tripTime: function tripTime(time) {
      return this.$moment(time).format('hh:mm') + this.$moment(time).locale(localStorage.getItem('lang')).format(' A');
    },
    unixConverter: function unixConverter(time) {
      return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A');
    },
    updateStudentStop: function updateStudentStop(boarding) {
      if (this.stops[boarding.Stop] === undefined) return;
      var students = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.stops[boarding.Stop].student);
      for (var student in students) {
        if (students[student].StudentID === boarding.StudentID) {
          if (boarding.CheckIn !== undefined) this.$set(students[student], 'CheckIn', boarding.CheckIn);
          if (boarding.CheckOut !== undefined) this.$set(students[student], 'CheckOut', boarding.CheckOut);
          if (boarding.IsMissing !== undefined) this.$set(students[student], 'IsMissing', boarding.IsMissing);
          return;
        }
      }
    },
    RFIDTagStatus: function RFIDTagStatus(TagID) {
      if (this.trip.RFIDStatus === null || TagID === null) return false;
      var RFIDStatus = this.trip.RFIDStatus;
      TagID = this.base_convert(TagID, 10, 16);
      if (RFIDStatus.current !== undefined && RFIDStatus.current[TagID] !== null) return true;
      return false;
    },
    base_convert: function base_convert(number, initialBase, changeBase) {
      if ((initialBase && changeBase) < 2 || (initialBase && changeBase) > 36) return this.$t('BASEBETWEEN');
      return parseInt(number + '', initialBase).toString(changeBase);
    },
    getTrips: function getTrips() {
      var self = this;
      var data = { filters: {} };
      data.filters.TripID = self.$route.params.id;
      var trip = this.$http.get('/trip?' + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([trip]).then(function (results) {
        self.loading = false;
        self.trip = results[0].data.trips[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(results[0].data.trips)[0]];
        self.getRoute(self.trip);
      });
    },
    tagIcon: function tagIcon(student) {
      if (student.rfid_status === null) return '';
      return student.rfid_status ? 'text-success' : 'text-danger';
    },
    getRoute: function getRoute(trip) {
      var self = this;
      self.loading_stops = true;
      this.subscribeToBoarding();
      this.subscribeToRFID();
      this.subscribeToLocation();
      var params = { TourID: trip.TourID, BusDriverID: trip.BusDriverID, BusMonitorID: trip.BusMonitorID, Direction: trip.Direction, Date: trip.Db_Date };
      this.$http.get('/trip/' + self.$route.params.id, { params: params }).then(function (response) {
        self.route = response.data.route;
        self.stops = response.data.stops;
        self.driver = response.data.driver;
        self.monitor = response.data.monitor;
        var duration = 0;
        for (var stop in self.stops) {
          stop = parseInt(stop);
          self.idlingTime += self.stops[stop].WaitingTime;
          if (stop > 0) {
            duration += self.stops[stop].DeltaT + self.stops[stop].WaitingTime;
            self.stops[stop].DeltaT = duration;
            self.students_rfid(self.stops[stop].student);
          }
        }
        for (var _stop in self.stops) {
          self.stops[_stop].Stop = parseInt(_stop);
          self.addMarker(self.stops[_stop]);
        }
        self.drawPath();
        self.getPulseLocation();
        self.loading_stops = false;
        self.mapHeight -= self.$refs.cost.$el.offsetHeight;
      }).catch(function (response) {
        self.loading_stops = false;
      });
    },
    students_rfid: function students_rfid(students) {
      var rfidStatus = null;
      for (var student in students) {
        var TagID = students[student].AssignedTagID;
        if (TagID !== null) {
          var hex = this.base_convert(TagID, 10, 16);
          rfidStatus = false;
          if (this.trip.RFIDStatus !== null) {
            if (this.trip.RFIDStatus.current[hex] !== undefined || this.trip.RFIDStatus.current[TagID]) {
              rfidStatus = true;
            }
          }
        }
        this.$set(students[student], 'rfid_status', rfidStatus);
      }
    },
    getSummaries: function getSummaries(param) {
      var _this5 = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this5.$t('TOTALCOST');
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toFixed(2) + ' ' + _this5.$t('AED');
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getExpense: function getExpense() {
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(this.expense)) return;
      var params = { TourID: this.trip.TourID, BusID: this.trip.BusID };
      var self = this;
      this.$http.get('/trip/expense', { params: params }).then(function (response) {
        self.expense = response.data;
      }).catch(function (response) {});
    },
    haversineGreatCircleDistance: function haversineGreatCircleDistance(latitudeFrom, longitudeFrom, latitudeTo, longitudeTo) {
      var earthRadius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 6371000;

      var latFrom = this.deg2rad(latitudeFrom);
      var lonFrom = this.deg2rad(longitudeFrom);
      var latTo = this.deg2rad(latitudeTo);
      var lonTo = this.deg2rad(longitudeTo);
      var latDelta = latTo - latFrom;
      var lonDelta = lonTo - lonFrom;
      var angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) + Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)));
      return angle * earthRadius;
    },
    deg2rad: function deg2rad(val) {
      return val * (Math.PI / 180);
    },
    pinSymbol: function pinSymbol(color) {
      return {
        path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color,
        labelOrigin: new this.maps.Point(0, -25)
      };
    },
    drawPath: function drawPath() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      var polyline = new this.maps.Polyline({
        path: new this.maps.geometry.encoding.decodePath(this.route.Polyline),
        strokeColor: this.route.RouteColor,
        strokeOpacity: 0.6,
        strokeWeight: 5
      });
      polyline.setMap(this.map);
      var path = [];
      for (var item in this.trip.location) {
        item = parseInt(item);
        var position = this.trip.location[item];
        path.push(new this.maps.LatLng(position.Lat, position.Lng));
        if (this.trip.location[item + 1] !== undefined) this.distance += this.haversineGreatCircleDistance(position.Lat, position.Lng, this.trip.location[item + 1].Lat, this.trip.location[item + 1].Lng);
      }
      this.distance = Math.round(this.distance) / 1000;
      this.path = new this.maps.Polyline({
        path: path,
        map: this.map,
        strokeColor: 'blue',
        strokeOpacity: 0.6,
        strokeWeight: 5
      });
    },
    addMarker: function addMarker(position) {
      var label = position.Stop + '';
      var marker = new this.maps.Marker({
        draggable: true,
        raiseOnDrag: true,
        position: new this.maps.LatLng(position.Lat, position.Lng),
        icon: this.pinSymbol(this.route.RouteColor),
        label: {
          text: label,
          color: '#fff',
          fontSize: '16px'
        }
      });
      if (position.Stop === 0) {
        marker.setIcon(__webpack_require__(21));
        marker.setLabel(null);
      }
      marker.setMap(this.map);
    },
    getPulseLocation: function getPulseLocation() {
      if (this.trip.IsClosed === 1) return;
      this.pulse = new this.MarkerWithLabel({ map: this.map });
      this.pulse.setIcon({ path: this.maps.SymbolPath.CIRCLE });
      this.pulse.set('labelClass', 'pulse');
      this.pulse.set('labelAnchor', new this.maps.Point(15, 15));
      this.setPulseLocation();
    },
    extendPath: function extendPath(locations) {
      for (var location in locations) {
        this.path.getPath().push(new this.maps.LatLng(parseFloat(locations[location].Lat), parseFloat(locations[location].Lng)));
      }
    },
    setPulseLocation: function setPulseLocation() {
      if (this.trip.location.length === 0) return this.pulse.setMap(null);
      var location = this.trip.location[this.trip.location.length - 1];
      var position = new this.maps.LatLng(parseFloat(location.Lat), parseFloat(location.Lng));
      this.pulse.setMap(this.map);
      this.pulse.setPosition(position);
      this.map.panTo(position);
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      violations: [],
      incident: { incident_type: null, bus: {}, monitor: {} },
      loading: true,
      status: { 0: 'success', 1: 'warning', 2: 'danger' },
      filter: null,
      active_filter: 'bus',
      buses: [],
      BusID: '',
      Label: '',
      date: [null, null],
      totalViolations: 0,
      currentPage: 1,
      visitedPage: [1],
      new_page: false,
      limit: 20,
      tableHeight: 0
    };
  },

  computed: {
    options: function options() {
      var options = [{
        value: 'bus',
        label: this.$t('BUS')
      }, {
        value: 'type',
        label: this.$t('VIOLATIONTYPE')
      }, {
        value: 'date',
        label: this.$t('DATE')
      }];
      return options;
    },
    violationTypes: function violationTypes() {
      var violationTypes = { 5: this.$t('SMOKEDETECTED'), 13: this.$t('PANICBUTTONPRESSED'), 15: this.$t('HIGHSPEEDALARM') };
      return violationTypes;
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.getViolations();
    this.getBuses();
  },

  methods: {
    getViolations: function getViolations() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      if (filter) {
        self.currentPage = 1;
        self.visitedPage = [1];
        self.new_page = true;
        self.violations = {};
      }
      if (self.violations[self.currentPage - 1] !== undefined) return;
      this.$http.get('/violation?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.violations, self.currentPage - 1, response.data.violations);
        self.totalViolations = response.data.total;
        self.new_page = self.loading = false;
      }).catch(function (response) {});
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.active_filter)) return;
      switch (this.active_filter) {
        case 'bus':
          data.filters['BusID'] = this.BusID;
          break;
        case 'type':
          data.filters['Label'] = this.Label;
          break;
        case 'date':
          if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(this.date[0]) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(this.date[1])) break;
          data.filters['minDate'] = this.$moment(this.date[0]).format('YYYY-MM-DD');
          data.filters['maxDate'] = this.$moment(this.date[1]).format('YYYY-MM-DD');
          break;
      }
      return data;
    },
    handleSelect: function handleSelect() {
      return true;
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.violations = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getViolations();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getViolations();
    },
    changeFilter: function changeFilter() {
      this.Label = this.BusID = '';
      if (this.filter === 'bus') this.getBuses();
    },
    getBuses: function getBuses() {
      var self = this;
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(self.buses)) return;
      this.$http.get('/bus').then(function (response) {
        self.buses = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.violations = {};
      this.getViolations();
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    },
    flagItem: function flagItem(item, type) {
      var flag = null;
      if (type === 'sticky') {
        item.IsSticky = !item.IsSticky;
        flag = item.IsSticky ? 1 : 0;
      } else {
        item.IsHidden = !item.IsHidden;
        flag = item.IsHidden ? 1 : 0;
      }
      var postData = { id: item.ViolationID, type: type, flag: flag, name: 'violation' };
      this.$http.post('/report/flag', postData).then(function (response) {}).catch(function (response) {});
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Save__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Save___default.a },
  data: function data() {
    return {
      school: { Gender: null, Type: null, DateFormat: null, Notification: false, Address: null, Threshold: {} },
      address: {},
      timing: { ClassEnd: null, ClassStart: null, EarlyDeparture: null, GateClose: null, GateOpen: null, LateArrival: undefined },
      academicTerms: [],
      grades: [],
      activities: [],
      adminImage: null,
      admin: null,
      gradeIndex: null,
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      center: { lat: 0, lng: 0 },
      markers: [],
      minutes: [5, 10, 15, 20, 25, 30],
      standingMinutes: [2, 4, 6, 8, 10],
      meters: [25, 50, 75, 100],
      AcademicYear: null,
      grade: { Grade: null, Age: null },
      Location: null,
      country: null,
      date_format: 'dd/MM/yyyy',
      loading: false,
      sessionDialog: false,
      message: null,
      error: false,
      maps: null,
      map: null,
      marker: null,
      selectedYear: null,
      autoSource: null,
      Activity: { ID: null, Name: null, Date: [null, null], StartTime: null, EndTime: null, Days: [] },
      postData: {},
      isIndeterminate: false,
      checkAll: false,
      parentMessages: ['MSGTOPARENT', 'REPORTABSENCE', 'EMAILTEACHER', 'CALLDRIVER', 'CALLNAANY', 'MSGTONAANY', 'CALLSCHOOL', 'EMAILSCHOOL'],
      enableConfirm: false
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getConfiguration();
  },

  computed: {
    daysC: function daysC() {
      var days = [this.$t('SUNDAY'), this.$t('MONDAY'), this.$t('TUESDAY'), this.$t('WEDNESDAY'), this.$t('THURSDAY'), this.$t('FRIDAY'), this.$t('SATURDAY')];
      this.days = days;
      return days;
    }
  },
  methods: {
    printError: function printError(message, key) {
      if (key === 'exception') return message;
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    changeAutoComplete: function changeAutoComplete() {
      var self = this;
      this.$google.then(function (Maps) {
        var autocomplete = new Maps.places.Autocomplete(document.getElementById('location'), { componentRestrictions: { country: self.school.Country } });
        Maps.event.addListener(autocomplete, 'place_changed', function () {
          self.setPlace(autocomplete.getPlace());
        });
      });
    },
    handleCheckAllChange: function handleCheckAllChange(event) {
      this.school.Messages = event.target.checked ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.parentMessages) : [];
      this.isIndeterminate = false;
    },
    handleCheckedMessageChange: function handleCheckedMessageChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.parentMessages.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.parentMessages.length;
    },
    loadSchoolMap: function loadSchoolMap() {
      var userData = JSON.parse(localStorage.getItem('userData'));
      this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
      var self = this;
      this.$google.then(function (Maps) {
        var positon = new Maps.LatLng(self.center);
        self.maps = Maps;
        self.map = new Maps.Map(document.getElementById('school-gmap'), {
          center: positon,
          zoom: 14
        });
        self.marker = new Maps.Marker({
          position: positon,
          icon: __webpack_require__(21)
        });
        self.marker.setMap(self.map);
        self.marker.addListener('dragend', self.changePosition);
        var autocomplete = new Maps.places.Autocomplete(document.getElementById('location'), { componentRestrictions: { country: self.school.Country } });
        Maps.event.addListener(autocomplete, 'place_changed', function () {
          self.setPlace(autocomplete.getPlace());
        });
      });
    },
    phoneValidation: function phoneValidation(rule, value, callback) {
      var regex = /^\+?[\d-]+$/;
      if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'));
      callback();
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.school.Logo = res.file_name;
    },
    getConfiguration: function getConfiguration() {
      var self = this;
      this.loading = true;
      this.$http.get('/configuration').then(function (response) {
        self.loading = false;
        self.school = response.data.school;
        self.admin = response.data.admin.FullName_EN;
        self.adminImage = response.data.admin.ImagePath;
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.timing).length !== 0) self.timing = response.data.timing;
        self.academicTerms = response.data.academic_terms;
        self.grades = response.data.grades;
        self.activities = response.data.activities;
        for (var activity in self.activities) {
          self.activities[activity].Date = [self.activities[activity].StartDate, self.activities[activity].EndDate];
          if (self.activities[activity].Days !== null) {
            self.activities[activity].Days = self.activities[activity].Days.split(',').map(Number);
          } else {
            self.activities[activity].Days = [];
          }
          delete self.activities[activity].StartDate;
          delete self.activities[activity].EndDate;
        }
        if (response.data.address !== null) self.address = response.data.address;
        self.center = { lat: parseFloat(self.school.Lat), lng: parseFloat(self.school.Lng) };
        self.marker = { lat: parseFloat(self.school.Lat), lng: parseFloat(self.school.Lng), icon: __webpack_require__(21) };
        self.loadSchoolMap();
      }).catch(function (response) {});
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (self.admin === null) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findUser(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findUser: function findUser(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();
      return this.$http.get('/user/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=config', { cancelToken: this.autoSource.token });
    },
    changeUser: function changeUser(data) {
      this.school.AdminID = data.PersonID;
    },
    gradeValidation: function gradeValidation() {
      if (!this.grade.Grade || !this.grade.Age) return true;
      if (this.grade.Grade.length < 1 || this.grade.Grade.length > 8) return true;
      return false;
    },
    newTerm: function newTerm() {
      var year = new Date().getFullYear();
      if (this.academicTerms.length !== 0) {
        var term = this.academicTerms[this.academicTerms.length - 1];
        year = term.year.split('/')[1];
      }
      var AcademicYear = year + '/' + (parseInt(year) + 1);
      this.academicTerms.push({ year: AcademicYear, YearID: null, terms: [] });
    },
    newGrade: function newGrade() {
      if (this.gradeIndex !== null) {
        this.grades[this.gradeIndex].Name = this.grade.Grade;
        this.grades[this.gradeIndex].Age = this.grade.Age;
      } else {
        this.grades.push({ GradeID: null, Name: this.grade.Grade, Age: this.grade.Age, Classes: [] });
      }
      this.grade.Grade = this.grade.Age = this.gradeIndex = null;
    },
    getSchoolPhoto: function getSchoolPhoto(image) {
      if (image === undefined) return this.BASEURL + 'uploads/thumbnails/no-school.png';
      image = image !== null && image !== '' ? image : 'no-school.png';
      return this.BASEURL + 'uploads/thumbnails/' + image;
    },
    setPlace: function setPlace(place) {
      this.school.Lat = place.geometry.location.lat();
      this.school.Lng = place.geometry.location.lng();
      this.school.Address = document.getElementById('location').value;
      this.marker.setPosition(new this.maps.LatLng(this.school.Lat, this.school.Lng));
      this.map.panTo(this.marker.getPosition());
      this.marker.setMap(this.map);
    },
    dateChange: function dateChange(date) {
      return this.$moment(date).format('YYYY/MM/DD');
    },
    dateFormat: function dateFormat(value) {
      return this.$moment(value).format(this.date_format.toUpperCase());
    },
    editGrade: function editGrade(index) {
      this.gradeIndex = index;
      this.grade.Grade = this.grades[index].Name;
      this.grade.Age = this.grades[index].Age;
    },
    activeDates: function activeDates(time) {
      var year = this.selectedYear.split('/');
      if (time.getFullYear() === parseInt(year[0]) || time.getFullYear() === parseInt(year[1])) {
        return false;
      } else return true;
    },
    restricNextDate: function restricNextDate(key, val) {
      console.log(key, val);
    },
    expandRow: function expandRow(row, expanded) {
      if (expanded) this.selectedYear = row.year;
    },
    changedAddess: function changedAddess(val) {
      console.log('test');
    },
    changePosition: function changePosition(marker) {
      this.school.Lat = marker.latLng.lat();
      this.school.Lng = marker.latLng.lng();
    },
    saveActivity: function saveActivity() {
      var postData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.Activity);
      var self = this;
      this.$http.post('/configuration/saveActivity', postData).then(function (response) {
        var data = response.data;
        if (data !== '') {
          self.Activity.ID = data;
          self.activities.push(self.Activity);
        }
        self.Activity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { ID: null, Name: null, Date: [null, null], StartTime: null, EndTime: null, Days: [] });
      }).catch(function () {});
    },
    deleteActivity: function deleteActivity(key, ID) {
      var self = this;
      var postData = { ID: ID, Status: 0 };
      this.$http.post('/configuration/deleteActivity', postData).then(function (response) {
        if (response.data.error) {
          return self.$message({
            message: self.$t('ACTIVITYASSIGNEDTOSTUDENT'),
            type: 'warning',
            showClose: true
          });
        }
        self.$delete(self.activities, key);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteGrade: function deleteGrade(key, ID, Name) {
      var self = this;
      if (!ID) {
        self.$delete(self.grades, key);
        return;
      }
      var postData = { GradeID: ID, Status: 0, Name: Name };
      this.$http.post('/configuration/deleteGrade', postData).then(function (response) {
        if (response.data.error) {
          return self.$message({
            message: self.$t('GRADEASSIGNEDTOSTUDENT'),
            type: 'warning',
            showClose: true
          });
        }
        self.$delete(self.grades, key);
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeMarkerPosition: function changeMarkerPosition(lat, lng) {
      var latlng = new this.maps.LatLng(lat, lng);
      this.marker.setPosition(latlng);
      this.map.setCenter(latlng);
      this.enableConfirm = false;
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Message__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Import__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-message-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Message___default.a, 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Import___default.a },
  data: function data() {
    return {
      guardians: {},
      students: [],
      guardian: { Deleted: false },
      filter: null,
      active_filter: 'name',
      loading: true,
      indexCheck: null,
      prevIndex: null,
      FullName: '',
      MobileNo: '',
      PersonID: '',
      Status: '',
      Relation: '',
      currentRow: null,
      new_page: false,
      tableHeight: 0,
      totalGuardians: 0,
      totalFilter: 0,
      currentPage: 1,
      visitedPage: [1],
      limit: 20,
      sending: false,
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      messageBox: false,
      autoSource: null,
      import_data: {}
    };
  },

  computed: {
    listGuardians: function listGuardians() {
      if (this.guardians[this.currentPage - 1] === undefined) return;
      var guardians = this.guardians[this.currentPage - 1];
      return guardians;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('GUARDIANNAME')
      }, {
        value: 'relation',
        label: this.$t('RELATION')
      }, {
        value: 'mobile',
        label: this.$t('MOBILENO')
      }, {
        value: 'id',
        label: this.$t('PERSONID')
      }, {
        value: 'status',
        label: this.$t('STATUS')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null }, { label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null }, { label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null }, { label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null }, { label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null }, { label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null }, { label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null }, { label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null }, { label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null }, { label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: true, format: 'date' }, { label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null }, { label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null }, { label: this.$t('EMAILADDRESS'), field: 'EMail', required: true, format: null }, { label: this.$t('RELATION'), field: 'Relation', required: true, format: null }, { label: this.$t('PRIMARYCONTACT'), field: 'IsMain', required: true, format: null }];
      return fields;
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.getGuardians();
  },

  methods: {
    removeFilter: function removeFilter(filter) {
      this.filter = '';
      this.guardians = {};
      this.getGuardians();
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    clearInput: function clearInput() {
      this.FullName = this.Status = this.Relation = this.MobileNo = this.PersonID = '';
      this.guardians = {};
      this.getGuardians();
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('^' + search, 'i');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getGuardians();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.guardians = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getGuardians();
    },
    getGuardians: function getGuardians() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      if (filter) {
        self.currentPage = 1;
        self.visitedPage = [1];
        self.new_page = true;
        self.guardians = {};
      }
      if (self.guardians[self.currentPage - 1] !== undefined) return;
      if (this.autoSource) this.autoSource.cancel();
      this.autoSource = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken.source();
      this.$http.get('/guardian?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1), { cancelToken: this.autoSource.token }).then(function (response) {
        self.autoSource = null;
        for (var guardian in response.data.guardians) {
          response.data.guardians[guardian].Deleted = false;
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(self.guardians, self.currentPage - 1, response.data.guardians);
        self.new_page = self.loading = false;
        self.totalGuardians = response.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      switch (this.active_filter) {
        case 'name':
          data.filters['FullName'] = this.FullName;
          break;
        case 'relation':
          data.filters['Relation'] = this.Relation;
          break;
        case 'id':
          data.filters['PersonID'] = this.PersonID;
          break;
        case 'mobile':
          data.filters['MobileNo'] = this.MobileNo;
          break;
        case 'status':
          data.filters['Status'] = this.Status;
          break;
      }
      return data;
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { PersonID: self.listGuardians[index].PersonID, Status: self.listGuardians[index].Status };
      this.$http.post('/guardian/delete', postData).then(function (response) {
        self.guardians = {};
        self.visitedPage = [self.currentPage];
        self.getGuardians();
        self.$message({
          message: response.data.error ? self.$t('GUARDIANCANNOTBEENDELETED') : self.$t('GUARDIANHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkRoute: function checkRoute(index) {
      var self = this;
      var guardian = self.listGuardians[index];
      guardian.Deleted = false;
      if (self.indexCheck === guardian.PersonID) return;
      self.prevIndex = index;
      if (guardian.students.length !== 0) {
        guardian.Deleted = false;
        self.indexCheck = guardian.PersonID;
        return self.$message({
          message: self.$t('GUARDIANCANNOTBEDELETED'),
          type: 'warning',
          showClose: true,
          onClose: function onClose() {
            self.indexCheck = null;
          }
        });
      } else guardian.Deleted = true;
    },
    deleteGuadian: function deleteGuadian() {},
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
      var load = false;
      if (this.FullName !== '' || this.Relation !== '' || this.Status !== '' || this.MobileNo !== '' || this.PersonID !== '') load = true;
      if (load) {
        this.FullName = this.Relation = this.Status = this.MobileNo = this.PersonID = '';
        this.getGuardians(true);
      }
    },
    showMessageModal: function showMessageModal(parent) {
      if (parent.students.length === 0) {
        return self.$message({
          message: self.$t('GUARDIANHASNOSTUDENTS'),
          type: 'warning',
          showClose: true
        });
      }
      this.students = parent.students;
      this.guardian = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(parent, ['FullName_AR', 'FullName_EN', 'ImagePath', 'IsMain', 'PersonID', 'Relation', 'deleted']);
      this.messageBox = true;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default.a },
  data: function data() {
    return {
      guardian: { Relation: null, IDExpiration: null, Nationality: null, ImagePath: null },
      contact: {},
      school: {},
      student: null,
      students: [],
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      loading: false,
      message: null,
      existedKey: null,
      error: false,
      date_format: 'dd/MM/yyyy',
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      autoSource: null
    };
  },

  watch: {
    students: {
      handler: function handler(data) {
        this.$nextTick(function () {
          this.$refs.relationForm.validateField('student');
        });
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getGuardian();
  },

  methods: {
    printError: function printError(message, key) {
      if (key === 'exception') return message;
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    phoneValidation: function phoneValidation(rule, value, callback) {
      var regex = /^\+?[\d-]+$/;
      if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'));
      callback();
    },
    hasRelation: function hasRelation(rule, value, callback) {
      if (this.students.length > 0) {
        var deleted = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.students, 'deleted');
        if (this.students.length !== deleted.length) return callback();
      }
      callback(this.$t('ISREQUIREDTOADDSTUDENT'));
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.guardian.ImagePath = res.file_name;
    },
    getGuardian: function getGuardian() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/guardian/' + this.$route.params.id).then(function (response) {
        self.guardian = response.data.person;
        self.guardian.IDExpiration = self.dateFormat(self.guardian.IDExpiration);
        self.contact = response.data.contact;
        self.students = response.data.students;
        self.loading = false;
      }).catch(function (response) {});
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    addStudent: function addStudent(data) {
      var student = data.student;
      if (this.students !== undefined) {
        for (var i = 0; i < this.students.length; i++) {
          if (this.students[i].StudentID === student.StudentID) {
            this.error = true;
            this.status = 'Error';
          }
        }
        if (this.error) {
          this.message = { exception: this.$t('STUDENT') + ': ' + (student.FirstName_EN + ' ' + student.FirstName_EN) + ' ' + this.$t('ALREADYINTHELIST') };
          return;
        }
      }
      if (student.IsMain === null) {
        student.IsMain = 1;
      } else {
        student.IsMain = null;
      }
      this.student = null;
      this.students.push(student);
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (self.student === null) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findStudent(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findStudent: function findStudent(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken.source();
      return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&id=' + this.guardian.PersonID + '&from=route', { cancelToken: this.autoSource.token });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.student.ImagePath = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$t('AVATARPICTUREMUSTBEJPGFORMAT'));
      }
      if (!isLt2M) {
        this.$message.error(this.$t('AVATARPICTURESIZECANNOTEXCEED'));
      }
      return isJPG && isLt2M;
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Absence__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Absence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_Absence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Tag__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Message__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dialogs_Message__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-absence-dialog': __WEBPACK_IMPORTED_MODULE_4__components_dialogs_Absence___default.a, 'el-tag-dialog': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Tag___default.a, 'el-message-dialog': __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Message___default.a, 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Import___default.a },
  data: function data() {
    return {
      students: {},
      absence: { AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0 },
      absenceStudent: {},
      direction: { 0: false, 1: false },
      compose: { Text: null },
      grades: {},
      student: { Deleted: false },
      messageStudent: [],
      absenceFrom: 'Bus',
      lang: 'en',
      printCardWidth: 24,
      indexCheck: 0,
      prevIndex: 0,
      tableHeight: 0,
      limit: 20,
      grade: {},
      totalStudents: 0,
      totalFilter: 0,
      template: 0,
      currentPage: 1,
      visitedPage: [1],
      filter: null,
      active_filter: 'name',
      reset: false,
      FullName: '',
      ExternalStudentID: '',
      RouteID: '',
      Grade: '',
      Class: '',
      Status: '',
      gradeClass: '',
      studentID: '',
      currentRow: null,
      message: null,
      loading: true,
      new_page: false,
      error: false,
      messageBox: false,
      absenceBox: false,
      saving: false,
      dialogVisible: false,
      selectedStudents: [],
      routes: [],
      callScan: false,
      findTag: false,
      school: {},
      parent: {},
      fieldText: {},
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      autoSource: null,
      import_data: {}
    };
  },

  computed: {
    listStudents: function listStudents() {
      if (this.students[this.currentPage - 1] === undefined) return;
      var students = this.students[this.currentPage - 1];
      return students;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('STUDENTNAME')
      }, {
        value: 'route',
        label: this.$t('ROUTENAME')
      }, {
        value: 'id',
        label: this.$t('STUDENTID')
      }, {
        value: 'grade',
        label: this.$t('GRADE')
      }, {
        value: 'status',
        label: this.$t('STATUS')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null }, { label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null }, { label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null }, { label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null }, { label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null }, { label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null }, { label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null }, { label: this.$t('DATEOFBIRTH'), field: 'DOB', required: true, format: 'date' }, { label: this.$t('GENDER'), field: 'Gender', required: true, format: null }, { label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null }, { label: this.$t('GRADE'), field: 'Grade', required: true, format: null }, { label: this.$t('CLASS'), field: 'Class', required: true, format: null }, { label: this.$t('HOUSENUMBER'), field: 'HouseNumber', required: true, format: null }, { label: this.$t('ADDRESS'), field: 'Address', required: false, format: null }, { label: this.$t('AREA'), field: 'Area', required: false, format: null }, { label: this.$t('CITY'), field: 'City', required: true, format: null }, { label: this.$t('STATE'), field: 'State', required: true, format: null }, { label: this.$t('ZIPCODE'), field: 'ZipCode', required: true, format: null }, { label: this.$t('SECTOR'), field: 'Sector', required: false, format: null }, { label: this.$t('ZONE'), field: 'Zone', required: false, format: null }, { label: this.$t('LAT'), field: 'Lat', required: true, format: null }, { label: this.$t('LNG'), field: 'Lng', required: true, format: null }];
      return fields;
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53);
    this.$refs.dialog.rendered = true;
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.school = { 'school_name': userData.school_name, 'contact_number': userData.contact_number, 'school_logo': userData.school_logo };
    this.getStudents();
    this.getGrades();
    this.getRoutes();
  },

  methods: {
    markAbsence: function markAbsence(student) {
      this.absence.StudentID = student.StudentID;
      this.absenceStudent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(student, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath']);
      this.absenceBox = true;
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    printAll: function printAll() {
      var students = this.students[this.currentPage - 1];
      for (var item in students) {
        this.printQueue(students[item]);
      }
    },
    removeFilter: function removeFilter() {
      this.changeFilter();
      this.active_filter = 'name';
      this.students = {};
      this.getStudents();
    },
    clearInput: function clearInput() {
      this.FullName = this.ExternalStudentID = '';
      this.students = {};
      this.getStudents();
    },
    gradeSelect: function gradeSelect(item) {
      if (item === '') {
        this.Grade = this.gradeClass = '';
      } else {}
    },
    changeFilter: function changeFilter() {
      this.FullName = this.ExternalStudentID = this.Grade = this.gradeClass = '';
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { StudentID: self.listStudents[index].StudentID, Status: self.listStudents[index].Status };
      this.$http.post('/student/delete', postData).then(function (response) {
        self.students = {};
        self.visitedPage = [self.currentPage];
        self.getStudents();
        self.$message({
          message: response.data.error ? self.$t('STUDENTCANNOTBEENDELETED') : self.$t('STUDENTHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      if (this.visitedPage.indexOf(val) >= 0) return;
      this.visitedPage.push(val);
      this.new_page = true;
      this.getStudents();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.selectedStudents.length = 0;
      this.limit = val;
      this.students = {};
      this.currentPage = 1;
      this.visitedPage = [1];
      this.loading = true;
      this.getStudents();
    },
    getStudents: function getStudents() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (filter) {
        this.currentPage = 1;
        this.visitedPage = [1];
        this.new_page = true;
        this.students = {};
      }
      if (this.students[this.currentPage - 1] !== undefined) return;
      if (this.autoSource) this.autoSource.cancel();
      this.autoSource = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
      var self = this;
      this.$http.get('/student?' + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(self.bindCurrentFilters()) + '&limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1), { cancelToken: this.autoSource.token }).then(function (response) {
        self.autoSource = null;
        for (var student in response.data.students) {
          response.data.students[student].Deleted = false;
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.students, self.currentPage - 1, response.data.students);
        self.new_page = self.loading = false;
        self.totalStudents = response.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    bindCurrentFilters: function bindCurrentFilters() {
      var data = { filters: [] };
      switch (this.active_filter) {
        case 'name':
          data.filters['FullName'] = this.FullName;
          break;
        case 'route':
          data.filters['RouteID'] = this.RouteID;
          break;
        case 'id':
          data.filters['ExternalStudentID'] = this.ExternalStudentID;
          break;
        case 'grade':
          data.filters['Grade'] = this.Grade.Name;
          if (this.gradeClass !== '') data.filters['Class'] = this.gradeClass;
          break;
        case 'status':
          data.filters['Status'] = this.Status;
          break;
      }
      return data;
    },
    getGrades: function getGrades() {
      var self = this;
      this.$http.get('/configuration/grade').then(function (response) {
        self.grades = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getRoutes: function getRoutes() {
      var self = this;
      this.$http.get('/route?ref=student').then(function (response) {
        self.routes = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    newStudent: function newStudent() {
      this.$router.push('/school/student/create');
    },
    isOnQueue: function isOnQueue(item) {
      if (this.selectedStudents.indexOf(item) >= 0) return true;
      return false;
    },
    printQueue: function printQueue(item) {
      if (this.selectedStudents.indexOf(item) >= 0) return this.selectedStudents.splice(this.selectedStudents.indexOf(item), 1);
      this.selectedStudents.push(item);
    },
    IDCard: function IDCard(item) {
      this.printCardWidth = 24;
      this.template = 3;
      this.selectedStudents = [];
      this.selectedStudents.push(item);
      this.dialogVisible = true;
    },
    printCard: function printCard() {
      this.dialogVisible = false;
      this.printCardWidth = 12;
      this.$nextTick(function () {
        var card = this.$refs.printCard.innerHTML;
        var w = window.open();
        w.document.write('<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>Print it!</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/element-ui/1.4.9/theme-default/index.css"><style>.el-row .el-row--flex {background-color: rgb(245, 200, 56) !important; width: auto;}.el-button-group {display: inline-flex;}.card-pic {background-color: #4b4b4b !important;padding-top: 10px;text-align: center;}.card-pic .pic {width: 75%;border-radius: 50%;margin: 10px;border: 4px solid #f5ca40;-webkit-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);-moz-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);}label.el-form-item__label {font-weight: normal;}form{margin: 10px;}.el-form--label-top .el-form-item__label{padding: 0 0 0 0;}.el-form-item {margin-bottom: 0px;}</style></head><body>');
        var s = w.document.createElement('script');
        s.type = 'text/javascript';
        s.src = __webpack_require__(80);
        w.document.write(card);
        w.document.body.appendChild(s);
        w.document.write('</body></html>');
        w.setTimeout(function () {
          w.print();
          w.close();
        }, 1000);
      });
    },
    handleDialogClose: function handleDialogClose(done) {
      this.dialogVisible = false;
    },
    checkRoute: function checkRoute(index) {
      var self = this;
      self.listStudents[self.prevIndex].Deleted = false;
      if (self.indexCheck === self.listStudents[index].StudentID) return;
      this.$http.get('/route/check?Type=Student&ID=' + self.listStudents[index].StudentID).then(function (response) {
        var result = response.data;
        self.prevIndex = index;
        if (result.TourID !== undefined) {
          self.listStudents[index].Deleted = false;
          self.indexCheck = self.listStudents[index].StudentID;
          return self.$message({
            message: self.$t('STUDENTHASBEENASSIGNEDTOROUTE'),
            type: 'warning',
            showClose: true,
            onClose: function onClose() {
              self.indexCheck = null;
            }
          });
        }
        self.listStudents[index].Deleted = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (self.FullName === null) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findStudent(queryString);
      if (queryString.length < 3) return;
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    findStudent: function findStudent(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
      return this.$http.get('/student/find?term=' + queryString + '&from=route', { cancelToken: this.autoSource.token });
    },
    searchStudent: function searchStudent() {
      var self = this;
      var term = self.FullName;
      if (self.ExternalStudentID != null) term = self.ExternalStudentID;
      if (self.autoSource) self.autoSource.cancel();
      self.findStudent(term).then(function (response) {
        for (var student in response.data.students) {
          response.data.students[student].Deleted = false;
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.students, self.currentPage - 1, response.data.students);
        self.new_page = self.loading = false;
        self.totalStudents = response.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    manageStudent: function manageStudent(data) {
      var student = data.student;
      this.$router.push({ path: '/school/student/' + student.StudentID });
    },
    showScanModal: function showScanModal(student) {
      var findTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.callScan = true;
      this.findTag = findTag;
      this.student = student;
    },
    showMessageModal: function showMessageModal(student) {
      var self = this;
      self.messageStudent = [];
      this.$http.get('/student/relation?StudentID=' + student.StudentID).then(function (response) {
        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(response.data)) {
          return self.$message({
            message: self.$t('STUDENTHASNOGUARDIAN'),
            type: 'warning',
            showClose: true
          });
        } else {
          self.messageStudent.push(student);
          self.parent = response.data;
          self.messageBox = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
      var load = false;
      if (this.FullName !== '' | this.RouteID !== '' | this.ExternalStudentID !== '' || this.Grade !== '' || this.Status !== '') load = true;
      if (load) {
        this.FullName = this.RouteID = this.ExternalStudentID = this.Grade = this.gradeClass = this.Status = '';
        this.getStudents(true);
      }
    },
    getSchoolPhoto: function getSchoolPhoto(image) {
      if (image === undefined) return this.BASEURL + 'uploads/thumbnails/adec-print-logo.png';
      image = image !== null && image !== '' ? image : 'adec-print-logo.png';
      return this.BASEURL + 'uploads/thumbnails/' + image;
    },
    handleClick: function handleClick(command) {
      switch (command) {
        case 'print':
          this.printAll();
          break;
        case 'tag':
          this.showScanModal({ AssignedTagID: null }, true);
          break;
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Tag__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dialogs_Tag__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default.a, 'el-tag-dialog': __WEBPACK_IMPORTED_MODULE_7__components_dialogs_Tag___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_5__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_6__components_dialogs_Save___default.a },
  data: function data() {
    return {
      student: { StudentID: null, Gender: null, Grade: null, Class: null, AssignedTagID: null, Nationality: null, DOB: null, ImagePath: null },
      loading: false,
      address: { Lng: null, Lat: null },
      grades: [],
      routes: [],
      activities: {},
      activityList: [],
      exludeActivities: [],
      Activity: null,
      Grade: {},
      school: {},
      guardians: [],
      guardian: null,
      activeIndex: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      cardWidth: 0,
      center: { lat: 0, lng: 0 },
      marker: { lat: 0, lng: 0, icon: { url: __webpack_require__(273) } },
      Location: null,
      country: null,
      timeout: null,
      error: false,
      callScan: false,
      findTag: false,
      loadingRoutes: false,
      loadingActivities: false,
      savingActivity: false,
      date_format: 'dd/MM/yyyy',
      maps: null,
      map: null,
      autoSource: null,
      changedPrimary: false,
      positionSet: true,
      studentMarker: null,
      message: null,
      defaultDate: Date.now() - 5 * 1000 * 60 * 60 * 24 * 365,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() >= Date.now() - 5 * 1000 * 60 * 60 * 24 * 365;
        }
      }
    };
  },

  computed: {
    listGuardians: function listGuardians() {
      return this.guardians;
    },
    listActivities: function listActivities() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.activities);
    }
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.country = userData.school_location.country;
    this.school = this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
    this.marker.lat = this.school.Lat;
    this.marker.lng = this.school.Lng;
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.cardWidth = window.innerWidth - this.$el.offsetWidth;
    this.getGrades();
    var self = this;
    this.$google.then(function (Maps) {
      var position = new Maps.LatLng(self.center);
      self.maps = Maps;
      self.map = new Maps.Map(document.getElementById('student-gmap'), {
        center: position,
        zoom: 14
      });
      var marker = new Maps.Marker({
        position: position,
        icon: __webpack_require__(21)
      });

      self.studentMarker = new Maps.Marker({
        position: position,
        draggable: true,
        animation: Maps.Animation.DROP,
        icon: __webpack_require__(273)
      });
      marker.setMap(self.map);
      self.studentMarker.setMap(self.map);
      self.studentMarker.addListener('dragend', self.changePosition);
      self.studentMarker.addListener('click', self.toggleBounce);
      var country = JSON.parse(localStorage.getItem('locale')).country;
      var autocomplete = new Maps.places.Autocomplete(document.getElementById('location'), { componentRestrictions: { country: country } });
      Maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();
        self.address.Lat = place.geometry.location.lat();
        self.address.Lng = place.geometry.location.lng();
        self.setPosition(true);
      });
    });
    self.getStudent();
  },

  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    changePosition: function changePosition(marker) {
      this.address.Lat = marker.latLng.lat();
      this.address.Lng = marker.latLng.lng();
      this.positionSet = false;
    },
    toggleBounce: function toggleBounce() {
      if (this.studentMarker.getAnimation() !== null) return this.studentMarker.setAnimation(null);
      this.studentMarker.setAnimation(this.maps.Animation.BOUNCE);
    },
    showScanModal: function showScanModal(student) {
      this.callScan = true;
      this.student = student;
    },
    valCoordinates: function valCoordinates(rule, value, callback) {
      var decRegexp = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/;
      if (!this.address.Lng || !this.address.Lat) {
        callback(new Error(this.$t('ISREQUIREDLATLNG')));
      } else if (!decRegexp.test(this.address.Lng) || !decRegexp.test(this.address.Lat)) {
        callback(new Error(this.$t('MUSTBEDECIMAL')));
      } else if (parseFloat(this.address.Lng) === this.school.Lng && parseFloat(this.address.Lat) === this.school.Lat) {
        callback(new Error(this.$t('SEEMSTOIDENTICAL')));
      }
      callback();
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.student.ImagePath = res.file_name;
    },
    findGuardian: function findGuardian(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken.source();
      return this.$http.get('/guardian/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&id=' + this.student.StudentID, { cancelToken: this.autoSource.token });
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (queryString === null) return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findGuardian(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getGrades: function getGrades() {
      var self = this;
      this.$http.get('/configuration/grade').then(function (response) {
        self.grades = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setGrade: function setGrade(item) {
      if (this.student.Grade === item) return;
      this.student.Grade = item.Name;
      this.student.Class = null;
    },
    base_convert: function base_convert(number, from, to) {
      if (number === null) return;
      if ((from && to) < 2 || (from && to) > 36) return this.$t('BASEBETWEEN');
      return parseInt(number + '', from).toString(to);
    },
    getStudent: function getStudent() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/student/' + this.$route.params.id + '').then(function (response) {
        var data = response.data;
        self.loading = false;
        self.address.Lat = self.school.Lat;
        self.address.Lng = self.school.Lng;
        if (data.student !== undefined && data.length !== 0) {
          self.student = data.student;
          self.student.DOB = self.dateFormat(self.student.DOB);
          self.Grade = self.student.Grade;
          self.dialogImageUrl = self.URL + 'upload/' + data.student.ImagePath;
          self.address = data.address;
          if (data.relatives !== undefined) {
            self.guardians = data.relatives;
            for (var guardian in self.guardians) {
              self.guardians[guardian].IsPrimary = false;
              if (self.guardians[guardian].IsMain === 1) self.guardians[guardian].IsPrimary = true;
            }
          }
        }
        self.setPosition();
      }).catch(function (response) {});
    },
    setPosition: function setPosition() {
      var autocomplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      this.$refs.addressForm.validateField('address', function (errorMessage) {
        if (errorMessage !== '') return;
        var position = new self.maps.LatLng(parseFloat(self.address.Lat), parseFloat(self.address.Lng));
        self.studentMarker.setPosition(position);
        self.map.panTo(self.studentMarker.getPosition());
        self.studentMarker.setMap(self.map);
        self.positionSet = true;
        if (!autocomplete && document.getElementById('location').value !== '') document.getElementById('location').value = '';
      });
    },
    checkPrimary: function checkPrimary(guardian) {
      if (guardian.IsPrimary) return;
      var guardians = this.guardians.slice();
      for (var i = 0; i < guardians.length; i++) {
        var IsMain = null;
        var IsPrimary = false;
        if (guardian.PersonID === guardians[i].PersonID) {
          IsMain = 1;
          IsPrimary = true;
        }
        guardians[i].IsPrimary = IsPrimary;
        guardians[i].IsMain = IsMain;
      }
      this.guardians = guardians;
    },
    addGuardian: function addGuardian(data) {
      var IsMain = 1;
      var error = false;
      if (this.guardians.length !== 0) {
        for (var guardian in this.guardians) {
          if (this.guardians[guardian].PersonID === data.person.PersonID) {
            error = true;
            this.message = this.$t('PERSONALREADYINTHELIST');
          }
          if (this.guardians[guardian].Relation !== 'GUARDIAN' && this.guardians[guardian].Relation === data.person.Relation) {
            error = true;
            this.message = this.$t('STUDENTCANNOTHAVEFATHERSORMOTHERS');
          }
          this.status = 'Warning';
        }
        if (error) {
          return this.$alert(this.message, this.$t('ERROR'), {
            confirmButtonText: this.$t('OK'),
            type: 'error'
          });
        }
        IsMain = null;
      }
      this.guardian = null;
      data.person.IsMain = this.student.StudentID === undefined ? 1 : IsMain;
      this.guardians.push(data.person);
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.student.ImagePath = res.file_name;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$t('AVATARPICTUREMUSTBEJPGFORMAT'));
      }
      if (!isLt2M) {
        this.$message.error(this.$t('AVATARPICTURESIZECANNOTEXCEED'));
      }
      return isJPG && isLt2M;
    },
    updateLocation: function updateLocation(marker) {
      this.address.Lat = marker.latLng.lat();
      this.address.Lng = marker.latLng.lng();
    },
    imageError: function imageError(res) {
      var string = res.split(' ');
      var message = this.$t(string[0], { size: string[1] });
      this.$alert(message, this.$t('ERROR'), { type: 'error', cancelButtonText: this.$t('CLOSE'), showCancelButton: true, showConfirmButton: false }).catch({});
    },
    getRoute: function getRoute() {
      var self = this;
      if (self.routes.length !== 0) return;
      self.loadingRoutes = true;
      this.$http.get('/route/assigned?StudentID=' + self.student.StudentID).then(function (response) {
        self.loadingRoutes = false;
        self.routes = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getActivity: function getActivity() {
      var self = this;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.activities).length !== 0) return;
      self.loadingActivities = true;
      this.$http.get('/student/activity?StudentID=' + self.student.StudentID).then(function (response) {
        self.loadingActivities = false;
        self.activities = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getActivities: function getActivities() {
      var self = this;
      if (self.activityList.length !== 0) return;
      this.$http.get('/configuration/activity').then(function (response) {
        self.activityList = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addActivity: function addActivity() {
      var self = this;
      self.savingActivity = true;
      this.$http.post('/student/save_activity', { StudentID: self.student.StudentID, ActivityID: self.Activity.ID }).then(function (response) {
        var data = { ActivityID: self.Activity.ID, StudentID: self.student.StudentID, Name: self.Activity.Name };
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(self.activities, self.Activity.ID, data);
        self.Activity = null;
        self.savingActivity = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteActivity: function deleteActivity(ActivityID) {
      var self = this;
      this.$http.post('/student/save_activity', { StudentID: self.student.StudentID, ActivityID: ActivityID, delete: true }).then(function (response) {
        self.$delete(self.activities, ActivityID);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTabData: function getTabData(tab) {
      switch (tab.name) {
        case 'route':
          this.getRoute();
          break;
        case 'activity':
          this.getActivity();
          this.getActivities();
          break;
      }
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_Import__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-doc-dialog': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc___default.a, 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Import___default.a },
  data: function data() {
    return {
      buses: [],
      bus: { Deleted: false, Documents: [] },
      currentRow: null,
      tableHeight: 0,
      filter: null,
      active_filter: 'model',
      loading: true,
      indexCheck: null,
      prevIndex: null,
      Model: '',
      Label: '',
      Plate: '',
      date_format: 'dd/MM/yyyy',
      dialogVisible: false,
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      import_data: {}
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53);
    this.getBuses();
  },

  computed: {
    listBuses: function listBuses() {
      var buses = this.buses;
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(buses)) return;
      if (this.active_filter === 'model') buses = this.filterBy(buses, this.Model, 'Model');
      if (this.active_filter === 'label') buses = this.filterBy(buses, this.Label, 'Label');
      if (this.active_filter === 'plate') buses = this.filterBy(buses, this.Plate, 'Plate');
      return buses;
    },
    options: function options() {
      var options = [{
        value: 'model',
        label: this.$t('MODEL')
      }, {
        value: 'label',
        label: this.$t('BUSNUMBER')
      }, {
        value: 'plate',
        label: this.$t('PLATENUMBER')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('BUSNUMBER'), field: 'Label', required: true, format: null }, { label: this.$t('MAKE'), field: 'Make', required: true, format: null }, { label: this.$t('MODEL'), field: 'Model', required: true, format: null }, { label: this.$t('YEAR'), field: 'Year', required: true, format: null }, { label: this.$t('SEATS'), field: 'MaxSeats', required: true, format: null }, { label: this.$t('PLATENUMBER'), field: 'Plate', required: true, format: null }, { label: this.$t('EXPIRATIONDATE'), field: 'RegistrationExpiration', required: true, format: 'date' }];
      return fields;
    }
  },
  methods: {
    getBuses: function getBuses() {
      var self = this;
      if (!self.loading) return;
      this.$http.get('/bus').then(function (response) {
        for (var bus in response.data) {
          response.data[bus].Documents = JSON.parse(response.data[bus].Documents);
          response.data[bus].Deleted = false;
        }
        self.buses = response.data;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    reCall: function reCall() {
      this.loading = true;
      this.getBuses();
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('^' + search, 'i');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.listBuses;
    },
    changeFilter: function changeFilter() {
      this.Model = this.Label = this.Plate = '';
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { BusID: self.buses[index].BusID, Status: self.buses[index].Status };
      this.$http.post('/bus/delete', postData).then(function (response) {
        self.buses[index].Deleted = false;
        self.buses[index].DeletedAT = self.buses[index].DeletedAT !== null ? null : '';
        self.buses[index].Status = self.buses[index].Status === '1' ? '0' : '1';
        if (self.buses[index].Status === '1') self.buses.push(self.buses.splice(index, 1)[0]);
        self.$message({
          message: response.data.error ? self.$t('BUSCANNOTBEENDELETED') : self.$t('BUSHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkRoute: function checkRoute(index) {
      var self = this;
      if (self.prevIndex !== null) self.buses[self.prevIndex].Deleted = false;
      if (self.indexCheck === self.buses[index].BusID) return;
      this.$http.get('/route/verify' + '&BusID=' + self.buses[index].BusID + '&TourID=' + null).then(function (response) {
        var result = response.data;
        var Deleted = true;
        if (result.error) {
          self.prevIndex = index;
          Deleted = false;
          self.indexCheck = self.buses[index].BusID;
          var message = self.$t('BUSCANNOTBEDEACTIVATED');
          return self.$message({
            message: message,
            type: 'warning',
            showClose: true,
            onClose: function onClose() {
              self.indexCheck = null;
            }
          });
        }
        self.buses[index].Deleted = Deleted;
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateHeight: function updateHeight(index) {},
    openSlider: function openSlider(bus) {
      if (typeof bus.Documents === 'string') bus.Documents = JSON.parse(bus.Documents);
      this.bus = bus;
      this.dialogVisible = true;
    },
    checkToView: function checkToView(doc) {
      if (typeof doc === 'string') doc = JSON.parse(doc);
      if (doc === null || doc.length === 0) return true;
      return false;
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    },
    clearInput: function clearInput() {
      this.Model = this.Label = this.Plate = '';
      this.listBuses;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-doc-dialog': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Doc___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default.a },
  data: function data() {
    return {
      bus: { BusID: null, Year: null, RegistrationExpiration: null, Documents: [], Expenses: {} },
      routes: [],
      loading: false,
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      date_format: 'dd/MM/yyyy',
      fileList: [],
      document: [],
      message: null,
      error: false,
      priceVal: false,
      loadingRoutes: false,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      yearDisable: {
        disabledDate: function disabledDate(time) {
          return time.getFullYear() - 1 >= new Date().getFullYear();
        }
      }
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getBus();
  },

  watch: {
    priceVal: function priceVal(newVal, oldVal) {
      if (!newVal) this.$nextTick(function () {
        this.$refs.expenseForm.validate();
      });
    }
  },
  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    getBus: function getBus() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      self.loading = true;
      this.$http.get('/bus/' + this.$route.params.id).then(function (response) {
        self.bus = response.data;
        self.bus.RegistrationExpiration = self.dateFormat(self.bus.RegistrationExpiration);
        self.bus.Expenses = JSON.parse(self.bus.Expenses);
        if (self.bus.Expenses.Price !== undefined && self.bus.Expenses.Price) self.priceVal = true;
        self.bus.Year = self.dateFormat(self.bus.Year);
        self.loading = false;
      }).catch(function (response) {});
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileUploaded: function fileUploaded(response, file, fileList) {
      this.bus.Documents.push({ label: '', file_name: response.file_name, deleted: false });
    },
    openSlider: function openSlider(bus) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.document, 0, bus);
      this.dialogVisible = true;
    },
    getRoute: function getRoute() {
      var self = this;
      if (self.routes.length !== 0) return;
      self.loadingRoutes = true;
      this.$http.get('/route/assigned?BusID=' + self.bus.BusID).then(function (response) {
        self.loadingRoutes = false;
        self.routes = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTabData: function getTabData(tab) {
      switch (tab.name) {
        case 'route':
          this.getRoute();
          break;
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text';
      var isLt2KB = file.size / 1024 < 400;
      this.message = {};
      if (!isJPG) {
        this.message['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt';
      }
      if (!isLt2KB) {
        this.message['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.message).length !== 0) this.error = true;
      return isJPG && isLt2KB;
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default.a },
  data: function data() {
    return {
      drivers: [],
      routes: [],
      driver: { Deleted: false },
      currentRow: null,
      tableHeight: 0,
      filter: null,
      active_filter: 'name',
      loading: true,
      indexCheck: null,
      prevIndex: null,
      FullName: '',
      PersonID: '',
      Nationality: '',
      LicenseImage: {},
      dialogVisible: false,
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      sending: null,
      import_data: {}
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53);
    this.getDrivers();
  },

  computed: {
    listDrivers: function listDrivers() {
      var drivers = this.drivers;
      if (this.active_filter === 'name') drivers = this.filterBy(drivers, this.FullName, ['FullName_EN', 'FullName_AR']);
      if (this.active_filter === 'id') drivers = this.filterBy(drivers, this.PersonID, 'ExternalPersonID');
      if (this.active_filter === 'nationality') drivers = this.filterBy(drivers, this.Nationality, 'Nationality');
      return drivers;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('DRIVERNAME')
      }, {
        value: 'id',
        label: this.$t('DRIVERID')
      }, {
        value: 'nationality',
        label: this.$t('NATIONALITY')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null }, { label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null }, { label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null }, { label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null }, { label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null }, { label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null }, { label: this.$t('GENDER'), field: 'Gender', required: true, format: null }, { label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null }, { label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null }, { label: this.$t('LICENSEEXPIRATION'), field: 'LicenseExpiration', required: true, format: 'date' }, { label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: true, format: 'date' }, { label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null }, { label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null }, { label: this.$t('EMAILADDRESS'), field: 'EMail', required: false, format: null }];
      return fields;
    }
  },
  methods: {
    getDrivers: function getDrivers() {
      var self = this;
      if (!self.loading) return;
      this.$http.get('/driver').then(function (response) {
        for (var driver in response.data) {
          response.data[driver].Deleted = false;
        }
        self.drivers = response.data;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendRegistration: function sendRegistration(driver) {
      var postData = {};
      var self = this;
      postData.driver = { FullName: driver.FullName_EN.replace(' ', ''), email: driver.EMail, BusDriverID: driver.BusDriverID };
      this.sending = driver.BusDriverID;
      this.$http.post('/registration', postData).then(function (response) {
        self.sending = null;
        self.$message({
          message: self.$t('REGISTRATIONHASBEENSENT'),
          type: 'success',
          showClose: true
        });
      }).catch(function () {});
    },
    reCall: function reCall() {
      this.loading = true;
      this.getDrivers();
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('(?:^|\\s)' + search, 'ig');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.listDrivers;
    },
    changeFilter: function changeFilter() {
      this.FullName = this.PersonID = this.Nationality = '';
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { PersonID: self.drivers[index].PersonID, Status: self.drivers[index].Status };
      this.$http.post('/driver/delete', postData).then(function (response) {
        self.drivers[index].Deleted = false;
        self.drivers[index].DeletedAT = self.drivers[index].DeletedAT !== null ? null : '';
        self.drivers[index].Status = self.drivers[index].Status === '1' ? '0' : '1';
        if (self.drivers[index].Status === '1') self.drivers.push(self.drivers.splice(index, 1)[0]);
        self.$message({
          message: response.data.error ? self.$t('DRIVERHASNOTBEENDELETED') : self.$t('DRIVERHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkRoute: function checkRoute(index) {
      var self = this;
      if (self.drivers[index].Status === '1') {
        self.drivers[index].Deleted = true;
        return;
      }
      if (self.prevIndex !== null) self.drivers[self.prevIndex].Deleted = false;
      if (self.indexCheck === self.drivers[index].BusDriverID) return;
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    },
    viewLicence: function viewLicence(image) {
      this.LicenseImage = image;
      this.dialogVisible = true;
    },
    clearInput: function clearInput() {
      this.FullName = this.PersonID = '';
      this.listDrivers;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_1_vue_perfect_scrollbar___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_3__components_dialogs_Save___default.a },
  data: function data() {
    return {
      person: { PersonID: null, IDExpiration: null, Gender: null, Nationality: null, ImagePath: null },
      driver: { LicenseExpiration: null, LicenseImage: null },
      contact: {},
      routes: [],
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      loading: false,
      message: null,
      error: false,
      loadingRoutes: false,
      date_format: 'dd/MM/yyyy',
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      alreadyExisted: { ID: false, Email: false }
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getDriver();
  },

  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    phoneValidation: function phoneValidation(rule, value, callback) {
      var regex = /^\+?[\d-]+$/;
      if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'));
      callback();
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.person.ImagePath = res.file_name;
    },
    getDriver: function getDriver() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/driver/' + this.$route.params.id).then(function (response) {
        self.person = response.data.person;
        self.person.IDExpiration = self.dateFormat(self.person.IDExpiration);
        self.driver = response.data.driver;
        self.driver.LicenseExpiration = self.dateFormat(self.driver.LicenseExpiration);
        self.contact = response.data.contact;
        self.loading = false;
      }).catch(function (response) {});
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.student.ImagePath = URL.createObjectURL(file.raw);
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type.split('/')[0] === 'image';
      var isLt2KB = file.size / 1024 < 400;
      this.message = {};
      if (!isJPG) {
        this.message['type'] = ' TYPEERROR png,gif,jpeg,jpg';
      }
      if (!isLt2KB) {
        this.message['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.message).length !== 0) this.error = true;
      return isJPG && isLt2KB;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      this.driver.LicenseImage = response.file_name;
    },
    uploadValidation: function uploadValidation() {
      this.$refs.LicenseForm.validateField('LicenseImage');
    },
    getRoute: function getRoute() {
      var self = this;
      if (self.routes.length !== 0) return;
      self.loadingRoutes = true;
      this.$http.get('/route/assigned?BusDriverID=' + self.driver.BusDriverID).then(function (response) {
        self.loadingRoutes = false;
        self.routes = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTabData: function getTabData(tab) {
      switch (tab.name) {
        case 'route':
          this.getRoute();
          break;
      }
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filter: null,
      active_filter: 'name',
      loading: true,
      routes: [],
      FullName: '',
      TourName: '',
      Label: '',
      currentRow: null,
      tableHeight: 0
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53);
    this.getRoutes();
  },

  computed: {
    listRoutes: function listRoutes() {
      var routes = this.routes;
      if (this.active_filter === 'monitorName') routes = this.filterBy(routes, this.FullName, ['supervisor.FullName_EN', 'supervisor.FullName_AR']);
      if (this.active_filter === 'driverName') routes = this.filterBy(routes, this.FullName, ['driver.FullName_EN', 'driver.FullName_AR']);
      if (this.active_filter === 'name') routes = this.filterBy(routes, this.TourName, 'TourName');
      if (this.active_filter === 'label') routes = this.filterBy(routes, this.Label, ['bus.Label']);
      return routes;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('ROUTENAME')
      }, {
        value: 'label',
        label: this.$t('BUSNAME')
      }, {
        value: 'driverName',
        label: this.$t('DRIVERNAME')
      }, {
        value: 'monitorName',
        label: this.$t('SUPERVISORNAME')
      }];
      return options;
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    getRoutes: function getRoutes() {
      var self = this;
      if (!self.loading) return;
      this.$http.get('/route').then(function (response) {
        self.routes = response.data;
        self.loading = false;
      }).catch(function (res) {
        if (res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('(?:^|\\s)' + search, 'ig');
          var dele1 = delimiter[0].split('.');
          if (el[dele1[0]] && regx.test(el[dele1[0]][dele1[1]])) res.push(el);
          if (delimiter[1]) {
            var dele2 = delimiter[1].split('.');
            if (el[dele2[0]] && regx.test(el[dele2[0]][dele2[1]])) res.push(el);
          }
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.listDrivers;
    },
    changeFilter: function changeFilter() {
      this.FullName = this.PersonID = this.Nationality = '';
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var clusterMaker = __webpack_require__(400);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default.a },
  data: function data() {
    return {
      MAXIMUM_WAYPOINT_LIMIT: 8,
      DEG_TO_RAD: 0.017453292519943295769236907684886,
      EARTH_RADIUS_IN_METERS: 6372797.560856,
      EARTH_RADIUS_IN_MILES: 3959,
      METERS_TO_MILES: 0.000621371192,
      infoIndex: null,
      infoOptions: { pixelOffset: { width: 0, height: -35 } },
      route: {
        TourID: null,
        bus: {},
        driver: {},
        monitor: {},
        Deleted: false
      },
      schedule: {
        TourID: null,
        Direction: null,
        ServiceDays: [],
        StartDate: null,
        EndDate: null,
        Time_AM_In: null,
        Time_AM_Out: null,
        Time_PM_In: null,
        Time_PM_Out: null,
        DelayedThreshold: '00:05'
      },
      direction: {
        TourID: null,
        TermID: null,
        RouteColor: '#4b4b4b',
        Snapshot: null,
        DraftAuthor: null,
        Updated: null,
        Polyline: [],
        IsManual: 1
      },
      bus: {},
      driver: {},
      monitor: {},
      term: {},
      students: {},
      coordinates: {},
      school: {},
      center: {},
      deleted_students: {},
      stops: [],
      student_search: [],
      terms: [],
      checkedDays: [],
      selectedStudents: [],
      days: [],
      buses: [],
      drivers: [],
      supervisors: [],
      markers: [],
      pin_location: null,
      animate_stop: null,
      autoSource: null,
      DraftAuthor: null,
      clonedName: null,
      student: null,
      studentSearch: null,
      selected_stop: null,
      Location: null,
      timeout: null,
      select_search: null,
      selectedBus: null,
      selectedDriver: null,
      selectedSupervisor: null,
      mapDuration: null,
      directionsService: null,
      directionsDisplay: null,
      polyline: null,
      message: null,
      maps: null,
      map: null,
      list: null,
      country: 'AE',
      date_format: 'dd/MM/yyyy',
      CSVFile: '',
      activeIndex: '',
      handleSelect: '',
      dialogImageUrl: '',
      loading: false,
      dialogVisible: false,
      checkAll: false,
      isIndeterminate: false,
      showBuses: false,
      showDrivers: false,
      showSupervisors: false,
      loadingBuses: true,
      loadingDrivers: true,
      loadingSupervisors: true,
      selectedMonitor: false,
      tickedDriver: false,
      pinMap: false,
      error: false,
      saving: false,
      item_checked: false,
      driver_checked: false,
      bus_checked: false,
      sending: false,
      assigning: {},
      cloning: false,
      loaded: false,
      dialogImport: false,
      import_data: {},
      progress_import: false,
      routing: false,
      is_ready: true,
      polylineIndex: 0,
      timer: 0,
      ServiceDate: 1,
      stepsHeight: 0,
      pickup: 0,
      dropoff: 0,
      departure: 0,
      cardHeight: 0,
      tabHeight: 0,
      current_stop: 0,
      direction_order: 0,
      active_direction: 0,
      drafted_stops: 0,
      deleted_stops: 0,
      filteredData: [],
      typed: '',
      ellipsis: false,
      dragged_list: {},
      moving_stop: null,
      is_manual: false,
      clusters_distance: {},
      cluster_index: 0,
      stops_order: []
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.DraftAuthor = userData.user_id;
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.school = this.center = { lat: userData.school_location.Lat, lng: userData.school_location.Lng };
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.tabHeight = this.cardHeight - 78;
    this.stepsHeight = this.tabHeight - 60;
    var self = this;
    this.$google.then(function (Maps) {
      var position = new Maps.LatLng(self.center);
      self.maps = Maps;
      self.map = new Maps.Map(document.getElementById('gmap-route'), {
        center: position,
        zoom: 14
      });
      self.markers[0] = self.addMarker(position, 0, null);
      self.markers[0].setMap(self.map);
      self.initMap();
      self.stops[0] = {
        originLat: self.center.lat,
        originLng: self.center.lng,
        Lat: self.center.lat,
        Lng: self.center.lng,
        DeltaT: 0,
        Distance: 0,
        Duration: 0,
        mapDuration: 0,
        WaitingTime: 0,
        inputs: false,
        deleted: false,
        draft: true,
        polyline: null,
        stop_id: 0,
        students: []
      };
      var key = self.center.lat + ',' + self.center.lng;
      self.coordinates[key] = 0;
      self.getRoute();
    });
    this.getAcademicTerms();
  },

  computed: {
    stopTab: function stopTab() {
      var disabledAM = true;
      var disabledPM = true;
      if (this.schedule.Time_AM_In !== undefined && this.schedule.Time_AM_Out !== undefined) disabledAM = false;
      if (this.schedule.Time_PM_In !== undefined && this.schedule.Time_PM_Out !== undefined) disabledPM = false;
      if (this.schedule.Direction === 3 && !disabledAM && !disabledPM) return false;
      if (this.schedule.Direction === 1 && !disabledAM || this.schedule.Direction === 2 && !disabledPM) return false;
      return true;
    },
    registrationTab: function registrationTab() {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.stops).length < 2 || this.monitor.BusMonitorID === undefined || this.driver.BusDriverID === undefined) return true;
      return false;
    },
    submitIcon: function submitIcon() {
      if (this.loading) return;
      if (this.route.TourID === null && this.stops.length <= 1 || this.route_ready(true)) return 'fa-check';
      return 'fa-road';
    },
    submissionText: function submissionText() {
      var text = 'GENERATEROUTE';
      if (this.routing) text = 'INPROGRESS';
      if (this.route.TourID === null && this.stops.length <= 1 || this.stops.length === 1) text = 'SAVE';
      if (this.direction.Polyline !== null && this.route_ready(true) && !this.routing) text = 'SAVE';
      if (this.direction.Polyline !== null && this.saving) text = 'SAVING';
      return this.$t(text);
    },
    tooltipText: function tooltipText(num) {
      if (this.departure === 1) return this.$t('SWITCHTOPICK-UP') + ' ' + (this.pickup !== 1 ? this.$t('FARTHEST') : this.$t('CLOSEST'));
      if (this.departure === 0) return this.$t('SWITCHTODROP-OFF') + ' ' + (this.dropoff !== 1 ? this.$t('FARTHEST') : this.$t('CLOSEST'));
    },
    loadingMessage: function loadingMessage() {
      if (this.routing) return this.$t('INPROGRESS');
      if (!this.loaded || this.progress_import) return this.$t('LOADING');
    },
    listStops: function listStops() {
      return this.stops;
    },
    daysC: function daysC() {
      return this.days = [this.$t('MONDAY'), this.$t('TUESDAY'), this.$t('WEDNESDAY'), this.$t('THURSDAY'), this.$t('FRIDAY'), this.$t('SATURDAY'), this.$t('SUNDAY')];
    },
    directions: function directions() {
      var directions = [{
        value: 1,
        label: this.$t('HOMETOSCHOOL')
      }, {
        value: 2,
        label: this.$t('SCHOOLTOHOME')
      }, {
        value: 3,
        label: this.$t('BOTH(ROUNDTRIP)')
      }];
      return directions;
    },
    fields: function fields() {
      return [{ label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null }, { label: this.$t('GPSLATITUDE'), field: 'lat', required: true, format: null }, { label: this.$t('GPSLONGITUDE'), field: 'lng', required: true, format: null }];
    },
    selectedModal: function selectedModal() {
      var selected = {};
      if (this.showBuses) selected = { data: this.buses, filter: 'Label', placeholder: this.$t('BUSNUMBER') };else if (this.showDrivers) selected = { data: this.drivers, filter: ['FullName_EN', 'FullName_AR'], placeholder: this.$t('NAME') };else if (this.showSupervisors) selected = { data: this.supervisors, filter: ['FullName_EN', 'FullName_AR'], placeholder: this.$t('NAME') };
      return selected;
    },
    noDragging: function noDragging() {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.dragged_list).length === 0) return true;
      return false;
    }
  },
  methods: {
    toggleMoving: function toggleMoving() {},
    movingStop: function movingStop(stop) {
      if (this.moving_stop === stop) return this.moving_stop = null;
      this.moving_stop = stop;
    },
    moveStop: function moveStop(destination) {
      var key = 0;
      if (destination < this.moving_stop) key = 1;
      var _stop = this.stops[this.moving_stop];
      this.$delete(this.stops, this.moving_stop);
      this.stops.splice(destination + key, 0, _stop);
      for (var stop in this.stops) {
        var students = this.stops[stop].students;
        for (var student in students) {
          var StudentID = students[student].StudentID;
          this.students[StudentID] = stop;
        }
      }
      this.drawMarkers(this.stops);
      this.route_ready(true);
      this.dragged_list = {};
      this.moving_stop = null;
    },
    isDragged: function isDragged(student, option) {
      var stop = this.students[student.StudentID];
      if (this.dragged_list[stop] === undefined) {
        var _stop = {};
        _stop[stop] = {};
        if (option === undefined) this.dragged_list = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.dragged_list, _stop);
        return false;
      }
      if (this.dragged_list[stop][student.StudentID] !== undefined) return true;
      return false;
    },
    dragStudent: function dragStudent(student) {
      var isDragged = this.isDragged(student, true);
      if (this.stops.length - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.dragged_list).length === 2 && !isDragged) return;
      var stop = this.students[student.StudentID];
      var _item = {};
      _item[student.StudentID] = student;
      if (!this.isDragged(student)) return this.dragged_list[stop] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.dragged_list[stop], _item);
      this.$delete(this.dragged_list[stop], student.StudentID);
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.dragged_list[stop]).length === 0) this.$delete(this.dragged_list, stop);
    },
    dropList: function dropList(stop) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.dragged_list).length === 0) return;
      for (var item in this.dragged_list) {
        var students = this.dragged_list[item];
        for (var student in students) {
          this.stops[stop].students.push(students[student]);
          this.removeStudent(student);
          this.students[student] = stop;
        }
        this.$delete(this.dragged_list, item);
      }
    },
    removeStudent: function removeStudent(StudentID) {
      var stop = this.students[StudentID];
      this.$delete(this.dragged_list[stop], StudentID);
      var students = this.stops[stop].students;
      for (var student in students) {
        if (students[student].StudentID === StudentID) return this.$delete(this.stops[stop].students, student);
      }
    },
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    headerFilter: function headerFilter(h, obj) {
      var _this = this;

      return h('el-input', { props: { value: this.typed }, attrs: { class: 'header-search', placeholder: this.selectedModal.placeholder }, on: { change: function change(val) {
            _this.filteredData = !val ? _this.selectedModal.data : _this.filterBy(_this.selectedModal.data, val, _this.selectedModal.filter);
          } } });
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('(?:^|\\s)' + search, 'ig');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    currentStops: function currentStops() {
      var stops = null;
      if (this.departure === 1) stops = this.pickup === 1 ? this.farthest_stops : this.closest_stops;
      if (this.departure === 0) stops = this.dropoff === 1 ? this.farthest_stops : this.closest_stops;
      return stops;
    },
    hideStep: function hideStep(key) {
      if (this.direction_order === 0 && key !== 0) return true;
      if (this.direction_order === 1 && key !== this.stops.length - 1) return true;
      return false;
    },
    buttonText: function buttonText() {
      if (this.departure === 1) return this.$t('PICK-UP') + ' ' + (this.pickup !== 0 ? this.$t('FARTHEST') : this.$t('CLOSEST'));
      if (this.departure === 0) return this.$t('DROP-OFF') + ' ' + (this.dropoff !== 0 ? this.$t('FARTHEST') : this.$t('CLOSEST'));
    },
    tabStudent: function tabStudent(student) {
      var key = this.selectedStudents.indexOf(student);
      if (key < 0) return this.selectedStudents.push(student);
      delete this.selectedStudents[key];
    },
    handleCheckAllChange: function handleCheckAllChange(event) {
      var days = [];
      for (var day in this.days) {
        days.push(day);
      }
      this.schedule.ServiceDays = event.target.checked ? days : [];
      this.isIndeterminate = false;
    },
    handleCheckedDaysChange: function handleCheckedDaysChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.days.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.days.length;
    },
    setPlace: function setPlace(place) {
      this.stops[this.current_stop].lat = place.geometry.location.lat();
      this.stops[this.current_stop].lng = place.geometry.location.lng();
      this.$refs.mapCard.panTo({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
      this.updateDirection();
    },
    findStudent: function findStudent(queryString) {
      this.autoSource = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.CancelToken.source();
      return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=route', { cancelToken: this.autoSource.token });
    },
    querySearch: function querySearch(queryString, cb) {
      var self = this;
      if (queryString === null || queryString === '') return;
      if (self.autoSource) self.autoSource.cancel();
      var result = self.findStudent(queryString);
      result.then(function (response) {
        self.autoSource = null;
        cb(!response.data ? [] : response.data);
      }).catch(function () {});
    },
    addStudent: function addStudent(data) {
      var _this2 = this;

      this.student = data;
      this.studentSearch = null;
      var self = this;
      if (data.student.Lat === this.school.lat && data.student.Lng === this.school.lng) {
        return self.$alert(this.$t('STOPMESSAGE5', { name: data.value }), this.$t('ADD') + ' ' + this.$t('STUDENT'), { showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close' }).then(function (res) {}, function (reason) {
          _this2.$nextTick(function () {
            return _this2.$refs.search.$el.children[0].lastElementChild.focus();
          });
        });
      }
      if (data.student.Status !== null || data.student.IsMain === null) {
        return self.$alert(this.$t('STOPMESSAGE1', { name: data.value }), this.$t('ADD') + ' ' + this.$t('STUDENT'), { showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close' }).then(function (res) {}, function (reason) {
          _this2.$nextTick(function () {
            return _this2.$refs.search.$el.children[0].lastElementChild.focus();
          });
        });
      }
      if (this.checkStop()) return;
      this.checkRoute(data.student.StudentID).then(function (response) {
        var result = response.data;
        if (result.TourID === undefined) return self.assignStop();
        self.$alert(self.$t('STUDENT') + ' ' + self.$t('STOPMESSAGE2', { name: data.value, route: result.TourName }), self.$t('ADD') + ' ' + self.$t('STUDENT'), { showCancelButton: true, cancelButtonText: 'Close', showConfirmButton: false }).then(function (res) {}, function (reason) {
          self.$nextTick(function () {
            return self.$refs.search.$el.children[0].lastElementChild.focus();
          });
        });
      }).catch(function () {});
    },
    assignProcess: function assignProcess(id, name, type) {
      this.$set(this.assigning, id, true);
      var self = this;
      this.checkRoute(id, type).then(function (response) {
        self.$set(self.assigning, id, false);
        var result = response.data;
        if (result.TourID === undefined) {
          switch (type) {
            case 'Bus':
              self.selectedBus = id;
              break;
            case 'Supervisor':
              self.selectedSupervisor = id;
              break;
            case 'Driver':
              self.selectedDriver = id;
              break;
          }
        } else self.$alert(self.$t(type.toUpperCase()) + ' ' + self.$t('STOPMESSAGE2', { name: name, route: result.TourName }), self.$t('ADD') + ' ' + self.$t(type.toUpperCase()), { showCancelButton: true, cancelButtonText: 'Close', showConfirmButton: false }).then(function (res) {}, function (reason) {
          self.$nextTick(function () {
            return self.$refs.search.$el.children[0].lastElementChild.focus();
          });
        });
      }).catch(function () {});
    },
    checkRoute: function checkRoute(id) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Student';

      var self = this;
      var params = {
        TourID: self.route.TourID,
        ID: id,
        Type: type,
        ServiceDays: this.schedule.ServiceDays,
        StartDate: this.$moment(this.schedule.StartDate).format('YYYY-MM-DD'),
        EndDate: this.$moment(this.schedule.EndDate).format('YYYY-MM-DD')
      };
      if (this.schedule.Time_AM_In && (this.schedule.Direction === 1 || this.schedule.Direction === 3)) {
        params.Time_AM_In = this.schedule.Time_AM_In;
        params.Time_AM_Out = this.schedule.Time_AM_Out;
      }
      if (this.schedule.Time_PM_In && (this.schedule.Direction === 2 || this.schedule.Direction === 3)) {
        params.Time_PM_In = this.schedule.Time_PM_In;
        params.Time_PM_Out = this.schedule.Time_PM_Out;
      }
      return this.$http.get('/route/check', { params: params });
    },
    checkStop: function checkStop() {
      var _this3 = this;

      var student = this.student.student;
      if (this.students[student.StudentID] !== undefined) {
        this.$alert(this.$t('STOPMESSAGE3', { name: this.student.value, stop: this.students[student.StudentID] }), this.$t('ADD') + ' ' + this.$t('STUDENT'), { showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close' }).then(function (res) {}, function (reason) {
          _this3.$nextTick(function () {
            return _this3.$refs.search.$el.children[0].lastElementChild.focus();
          });
        });
        return true;
      }
      for (var stop in this.stops) {
        var students = this.stops[stop].students;
        for (var item in students) {
          if (students[item].Lat === student.Lat && students[item].Lng === student.Lng) {
            student.draft = true;
            this.students[student.StudentID] = stop;
            this.stops[stop].students.push(student);
            this.$nextTick(function () {
              return _this3.$refs.search.$el.children[0].lastElementChild.focus();
            });
            this.$message({ message: this.$t('STOPMESSAGE4', { name: this.student.value, stop: stop }), type: 'success' });
            return true;
          }
        }
      }
      return false;
    },
    assignStop: function assignStop() {
      var _this4 = this;

      var student = this.student.student;
      student.draft = true;
      student.deleted = false;
      var stop = this.stops.length;
      this.students[student.StudentID] = stop;
      var extra = {
        DeltaT: 0,
        Distance: 0,
        Duration: 0,
        Lat: parseFloat(student.Lat),
        Lng: parseFloat(student.Lng),
        WaitingTime: 0,
        deleted: false,
        draft: true,
        inputs: false,
        mapDuration: 0,
        originLat: parseFloat(student.Lat),
        originLng: parseFloat(student.Lng),
        polyline: null,
        stop_id: stop,
        students: [student]
      };
      var key = student.Lat + ',' + student.Lng;
      this.coordinates[key] = stop;
      this.is_ready = false;
      this.stops.push(extra);
      this.drafted_stops++;
      var position = new this.maps.LatLng(extra.Lat, extra.Lng);
      this.markers[stop] = this.addMarker(position, stop, this.direction.RouteColor);
      this.markers[stop].setMap(this.map);
      this.pinStudentLocation(student);
      this.scrollDown();
      this.$nextTick(function () {
        return _this4.$refs.search.$el.children[0].lastElementChild.focus();
      });
    },
    insertStop: function insertStop(current) {
      var newStop = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.stops[current]);
      newStop.student = [];
      this.stops.splice(current, 0, newStop);
      for (var stop in this.stops) {
        this.stops[stop].Stop = stop;
        this.stops[stop] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.stops[stop]);
      }
    },
    getBuses: function getBuses() {
      this.filteredData = [];
      this.showBuses = true;
      this.$refs.OVForm.validateField('BusID');
      var self = this;
      if (self.buses.length !== 0) return self.filteredData = self.buses;
      this.$http.get('/bus').then(function (response) {
        self.buses = self.filteredData = response.data;
        self.loadingBuses = false;
      }).catch(function (response) {});
    },
    getDrivers: function getDrivers() {
      this.filteredData = [];
      this.showDrivers = true;
      this.$refs.OVForm.validateField('BusDriverID');
      var self = this;
      if (self.drivers.length !== 0) return self.filteredData = self.drivers;
      this.$http.get('/driver').then(function (response) {
        self.drivers = self.filteredData = response.data;
        self.loadingDrivers = false;
      }).catch(function (response) {});
    },
    getSupervisors: function getSupervisors() {
      this.filteredData = [];
      this.showSupervisors = true;
      this.$refs.OVForm.validateField('BusMonitorID');
      var self = this;
      if (self.supervisors.length !== 0) return self.filteredData = self.supervisors;
      this.$http.get('/supervisor').then(function (response) {
        self.supervisors = self.filteredData = response.data;
        self.loadingSupervisors = false;
      }).catch(function (response) {});
    },
    isEllipsisActive: function isEllipsisActive(e) {
      this.ellipsis = e.target.clientWidth < e.target.scrollWidth;
    },
    updateDirection: function updateDirection() {
      var self = this;
      var postData = { stops: this.stops };
      this.$http.post('/route/path', postData).then(function (response) {
        self.route.path = response.data;
      }).catch(function (response) {});
    },
    reAssignStops: function reAssignStops() {
      var studentsStops = {};
      var stops = [];
      var _stops = [];
      for (var stop in this.stops) {
        stop = parseInt(stop);
        var students = this.stops[stop].students;
        if (!this.stops[stop].deleted) {
          stops[stop] = {};
          stops[stop].WaitingTime = students.length;
          stops[stop].TourID = parseInt(this.route.TourID);
          stops[stop].Direction = 1;
          stops[stop].DeltaT = Math.floor(this.stops[stop].Duration / 60);
          stops[stop].Distance = this.stops[stop].Distance;
          stops[stop].Lat = this.stops[stop].Lat;
          stops[stop].Lng = this.stops[stop].Lng;
          stops[stop].Stop = stop;
          _stops[stop] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, stops[stop]);
          _stops[stop].Direction = 2;
          for (var student in students) {
            var studentID = students[student].StudentID;
            if (!students[student].deleted) {
              if (studentsStops[studentID] === undefined) studentsStops[studentID] = {};
              studentsStops[studentID].StudentID = studentID;
              studentsStops[studentID].ToSchool = stops[stop].Stop;
              studentsStops[studentID].ToHome = stops[stop].Stop;
              studentsStops[studentID].TourID = students[student].TourID === undefined ? stops[stop].TourID : students[student].TourID;
              studentsStops[studentID].BusID = this.route.BusID;
            }
          }
        }
      }
      if (this.polyline === null) return [[], {}];
      return [[].concat.apply(stops, _stops), studentsStops];
    },
    save: function save() {
      if (!this.route_ready(true)) return this.getDirection(this.partition());
      this.saveRoute();
    },
    saveRoute: function saveRoute() {
      var data = this.reAssignStops();
      this.schedule.StartDate = this.$moment(this.schedule.StartDate).format('YYYY-MM-DD');
      this.schedule.EndDate = this.$moment(this.schedule.EndDate).format('YYYY-MM-DD');
      if (this.stops.length === 1) this.direction['Polyline'] = null;
      var postData = {
        route: this.route,
        direction: this.direction,
        stops: data[0],
        students: data[1],
        schedule: this.schedule
      };
      var self = this;
      this.saving = true;
      this.$http.post('/route/save', postData).then(function (response) {
        self.saving = false;
        var data = response.data;
        self.message = data.message;
        self.error = data.error;
        if (!self.error) {
          self.$router.push({ path: '/transportation/route' });
          self.$message({ message: self.$t(self.message), type: 'success', showClose: true });
          return;
        }
        self.$refs.OVForm.validate(function (valid) {});
        self.$refs.routeForm.validate(function (valid) {});
        self.$refs.infoForm.validate(function (valid) {});
      }).catch(function () {});
    },
    sendRegistration: function sendRegistration() {
      var postData = {};
      var self = this;
      if (this.selectedMonitor) {
        postData.supervisor = { FullName: this.monitor.FullName_EN.replace(' ', ''), email: this.monitor.EMail, BusMonitorID: this.monitor.BusMonitorID };
      }
      if (this.tickedDriver) {
        postData.driver = { FullName: this.driver.FullName_EN.replace(' ', ''), email: this.driver.EMail, BusDriverID: this.driver.BusDriverID };
      }
      if (this.selectedStudents.length !== 0) {
        postData.students = this.selectedStudents;
      }
      this.sending = true;
      this.$http.post('/registration', postData).then(function (response) {
        self.sending = false;
        if (!response.data.error) {
          self.$message({ message: response.data.message, type: 'success' });
          return;
        }
      }).catch(function () {});
    },
    toRad: function toRad(Value) {
      return Value * Math.PI / 180;
    },
    clearEverything: function clearEverything() {
      this.message = null;
      this.selectedBus = null;
      this.selectedDriver = null;
      this.selectedSupervisor = null;
      this.error = false;
      this.item_checked = false;
    },
    verifyItem: function verifyItem() {
      var self = this;
      var postData = 'BusDriverID=' + self.selectedDriver;
      if (self.selectedSupervisor !== null) postData = 'BusMonitorID=' + self.selectedSupervisor;
      if (self.selectedBus !== null) postData = 'BusID=' + self.selectedBus;
      this.$http.get('/route/verify?' + postData + '&TourID=' + self.route.TourID).then(function (response) {
        self.message = response.data.message;
        self.item_checked = response.data.error;
      }).catch(function (response) {});
    },
    setBus: function setBus() {
      this.route.BusID = this.selectedBus;
      this.$refs.OVForm.validateField('BusID');
      this.showBuses = false;
      for (var bus in this.buses) {
        if (this.buses[bus].BusID === this.selectedBus) {
          this.bus = this.buses[bus];
          break;
        }
      }
      this.clearEverything();
    },
    setDriver: function setDriver() {
      this.route.BusDriverID = this.selectedDriver;
      this.$refs.OVForm.validateField('BusDriverID');
      this.showDrivers = false;
      for (var driver in this.drivers) {
        if (this.drivers[driver].BusDriverID === this.selectedDriver) {
          this.driver = this.drivers[driver];
          break;
        }
      }
      this.clearEverything();
    },
    setSupervisor: function setSupervisor() {
      this.route.BusMonitorID = this.selectedSupervisor;
      this.$refs.OVForm.validateField('BusMonitorID');
      this.showSupervisors = false;
      for (var supervisor in this.supervisors) {
        if (this.supervisors[supervisor].BusMonitorID === this.selectedSupervisor) {
          this.monitor = this.supervisors[supervisor];
          break;
        }
      }
      this.clearEverything();
    },
    getAcademicTerms: function getAcademicTerms() {
      var self = this;
      this.$http.get('/configuration/academic_term').then(function (response) {
        self.terms = response.data;
      }).catch(function (res) {});
    },
    setTerm: function setTerm(TermID) {
      var term = null;
      for (var item in this.terms) {
        if (this.terms[item].YearID === TermID) {
          term = this.terms[item];
          break;
        }
      }
      this.direction.TermID = term.YearID;
      this.schedule.StartDate = new Date(term.terms[0].StartDate);
      this.schedule.EndDate = new Date(term.terms[term.terms.length - 1].EndDate);
    },
    draftRoute: function draftRoute() {
      // let self = this
      // if (this.direction.DraftAuthor !== null) return
      // this.$http.put('/route/draft', {TourID: this.route.TourID, TourName: this.route.TourName, DraftAuthor: this.DraftAuthor}).then(function (response) {
      //   if (response.data.TourID === undefined) return
      //   self.route.TourID = response.data.TourID
      //   self.direction.TourID = response.data.TourID
      //   self.schedule.TourID = response.data.TourID
      //   self.direction.DraftAuthor = response.data.DraftAuthor
      // }).catch(function (response) {})
    },
    getRoute: function getRoute() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/route/' + this.$route.params.id + '').then(function (response) {
        self.route = response.data.route;
        if (response.data.bus) self.bus = response.data.bus;
        if (response.data.driver) self.driver = response.data.driver;
        if (response.data.monitor) self.monitor = response.data.monitor;
        if (response.data.direction) self.direction = response.data.direction;
        self.direction.IsManual = parseInt(self.direction.IsManual);
        self.is_manual = !!self.direction.IsManual;
        if (self.direction.TermID !== null) self.ServiceDate = 0;
        self.routeSchedule(response.data.schedule);
        if (response.data.direction.Polyline !== null) self.drawPolyline([response.data.direction.Polyline[0]]);
        self.getStops();
      }).catch(function (response) {});
    },
    getStops: function getStops() {
      var self = this;
      var params = { TourID: self.route.TourID, Updated: self.direction.Updated, DraftAuthor: self.direction.DraftAuthor, Snapshot: self.direction.Snapshot };
      this.$http.get('/route/stops', { params: params }).then(function (response) {
        self.loading = false;
        if (response.data.stops === undefined) return;
        self.direction.Snapshot = response.data.version;
        self.drawMarkers(response.data.stops);
      }).catch(function (response) {});
    },
    drawMarkers: function drawMarkers(stops) {
      if (stops.length === 0) return;
      this.stops = stops;
      this.stops_order = [];
      this.students = {};
      for (var stop in stops) {
        stop = parseInt(stop);
        if (stops[stop].students[0] === undefined) stops[stop].students = [];
        var key = stops[stop].originLat + ',' + stops[stop].originLng;
        this.coordinates[key] = stop;
        if (this.markers[stop] !== undefined) this.markers[stop].setMap(null);
        var position = new this.maps.LatLng(stops[stop].Lat, stops[stop].Lng);
        this.markers[stop] = this.addMarker(position, stop, this.direction.RouteColor);
        this.markers[stop].setMap(this.map);
        if (stop > 0) {
          this.stops_order.push(stops[stop].stop_id);
          this.studentStop(stop);
        }
      }
      for (var i = this.stops.length; i < this.markers.length; i++) {
        if (this.markers[i] !== undefined) this.markers[i].setMap(null);
      }
    },
    studentStop: function studentStop(stop) {
      var students = this.stops[stop].students;
      for (var student in students) {
        var StudentID = students[student].StudentID;
        if (this.students[StudentID] === undefined) this.students[StudentID] = stop;
      }
    },
    drawPolyline: function drawPolyline(directions) {
      if (directions.length === 0) return this.is_ready = false;
      var path = [];
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      for (var polyline in directions) {
        path = path.concat(new this.maps.geometry.encoding.decodePath(directions[polyline]));
      }
      if (this.polyline !== null) this.polyline.setMap(null);
      this.polyline = new this.maps.Polyline({
        path: path,
        strokeColor: this.direction.RouteColor,
        strokeOpacity: 1.0,
        strokeWeight: 5
      });
      this.polyline.setMap(this.map);
      var paths = this.maps.geometry.encoding.encodePath(path);
      this.direction.Polyline = [paths, paths];
      this.is_ready = true;
      this.routing = false;
    },
    routeSchedule: function routeSchedule(schedule) {
      if (!schedule) return this.schedule.TourID = this.route.TourID;
      this.schedule = schedule;
      this.schedule.Direction = parseInt(this.schedule.Direction);
      this.schedule.StartDate = new Date(this.schedule.StartDate);
      this.schedule.EndDate = new Date(this.schedule.EndDate);
    },
    partition: function partition() {
      var p = 1;
      var stops = [];
      var deletedStops = [];
      var coordinates = {};
      this.deleted_stops = 0;
      this.deleted_students = {};
      var s = 0;
      for (var stop in this.stops) {
        stop = parseInt(stop);
        if (!this.stops[stop].deleted) {
          var key = this.stops[stop].originLat + ',' + this.stops[stop].originLng;
          this.stops[stop].stop_id = coordinates[key] = s++;
          stops.push(this.stops[stop]);
        } else {
          deletedStops.push(stop);
        }
      }
      for (var _s in deletedStops) {
        this.removeStop(deletedStops[_s]);
      }
      this.coordinates = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, coordinates);
      this.stops = stops;
      stops = this.clusterPoints();
      var points = stops.length;
      if (points > 23 && points <= 46) p = 2;
      if (points > 46) p = 3;
      var results = [];
      var chunks = Math.floor(points / p);
      var starting = 0;
      var ending = 0;
      if (p === 1) return [stops];
      for (var i = 0; i < p; i++) {
        ending += chunks + i;
        results.push(stops.slice(starting, ending));
        starting += results[i].length;
      }
      return results;
    },
    getDirection: function getDirection(stops) {
      var directions = [];
      var self = this;
      self.routing = true;
      for (var s in stops) {
        var points = stops[s];
        if (s > 0) points.unshift(stops[s - 1].slice(-1)[0]);
        var k = points.length - 1;
        var origin = new self.maps.LatLng({ lat: points[0].Lat, lng: points[0].Lng });
        var destination = new self.maps.LatLng({ lat: points[k].Lat, lng: points[k].Lng });
        points = points.slice(1, k);
        var wayPoints = [];
        for (var point in points) {
          wayPoints.push({
            location: new self.maps.LatLng({ lat: points[point].Lat, lng: points[point].Lng }),
            stopover: true
          });
        }
        directions.push(self.setDirection(origin, destination, wayPoints));
      }
      // let duration = 0
      // let distance = 0
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(directions).then(function (routes) {
        var route = 0;
        var directions = [];
        var i = 1;
        // let colors = ['#001f3f', '#FF4136', '#FF851B']
        var _stops = [self.stops[0]];
        for (route in routes) {
          route = parseInt(route);
          directions.push(routes[route].overview_polyline);
          var legs = routes[route].legs;
          var orders = routes[route].waypoint_order;
          orders.push(orders.length);
          var order = 0;
          for (var leg in legs) {
            if (orders[leg] !== undefined) order = orders[leg] + 1;
            var students = stops[route][order].students;
            leg = parseInt(leg);
            var stop = {
              DeltaT: legs[leg].duration.value / 60,
              Distance: legs[leg].distance.value,
              Duration: legs[leg].duration.value,
              Lat: legs[leg].end_location.lat(),
              Lng: legs[leg].end_location.lng(),
              WaitingTime: students.length / 2,
              deleted: false,
              draft: false,
              inputs: false,
              mapDuration: 0,
              originLat: stops[route][order].Lat,
              originLng: stops[route][order].Lng,
              polyline: null,
              stop_id: i++,
              students: students
            };
            _stops.push(stop);
            // distance += legs[leg].distance.value
            // duration += legs[leg].duration.value
          }
        }
        self.stops = _stops;
        self.is_ready = true;
        self.routing = false;
        self.drawMarkers(self.stops);
        self.drawPolyline(directions);
      });
    },
    setDirection: function setDirection(origin, destination, waypoints) {
      var self = this;
      self.direction.IsManual = self.is_manual;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.directionsService.route({
          origin: origin,
          destination: destination,
          waypoints: waypoints,
          optimizeWaypoints: !self.direction.IsManual,
          travelMode: self.maps.DirectionsTravelMode.DRIVING
        }, function (response, status) {
          if (status === 'OK') {
            var route = response.routes[0];
            resolve(route);
          } else {
            reject(status);
          }
        });
      });
    },
    initMap: function initMap() {
      this.directionsService = new this.maps.DirectionsService();
      this.directionsDisplay = new this.maps.DirectionsRenderer({ suppressMarkers: true });
      this.directionsDisplay.setMap(this.map);
    },
    pinSymbol: function pinSymbol(color) {
      return {
        path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color,
        labelOrigin: new this.maps.Point(0, -25)
      };
    },
    addMarker: function addMarker(position, i, color) {
      if (i === 0) {
        return new this.maps.Marker({
          position: position,
          icon: __webpack_require__(21)
        });
      }
      var label = i + ' ';
      if (!color) color = '#f5c93c';
      return new this.maps.Marker({
        draggable: false,
        raiseOnDrag: true,
        position: position,
        icon: this.pinSymbol(color),
        animation: null,
        label: {
          text: label,
          color: '#fff',
          fontSize: '16px'
        },
        labelClass: 'marker-label'
      });
    },
    status: function status() {
      var self = this;
      var postData = { TourID: this.route.TourID, Deleted: this.route.Deleted };
      this.$http.post('/route/status', postData).then(function (response) {
        self.$message(self.$t('ROUTESUCCESSFULLY') + ' ' + (self.route.Deleted === '1' ? self.$t('DEACTIVATED') : self.$t('RESTORED')));
        var EventBus = __webpack_require__(9).EventBus;
        EventBus.trips.total = response.data.trips;
      }).catch(function (res) {});
    },
    cloneRoute: function cloneRoute() {
      var self = this;
      this.cloning = true;
      this.$http.get('/route/clone/' + this.route.TourID + '' + '&name=' + this.clonedName).then(function (response) {
        self.cloning = false;
        self.$message(self.$t('ROUTESUCCESSFULLYCLONED'));
      }).catch(function (res) {});
    },
    setPathColor: function setPathColor(val) {
      if (this.polyline === null) return;
      this.polyline.setOptions({ strokeColor: val });
      for (var marker in this.markers) {
        if (parseInt(marker) !== 0) this.markers[marker].setIcon(this.pinSymbol(val));
      }
    },
    setDepature: function setDepature(val) {
      if (val === 3) return;
      if (val === 1) {
        this.schedule.Time_PM_In = undefined;
        this.schedule.Time_PM_Out = undefined;
        this.departure = 1;
      } else {
        this.schedule.Time_AM_In = undefined;
        this.schedule.Time_AM_Out = undefined;
        this.departure = 2;
      }
    },
    changeDirection: function changeDirection() {},
    pinStudentLocation: function pinStudentLocation(student) {
      var self = this;
      if (self.pin_location !== null) self.pin_location.setMap(null);
      self.pin_location = new self.maps.Marker({
        map: self.map,
        animation: self.maps.Animation.BOUNCE,
        position: new this.maps.LatLng(student.Lat, student.Lng)
      });
      self.map.panTo(self.pin_location.getPosition());
    },
    clearSelections: function clearSelections() {
      this.typed = this.typed === '' ? null : '';
      if (!this.showBuses) this.selectedBus = null;
      if (!this.showDrivers) this.selectedDriver = null;
      if (!this.showSupervisors) this.selectedSupervisor = null;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      var self = this;
      if (response.error) {
        return self.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      self.$http.get('/student/coordinates', { params: { cvs_file: response.file_name } }).then(function (response) {
        self.bulkValidation(response.data.stops);
      }).catch(function (res) {});
    },
    bulkValidation: function bulkValidation(stops) {
      var self = this;
      var s = this.stops.length;
      var promises = [];
      var studentStops = {};
      for (var stop in stops) {
        var students = stops[stop].students;
        for (var student in students) {
          var StudentID = students[student].StudentID;
          if (this.students[StudentID] === undefined) {
            studentStops[StudentID] = { stop: stop, student: students[student] };
            promises.push(this.checkRoute(StudentID));
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (results) {
        for (var item in results) {
          var data = results[item].data;
          if (data.success !== undefined) {
            var _stop2 = studentStops[data.ID].stop;
            var key = stops[_stop2].originLat + ',' + stops[_stop2].originLng;
            var _stop = self.coordinates[key];
            if (_stop === undefined) {
              _stop = self.coordinates[key] = s++;
              stops[_stop2].stop_id = _stop;
              stops[_stop2].students = [];
              self.stops.push(stops[_stop2]);
            }
            self.stops[_stop].students.push(studentStops[data.ID].student);
          }
        }
        self.drawMarkers(self.stops);
        if (self.polyline !== null) self.polyline.setMap(null);
        self.progress_import = false;
        self.is_ready = false;
      });
    },
    processUpload: function processUpload() {
      this.progress_import = true;
    },
    saveStops: function saveStops() {
      var stops = this.optimizeStops();
      if (!stops) return;
      this.$http.post('/route/stops', { TourID: this.route.TourID, stops: stops }).then(function (response) {}).catch(function (res) {});
    },
    loadOptimizedRoute: function loadOptimizedRoute(data) {
      var self = this;
      this.$http.get('/route/optimize', { params: data }).then(function (response) {
        self.$notify({
          title: 'Success',
          message: 'Route successfully optimized!',
          type: 'success'
        });
        self.drawMarkers(response.data.stops);
        self.drawPolyline(response.data.directions);
      }).catch(function (res) {});
    },
    arrangeStudentStop: function arrangeStudentStop(students) {
      var studentIDs = [];
      var draft = false;
      var i = 0;
      for (var student in students) {
        studentIDs.push(students[student].StudentID);
        i++;
        if (students[student].deleted && !students[student].draft) {
          delete studentIDs.slice(i--, 1);
          draft = true;
        } else if (!students[student].deleted && students[student].draft) {
          draft = true;
        }
      }
      if (!draft) studentIDs = [];
      return studentIDs;
    },
    optimizeStops: function optimizeStops() {
      var stops = {};
      var deletedStops = [];
      var type = 'school';
      var i = 0;
      if (this.stops.length === 1) return false;
      for (var item in this.stops) {
        item = parseInt(item);
        if (item > 0) type = 'stop';
        var stop = {
          Lat: this.stops[item].originLat,
          Lng: this.stops[item].originLng,
          Type: type,
          students: this.arrangeStudentStop(this.stops[item].students)
        };
        if ((this.stops[item].draft || stop.students.length > 0) && !this.stops[item].deleted) {
          var key = this.direction.Snapshot !== null ? this.stops[item].stop_id : i++;
          stops[key] = stop;
        } else if (this.stops[item].deleted && !this.stops[item].draft) {
          deletedStops.push(this.stops[item].stop_id + '');
        }
      }
      var data = {};
      if (deletedStops.length > 0) data.delete_waypoints = deletedStops;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(stops).length > 0) data.modify = stops;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).length === 0) return false;
      return data;
    },
    optimizeRoute: function optimizeRoute() {
      var _this5 = this;

      var stops = this.optimizeStops();
      if (!stops) return;
      if (this.is_ready) return this.$message(this.$t('ROUTEISOTIMIZED'));
      this.draftRoute();
      this.routing = true;
      var event = this.API_KEY + '-' + this.route.TourID;
      this.$channel.bind(event, function (data) {
        data.TourID = _this5.route.TourID;
        _this5.direction.Snapshot = data.Version;
        _this5.loadOptimizedRoute(data);
      }).bind(this);
      var self = this;
      this.$http.put('/route/optimize', { TourID: this.route.TourID, stops: stops }).then(function (response) {
        if (response.data.stops === undefined) return;
        self.drawMarkers(response.data.stops);
        self.drawPolyline(response.data.directions);
      }).catch(function (res) {});
    },
    removeStop: function removeStop(key) {
      this.$delete(this.stops, key);
      if (this.pin_location !== null) this.pin_location.setMap(null);
      this.markers[key].setMap(null);
      // this.is_ready = false
      if (this.deleted_stops === 0) this.is_ready = true;
      this.students = {};
      for (var stop in this.stops) {
        this.studentStop(stop);
      }
    },
    validateStudents: function validateStudents(students) {
      var deleteStudents = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.deleted_students).length;
      var _delete = true;
      if (students.length === deleteStudents) _delete = false;
      for (var student in students) {
        var StudentID = students[student].StudentID;
        if (this.deleted_students[StudentID] !== undefined) students[student].deleted = _delete;
      }
      if (!_delete) this.deleted_students = {};
      return !_delete;
    },
    deleteAction: function deleteAction(item, key) {
      item.deleted = !item.deleted;
      var isReady = true;
      if (item.students !== undefined) {
        if (this.stops.length === 2) {
          item.draft = true;
          if (this.polyline !== null) this.polyline.setMap(null);
          this.direction.Polyline = null;
          this.stops_order = [];
          this.polyline = null;
        }
        if (item.draft && item.deleted) return this.removeStop(key);
        item.deleted ? this.deleted_stops++ : this.deleted_stops--;
      } else {
        if (item.deleted && this.stops[key].draft && this.stops[key].students.length === 1) return this.removeStop(key);
        item.deleted ? this.$set(this.deleted_students, item.StudentID, key) : this.$delete(this.deleted_students, item.StudentID);
        if (this.validateStudents(this.stops[key].students)) return this.deleteAction(this.stops[key], key);
      }
      if (this.deleted_stops > 0 || this.drafted_stops > 0) isReady = false;
      this.is_ready = isReady;
    },
    scrollDown: function scrollDown() {
      this.$nextTick(function () {
        this.$refs.ScrollbarStops.$el.scrollTop = this.$refs.stops.offsetHeight;
        this.$refs.ScrollbarStops.update();
      });
    },
    cluster: function cluster(stops, num) {
      var points = [];
      for (var stop in stops) {
        var point = stops[stop];
        points.push([point.originLat, point.originLng]);
      }
      if (points.length < 23) return [{ points: points }];
      clusterMaker.data(points);
      return clusterMaker.clusters();
    },
    computeDistance: function computeDistance(origin, destination) {
      var start = new this.maps.LatLng(origin.Lat, origin.Lng);
      var end = new this.maps.LatLng(destination.Lat, destination.Lng);
      return this.maps.geometry.spherical.computeDistanceBetween(start, end);
    },
    clusterPoints: function clusterPoints() {
      if (this.is_manual) return this.stops;
      var stops = this.stops.slice();
      for (var stop in stops) {
        stops[stop].school_distance = this.computeDistance(stops[0], stops[stop]);
      }
      var items = stops.sort(function (a, b) {
        return a.school_distance - b.school_distance;
      });
      var clusters = this.sortClusters(items.slice(), 4);
      var _stops = [stops[0]];
      for (var cluster in clusters) {
        var points = clusters[cluster].points;
        for (var point in points) {
          var key = points[point][0] + ',' + points[point][1];
          _stops.push(this.stops[this.coordinates[key]]);
        }
      }
      return _stops;
    },
    sortClusters: function sortClusters(items, num) {
      if (num === undefined) num = 3;
      var origin = items.shift();
      var clusters = this.cluster(items, num);
      var destination = void 0;
      for (var cluster in clusters) {
        var point = clusters[cluster];
        if (point !== undefined) {
          destination = { Lat: point.points[0][0], Lng: point.points[0][1] };
          clusters[cluster].distance = this.computeDistance(origin, destination);
        }
      }
      return clusters.sort(function (a, b) {
        return a.distance - b.distance;
      });
    },
    route_ready: function route_ready(matched) {
      if (matched && this.stops.length === 1) return this.is_ready = true;
      var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.stops);
      keys = keys.slice(1);
      var order1 = keys.join();
      var order2 = this.stops_order.join();
      var isReady = order1 === order2;
      if (this.is_manual !== !!this.direction.IsManual && isReady === !this.is_manual) isReady = false;
      if (this.direction.Polyline === null) isReady = false;
      if (this.deleted_stops > 0) isReady = false;
      if (matched) return this.is_ready = isReady;
      this.is_manual = !this.is_manual;
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'el-import-dialog': __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Import___default.a },
  data: function data() {
    return {
      supervisors: [],
      routes: [],
      supervisor: { Deleted: false },
      currentRow: null,
      tableHeight: 0,
      filter: null,
      active_filter: 'name',
      loading: true,
      indexCheck: null,
      prevIndex: null,
      sending: null,
      FullName: '',
      PersonID: '',
      Nationality: '',
      CSVReader: {},
      CSVFile: '',
      dialogImport: false,
      import_data: {}
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.import_data = { folder: this.$route.path.split('/')[2], type: 'import' };
    this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53);
    this.getSupervisors();
  },

  computed: {
    listSupervisors: function listSupervisors() {
      var supervisors = this.supervisors;
      if (this.active_filter === 'name') supervisors = this.filterBy(supervisors, this.FullName, ['FullName_EN', 'FullName_AR']);
      if (this.active_filter === 'id') supervisors = this.filterBy(supervisors, this.PersonID, 'ExternalPersonID');
      if (this.active_filter === 'nationality') supervisors = this.filterBy(supervisors, this.Nationality, 'Nationality');
      return supervisors;
    },
    options: function options() {
      var options = [{
        value: 'name',
        label: this.$t('SUPERVISORNAME')
      }, {
        value: 'id',
        label: this.$t('SUPERVISORID')
      }, {
        value: 'nationality',
        label: this.$t('NATIONALITY')
      }];
      return options;
    },
    fields: function fields() {
      var fields = [{ label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null }, { label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null }, { label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null }, { label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null }, { label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null }, { label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null }, { label: this.$t('GENDER'), field: 'Gender', required: true, format: null }, { label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null }, { label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null }, { label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: false, format: 'date' }, { label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null }, { label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null }, { label: this.$t('EMAILADDRESS'), field: 'EMail', required: true, format: null }];
      return fields;
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    currentLang: function currentLang() {
      return localStorage.getItem('lang');
    },
    getSupervisors: function getSupervisors() {
      var self = this;
      if (!self.loading) return;
      this.$http.get('/supervisor').then(function (response) {
        for (var supervisor in response.data) {
          response.data[supervisor].Deleted = false;
        }
        self.supervisors = response.data;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    reCall: function reCall() {
      this.loading = true;
      this.getSupervisors();
    },
    filterBy: function filterBy(arr, search, delimiter) {
      if (!search) return arr;
      var res = [];
      arr.filter(function (el) {
        if ((typeof delimiter === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(delimiter)) === 'object') {
          var regx = new RegExp('(?:^|\\s)' + search, 'ig');
          if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el);
        } else {
          search = '^' + search;
          if (new RegExp(search, 'i').test(el[delimiter])) res.push(el);
        }
      });
      return res;
    },
    removeFilter: function removeFilter(filter) {
      this.changeFilter();
      this.filter = '';
      this.listSupervisors;
    },
    changeFilter: function changeFilter() {
      this.FullName = this.PersonID = this.Nationality = '';
    },
    toggleStatus: function toggleStatus(index) {
      var self = this;
      var postData = { PersonID: self.supervisors[index].PersonID, Status: self.supervisors[index].Status };
      this.$http.post('/supervisor/delete', postData).then(function (response) {
        self.supervisors[index].Deleted = false;
        self.supervisors[index].DeletedAT = self.supervisors[index].DeletedAT !== null ? null : '';
        self.supervisors[index].Status = self.supervisors[index].Status === '1' ? '0' : '1';
        if (self.supervisors[index].Status === '1') self.supervisors.push(self.supervisors.splice(index, 1)[0]);
        self.$message({
          message: response.data.error ? self.$t('SUPERVISORHASNOTBEENDELETED') : self.$t('SUPERVISORHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
          type: response.data.error ? 'error' : 'success',
          showClose: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkRoute: function checkRoute(index) {
      var self = this;
      if (self.supervisors[index].Status === '1') {
        self.supervisors[index].Deleted = true;
        return;
      }
      if (self.prevIndex !== null) self.supervisors[self.prevIndex].Deleted = false;
      if (self.indexCheck === self.supervisors[index].BusMonitorID) return;
      this.$http.get('/route/verify' + '&BusMonitorID=' + self.supervisors[index].BusMonitorID + '&TourID=' + null).then(function (response) {
        var result = response.data;
        var Deleted = true;
        if (result.error) {
          self.prevIndex = index;
          Deleted = false;
          self.indexCheck = self.supervisors[index].BusMonitorID;
          return self.$message({
            message: self.$t('SUPERVISORCANNOTBEDEACTIVATED'),
            type: 'warning',
            showClose: true,
            onClose: function onClose() {
              self.indexCheck = null;
            }
          });
        }
        self.supervisors[index].Deleted = Deleted;
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendRegistration: function sendRegistration(supervisor) {
      var postData = {};
      var self = this;
      postData.supervisor = { FullName: supervisor.FullName_EN.replace(' ', ''), email: supervisor.EMail, BusMonitorID: supervisor.BusMonitorID };
      this.sending = supervisor.BusMonitorID;
      this.$http.post('/registration', postData).then(function (response) {
        self.sending = null;
        self.$message({
          message: self.$t('REGISTRATIONHASBEENSENT'),
          type: 'success',
          showClose: true
        });
      }).catch(function () {});
    },
    changedFilter: function changedFilter(val) {
      if (val === null) return;
      this.active_filter = val;
      this.filter = null;
    },
    clearInput: function clearInput() {
      this.FullName = this.PersonID = '';
      this.listDrivers;
    },
    uploadedFile: function uploadedFile(response, file, fileList) {
      if (response.error) {
        return this.$message({
          message: response.error,
          type: 'error',
          showClose: true
        });
      }
      this.CSVReader = response.fields;
      this.CSVFile = response.file_name;
      this.dialogImport = true;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a, 'wi-upload': __WEBPACK_IMPORTED_MODULE_1__components_dialogs_Upload___default.a, 'wi-save': __WEBPACK_IMPORTED_MODULE_2__components_dialogs_Save___default.a },
  data: function data() {
    return {
      person: { PersonID: null, Gender: null, ImagePath: null, IDExpiration: null, Nationality: null },
      supervisor: {},
      contact: {},
      school: {},
      address: {},
      routes: [],
      activeIndex: '',
      handleSelect: '',
      dialogVisible: false,
      dialogImageUrl: '',
      cardHeight: 0,
      loading: false,
      message: null,
      error: false,
      loadingRoutes: false,
      pickerOption: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  mounted: function mounted() {
    this.switchLanguage();
    this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53;
    this.getSupervisor();
  },

  methods: {
    printError: function printError(message) {
      var error = message.split(' ');
      if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], { len: error[2] }) + '</br>';
      return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>';
    },
    phoneValidation: function phoneValidation(rule, value, callback) {
      var regex = /^\+?[\d-]+$/;
      if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'));
      callback();
    },
    imageUploaded: function imageUploaded(res) {
      if (res.file_name !== undefined) this.person.ImagePath = res.file_name;
    },
    getSupervisor: function getSupervisor() {
      var self = this;
      if (this.$route.params.id === 'create') return;
      this.loading = true;
      this.$http.get('/supervisor/' + this.$route.params.id).then(function (response) {
        self.person = response.data.person;
        if (self.person.IDExpiration) self.person.IDExpiration = self.dateFormat(self.person.IDExpiration);
        self.supervisor = response.data.monitor;
        self.contact = response.data.contact;
        self.loading = false;
      }).catch(function (response) {});
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.student.ImagePath = URL.createObjectURL(file.raw);
    },
    getRoute: function getRoute() {
      var self = this;
      if (self.routes.length !== 0) return;
      self.loadingRoutes = true;
      this.$http.get('/route/assigned?BusMonitorID=' + self.supervisor.BusMonitorID).then(function (response) {
        self.loadingRoutes = false;
        self.routes = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTabData: function getTabData(tab) {
      switch (tab.name) {
        case 'route':
          this.getRoute();
          break;
      }
    }
  }
});

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 145,
	"./af.js": 145,
	"./ar": 152,
	"./ar-dz": 146,
	"./ar-dz.js": 146,
	"./ar-kw": 147,
	"./ar-kw.js": 147,
	"./ar-ly": 148,
	"./ar-ly.js": 148,
	"./ar-ma": 149,
	"./ar-ma.js": 149,
	"./ar-sa": 150,
	"./ar-sa.js": 150,
	"./ar-tn": 151,
	"./ar-tn.js": 151,
	"./ar.js": 152,
	"./az": 153,
	"./az.js": 153,
	"./be": 154,
	"./be.js": 154,
	"./bg": 155,
	"./bg.js": 155,
	"./bm": 156,
	"./bm.js": 156,
	"./bn": 157,
	"./bn.js": 157,
	"./bo": 158,
	"./bo.js": 158,
	"./br": 159,
	"./br.js": 159,
	"./bs": 160,
	"./bs.js": 160,
	"./ca": 161,
	"./ca.js": 161,
	"./cs": 162,
	"./cs.js": 162,
	"./cv": 163,
	"./cv.js": 163,
	"./cy": 164,
	"./cy.js": 164,
	"./da": 165,
	"./da.js": 165,
	"./de": 168,
	"./de-at": 166,
	"./de-at.js": 166,
	"./de-ch": 167,
	"./de-ch.js": 167,
	"./de.js": 168,
	"./dv": 169,
	"./dv.js": 169,
	"./el": 170,
	"./el.js": 170,
	"./en-au": 171,
	"./en-au.js": 171,
	"./en-ca": 172,
	"./en-ca.js": 172,
	"./en-gb": 173,
	"./en-gb.js": 173,
	"./en-ie": 174,
	"./en-ie.js": 174,
	"./en-il": 175,
	"./en-il.js": 175,
	"./en-nz": 176,
	"./en-nz.js": 176,
	"./eo": 177,
	"./eo.js": 177,
	"./es": 180,
	"./es-do": 178,
	"./es-do.js": 178,
	"./es-us": 179,
	"./es-us.js": 179,
	"./es.js": 180,
	"./et": 181,
	"./et.js": 181,
	"./eu": 182,
	"./eu.js": 182,
	"./fa": 183,
	"./fa.js": 183,
	"./fi": 184,
	"./fi.js": 184,
	"./fo": 185,
	"./fo.js": 185,
	"./fr": 188,
	"./fr-ca": 186,
	"./fr-ca.js": 186,
	"./fr-ch": 187,
	"./fr-ch.js": 187,
	"./fr.js": 188,
	"./fy": 189,
	"./fy.js": 189,
	"./gd": 190,
	"./gd.js": 190,
	"./gl": 191,
	"./gl.js": 191,
	"./gom-latn": 192,
	"./gom-latn.js": 192,
	"./gu": 193,
	"./gu.js": 193,
	"./he": 194,
	"./he.js": 194,
	"./hi": 195,
	"./hi.js": 195,
	"./hr": 196,
	"./hr.js": 196,
	"./hu": 197,
	"./hu.js": 197,
	"./hy-am": 198,
	"./hy-am.js": 198,
	"./id": 199,
	"./id.js": 199,
	"./is": 200,
	"./is.js": 200,
	"./it": 201,
	"./it.js": 201,
	"./ja": 202,
	"./ja.js": 202,
	"./jv": 203,
	"./jv.js": 203,
	"./ka": 204,
	"./ka.js": 204,
	"./kk": 205,
	"./kk.js": 205,
	"./km": 206,
	"./km.js": 206,
	"./kn": 207,
	"./kn.js": 207,
	"./ko": 208,
	"./ko.js": 208,
	"./ky": 209,
	"./ky.js": 209,
	"./lb": 210,
	"./lb.js": 210,
	"./lo": 211,
	"./lo.js": 211,
	"./lt": 212,
	"./lt.js": 212,
	"./lv": 213,
	"./lv.js": 213,
	"./me": 214,
	"./me.js": 214,
	"./mi": 215,
	"./mi.js": 215,
	"./mk": 216,
	"./mk.js": 216,
	"./ml": 217,
	"./ml.js": 217,
	"./mn": 218,
	"./mn.js": 218,
	"./mr": 219,
	"./mr.js": 219,
	"./ms": 221,
	"./ms-my": 220,
	"./ms-my.js": 220,
	"./ms.js": 221,
	"./mt": 222,
	"./mt.js": 222,
	"./my": 223,
	"./my.js": 223,
	"./nb": 224,
	"./nb.js": 224,
	"./ne": 225,
	"./ne.js": 225,
	"./nl": 227,
	"./nl-be": 226,
	"./nl-be.js": 226,
	"./nl.js": 227,
	"./nn": 228,
	"./nn.js": 228,
	"./pa-in": 229,
	"./pa-in.js": 229,
	"./pl": 230,
	"./pl.js": 230,
	"./pt": 232,
	"./pt-br": 231,
	"./pt-br.js": 231,
	"./pt.js": 232,
	"./ro": 233,
	"./ro.js": 233,
	"./ru": 234,
	"./ru.js": 234,
	"./sd": 235,
	"./sd.js": 235,
	"./se": 236,
	"./se.js": 236,
	"./si": 237,
	"./si.js": 237,
	"./sk": 238,
	"./sk.js": 238,
	"./sl": 239,
	"./sl.js": 239,
	"./sq": 240,
	"./sq.js": 240,
	"./sr": 242,
	"./sr-cyrl": 241,
	"./sr-cyrl.js": 241,
	"./sr.js": 242,
	"./ss": 243,
	"./ss.js": 243,
	"./sv": 244,
	"./sv.js": 244,
	"./sw": 245,
	"./sw.js": 245,
	"./ta": 246,
	"./ta.js": 246,
	"./te": 247,
	"./te.js": 247,
	"./tet": 248,
	"./tet.js": 248,
	"./tg": 249,
	"./tg.js": 249,
	"./th": 250,
	"./th.js": 250,
	"./tl-ph": 251,
	"./tl-ph.js": 251,
	"./tlh": 252,
	"./tlh.js": 252,
	"./tr": 253,
	"./tr.js": 253,
	"./tzl": 254,
	"./tzl.js": 254,
	"./tzm": 256,
	"./tzm-latn": 255,
	"./tzm-latn.js": 255,
	"./tzm.js": 256,
	"./ug-cn": 257,
	"./ug-cn.js": 257,
	"./uk": 258,
	"./uk.js": 258,
	"./ur": 259,
	"./ur.js": 259,
	"./uz": 261,
	"./uz-latn": 260,
	"./uz-latn.js": 260,
	"./uz.js": 261,
	"./vi": 262,
	"./vi.js": 262,
	"./x-pseudo": 263,
	"./x-pseudo.js": 263,
	"./yo": 264,
	"./yo.js": 264,
	"./zh-cn": 265,
	"./zh-cn.js": 265,
	"./zh-hk": 266,
	"./zh-hk.js": 266,
	"./zh-tw": 267,
	"./zh-tw.js": 267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAvCAYAAAC/vqlHAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AseDgE2wbkpTQAABIVJREFUaN7VmltsFFUYgL/ZtlBbEJToCxU1pipPhie3RuObadBI9FHQqhglCiQkRgMaNQSNcX0xNfoABNGYVFNbo74IqNFE3ZqWFrmkWre1ay1Uit3ufXcux4ee0ZOx2063c1n+5M/O7s6eOd/8/5z/clajChFCcLlK/XJ+nO9rC3XyTbf/GCxwFdIKROXrtYAG5IBR4BTQB5Rr1sIuZR2wA3gEuHmRc7NAN/A2MODHZCI+38xngTHggAtYgFXAo0A/8Alw3eUCvB74BogBq6sc40HgZ2BLrQNvBH4A7vRgrLVAD/BMrQKvB44BGzw2SiewtdaA64AuoMUHr9GAQ8BttQS82yM3riSNwBF5Y0MHXgu8FECI2wQ8XAvAT0noIOQ56eKhAncEmK1tlNlaaMA3yEkEKe1hAt8RQt3QFiZwawjArWECrwsB+KowgetDAG4IEzgVAnA2TOBkCMCJMN0xHTStEGRXtcU1mX9ogJBqH/sKPBY0sCXEOLDC5lfUfm8px54D9zPXl2oOCnjyr/JPsjuiAlry2JRqOT73DFgHvgLuD4jXjB2dHATWzANsAoZUXaqhfO9ZSOkJCjidNU8e7p3SgSvncWPbumWpRaDEf51Qyyvgz+SgK/wGPjua/1bWxs4FSigubcj5NCiRqARYXlVLM8Dnvi9WFqUXOpMnpGfWyVfn8UrgCqBJritN0hB1QMTLjsdBv4GTF0on+k5n5ks6NKkRqXXSuislbL1taS+BjwHn/ATuPj7d6/JUG15zqpfAAnjDL9iZtDH08rt/DC9hLtZ84cnrNu2HzO0TeS69X/99ZImw9sJVkuHJ9APYAPZ5DXspZfTten10YAmwugxJeaAgwX2xMMDHQNzDvNns7Dr/jptFXInBBZn95SS4bicefgAL5nYLDS8G+y1Z6I6992dikevZCUdJWjUr1bauacdsvzbTTgFvLneQQsma3Lpv5JALWF2xakbC5uUNMNQExbft0sRE8RUhGFqGK1sHe6b2n03kC4uAliRsxgFbdhYOvgLf1NJYSmWMbUKQq8pFfs0d3vvW+JkKoIbyrGZlTW7DFpVV2fKj41FRWu7pH744oz+xWFHulAvT+nd3P37m/QVCjQ2aUTTvgBV+tXgWXDlv3DzQeyllHHDdrCqYiXt3ndtvmEI4Sr6S4znNSMs6FyfL755WRcnFowKwNrT3x2YzxlEXi9TEtr0ju4fHCnmlrnWCphUXdmXVIC2MHRtvfWBwTypjdFU6qVi2zu+Jje08Hk9NKxlSXoKmFc1WAxoksACMdNYs3rJlcOd0Sv9fmMkXrdGnXx3d/sEXF5PzWHPWYVHX7hsKsO3WgJ7Nm4Xr2ween5gqvyYnTCZnDna8ONLx0ZfT445nc1axqJ0xlQEzF49actwlS1X7rPZfD5fyT7zmaFxTCvXG4U83PXn1mob77nrs9PZffi+UHX0oXcme/rWkE7I5Gq9dYAU6AtQ9tPma1eOTxcj3QxlDKTxMpekmgAUtWfPACrSzQEetWd26a+DACw6saW6vrTm6j77KP/sTIRc4iJUIAAAAAElFTkSuQmCC"

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(294)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(295)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(296)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(297)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(298)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(591),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(299)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(300)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(301)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(302)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(303)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(304)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(314)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(315)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(316)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(317)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(318)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(319)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(590),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(320)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(321)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(322)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(323)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(324)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(325)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(326)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(327)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(328)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(589),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(329)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(330)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(331)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(332)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  "data-v-4c4f4e63",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEDRIVERS')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/transportation/driver/create'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWDRIVER')) + "\n            ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('UPLOADCSVFILE')) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHNAME'),
      "icon": _vm.FullName ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHID'),
      "icon": _vm.PersonID ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.PersonID),
      callback: function($$v) {
        _vm.PersonID = $$v
      },
      expression: "PersonID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'nationality') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SERACHBYNATIONALITY'),
      "filterable": true,
      "clearable": ""
    },
    model: {
      value: (_vm.Nationality),
      callback: function($$v) {
        _vm.Nationality = $$v
      },
      expression: "Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listDrivers,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalPersonID",
      "label": _vm.$t('ID'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n             " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LicenseExpiration",
      "label": _vm.$t('LICENSEEXPIRATION'),
      "min-width": "160",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('LICENCE'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          ref: "popLicense",
          attrs: {
            "placement": "left",
            "width": "250",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.LicenseImage, 'license')
          }
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "popover",
            rawName: "v-popover:popLicense",
            arg: "popLicense"
          }],
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.viewLicence(scope.row.LicenseImage)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sticky-note"
        }), _vm._v(" " + _vm._s(_vm.$t('LICENCE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ASSIGNEDTOBUS'),
      "min-width": "160",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.RouteID !== null ? _vm.$t('ASSIGNED') : _vm.$t('NOTASSIGNED')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('registration') && scope.row.EMail) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDREGISTRATIONCODE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.BusDriverID === _vm.sending,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.sendRegistration(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.BusDriverID !== _vm.sending ? 'fa-key' : 'fa-circle-o-notch fa-spin']
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITDRIVER'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/driver/' + scope.row.PersonID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "disabled": scope.row.RouteID != null ? true : false,
            "content": _vm.drivers[scope.$index].Status == 0 ? _vm.$t('DEACTIVATEDRIVER') : _vm.$t('ACTIVATEDRIVER'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.driver = _vm.drivers[scope.$index]
            }
          },
          model: {
            value: (_vm.drivers[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.drivers[scope.$index], "Deleted", $$v)
            },
            expression: "drivers[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + _vm._s(_vm.drivers[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISDRIVER') : _vm.$t('RESTORETHISDRIVER')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.drivers[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "disabled": scope.row.RouteID != null,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.drivers[scope.$index].Deleted = true
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.Status != 0 ? 'fa-undo' : 'fa-times']
        })])], 1)], 1) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('DRIVERS'),
      "uri": "driver/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.reCall,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('LICENCEIMAGE'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getAsset(_vm.LicenseImage, 'license')
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "incident"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATIONS')))])]), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'bus') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYBUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getViolations(true)
      }
    },
    model: {
      value: (_vm.BusID),
      callback: function($$v) {
        _vm.BusID = $$v
      },
      expression: "BusID"
    }
  }, _vm._l((_vm.buses), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Label,
        "value": item.BusID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'type') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYTYPE'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getViolations(true)
      }
    },
    model: {
      value: (_vm.Label),
      callback: function($$v) {
        _vm.Label = $$v
      },
      expression: "Label"
    }
  }, _vm._l((_vm.violationTypes), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'date') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "change": function($event) {
        _vm.getViolations(true)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.violations[_vm.currentPage - 1],
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('ROUTE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.TourName)), _c('br'), _c('small', [_vm._v(_vm._s(scope.row.datetime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverName_EN,
          NameAR: scope.row.DriverName_AR
        })) + "            \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bus_plate",
      "label": _vm.$t('BUS')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('VIOLATION')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.$t(scope.row.Label)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('flag', 'report/violation')) ? _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, 'sticky')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('flag', 'report/violation')) ? _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsHidden ? _vm.$t('SHOW') : _vm.$t('HIDE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, 'hidden')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsHidden ? 'fa-eye-slash' : 'fa-eye']
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalViolations
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "id": "studentManage",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'addressForm'],
      "title": _vm.$t('MANAGESTUDENT'),
      "data": {
        student: this.student,
        guardians: this.guardians,
        address: this.address
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.student,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.student
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDER'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.student.Gender),
      callback: function($$v) {
        _vm.$set(_vm.student, "Gender", $$v)
      },
      expression: "student.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.student, "FirstName_EN", $$v)
      },
      expression: "student.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "FirstName_AR", $$v)
      },
      expression: "student.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.student, "MiddleName", $$v)
      },
      expression: "student.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "MiddleName_AR", $$v)
      },
      expression: "student.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.student, "LastName_EN", $$v)
      },
      expression: "student.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "LastName_AR", $$v)
      },
      expression: "student.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DATEOFBIRTH'),
      "prop": "DOB",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "picker-options": _vm.pickerOption,
      "default-value": _vm.defaultDate,
      "format": _vm.date_format
    },
    model: {
      value: (_vm.student.DOB),
      callback: function($$v) {
        _vm.$set(_vm.student, "DOB", $$v)
      },
      expression: "student.DOB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.student.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.student, "Nationality", $$v)
      },
      expression: "student.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GRADE'),
      "prop": "Grade",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "GradeID",
      "placeholder": _vm.$t('SELECTGRADE')
    },
    on: {
      "change": _vm.setGrade
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASS'),
      "prop": "Class",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.student.Grade == null,
      "placeholder": _vm.$t('SELECTCLASS')
    },
    model: {
      value: (_vm.student.Class),
      callback: function($$v) {
        _vm.$set(_vm.student, "Class", $$v)
      },
      expression: "student.Class"
    }
  }, _vm._l((_vm.Grade.Classes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STUDENTSCHOOLID'),
      "prop": "ExternalStudentID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('STUDENTSCHOOLID') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 16,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 16
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.ExternalStudentID),
      callback: function($$v) {
        _vm.$set(_vm.student, "ExternalStudentID", $$v)
      },
      expression: "student.ExternalStudentID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ATTENDANCETAGID')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('CLICKONSCAN')
    },
    model: {
      value: (_vm.student.AssignedTagID),
      callback: function($$v) {
        _vm.$set(_vm.student, "AssignedTagID", $$v)
      },
      expression: "student.AssignedTagID"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showScanModal(_vm.student)
      }
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.$t('SCAN')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ADDRESS')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "addressBar",
    style: ({
      height: _vm.cardHeight - 42 + 'px'
    })
  }, [_c('el-form', {
    ref: "addressForm",
    attrs: {
      "model": _vm.address,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "googleMapV"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "id": "student-gmap"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "el-input__inner",
    staticStyle: {
      "padding": "25px 10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COORDINATES'),
      "prop": "address",
      "rules": {
        validator: _vm.valCoordinates,
        required: true,
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": function($event) {
        _vm.positionSet = false
      }
    },
    model: {
      value: (_vm.address.Lat),
      callback: function($$v) {
        _vm.$set(_vm.address, "Lat", _vm._n($$v))
      },
      expression: "address.Lat"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LAT')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": function($event) {
        _vm.positionSet = false
      }
    },
    model: {
      value: (_vm.address.Lng),
      callback: function($$v) {
        _vm.$set(_vm.address, "Lng", _vm._n($$v))
      },
      expression: "address.Lng"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LNG')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.positionSet
    },
    on: {
      "click": function($event) {
        _vm.setPosition()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('HOUSENUMBER'),
      "prop": "HouseNumber",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.HouseNumber),
      callback: function($$v) {
        _vm.$set(_vm.address, "HouseNumber", $$v)
      },
      expression: "address.HouseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STREETADDRESS')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Address),
      callback: function($$v) {
        _vm.$set(_vm.address, "Address", $$v)
      },
      expression: "address.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('AREA')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Area),
      callback: function($$v) {
        _vm.$set(_vm.address, "Area", $$v)
      },
      expression: "address.Area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZONE')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Zone),
      callback: function($$v) {
        _vm.$set(_vm.address, "Zone", $$v)
      },
      expression: "address.Zone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SECTOR')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Sector),
      callback: function($$v) {
        _vm.$set(_vm.address, "Sector", $$v)
      },
      expression: "address.Sector"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CITY'),
      "prop": "City",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 34,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 34
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.City),
      callback: function($$v) {
        _vm.$set(_vm.address, "City", $$v)
      },
      expression: "address.City"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATE'),
      "prop": "State",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 34,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 34
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.State),
      callback: function($$v) {
        _vm.$set(_vm.address, "State", $$v)
      },
      expression: "address.State"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZIPCODE'),
      "prop": "ZipCode",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.address, "ZipCode", $$v)
      },
      expression: "address.ZipCode"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('GUARDIANS')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHGUARDIANNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.addGuardian
    },
    model: {
      value: (_vm.guardian),
      callback: function($$v) {
        _vm.guardian = $$v
      },
      expression: "guardian"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listGuardians,
      "highlight-current-row": "",
      "height": _vm.cardHeight - 118,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'guardian'),
            "alt": ""
          }
        }), _vm._v("\n                     " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('RELATION'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.Relation)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PRIMARYCONTACT'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkPrimary(scope.row)
            }
          }
        }, [_c('span', {
          staticClass: "el-radio__input",
          class: {
            'is-checked': scope.row.IsPrimary
          }
        }, [_c('span', {
          staticClass: "el-radio__inner"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.length > 1 && !scope.row.IsMain),
            expression: "scope.row.length>1 && !scope.row.IsMain"
          }],
          staticClass: "fa fa-2x",
          class: scope.row.deleted ? 'fa-undo' : 'fa-remove',
          on: {
            "click": function($event) {
              scope.row.deleted = !scope.row.deleted
            }
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (_vm.student.StudentID != null) ? _c('el-tab-pane', {
    attrs: {
      "name": "route",
      "label": _vm.$t('ROUTES')
    }
  }, [_c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight - 118,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BusNumber",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "100",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.DriverPhoto, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverFullName_EN,
          NameAR: scope.row.DriverFullName_AR
        })) + "            \n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.MonitorPhoto, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.MonitorFullName_EN,
          NameAR: scope.row.MonitorFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "align": "right",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingActivities),
      expression: "loadingActivities"
    }],
    attrs: {
      "name": "activity",
      "label": _vm.$t('ACTIVITIES'),
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "ID",
      "placeholder": _vm.$t('SELECTACTIVITY')
    },
    model: {
      value: (_vm.Activity),
      callback: function($$v) {
        _vm.Activity = $$v
      },
      expression: "Activity"
    }
  }, _vm._l((_vm.activityList), function(item, index) {
    return (!_vm.activities[item.ID]) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.Activity == null || _vm.savingActivity,
      "value-key": "ID"
    },
    on: {
      "click": _vm.addActivity
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.savingActivity),
      expression: "!savingActivity"
    }],
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.savingActivity ? _vm.$t('SAVING') : _vm.$t('ADDACTIVITY')) + "\n  ")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listActivities,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIVITYNAME'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEACTIVITY'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteActivity(props.row.ActivityID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-remove"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ABSENCES')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABSENCES')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('MESSAGES')
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tag-dialog', {
    attrs: {
      "callScan": _vm.callScan,
      "student": _vm.student
    },
    on: {
      "update:callScan": function($event) {
        _vm.callScan = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "absenceDialog",
      "size": "small",
      "show-close": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.clearData,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.status) ? _c('span', {
    staticClass: "deleted-head"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('ABSENCEDELETED')) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('MARKABSENCE')) + " ")])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card search",
    class: [_vm.status ? 'disabled-dialog' : ''],
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "body-style": {
        padding: (_vm.student.StudentID == undefined ? '' : 0)
      }
    }
  }, [(_vm.student.StudentID) ? _c('div', {
    staticClass: "media",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.student.ImagePath, 'student')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("\n                    " + _vm._s(_vm._FullName({
    NameEN: _vm.student.FullName_EN,
    NameAR: _vm.student.FullName_AR
  })) + "\n                    "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-remove",
    on: {
      "click": _vm.clearInput
    }
  })]), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.search && _vm.student.StudentID == undefined) ? _c('div', [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHSTUDENTNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.addStudent
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-row', {
    class: [_vm.status ? 'disabled-dialog' : ''],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "size": "large",
      "format": "dd/MM/yyyy",
      "disabled": _vm.absence.AbsentID != undefined || this.student.StudentID == undefined,
      "placeholder": _vm.$t('FROM')
    },
    on: {
      "change": _vm.setDate
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('el-scrollbar', {
    ref: "dateScroll",
    attrs: {
      "viewStyle": {
        height: _vm.scrollHeight + 'px',
        'padding-right': 4 + 'px'
      }
    }
  }, [_c('div', _vm._l((_vm.absences), function(item, key) {
    return _c('el-row', {
      key: key
    }, [_c('el-button-group', {
      staticClass: "list",
      staticStyle: {
        "display": "block"
      }
    }, [_c('el-button', {
      class: {
        'text-success': !item.Deleted && _vm.absence.AbsentDate == item.AbsentDate
      },
      staticStyle: {
        "background-image": "none"
      },
      attrs: {
        "disabled": item.Deleted,
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.absence = item
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(key))]), _vm._v(" "), _c('el-popover', {
      ref: key,
      refInFor: true,
      attrs: {
        "disabled": item.AbsentID == null,
        "trigger": "click",
        "placement": "right",
        "width": "160"
      },
      on: {
        "show": function($event) {
          _vm.absence = item
        }
      },
      model: {
        value: (item.Excluded),
        callback: function($$v) {
          _vm.$set(item, "Excluded", $$v)
        },
        expression: "item.Excluded"
      }
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + " " + _vm._s(!item.Deleted ? _vm.$t('DEACTIVATETHISABSENCE') : _vm.$t('RESTORETHISABSENCE')))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": _vm.$t('WRITEANOTE')
      },
      model: {
        value: (item.DeleteNote),
        callback: function($$v) {
          _vm.$set(item, "DeleteNote", $$v)
        },
        expression: "item.DeleteNote"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "margin": "0",
        "margin-top": "5px"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.cancelPopover(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toggleStatus(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
      staticClass: "pull-right",
      attrs: {
        "slot": "reference",
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.preDelete(key)
        }
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa",
      class: [item.Deleted ? 'fa-undo' : 'fa-times']
    })])], 1)], 1)], 1)
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(!_vm.disableInputs) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "body-style": "padding:0px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.absence.AbsentID == null ? _vm.$t('ADDING') : _vm.$t('UPDATING')) + " " + _vm._s(_vm.$t('ABSENCEON') + ' ' + _vm.date_format(_vm.absence.AbsentDate)))])])]) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('ABSENCEFROM')))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    class: [_vm.absence.OnlyFromBus === 0 && _vm.absence.OnlyFromBus != null ? 'btn-active' : ''],
    attrs: {
      "disabled": _vm.disableInputs
    },
    on: {
      "click": function($event) {
        _vm.absentFrom(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-university fa-2x"
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('SCHOOL')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [(_vm.absence.OnlyFromBus == null) ? _c('h4', [_c('i', {
    staticClass: "fa fa-chevron-left fa-1x"
  }), _vm._v(" " + _vm._s(_vm.$t('CHOOSEONE')) + " "), _c('i', {
    staticClass: "fa fa-chevron-right fa-1x"
  })]) : (_vm.absence.OnlyFromBus === 1) ? _c('h4', [_vm._v(_vm._s(_vm.$t('BUSONLY')))]) : (_vm.direction[0] && _vm.direction[1] && _vm.absence.OnlyFromBus === 0) ? _c('h4', [_vm._v(_vm._s(_vm.$t('ENTIREDAY')))]) : ((!_vm.direction[0] && !_vm.direction[1]) && _vm.absence.OnlyFromBus === 0) ? _c('h4', [_vm._v(_vm._s(_vm.$t('EMPTYDAY')))]) : _c('h4', [_vm._v(_vm._s(_vm.$t('PARTIALDAY')))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    class: [_vm.absence.OnlyFromBus === 1 ? 'btn-active' : ''],
    attrs: {
      "disabled": _vm.disableInputs
    },
    on: {
      "click": function($event) {
        _vm.absentFrom(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bus fa-2x"
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('BUSONLY')))])], 1)], 1), _vm._v(" "), (_vm.absence.OnlyFromBus === 0 && _vm.absence.OnlyFromBus != null) ? _c('el-row', {
    staticClass: "text-center",
    staticStyle: {
      "min-height": "75px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    class: [_vm.absence.Trip !== 2 ? 'btn-active' : ''],
    staticStyle: {
      "padding": "29px 16px"
    },
    attrs: {
      "disabled": _vm.disableInputs
    },
    on: {
      "click": function($event) {
        _vm.busTrip(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('MORNING')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "span": 8
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    class: [_vm.absence.Trip !== 1 ? 'btn-active' : ''],
    staticStyle: {
      "padding": "29px 16px"
    },
    attrs: {
      "disabled": _vm.disableInputs
    },
    on: {
      "click": function($event) {
        _vm.busTrip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AFTERNOON')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.absence.OnlyFromBus === 1 && _vm.absence.OnlyFromBus != null) ? _c('el-row', {
    staticClass: "text-center",
    staticStyle: {
      "min-height": "75px",
      "padding-top": "10px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 7
    }
  }, [_c('el-button', {
    class: [_vm.absence.Trip !== 2 ? 'btn-active' : ''],
    on: {
      "click": function($event) {
        _vm.busTrip(0)
      }
    }
  }, [_c('span', {
    staticClass: "morning icon",
    class: [_vm.absence.Trip !== 2 ? 'activated' : '']
  }), _vm._v("\n                    " + _vm._s(_vm.$t('HOMETOSCHOOL')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-top": "25px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-chevron-left fa-1x"
  }), _vm._v(" " + _vm._s(_vm.$t('SELECTONEORBOTH')) + " "), _c('i', {
    staticClass: "fa fa-chevron-right fa-1x"
  })])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 7
    }
  }, [_c('el-button', {
    class: [_vm.absence.Trip !== 1 ? 'btn-active' : ''],
    on: {
      "click": function($event) {
        _vm.busTrip(1)
      }
    }
  }, [_c('span', {
    staticClass: "evening icon",
    class: [_vm.absence.Trip !== 1 ? 'activated' : '']
  }), _vm._v("\n                    " + _vm._s(_vm.$t('SCHOOLTOHOME')))])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card absences-common",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('REASON')))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "icon-v sickness",
    class: [_vm.absence.Reason == 'Sickness' ? 'activated' : ''],
    attrs: {
      "disabled": _vm.disableInputs,
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.absence.Reason = 'Sickness'
      }
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t('SICKNESS')) + "\n            ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "icon-v vacation",
    class: [_vm.absence.Reason == 'Vacation' ? 'activated' : ''],
    attrs: {
      "disabled": _vm.disableInputs,
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.absence.Reason = 'Vacation'
      }
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t('VACATION')) + "\n            ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "icon-v emergency",
    class: [_vm.absence.Reason == 'Emergency' ? 'activated' : ''],
    attrs: {
      "disabled": _vm.disableInputs,
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.absence.Reason = 'Emergency'
      }
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t('EMERGENCY')) + "\n            ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "icon-v personal",
    class: [_vm.absence.Reason == 'Personal' ? 'activated' : ''],
    attrs: {
      "disabled": _vm.disableInputs,
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.absence.Reason = 'Personal'
      }
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t('PERSONAL')) + "\n            ")], 1)], 1)], 1), _vm._v(" "), (!_vm.disableInputs && !_vm.absence.Deleted && _vm.absence.Completed && _vm.nonCompletedDates.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    ref: "copyto",
    attrs: {
      "placeholder": _vm.CopiedDate.length ? _vm.$t('COPIED') : _vm.$t('COPYTO'),
      "multiple": ""
    },
    on: {
      "visible-change": _vm.hideTag
    },
    model: {
      value: (_vm.copied_date),
      callback: function($$v) {
        _vm.copied_date = $$v
      },
      expression: "copied_date"
    }
  }, [_c('el-option', {
    key: 0,
    staticStyle: {
      "padding": "0px 1px",
      "height": "44px"
    },
    attrs: {
      "value": 0
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.SelectAll ? _vm.$t('SELECTALL') : _vm.$t('DESELECTALL')))])], 1), _vm._v(" "), _vm._l((_vm.nonCompletedDates), function(item, key) {
    return (item.AbsentDate != _vm.absence.AbsentDate) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": item
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.CopiedDate.length == 0
    },
    on: {
      "click": function($event) {
        _vm.copiesTo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.checkUp || _vm.saving || _vm.status,
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.saveAbsence()
      }
    }
  }, [_vm._v(_vm._s(_vm.saving ? _vm.$t('SAVING') : _vm.$t('SAVE')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEROUTES')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save'),
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/transportation/route/create'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDNEWROUTE')))])], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHROUTENAME')
    },
    model: {
      value: (_vm.TourName),
      callback: function($$v) {
        _vm.TourName = $$v
      },
      expression: "TourName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'label') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHBUS')
    },
    model: {
      value: (_vm.Label),
      callback: function($$v) {
        _vm.Label = $$v
      },
      expression: "Label"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'driverName') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHDRIVER')
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'monitorName') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHSUPERVISOR')
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listRoutes,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "default-sort": {
        prop: 'DraftAuthor',
        order: 'descending'
      },
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.isAllowed('save') ? _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              }) : ''
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bus.Label",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "140",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.driver.ImagePath, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.driver.FullName_EN,
          NameAR: scope.row.driver.FullName_AR
        })) + "            \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.supervisor.ImagePath, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.supervisor.FullName_EN,
          NameAR: scope.row.supervisor.FullName_AR
        })) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count_students",
      "min-width": "130",
      "label": _vm.$t('TOTALSTUDENTS'),
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count_stops",
      "min-width": "120",
      "label": _vm.$t('TOTALSTOPS'),
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "200",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Deleted) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Deleted) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'contactForm'],
      "title": _vm.$t('SCHOOLCONFIGURATION'),
      "data": {
        school: this.school,
        address: this.address,
        grades: this.grades,
        timing: this.timing,
        terms: this.academicTerms
      },
      "redirect": false,
      "auth": true
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "tabs",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.school,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.school,
      "logo": true
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('TYPESOFSCHOOL'),
      "prop": "Type",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Type),
      callback: function($$v) {
        _vm.$set(_vm.school, "Type", $$v)
      },
      expression: "school.Type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('PUBLIC')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('PRIVATE')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDERDIVERSITY'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Gender),
      callback: function($$v) {
        _vm.$set(_vm.school, "Gender", $$v)
      },
      expression: "school.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Mixed"
    }
  }, [_vm._v(_vm._s(_vm.$t('MIXED')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME'),
      "prop": "Name_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.Name_EN),
      callback: function($$v) {
        _vm.$set(_vm.school, "Name_EN", $$v)
      },
      expression: "school.Name_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME(ARABIC)'),
      "prop": "Name_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.Name_AR),
      callback: function($$v) {
        _vm.$set(_vm.school, "Name_AR", $$v)
      },
      expression: "school.Name_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COUNTRY'),
      "prop": "Country",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTYOURZONE'),
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.changeAutoComplete()
      }
    },
    model: {
      value: (_vm.school.Country),
      callback: function($$v) {
        _vm.$set(_vm.school, "Country", $$v)
      },
      expression: "school.Country"
    }
  }, _vm._l((_vm.$countries), function(stop, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": stop,
        "value": key
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DATEFORMAT')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDATEFORMAT')
    },
    model: {
      value: (_vm.school.DateFormat),
      callback: function($$v) {
        _vm.$set(_vm.school, "DateFormat", $$v)
      },
      expression: "school.DateFormat"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('DAYMONTHYEAR'),
      "value": "dd/MM/yyyy"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('MONTHDAYYEAR'),
      "value": "MM/dd/yyyy"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ADDRESS')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "addressBar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight - 42 + 'px'
    })
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.address,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "googleMap"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "id": "school-gmap"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school.Address),
      expression: "school.Address"
    }],
    staticClass: "el-input__inner",
    staticStyle: {
      "padding": "25px 10px"
    },
    attrs: {
      "disabled": !_vm.school.Country,
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.school.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.school, "Address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COORDINATES')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    on: {
      "change": function($event) {
        _vm.enableConfirm = true
      }
    },
    model: {
      value: (_vm.school.Lat),
      callback: function($$v) {
        _vm.$set(_vm.school, "Lat", $$v)
      },
      expression: "school.Lat"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LATITUDE')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    on: {
      "change": function($event) {
        _vm.enableConfirm = true
      }
    },
    model: {
      value: (_vm.school.Lng),
      callback: function($$v) {
        _vm.$set(_vm.school, "Lng", $$v)
      },
      expression: "school.Lng"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LONGITUDE')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.enableConfirm
    },
    on: {
      "click": function($event) {
        _vm.changeMarkerPosition(_vm.school.Lat, _vm.school.Lng)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUILDINGNUMBER')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.HouseNumber),
      callback: function($$v) {
        _vm.$set(_vm.address, "HouseNumber", $$v)
      },
      expression: "address.HouseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STREETADDRESS')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Address),
      callback: function($$v) {
        _vm.$set(_vm.address, "Address", $$v)
      },
      expression: "address.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('AREA')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Area),
      callback: function($$v) {
        _vm.$set(_vm.address, "Area", $$v)
      },
      expression: "address.Area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZONE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Zone),
      callback: function($$v) {
        _vm.$set(_vm.address, "Zone", $$v)
      },
      expression: "address.Zone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SECTOR')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Sector),
      callback: function($$v) {
        _vm.$set(_vm.address, "Sector", $$v)
      },
      expression: "address.Sector"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CITY')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.City),
      callback: function($$v) {
        _vm.$set(_vm.address, "City", $$v)
      },
      expression: "address.City"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.State),
      callback: function($$v) {
        _vm.$set(_vm.address, "State", $$v)
      },
      expression: "address.State"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZIPCODE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.address, "ZipCode", $$v)
      },
      expression: "address.ZipCode"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTS')
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.adminImage, 'user')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHUSERSNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.changeUser
    },
    model: {
      value: (_vm.admin),
      callback: function($$v) {
        _vm.admin = $$v
      },
      expression: "admin"
    }
  })], 1)])]), _vm._v(" "), _c('el-form', {
    ref: "contactForm",
    staticStyle: {
      "margin-top": "15px",
      "padding": "15px"
    },
    attrs: {
      "model": _vm.school,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLEMAIL'),
      "prop": "AdminEmail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.AdminEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "AdminEmail", $$v)
      },
      expression: "school.AdminEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLPHONENUMBER'),
      "prop": "AdminPhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.AdminPhone),
      callback: function($$v) {
        _vm.$set(_vm.school, "AdminPhone", $$v)
      },
      expression: "school.AdminPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSCOMPANYEMAIL'),
      "prop": "BusCompanyEmail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.BusCompanyEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "BusCompanyEmail", $$v)
      },
      expression: "school.BusCompanyEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSCOMPANYPHONENUMBER'),
      "prop": "BusCompanyContact",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.BusCompanyContact),
      callback: function($$v) {
        _vm.$set(_vm.school, "BusCompanyContact", $$v)
      },
      expression: "school.BusCompanyContact"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LOCALPOLICEEMAIL'),
      "prop": "PoliceEmail",
      "rules": [{
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.PoliceEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "PoliceEmail", $$v)
      },
      expression: "school.PoliceEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LOCALPOLICEPHONENUMBER'),
      "prop": "PoliceContact",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.PoliceContact),
      callback: function($$v) {
        _vm.$set(_vm.school, "PoliceContact", $$v)
      },
      expression: "school.PoliceContact"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('GRADES')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "gradeForm",
    attrs: {
      "model": _vm.grade,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "prop": "Grade",
      "rules": [{
        min: 1,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 1
        }),
        trigger: 'blur'
      }, {
        max: 10,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 8
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('GRADE')
    },
    model: {
      value: (_vm.grade.Grade),
      callback: function($$v) {
        _vm.$set(_vm.grade, "Grade", $$v)
      },
      expression: "grade.Grade"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('AGE')
    },
    model: {
      value: (_vm.grade.Age),
      callback: function($$v) {
        _vm.$set(_vm.grade, "Age", $$v)
      },
      expression: "grade.Age"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.gradeValidation()
    },
    on: {
      "click": _vm.newGrade
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.gradeIndex == null ? _vm.$t('ADDGRADE') : _vm.$t('SAVE')) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.grades,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((props.row.Classes), function(value, index) {
          return _c('el-col', {
            key: index,
            staticStyle: {
              "margin-bottom": "10px"
            },
            attrs: {
              "span": 6
            }
          }, [_c('el-input', {
            model: {
              value: (props.row.Classes[index]),
              callback: function($$v) {
                _vm.$set(props.row.Classes, index, $$v)
              },
              expression: "props.row.Classes[index]"
            }
          }, [_c('el-button', {
            attrs: {
              "slot": "prepend",
              "icon": "close"
            },
            on: {
              "click": function($event) {
                props.row.Classes.splice(index, 1)
              }
            },
            slot: "prepend"
          })], 1)], 1)
        }), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "disabled": props.row.Classes[props.row.Classes.length - 1] == ''
          },
          on: {
            "click": function($event) {
              props.row.Classes.push('')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWCLASS')))])], 1)], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('GRADE'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('AVERAGEAGE'),
      "prop": "Age",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITGRADE'),
            "placement": "top"
          }
        }, [(props.$index != _vm.gradeIndex) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editGrade(props.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEGRADE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteGrade(props.$index, props.row.GradeID, props.row.Name)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('TIMINGS')
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "model": _vm.timing,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GATEOPENTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('GATEOPENTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.timing.GateOpen),
      callback: function($$v) {
        _vm.$set(_vm.timing, "GateOpen", $$v)
      },
      expression: "timing.GateOpen"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASSSTARTTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('CLASSSTARTTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.OpenTime
      }
    },
    model: {
      value: (_vm.timing.ClassStart),
      callback: function($$v) {
        _vm.$set(_vm.timing, "ClassStart", $$v)
      },
      expression: "timing.ClassStart"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LATEARRIVALTIME')
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.timing.LateArrival),
      callback: function($$v) {
        _vm.$set(_vm.timing, "LateArrival", $$v)
      },
      expression: "timing.LateArrival"
    }
  }, _vm._l((_vm.minutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('EARLYDEPARTURETIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('EARLYDEPARTURETIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.ArrivalTime
      }
    },
    model: {
      value: (_vm.timing.EarlyDeparture),
      callback: function($$v) {
        _vm.$set(_vm.timing, "EarlyDeparture", $$v)
      },
      expression: "timing.EarlyDeparture"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASSENDTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('CLASSENDTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.DepartureTime
      }
    },
    model: {
      value: (_vm.timing.ClassEnd),
      callback: function($$v) {
        _vm.$set(_vm.timing, "ClassEnd", $$v)
      },
      expression: "timing.ClassEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GATECLOSETIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('GATECLOSETIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.EndTime
      }
    },
    model: {
      value: (_vm.timing.GateClose),
      callback: function($$v) {
        _vm.$set(_vm.timing, "GateClose", $$v)
      },
      expression: "timing.GateClose"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ACADEMICTERMS')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.newTerm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEXTACADEMICYEAR')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.academicTerms,
      "height": _vm.cardHeight - 118
    },
    on: {
      "expand": _vm.expandRow
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.terms.length != 0) ? _c('el-row', {
          staticStyle: {
            "font-weight": "bold"
          },
          attrs: {
            "gutter": 20
          }
        }, [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('TERMNAME')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('STARTDATE')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('ENDDATE')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 2
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.row.terms), function(term, key) {
          return _c('el-row', {
            key: key,
            staticStyle: {
              "padding": "15px 0"
            },
            attrs: {
              "gutter": 20
            }
          }, [_c('el-col', {
            attrs: {
              "span": 6
            }
          }, [_c('el-input', {
            attrs: {
              "disabled": term.IsDeleted == 1
            },
            model: {
              value: (term.Name),
              callback: function($$v) {
                _vm.$set(term, "Name", $$v)
              },
              expression: "term.Name"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-date-picker', {
            attrs: {
              "disabled": term.IsDeleted == 1,
              "format": _vm.date_format,
              "type": "date",
              "picker-options": {
                disabledDate: _vm.activeDates
              },
              "placeholder": _vm.$t('STARTDATE'),
              "default-value": new Date(props.row.year.split('/')[0] + '-01-01')
            },
            on: {
              "change": function($event) {
                _vm.restricNextDate(term.StartDate, key)
              }
            },
            model: {
              value: (term.StartDate),
              callback: function($$v) {
                _vm.$set(term, "StartDate", $$v)
              },
              expression: "term.StartDate"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-date-picker', {
            attrs: {
              "disabled": term.IsDeleted == 1,
              "format": _vm.date_format,
              "type": "date",
              "placeholder": _vm.$t('ENDDATE'),
              "default-value": new Date(props.row.year.split('/')[0] + '-01-01')
            },
            model: {
              value: (term.EndDate),
              callback: function($$v) {
                _vm.$set(term, "EndDate", $$v)
              },
              expression: "term.EndDate"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 2
            }
          }, [_c('i', {
            staticClass: "fa",
            class: [term.IsDeleted == 0 ? 'fa-times' : ' fa-undo'],
            staticStyle: {
              "font-size": "25px",
              "margin-top": "5px"
            },
            on: {
              "click": function($event) {
                term.IsDeleted = (term.IsDeleted == 0 ? 1 : 0)
              }
            }
          })])], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-button', {
          on: {
            "click": function($event) {
              props.row.terms.push({
                Name: '',
                YearID: props.row.YearID,
                StartDate: '',
                EndDate: '',
                IsDeleted: 0
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWTERM')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('YEAR'),
      "prop": "year"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STARTINGDATE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.row.terms.length == 0 ? '-' : _vm.dateFormat(props.row.terms[0].StartDate)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ENDINGDATE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.row.terms.length == 0 ? '-' : _vm.dateFormat(props.row.terms[props.row.terms.length - 1].EndDate)) + "\n            ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ACTIVITIES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('ACTIVITYNAME')
    },
    model: {
      value: (_vm.Activity.Name),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Name", $$v)
      },
      expression: "Activity.Name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.Activity.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "StartTime", $$v)
      },
      expression: "Activity.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "disabled": _vm.Activity.StartTime == null,
      "picker-options": {
        start: _vm.Activity.StartTime,
        step: '00:15',
        end: '16:00',
        minTime: _vm.Activity.StartTime
      }
    },
    model: {
      value: (_vm.Activity.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "EndTime", $$v)
      },
      expression: "Activity.EndTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.Activity.Date),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Date", $$v)
      },
      expression: "Activity.Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": _vm.$t('SELECTDAYS')
    },
    model: {
      value: (_vm.Activity.Days),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Days", $$v)
      },
      expression: "Activity.Days"
    }
  }, _vm._l((_vm.daysC), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.Activity.Name == null
    },
    on: {
      "click": _vm.saveActivity
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.Activity.ID == null ? _vm.$t('ADDACTIVITY') : _vm.$t('SAVE')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.activities,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIVITYNAME'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITACTIVITY'),
            "placement": "top"
          }
        }, [(_vm.Activity.ID != props.row.ID) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.Activity = props.row
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEACTIVITY'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteActivity(props.$index, props.row.ID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('MESSAGES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PARENTMESSAGES')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHECKALL')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedMessageChange
    },
    model: {
      value: (_vm.school.Messages),
      callback: function($$v) {
        _vm.$set(_vm.school, "Messages", $$v)
      },
      expression: "school.Messages"
    }
  }, _vm._l((_vm.parentMessages), function(message, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: key,
      attrs: {
        "disabled": key === 2,
        "label": key.toString()
      }
    }, [_vm._v(_vm._s(_vm.$t(message)))])], 1)
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('EXTRAFEATURES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SHOWNOTIFICATIONS')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Notification),
      callback: function($$v) {
        _vm.$set(_vm.school, "Notification", $$v)
      },
      expression: "school.Notification"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('DISABLE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENABLE')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INCLUDEWIOTBOX')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.WiotBox),
      callback: function($$v) {
        _vm.$set(_vm.school, "WiotBox", $$v)
      },
      expression: "school.WiotBox"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('DISABLE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENABLE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('MAXIMUMDURATION')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.school.Threshold.Duration),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Duration", $$v)
      },
      expression: "school.Threshold.Duration"
    }
  }, _vm._l((_vm.minutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('STANDINGINFRONTCHILDHOUSE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.school.Threshold.Standing),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Standing", $$v)
      },
      expression: "school.Threshold.Standing"
    }
  }, _vm._l((_vm.standingMinutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('DROPPEDOFINWRONGPLACE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMETERS')
    },
    model: {
      value: (_vm.school.Threshold.Dropped),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Dropped", $$v)
      },
      expression: "school.Threshold.Dropped"
    }
  }, _vm._l((_vm.meters), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('METER'),
        "value": num
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, key) {
    return _c('span', {
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError, key))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-reset"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(544)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "pass"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "left-start"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Use at least 8 characters including "), _c('u', [_vm._v("Lowercase, Uppercase Numbers "), _c('br'), _vm._v("and Special Characters")]), _vm._v(". Don’t use a password from another site, "), _c('br'), _vm._v("phrases from "), _c('u', [_vm._v("Username")]), _vm._v(" or something too obvious like your pet’s name.")]), _vm._v(" "), _c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pass", $$v)
      },
      expression: "ruleForm.pass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large",
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.passwordReset('ruleForm')
      }
    },
    model: {
      value: (_vm.ruleForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkPass", $$v)
      },
      expression: "ruleForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.pass),
      expression: "ruleForm.pass"
    }],
    ref: "meter",
    attrs: {
      "percentage": _vm.currentStrength.percentage,
      "status": _vm.currentStrength.status
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('div', {
    staticClass: "curve-down-area"
  }), _vm._v(" "), _c('div', {
    staticClass: "down-curve down-curve2"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-page-container"
  }, [_c('div', {
    staticClass: "form-reset"
  }, [_c('el-row', {
    staticClass: "submit_button"
  }, [_c('el-button', {
    staticClass: "btn-lg",
    staticStyle: {
      "margin-bottom": "10px",
      "width": "480px"
    },
    attrs: {
      "type": "submit",
      "size": "large"
    },
    domProps: {
      "textContent": _vm._s(_vm.changing ? 'Changing..' : 'Change Password')
    },
    on: {
      "click": function($event) {
        _vm.passwordReset('ruleForm')
      }
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Error",
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold"
    }, [_vm._v(_vm._s(messageError)), _c('br')])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "trip"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('BUSTRIPS')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-row', {
    ref: "filter",
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.tab = (_vm.tab == 1 ? 0 : 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.tab === 0 ? 'fa-list' : 'fa-map-marker']
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tab === 0 ? _vm.$t('LIST') : _vm.$t('MAP'))
    }
  })])], 1), _vm._v(" "), (_vm.tab === 0) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.active_trips() != 0) ? _c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SELECTROUTE')
    },
    on: {
      "change": _vm.routeChange
    },
    model: {
      value: (_vm.route),
      callback: function($$v) {
        _vm.route = $$v
      },
      expression: "route"
    }
  }, [_c('el-option', {
    staticClass: "route-select",
    attrs: {
      "value": -1
    }
  }, [_c('el-tag', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.selectAll() ? _vm.$t('UNCHECKALL') : _vm.$t('CHECKALL')))])], 1), _vm._v(" "), _vm._l((_vm.routes), function(item, key) {
    return (_vm.isLive(item)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item.TourName,
        "value": key
      }
    }, [_c('el-tag', {
      staticStyle: {
        "display": "block",
        "text-align": "center"
      },
      style: ('background-color:' + item.RouteColor)
    }, [_vm._v("\n              " + _vm._s(item.TourName) + "\n              "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.paths[item.TourID] != undefined),
        expression: "paths[item.TourID] !=undefined"
      }],
      staticClass: "fa fa-check"
    })])])], 1) : _vm._e()
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'direction') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYDIRECTION'),
      "clearable": ""
    },
    on: {
      "change": _vm.getFilteredTrips
    },
    model: {
      value: (_vm.Direction),
      callback: function($$v) {
        _vm.Direction = $$v
      },
      expression: "Direction"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('HOMETOSCHOOL')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('SCHOOLTOHOME')
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'monitor') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYMONITOR'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getFilteredTrips
    },
    model: {
      value: (_vm.BusMonitorID),
      callback: function($$v) {
        _vm.BusMonitorID = $$v
      },
      expression: "BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.FirstName_EN + ' ' + item.LastName_EN,
        "value": item.BusMonitorID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'date') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE'),
      "picker-options": _vm.pickerOption,
      "clearabble": _vm.checkToday()
    },
    on: {
      "change": function($event) {
        _vm.getFilteredTrips('date')
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "live-trip-btn",
    attrs: {
      "span": 6
    }
  }, [(_vm.tab === 1) ? _c('el-badge', {
    attrs: {
      "value": _vm.active_trips()
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": !_vm.is_live ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        _vm.btnGroup(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSEDTRIPS')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.is_live ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        _vm.btnGroup(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LIVETRIPS')))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 0),
      expression: "tab==0"
    }],
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.mapHeight + 'px'
    }),
    attrs: {
      "id": "live-gmap"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 1),
      expression: "tab==1"
    }],
    staticStyle: {
      "border-top": "1px solid #ddd"
    },
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('el-row', {
    staticStyle: {
      "height": "inherit"
    },
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "twocolumn",
    attrs: {
      "span": 12
    }
  }, [(_vm.listTrips['left'].length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NOANYWARNTRIPS')))])]) : _vm._e(), _vm._v(" "), _c('VuePerfectScrollbar', {
    ref: "ScrollbarLeft",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.listTrips['left']), function(trip, key) {
    return (_vm.is_live == !trip.IsClosed) ? _c('el-button', {
      key: key,
      staticClass: "trip-box",
      attrs: {
        "disabled": trip.disabledTrip,
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [(_vm.cachedDates['left'][trip.Date] == trip.TripID) ? _c('el-row', {
      staticClass: "row date-header"
    }, [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" " + _vm._s(_vm.tripDate(trip.Db_Date)))]) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": 2
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "activity",
      attrs: {
        "span": 5,
        "align": _vm.alignDirection('right')
      },
      nativeOn: {
        "mouseover": function($event) {
          trip.disabledTrip = true
        },
        "mouseleave": function($event) {
          trip.disabledTrip = false
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "trip",
        "trigger": "hover",
        "disabled": trip.activity.total_alerts == 0,
        "title": _vm.$t('TRIPALERTS'),
        "placement": "right-start",
        "width": "620"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_alerts,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-bell",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.alerts),
        "default-sort": {
          prop: 'Sent',
          order: 'descending'
        },
        "empty-text": _vm.$t('NOALERTS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "85",
        "label": _vm.$t('TYPE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.Event)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "130",
        "label": _vm.$t('OCCURED')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.EventType)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "195",
        "property": "Sent",
        "label": _vm.$t('DATE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Sent)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "show-overflow-tooltip": "",
        "label": _vm.$t('MESSAGE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.Text ? scope.row.Text : '-'))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.EntityID != null || scope.row.Event == 'INCIDENT') ? _c('el-button', {
            attrs: {
              "size": "mini",
              "loading": scope.row.EventID === _vm.sendingEvent
            },
            on: {
              "click": function($event) {
                _vm.activityInfo(scope.row, scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('MOREINFO')))]) : _vm._e()]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('el-popover', {
      attrs: {
        "trigger": "hover",
        "disabled": trip.activity.total_violations == 0,
        "title": _vm.$t('TRIPVIOLATIONS'),
        "placement": "right",
        "width": "450"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_violations,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-tachometer"
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.violations),
        "empty-text": _vm.$t('NOVIOLATIONS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "Type",
        "min-width": "115"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.incident_type)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": "185",
        "label": "Date"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Timestamp)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "145",
        "show-overflow-tooltip": "",
        "property": "Text",
        "label": "Message"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e(), _vm._v(" "), (trip.Db_Date === null) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('EXPECTEDTOSTART')) + " "), _c('span', {
      staticClass: "delayed pull-right"
    }, [_vm._v(_vm._s(_vm.$t('DELAYEDBY') + ' ' + _vm.delayed_time(trip)))])]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "twocolumn",
    attrs: {
      "span": 12
    }
  }, [(_vm.listTrips['right'].length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NOANYCLEANTRIPS')))])]) : _vm._e(), _vm._v(" "), _c('VuePerfectScrollbar', {
    ref: "ScrollbarRight",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.listTrips['right']), function(trip, key) {
    return (_vm.is_live == !trip.IsClosed) ? _c('el-button', {
      key: key,
      staticClass: "trip-box",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [(_vm.cachedDates['right'][trip.Date] == trip.TripID) ? _c('el-row', {
      staticClass: "row date-header"
    }, [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" " + _vm._s(_vm.tripDate(trip.Db_Date)))]) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": 4
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 14,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }))])], 1)], 1)], 1), _vm._v(" "), (_vm.tab == 1 && _vm.paginationHeight != 0) ? _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px",
      "border-top": "1px solid #ddd"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalTrips
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.event,
      "alert": _vm.notifyAlert,
      "visible": _vm.eventVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.eventVisible = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card message",
    attrs: {
      "height": "335",
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.$t('MESSAGES')))]), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('WRITEAMESSAGE'),
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.messageBox = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment fa-2x"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.message_loading),
      expression: "message_loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listMessages,
      "row-class-name": "pointer-hover",
      "height": 340,
      "stripe": ""
    },
    on: {
      "current-change": _vm.selectedConversation
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "media"
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.monitor.ImagePath, 'supervisor')
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-body"
        }, [_vm._v("\n                    " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        })) + "\n                    "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s((scope.row.time_ago.split(' ').length === 1) ? _vm.$t(scope.row.time_ago.split(' ')[0]) : _vm.$t(scope.row.time_ago.split(' ')[1], {
          var: scope.row.time_ago.split(' ')[0]
        })))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.readMore(scope.row.Text)) + "\n                ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', 'report/message')
    },
    on: {
      "click": function($event) {
        _vm.viewMore('message')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card violation",
    attrs: {
      "height": "335",
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    class: 'fa ' + (_vm.wiot_box == 1 ? 'fa-tachometer' : 'fa-user-times')
  }), _vm._v(" " + _vm._s(_vm.$t(_vm.wiot_box != 1 ? 'SCHOOLANDBUSABSENCES' : 'BUSVIOLATIONSANDALARMS')))]), _vm._v(" "), (_vm.wiot_box != 1) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('SWITCHTOABSENCES', {
        var: _vm.$t(_vm.absenceFrom == 'bus' ? 'SCHOOL' : 'BUS')
      }),
      "placement": "top"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.switchTo()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.absenceFrom !== 'bus' ? 'fa-university' : 'fa-bus']
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.absenceFrom !== 'bus' ? _vm.$t('SCHOOL') : _vm.$t('BUS'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.wiot_box != 1) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.absence_loading),
      expression: "absence_loading"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listAbsences,
      "row-class-name": "pointer-hover",
      "highlight-current-row": "",
      "height": 340,
      "stripe": ""
    },
    on: {
      "row-click": _vm.showAbsence
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "175",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "49px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DATE'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.date_format(scope.row.AbsentDate))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t(_vm.absenceFrom == 'bus' ? 'PICK-UP/DROP-OFF' : 'REASON'),
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s((_vm.absenceFrom == 'bus' ? _vm.$t(scope.row.Direction.title) : _vm.$t(scope.row.Reason.toUpperCase()))) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('REPORTEDBY'),
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t(scope.row.ReportedBy)))])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.wiot_box == 1) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.violation_loading),
      expression: "violation_loading"
    }],
    attrs: {
      "data": _vm.violations,
      "element-loading-text": _vm.$t('LOADING'),
      "height": 340,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "bus_plate",
      "label": _vm.$t('BUS'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.busNumber)), _c('br'), _c('small', [_vm._v(_vm._s(scope.row.datetime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('VIOLATION'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.$t(scope.row.Label)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/violation')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, scope.$index, 'violation')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsHidden ? _vm.$t('SHOW') : _vm.$t('HIDE'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/violation')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.hideItem(scope.row, scope.$index, 'violation')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsHidden ? 'fa-eye-slash' : 'fa-eye']
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', _vm.wiot_box == 1 ? 'report/violation' : 'attendance/absence')
    },
    on: {
      "click": function($event) {
        _vm.viewMore(_vm.wiot_box == 1 ? 'violation' : 'absence')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card incident",
    attrs: {
      "height": 335,
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.$t('INCIDENTS')))])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.incident_loading),
      expression: "incident_loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.incidents,
      "height": 340,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": _vm.$t('BUSSUPERVISOR')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                     " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        }))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.incident_date(scope.row.Timestamp)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                        " + _vm._s(scope.row.student_id.length) + "\n                                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.status[scope.row.statusColor]
          }
        }, [_vm._v("\n                                            " + _vm._s(_vm.reportStatus[scope.row.statusColor]) + "\n                                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('VIEWINCIDENTDETAILS'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              _vm.showIncident(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" " + _vm._s(_vm.$t('DETAILS')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/incident')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, scope.$index, 'incident')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', 'report/incident')
    },
    on: {
      "click": function($event) {
        _vm.viewMore('incident')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card transport",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" " + _vm._s(_vm.$t('BUSTRIPS')))]), _vm._v(" "), (_vm.delayed_trips != 0) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('SWITCHTO', {
        var: _vm.$t(!_vm.started_mode ? 'ACTIVE' : 'DELAYED')
      }),
      "placement": "top"
    }
  }, [(_vm.delayed_trips != 0) ? _c('el-badge', {
    staticClass: "trip-badge",
    attrs: {
      "value": _vm.delayedCount,
      "hidden": !_vm.started_mode
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.started_mode = !_vm.started_mode
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t(!_vm.started_mode ? 'ACTIVE' : 'DELAYED'))
    }
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.trip_loading),
      expression: "trip_loading"
    }],
    staticStyle: {
      "height": "340px"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('VuePerfectScrollbar', {
    style: ({
      height: '340px'
    })
  }, [_vm._l((_vm.sortedTrips), function(trip, index) {
    return (_vm.sortedTrips.length > 0) ? _c('el-button', {
      key: index,
      staticClass: "trip-box",
      attrs: {
        "disabled": trip.disabledTrip,
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [_c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": _vm.showActivity(trip.activity) ? 2 : 4
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), (_vm.showActivity(trip.activity)) ? _c('el-col', {
      staticClass: "activity",
      attrs: {
        "span": 5,
        "align": _vm.alignDirection('right')
      },
      nativeOn: {
        "mouseover": function($event) {
          trip.disabledTrip = true
        },
        "mouseleave": function($event) {
          trip.disabledTrip = false
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "trigger": "hover",
        "disabled": trip.activity.total_violations == 0,
        "title": _vm.$t('TRIPVIOLATIONS'),
        "placement": "right",
        "width": "450"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_violations,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-tachometer"
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.violations),
        "empty-text": _vm.$t('NOVIOLATIONS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "Type",
        "min-width": "115"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.incident_type)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": "185",
        "label": "Date"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Timestamp)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "145",
        "show-overflow-tooltip": "",
        "property": "Text",
        "label": "Message"
      }
    })], 1)], 1), _vm._v(" "), _c('el-popover', {
      attrs: {
        "popper-class": "trip",
        "trigger": "hover",
        "disabled": trip.activity.total_alerts == 0,
        "title": _vm.$t('TRIPALERTS'),
        "placement": "right-start",
        "width": "620"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_alerts,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-bell",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.alerts),
        "default-sort": {
          prop: 'Sent',
          order: 'descending'
        },
        "empty-text": _vm.$t('NOALERTS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "85",
        "label": _vm.$t('TYPE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.Event)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "130",
        "label": _vm.$t('OCCURED')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.EventType)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "195",
        "property": "Sent",
        "label": _vm.$t('DATE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Sent)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "show-overflow-tooltip": "",
        "label": _vm.$t('MESSAGE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.Text ? scope.row.Text : '-'))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.EntityID != null || scope.row.Event == 'INCIDENT') ? _c('el-button', {
            attrs: {
              "size": "mini",
              "loading": scope.row.EventID === _vm.sendingEvent
            },
            on: {
              "click": function($event) {
                _vm.activityInfo(scope.row, scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('MOREINFO')))]) : _vm._e()]
        }
      }])
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": _vm.showActivity(trip.activity) ? 11 : 14,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e(), _vm._v(" "), (trip.Db_Date === null) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('EXPECTEDTOSTART')) + " "), _c('span', {
      staticClass: "delayed pull-right"
    }, [_vm._v(_vm._s(_vm.$t('DELAYEDBY') + ' ' + _vm.delayed_time(trip)))])]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.sortedTrips.length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NODATA')))])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.viewMore('trip')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])])], 1)], 1), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "selected-student": _vm.absence_student,
      "visible": _vm.absenceBox
    },
    on: {
      "update": _vm.updateAbsence,
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "alert": _vm.notifyAlert,
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "deleteIncident": _vm.deleteIncident,
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-resize-bar"
  }, [_c('div', {
    staticClass: "g-resize-highlight",
    style: ({
      width: _vm.left + '%',
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "circle-btn",
    style: ({
      left: _vm.left + '%',
    }),
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('IMPORTDATA'),
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "id": "import"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px",
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.$t('IMPORT') + ' ' + _vm.title))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "36px",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning text-danger"
  }), _vm._v(" " + _vm._s(_vm.$t('REQUIREDFIELDS')))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "field",
      "placeholder": _vm.$t('SELECTFIELD')
    },
    model: {
      value: (_vm.importField),
      callback: function($$v) {
        _vm.importField = $$v
      },
      expression: "importField"
    }
  }, _vm._l((_vm.fields), function(item, key) {
    return (_vm.isSet(item.field)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item.label,
        "value": item
      }
    }, [_vm._v("\n    " + _vm._s(item.label) + " "), (item.required) ? _c('i', {
      staticClass: "el-icon-warning text-danger",
      staticStyle: {
        "float": "right"
      }
    }) : _vm._e()]) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": !_vm.importField,
      "placeholder": _vm.$t('SELECTFIELDVALUE')
    },
    on: {
      "change": _vm.setValue
    },
    model: {
      value: (_vm.importValue),
      callback: function($$v) {
        _vm.importValue = $$v
      },
      expression: "importValue"
    }
  }, _vm._l((_vm.csv_reader), function(value, key) {
    return (_vm.isSet(key, true)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": key + ':' + value,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "-10px",
      "margin-top": "10px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": 400,
      "highlight-current-row": "",
      "stripe": "",
      "data": _vm.importData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "min-width": "120",
      "label": _vm.$t('DATAFIELDTYPE')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "min-width": "130",
      "label": _vm.$t('DATAVALUE')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "csv_field",
      "min-width": "140",
      "label": _vm.$t('CSVCOLUMN')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('FORMAT'),
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.format) ? _c('span', [_vm._v(_vm._s(_vm.$t('N/A')))]) : _vm._e(), _vm._v(" "), (scope.row.format) ? _c('el-select', {
          attrs: {
            "placeholder": _vm.$t('SELECTFORMAT')
          },
          model: {
            value: (scope.row.format_value),
            callback: function($$v) {
              _vm.$set(scope.row, "format_value", $$v)
            },
            expression: "scope.row.format_value"
          }
        }, _vm._l((_vm.formats[scope.row.format]), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.value,
              "value": item.format
            }
          })
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "close"
          },
          on: {
            "click": function($event) {
              _vm.resetValue(scope.row.field)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/import',
      "headers": {
        'Accept-Language': _vm.currentLang()
      },
      "on-success": _vm.uploadedFile
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelImport
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.required_fields != 0,
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.startImporting
    }
  }, [_vm._v(_vm._s(_vm.importing ? _vm.$t('IMPORTINGDATA') : _vm.$t('STARTIMPORTING')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-aside"
  }, [_c('div', {
    staticClass: "g-crop-image-box"
  }, [_c('div', {
    staticClass: "g-crop-image-principal",
    on: {
      "touchstart": _vm.drag,
      "mousedown": _vm.drag
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      backgroundImage: 'url(' + _vm.src + ')',
      cursor: _vm.isResize ? 'default' : 'move'
    })
  }, [_c('img', {
    ref: "crop-image",
    staticStyle: {
      "width": "0",
      "height": "0"
    },
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "image-mask"
  }, [_c('div', {
    staticClass: "mask top",
    style: ({
      top: 0,
      height: _vm.cropCSS.top + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask bottom",
    style: ({
      bottom: 0,
      top: (_vm.cropCSS.top + _vm.cropCSS.height) + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: 0,
      width: _vm.cropCSS.left + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: (_vm.cropCSS.left + _vm.cropCSS.width) + 'px',
      right: 0
    })
  })]) : _vm._e(), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "crop-box",
    style: ({
      top: _vm.cropCSS.top + 'px',
      left: _vm.cropCSS.left + 'px',
      height: _vm.cropCSS.height + 'px',
      width: _vm.cropCSS.width + 'px'
    })
  }, [_c('div', {
    staticClass: "reference-line v"
  }), _vm._v(" "), _c('div', {
    staticClass: "reference-line h"
  }), _vm._v(" "), _c('a', {
    staticClass: "g-resize",
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resize($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resize($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.resize) ? _c('resize-bar', {
    ref: "resizeBar",
    on: {
      "resize": _vm.resizeImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRotate) ? _c('rotate-bar', {
    on: {
      "rotate": _vm.rotateImage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEGUARDIANS')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/school/guardian/create'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWGUARDIAN')) + "\n          ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('UPLOADCSVFILE')) + "\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHGUARDIAN'),
      "icon": _vm.FullName == '' ? '' : 'circle-close',
      "on-icon-click": _vm.clearInput
    },
    on: {
      "change": function($event) {
        _vm.getGuardians(true)
      }
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHPERSONID'),
      "icon": _vm.PersonID == '' ? '' : 'circle-close',
      "on-icon-click": _vm.clearInput
    },
    on: {
      "change": function($event) {
        _vm.getGuardians(true)
      }
    },
    model: {
      value: (_vm.PersonID),
      callback: function($$v) {
        _vm.PersonID = $$v
      },
      expression: "PersonID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'mobile') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHMOBILENO'),
      "icon": _vm.MobileNo == '' ? '' : 'circle-close',
      "on-icon-click": _vm.clearInput
    },
    on: {
      "change": function($event) {
        _vm.getGuardians(true)
      }
    },
    model: {
      value: (_vm.MobileNo),
      callback: function($$v) {
        _vm.MobileNo = $$v
      },
      expression: "MobileNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'relation') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SEARCHBYRELATION'),
      "filterable": true,
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getGuardians(true)
      }
    },
    model: {
      value: (_vm.Relation),
      callback: function($$v) {
        _vm.Relation = $$v
      },
      expression: "Relation"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('FATHER'),
      "value": "Father"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('MOTHER'),
      "value": "Mother"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('GUARDIAN'),
      "value": "Guardian"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'status') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SEARCHBYSTATUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getGuardians(true)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('ACTIVE'),
      "value": "1"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ACTIVE')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('INACTIVE'),
      "value": "2"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "danger",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('INACTIVE')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listGuardians,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', _vm._l((props.row.students), function(student, index) {
          return _c('div', {
            key: index,
            staticClass: "expanded-student el-col el-col-4",
            attrs: {
              "span": 4
            },
            on: {
              "click": function($event) {
                _vm.$router.push('/school/student/' + student.StudentID)
              }
            }
          }, [_c('img', {
            staticClass: "img-circle",
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": _vm.getAsset(student.ImagePath, 'student'),
              "alt": ""
            }
          }), _c('br'), _vm._v("\n              " + _vm._s(_vm._FullName({
            NameEN: student.FullName_EN,
            NameAR: student.FullName_AR
          })) + "\n          ")])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalPersonID",
      "label": _vm.$t('PERSONID'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n\n\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MobilePhone",
      "label": _vm.$t('MOBILENO'),
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('RELATION'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.$t(scope.row.Relation)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDMESSAGE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showMessageModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-comment"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITPERSON'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/school/guardian/' + scope.row.PersonID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.listGuardians[scope.$index].Status == 0 ? _vm.$t('DEACTIVATEPERSON') : _vm.$t('ACTIVATEPERSON'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.guardian = _vm.listGuardians[scope.$index]
            }
          },
          model: {
            value: (_vm.listGuardians[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.listGuardians[scope.$index], "Deleted", $$v)
            },
            expression: "listGuardians[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + " " + _vm._s(_vm.listGuardians[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISSTUDENT') : _vm.$t('RESTORETHISSTUDENT')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.listGuardians[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkRoute(scope.$index)
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.Status != 0 ? 'fa-undo' : 'fa-times']
        })])], 1)], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalGuardians
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox,
      "showRemove": false,
      "studentList": _vm.students,
      "parent": _vm.guardian
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('GUARDIANS'),
      "uri": "guardian/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.getGuardians,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-rotate-bar"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateLeft
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M281.7,243.8V138.2c75.9,13.5,135.4,78.6,135.4,159.8s-59.6,146.3-135.4,159.8V512\n        c105.7-13.5,189.6-102.9,189.6-214s-84-200.5-189.6-214V0L159.8,121.9L281.7,243.8z M94.8,270.9c2.7-24.4,13.5-46.1,27.1-67.7\n        L84,165.2C59.6,197.8,46.1,233,40.6,270.9H94.8z M159.8,430.7l-37.9,37.9c32.5,24.4,67.7,37.9,105.7,43.3v-54.2\n        C203.2,455.1,181.5,444.3,159.8,430.7z M94.8,325.1H40.6c2.7,37.9,19,73.1,43.3,105.7l37.9-37.9\n        C108.4,371.1,97.5,349.5,94.8,325.1z",
      "fill": "#27ae60"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateRight
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M331.5,114.75L216.75,0v79.05C117.3,91.8,38.25,175.95,38.25,280.5s79.05,188.7,178.5,201.45v-51    C145.35,418.2,89.25,357,89.25,280.5s56.1-137.7,127.5-150.45v99.45L331.5,114.75z M443.7,255    c-5.101-35.7-17.851-68.85-40.8-99.45l-35.7,35.7c12.75,20.4,22.95,40.8,25.5,63.75H443.7z M267.75,430.95v51    c35.7-5.101,68.85-17.851,99.45-40.8l-35.7-35.7C311.1,418.2,290.7,428.4,267.75,430.95z M367.2,369.75l35.7,35.7    c22.949-30.601,38.25-63.75,40.8-99.45h-51C390.15,328.95,379.95,349.35,367.2,369.75z",
      "fill": "#27ae60"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "messageDialog",
      "size": "small",
      "show-close": false,
      "title": _vm.$t('COMPOSEMESSAGE'),
      "visible": _vm.messageBox
    },
    on: {
      "close": _vm.clearCompose,
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }, [_c('el-form', [(!_vm.message && _vm.showRemove) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTRECIPIENT')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTRECIPIENT')
    },
    on: {
      "change": function($event) {
        _vm.compose.RecipientID = ''
      }
    },
    model: {
      value: (_vm.compose.Recipient),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Recipient", $$v)
      },
      expression: "compose.Recipient"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": _vm.$t('RECIPIENT0')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('RECIPIENT1')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('RECIPIENT2')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": _vm.$t('RECIPIENT3')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": _vm.$t('RECIPIENT4')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": _vm.$t('RECIPIENT5')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": _vm.$t('RECIPIENT6')
    }
  })], 1)], 1), _vm._v(" "), (_vm.compose.Recipient == 2) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTGRADE')
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "GradeID",
      "placeholder": _vm.$t('SELECTGRADE'),
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.classID = null
      }
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(grade, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": grade.Name,
        "value": grade
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.compose.Recipient == 2 && _vm.compose.RecipientID) ? _c('el-form-item', {
    staticClass: "classes",
    attrs: {
      "label": _vm.$t('SELECTCLASS')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.classID),
      callback: function($$v) {
        _vm.classID = $$v
      },
      expression: "classID"
    }
  }, _vm._l((_vm.Grade.Classes), function(cls, index) {
    return (cls) ? _c('el-radio-button', {
      key: index,
      attrs: {
        "label": cls
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.compose.Recipient == 3 && _vm.buses != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTBUS')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": ""
    },
    model: {
      value: (_vm.compose.RecipientID),
      callback: function($$v) {
        _vm.$set(_vm.compose, "RecipientID", $$v)
      },
      expression: "compose.RecipientID"
    }
  }, _vm._l((_vm.buses[4]), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.BusID,
        "label": item.bus_number
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(item.bus_number) + "-" + _vm._s(item.TourName))])])
  }))], 1) : _vm._e(), _vm._v(" "), ((_vm.compose.Recipient == 4 || _vm.compose.Recipient == 5) && _vm.buses != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTBUSROUTE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUSROUTE'),
      "filterable": ""
    },
    on: {
      "visible-change": function($event) {
        _vm.getBoardedTrips()
      }
    },
    model: {
      value: (_vm.compose.RecipientID),
      callback: function($$v) {
        _vm.$set(_vm.compose, "RecipientID", $$v)
      },
      expression: "compose.RecipientID"
    }
  }, _vm._l((_vm.buses[5]), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.bus_number,
        "value": item.TripID
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(item.bus_number) + "-" + _vm._s(item.TourName))])])
  }))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.compose.Recipient == 6 && (_vm.person || _vm.message || (!_vm.message && _vm.showRemove))),
      expression: "compose.Recipient==6 && (person || message || (!message && showRemove))"
    }],
    staticClass: "box-card",
    attrs: {
      "body-style": {
        display: (_vm.message || (!_vm.message && _vm.showRemove)) ? '' : 'none'
      }
    }
  }, [(_vm.person) ? _c('div', {
    staticClass: "media",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.person.ImagePath, (_vm.person.Relation == null || _vm.person.Relation == '' ? 'supervisor' : 'guardian'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("\n                      " + _vm._s(_vm._FullName({
    NameEN: _vm.person.FullName_EN,
    NameAR: _vm.person.FullName_AR
  })) + "\n                      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.person && _vm.showRemove),
      expression: "person && showRemove"
    }],
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-remove",
    on: {
      "click": _vm.clearInput
    }
  })]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s((_vm.person.Relation == null || _vm.person.Relation == '') ? _vm.$t('BUSSUPERVISOR') : _vm.$t(_vm.person.Relation)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }]
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('CONVERSATION')))]), _vm._v(" "), _c('br'), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.message.Text)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.message && _vm.showRemove),
      expression: "!message && showRemove"
    }]
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHPERSONNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.addPerson
    },
    model: {
      value: (_vm.personName),
      callback: function($$v) {
        _vm.personName = $$v
      },
      expression: "personName"
    }
  })], 1)]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.compose.Recipient == 6 && _vm.students.length != 0),
      expression: "compose.Recipient==6 && students.length!=0"
    }],
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('MESSAGEFOR')))]), _vm._v(" "), _vm._l((_vm.students), function(student, key) {
    return _c('el-collapse-transition', {
      key: key
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showStudentsList(student.StudentID)),
        expression: "showStudentsList(student.StudentID)"
      }],
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "media-object img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(student.ImagePath, 'student')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v("\n                              " + _vm._s(_vm._FullName({
      NameEN: student.FullName_EN,
      NameAR: student.FullName_AR
    })) + "\n                              "), (_vm.students.length > 1) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('LISTALLSTUDENTS'),
        "placement": "top",
        "effect": "light"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showStudentsList(student.StudentID, true)),
        expression: "showStudentsList(student.StudentID, true)"
      }],
      staticStyle: {
        "padding-right": "8px"
      },
      attrs: {
        "type": "text",
        "icon": "arrow-down"
      },
      on: {
        "click": function($event) {
          _vm.compose.RecipientID = null
        }
      }
    })], 1), _vm._v(" "), _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": student.StudentID
      },
      model: {
        value: (_vm.compose.RecipientID),
        callback: function($$v) {
          _vm.$set(_vm.compose, "RecipientID", $$v)
        },
        expression: "compose.RecipientID"
      }
    }, [_c('small', [_vm._v(_vm._s(student.IsMain != null ? '' : _vm.$t('NOT')) + " " + _vm._s(_vm.$t('PRIMARY')))])])], 1) : _vm._e()])])])])])
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "compose",
    attrs: {
      "body-style": {
        padding: '8px'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "slot": "header",
      "type": "textarea",
      "maxlength": 256,
      "rows": 8,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    slot: "header",
    model: {
      value: (_vm.compose.Text),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Text", $$v)
      },
      expression: "compose.Text"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    attrs: {
      "on-success": _vm.updateFile,
      "before-upload": _vm.beforeUpload,
      "on-progress": _vm.limitFile,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "action": _vm.URL + 'media/upload',
      "data": {
        folder: 'message',
        type: 'attachment'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.$t('ATTACHMENT')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('FILESWITHASIZE')) + " ")])], 1)], 1), _vm._v(" "), (_vm.attached != null) ? _c('el-col', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-tag', {
    attrs: {
      "closable": _vm.attached,
      "type": _vm.attached ? 'success' : 'primary'
    },
    on: {
      "close": function($event) {
        _vm.handleRemove()
      }
    }
  }, [_c('i', {
    class: {
      'el-icon-loading': !_vm.attached
    }
  }), _vm._v(" " + _vm._s(_vm.attached ? _vm.compose.Attachment.Filename : _vm.$t('ATTACHING')))])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.attached != null ? 6 : 16
    }
  }, [_c('h5', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHARACTERSREMAINING')) + " "), _c('span', {
    staticClass: "text-right",
    domProps: {
      "textContent": _vm._s(_vm.textLimit())
    }
  }, [_vm._v("256")])])])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.messageBox = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.validateInput(),
      "loading": _vm.loadingSend
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('SEND')))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "small"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.errorMessage), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEBUSES')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/transportation/bus/create'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWBUS')) + "\n          ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('UPLOADCSVFILE')) + "\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'model') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHMODEL'),
      "icon": _vm.Model ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.Model),
      callback: function($$v) {
        _vm.Model = $$v
      },
      expression: "Model"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'label') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHBUS'),
      "icon": _vm.Label ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.Label),
      callback: function($$v) {
        _vm.Label = $$v
      },
      expression: "Label"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'plate') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHPLATE'),
      "icon": _vm.Plate ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.Plate),
      callback: function($$v) {
        _vm.Plate = $$v
      },
      expression: "Plate"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listBuses,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "Label",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Model",
      "label": _vm.$t('MODEL'),
      "min-width": "100",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Year",
      "label": _vm.$t('YEAR'),
      "min-width": "90",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Plate",
      "label": _vm.$t('PLATENUMBER'),
      "min-width": "140",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MaxSeats",
      "label": _vm.$t('SEATS'),
      "align": "center",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RegistrationExpiration",
      "label": _vm.$t('EXPIRATIONDATE'),
      "min-width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('DOCUMENTS'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "disabled": _vm.checkToView(scope.row.Documents),
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.openSlider(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sticky-note"
        }), _vm._v(" " + _vm._s(_vm.$t('VIEW')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "align": "center",
      "min-width": "95",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ASSIGNEDTOBUS'),
      "min-width": "165",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.RouteID !== null ? _vm.$t('ASSIGNED') : _vm.$t('NOTASSIGNED')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITBUS'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/bus/' + scope.row.BusID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "disabled": scope.row.RouteID != null ? true : false,
            "content": _vm.buses[scope.$index].Status == 0 ? _vm.$t('DEACTIVATEBUS') : _vm.$t('ACTIVATEBUS'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.bus = _vm.buses[scope.$index]
            }
          },
          model: {
            value: (_vm.buses[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.buses[scope.$index], "Deleted", $$v)
            },
            expression: "buses[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(_vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + _vm._s(_vm.buses[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISBUS') : _vm.$t('RESTORETHISBUS')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.buses[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "disabled": scope.row.RouteID != null,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.buses[scope.$index].Deleted = true
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.Status != 0 ? 'fa-undo' : 'fa-times']
        })])], 1)], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-doc-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "document": _vm.bus.Documents
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('BUSES'),
      "uri": "bus/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.reCall,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'contactForm', 'relationForm'],
      "title": _vm.$t('MANAGEGUARDIAN'),
      "data": {
        person: this.guardian,
        students: this.students,
        contact: this.contact
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.guardian,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.guardian
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('RELATION'),
      "prop": "Relation",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.guardian.Relation),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "Relation", $$v)
      },
      expression: "guardian.Relation"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Father"
    }
  }, [_vm._v(_vm._s(_vm.$t('FATHER')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Mother"
    }
  }, [_vm._v(_vm._s(_vm.$t('MOTHER')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Guardian"
    }
  }, [_vm._v(_vm._s(_vm.$t('GUARDIAN')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "FirstName_EN", $$v)
      },
      expression: "guardian.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "FirstName_AR", $$v)
      },
      expression: "guardian.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "MiddleName", $$v)
      },
      expression: "guardian.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "MiddleName_AR", $$v)
      },
      expression: "guardian.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "LastName_EN", $$v)
      },
      expression: "guardian.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "LastName_AR", $$v)
      },
      expression: "guardian.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDNUMBER'),
      "prop": "ExternalPersonID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('IDNUMBER') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.guardian.ExternalPersonID),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "ExternalPersonID", $$v)
      },
      expression: "guardian.ExternalPersonID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDEXPIRATIONDATE'),
      "prop": "IDExpiration",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "picker-options": _vm.pickerOption,
      "format": _vm.date_format
    },
    model: {
      value: (_vm.guardian.IDExpiration),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "IDExpiration", $$v)
      },
      expression: "guardian.IDExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.guardian.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.guardian, "Nationality", $$v)
      },
      expression: "guardian.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTINFO')
    }
  }, [_c('el-form', {
    ref: "contactForm",
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    },
    attrs: {
      "model": _vm.contact,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MOBILEPHONE'),
      "prop": "MobilePhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "MobilePhone", $$v)
      },
      expression: "contact.MobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('EMAILADDRESS'),
      "prop": "EMail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('EMAILADDRESS') + ' ' + _vm.$t('ALREADYEXISTED')
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.EMail),
      callback: function($$v) {
        _vm.$set(_vm.contact, "EMail", $$v)
      },
      expression: "contact.EMail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LANDLINEPHONE'),
      "prop": "LandlinePhone",
      "rules": {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.LandlinePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "LandlinePhone", $$v)
      },
      expression: "contact.LandlinePhone"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('STUDENTSRELATIONSHIP')
    }
  }, [_c('el-form', {
    ref: "relationForm",
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    },
    attrs: {
      "labelSuffix": _vm.$t('GUARDIAN'),
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "student",
      "rules": [{
        validator: _vm.hasRelation,
        message: _vm.$t('ISREQUIREDTOADDSTUDENT'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHSTUDENTNAME'),
      "disabled": !_vm.guardian.Relation,
      "icon": "search"
    },
    on: {
      "select": _vm.addStudent
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })], 1), _vm._v(" "), (!_vm.guardian.Relation) ? _c('span', [_vm._v(_vm._s(_vm.$t('MAKESUREYOUSELECTEDRELATION')))]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.students,
      "highlight-current-row": "",
      "height": _vm.cardHeight - 118,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n              " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PRIMARYCONTACT'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.IsMain === null ? _vm.$t('NOT') : '')
          }
        }), _vm._v(" " + _vm._s(_vm.$t('PRIMARY')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.guardian.PersonID !== undefined),
            expression: "guardian.PersonID!==undefined"
          }],
          staticClass: "fa fa-2x",
          class: scope.row.deleted ? 'fa-undo' : 'fa-remove',
          on: {
            "click": function($event) {
              scope.row.deleted = !scope.row.deleted
            }
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Messages"
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, key) {
    return _c('span', {
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError, key))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'accountForm', 'contactForm'],
      "title": _vm.$t('MANAGEUSER'),
      "data": {
        person: this.person,
        user: this.user,
        contact: this.contact
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.person,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDER'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.person.Gender),
      callback: function($$v) {
        _vm.$set(_vm.person, "Gender", $$v)
      },
      expression: "person.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('FIRSTNAME')
    },
    model: {
      value: (_vm.person.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_EN", $$v)
      },
      expression: "person.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('FIRSTNAME(ARABIC)')
    },
    model: {
      value: (_vm.person.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_AR", $$v)
      },
      expression: "person.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('FATHERNAME')
    },
    model: {
      value: (_vm.person.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName", $$v)
      },
      expression: "person.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('FATHERNAME(ARABIC)')
    },
    model: {
      value: (_vm.person.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName_AR", $$v)
      },
      expression: "person.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('LASTNAME')
    },
    model: {
      value: (_vm.person.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_EN", $$v)
      },
      expression: "person.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('LASTNAME(ARABIC)')
    },
    model: {
      value: (_vm.person.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_AR", $$v)
      },
      expression: "person.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDNUMBER'),
      "prop": "ExternalPersonID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('IDNUMBER') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        max: 18,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 18
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('IDNUMBER')
    },
    model: {
      value: (_vm.person.ExternalPersonID),
      callback: function($$v) {
        _vm.$set(_vm.person, "ExternalPersonID", $$v)
      },
      expression: "person.ExternalPersonID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDEXPIRATIONDATE'),
      "prop": "IDExpiration",
      "rules": {
        required: false,
        type: 'date',
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": "dd/MM/yyyy",
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.person.IDExpiration),
      callback: function($$v) {
        _vm.$set(_vm.person, "IDExpiration", $$v)
      },
      expression: "person.IDExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.person.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.person, "Nationality", $$v)
      },
      expression: "person.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ACCOUNTLOGIN')
    }
  }, [_c('el-form', {
    ref: "accountForm",
    attrs: {
      "model": _vm.user,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('USERNAME(EMAILADDRESS)'),
      "prop": "UserID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('USERNAME(EMAILADDRESS)') + ' ' + _vm.$t('ALREADYEXISTED')
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('ENTERUSERNAME')
    },
    model: {
      value: (_vm.user.UserID),
      callback: function($$v) {
        _vm.$set(_vm.user, "UserID", $$v)
      },
      expression: "user.UserID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.person.PersonID) === parseInt(_vm.loggedInUserID)),
      expression: "parseInt(person.PersonID) === parseInt(loggedInUserID)"
    }],
    attrs: {
      "label": _vm.$t('CHANGEPASSWORD'),
      "prop": "Password",
      "rules": {
        validator: _vm.passwordValidation,
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "disabled": _vm.editPassword,
      "icon": _vm.editPassword ? 'edit' : 'circle-close',
      "on-icon-click": _vm.changePassword,
      "placeholder": _vm.$t('ENTERPASSWORD')
    },
    model: {
      value: (_vm.renderPwd),
      callback: function($$v) {
        _vm.renderPwd = $$v
      },
      expression: "renderPwd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ROLE'),
      "prop": "Level",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    staticClass: "role",
    attrs: {
      "disabled": parseInt(_vm.person.PersonID) === parseInt(_vm.loggedInUserID)
    },
    model: {
      value: (_vm.user.Level),
      callback: function($$v) {
        _vm.$set(_vm.user, "Level", $$v)
      },
      expression: "user.Level"
    }
  }, _vm._l((_vm.levels), function(level, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": level.name,
        "value": level.id
      }
    }, [_c('span', [_vm._v(_vm._s(level.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.$t('LEVEL') + ' ' + level.id))])])
  }))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTINFO')
    }
  }, [_c('el-form', {
    ref: "contactForm",
    attrs: {
      "model": _vm.contact,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MOBILENO'),
      "prop": "MobilePhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "MobilePhone", $$v)
      },
      expression: "contact.MobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "hidden",
      "value": _vm.user.UserID
    },
    model: {
      value: (_vm.contact.EMail),
      callback: function($$v) {
        _vm.$set(_vm.contact, "EMail", $$v)
      },
      expression: "contact.EMail"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LANDLINEPHONE'),
      "prop": "LandlinePhone",
      "rules": {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.LandlinePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "LandlinePhone", $$v)
      },
      expression: "contact.LandlinePhone"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEABSENCES')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isAllowed('save'),
      "icon": "plus"
    },
    on: {
      "click": _vm.addAbsence
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDNEWABSENCE')))])], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.switchTo()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.absenceFrom !== 'bus' ? 'fa-university' : 'fa-bus']
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.absenceFrom !== 'bus' ? _vm.$t('SCHOOL') : _vm.$t('BUS'))
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'reason') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYREASON'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getAbsences(true)
      }
    },
    model: {
      value: (_vm.Reason),
      callback: function($$v) {
        _vm.Reason = $$v
      },
      expression: "Reason"
    }
  }, _vm._l((_vm.reasons), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'date') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "change": function($event) {
        _vm.getAbsences(true)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHSTUDENTNAME'),
      "icon": _vm.FullName ? 'circle-cross' : '',
      "on-icon-click": _vm.removeNameFilter
    },
    on: {
      "select": _vm.searchStudent
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listAbsences,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DATE'),
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.date_format(scope.row.AbsentDate))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": (_vm.absenceFrom == 'bus' ? _vm.$t('PICK-UP/DROP-OFF') : _vm.$t('REASON')),
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s((_vm.absenceFrom == 'bus' ? _vm.$t(scope.row.Direction.title) : _vm.$t(scope.row.Reason))) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Grade",
      "label": _vm.$t('GRADE'),
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Class",
      "label": _vm.$t('CLASS'),
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('REPORTEDBY'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t(scope.row.ReportedBy)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDMESSAGE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showMessageModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-envelope"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITABSENCE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showAbsence(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEABSENCE'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.student = _vm.listAbsences[scope.$index]
            }
          },
          model: {
            value: (_vm.listAbsences[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.listAbsences[scope.$index], "Deleted", $$v)
            },
            expression: "listAbsences[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + " " + _vm._s(_vm.listAbsences[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISABSENCE') : _vm.$t('RESTORETHISABSENCE')))]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "placeholder": _vm.$t('WRITEANOTE')
          },
          model: {
            value: (_vm.listAbsences[scope.$index].DeleteNote),
            callback: function($$v) {
              _vm.$set(_vm.listAbsences[scope.$index], "DeleteNote", $$v)
            },
            expression: "listAbsences[scope.$index].DeleteNote"
          }
        }), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0",
            "margin-top": "5px"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.listAbsences[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.preDelete(scope.$index)
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])], 1)], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalAbsences
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "status": _vm.absence_status,
      "selected-student": _vm.student,
      "search": _vm.serachStudent,
      "server-check": _vm.serverCheck,
      "visible": _vm.absenceBox
    },
    on: {
      "update": _vm.updateAbsence,
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox,
      "showRemove": false,
      "studentList": _vm.messageStudent,
      "parent": _vm.parent
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "student-list"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t("MANAGESTUDENTS")))]), _vm._v(" "), (_vm.selectedStudents.length != 0) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "close"
    },
    on: {
      "click": function($event) {
        _vm.selectedStudents = []
      }
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.printCard
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t("PRINTCARDS")) + " ("), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.selectedStudents.length)
    }
  }), _vm._v(")")])], 1) : _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    },
    on: {
      "command": _vm.handleClick
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": _vm.newStudent
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWSTUDENT')) + "\n                ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown",
      "id": "student"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t("UPLOADCSVFILE")) + "\n              ")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "print"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t("PRINTALLCARDS")))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('save_tag'),
      "command": "tag"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.$t("CHECKTAGID")))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHSTUDENTNAME'),
      "icon": _vm.FullName ? 'circle-close' : ''
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      },
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHSTUDENTID'),
      "icon": _vm.ExternalStudentID ? 'circle-close' : ''
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      },
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.ExternalStudentID),
      callback: function($$v) {
        _vm.ExternalStudentID = $$v
      },
      expression: "ExternalStudentID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'route') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYROUTE'),
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.RouteID),
      callback: function($$v) {
        _vm.RouteID = $$v
      },
      expression: "RouteID"
    }
  }, _vm._l((_vm.routes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.TourName,
        "value": item.TourID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'grade') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "value-key": "GradeID",
      "placeholder": _vm.$t('FILTERBYGRADE'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.Grade.Classes != undefined && _vm.active_filter == 'grade') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYCLASS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.gradeClass),
      callback: function($$v) {
        _vm.gradeClass = $$v
      },
      expression: "gradeClass"
    }
  }, _vm._l((_vm.Grade.Classes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'status') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYSTATUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('ACTIVE'),
      "value": "1"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ACTIVE')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('INACTIVE'),
      "value": "2"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "danger",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('INACTIVE')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listStudents,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalStudentID",
      "label": _vm.$t('STUDENTID'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "prop": "FullName_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n                " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Grade",
      "label": _vm.$t('GRADE'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Class",
      "label": _vm.$t('CLASS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AssignmentStatus",
      "label": _vm.$t('ASSIGNEDTOBUS'),
      "min-width": "160",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.AssignmentStatus !== null ? _vm.$t('ASSIGNED') : _vm.$t('NOTASSIGNED')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": _vm.isOnQueue(scope.row) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.printQueue(scope.row)
            }
          }
        }, [_c('i', {
          class: [_vm.isOnQueue(scope.row) ? 'fa fa-check-square' : 'fa fa-square-o']
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.IDCard(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-id-card"
        }), _vm._v(" " + _vm._s(_vm.$t('IDCARD')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "220",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('save', 'attendance/absence')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('MARKABSENCE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.markAbsence(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user-times"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDMESSAGE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showMessageModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-comment"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save_tag')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('ISSUEATTENDANCETAG'),
            "placement": "top"
          }
        }, [_c('el-button', {
          class: [scope.row.AssignedTagID != null ? 'text-success' : ''],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showScanModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wifi"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITSTUDENT'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/school/student/' + scope.row.StudentID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "disabled": scope.row.AssignmentStatus != null ? true : false,
            "content": _vm.listStudents[scope.$index].Status == 0 ? _vm.$t('DEACTIVATESTUDENT') : _vm.$t('ACTIVATESTUDENT'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.student = _vm.listStudents[scope.$index]
            }
          },
          model: {
            value: (_vm.listStudents[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.listStudents[scope.$index], "Deleted", $$v)
            },
            expression: "listStudents[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + _vm._s(_vm.listStudents[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISSTUDENT') : _vm.$t('RESTORETHISSTUDENT')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.listStudents[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "disabled": scope.row.AssignmentStatus != null,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkRoute(scope.$index)
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.DeletedAT != null ? 'fa-undo' : 'fa-times']
        })]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalStudents
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tag-dialog', {
    attrs: {
      "callScan": _vm.callScan,
      "findTag": _vm.findTag,
      "student": _vm.student
    },
    on: {
      "update:callScan": function($event) {
        _vm.callScan = $event
      }
    }
  }), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "selected-student": _vm.absenceStudent,
      "server-check": true,
      "visible": _vm.absenceBox
    },
    on: {
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox,
      "showRemove": false,
      "studentList": _vm.messageStudent,
      "parent": _vm.parent
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('STUDENTS'),
      "uri": "student/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.getStudents,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": _vm.$t('STUDENTIDCARD'),
      "visible": _vm.dialogVisible,
      "before-close": _vm.handleDialogClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    ref: "printCard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.selectedStudents), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "span": _vm.printCardWidth
      }
    }, [_c('el-row', {
      staticStyle: {
        "background-color": "#f5c838!important"
      },
      attrs: {
        "type": "flex"
      }
    }, [_c('el-col', {
      staticClass: "card-pic",
      attrs: {
        "span": 6
      }
    }, [_c('img', {
      staticClass: "img-circle pic",
      attrs: {
        "src": _vm.getAsset(item.ImagePath)
      }
    }), _c('br'), _c('br'), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "60%",
        "margin-bottom": "5px"
      },
      attrs: {
        "src": _vm.getAsset(_vm.school.school_logo === 'no-school.png' ? 'adec-print-logo.png' : _vm.school.school_logo, 'configuration')
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.school.school_name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }, [_c('el-form', {
      staticStyle: {
        "margin": "15px"
      },
      attrs: {
        "label-position": "top"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('FIRSTNAME')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm._FullName({
          NameEN: item.FirstName_EN,
          NameAR: item.FirstName_AR
        }),
        "readonly": ""
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('LASTNAME')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm._FullName({
          NameEN: item.LastName_EN,
          NameAR: item.LastName_AR
        }),
        "readonly": ""
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('SCHOOLCONTACT')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm.school.contact_number,
        "readonly": ""
      }
    })], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GRADE')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.Grade,
        "readonly": ""
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('CLASS')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.Class,
        "readonly": ""
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('STUDENTID')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.ExternalStudentID,
        "readonly": ""
      }
    })], 1)], 1)], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printCard
    }
  }, [_vm._v(_vm._s(_vm.$t('PRINT')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGESUPERVISORS')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/transportation/supervisor/create'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWSUPERVISOR')) + "\n            ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "data": _vm.import_data,
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('UPLOADCSVFILE')) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHNAME'),
      "icon": _vm.FullName ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHID'),
      "icon": _vm.PersonID ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.PersonID),
      callback: function($$v) {
        _vm.PersonID = $$v
      },
      expression: "PersonID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'nationality') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SERACHBYNATIONALITY'),
      "filterable": true,
      "clearable": ""
    },
    model: {
      value: (_vm.Nationality),
      callback: function($$v) {
        _vm.Nationality = $$v
      },
      expression: "Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listSupervisors,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalPersonID",
      "min-width": "150",
      "label": _vm.$t('ID'),
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ASSIGNEDTOBUS'),
      "min-width": "160",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.RouteID !== null ? _vm.$t('ASSIGNED') : _vm.$t('NOTASSIGNED')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('registration')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDREGISTRATIONCODE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.BusMonitorID === _vm.sending,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.sendRegistration(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.BusMonitorID !== _vm.sending ? 'fa-key' : 'fa-circle-o-notch fa-spin']
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITSUPERVISOR'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/supervisor/' + scope.row.PersonID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "disabled": scope.row.RouteID != null ? true : false,
            "content": _vm.supervisors[scope.$index].Status == 0 ? _vm.$t('DEACTIVATESUPERVISOR') : _vm.$t('ACTIVATESUPERVISOR'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.supervisor = _vm.supervisors[scope.$index]
            }
          },
          model: {
            value: (_vm.supervisors[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.supervisors[scope.$index], "Deleted", $$v)
            },
            expression: "supervisors[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + _vm._s(_vm.supervisors[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISSUPERVISOR') : _vm.$t('RESTORETHISSUPERVISOR')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.supervisors[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "disabled": scope.row.RouteID != null,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkRoute(scope.$index)
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.Status != 0 ? 'fa-undo' : 'fa-times']
        })])], 1)], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('SUPERVISORS'),
      "uri": "supervisor/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.reCall,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'expenseForm'],
      "title": _vm.$t('MANAGEBUS'),
      "data": {
        bus: this.bus
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "tabs",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.bus,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSNUMBER'),
      "prop": "Label",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Label),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Label", $$v)
      },
      expression: "bus.Label"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('REGISTRATIONEXPIRATIONDATE'),
      "prop": "RegistrationExpiration",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": _vm.date_format,
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.bus.RegistrationExpiration),
      callback: function($$v) {
        _vm.$set(_vm.bus, "RegistrationExpiration", $$v)
      },
      expression: "bus.RegistrationExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PLATENUMBER'),
      "prop": "Plate",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Plate),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Plate", $$v)
      },
      expression: "bus.Plate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SEATINGCAPACITY'),
      "prop": "MaxSeats",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.MaxSeats),
      callback: function($$v) {
        _vm.$set(_vm.bus, "MaxSeats", $$v)
      },
      expression: "bus.MaxSeats"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MODEL'),
      "prop": "Model",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Model),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Model", $$v)
      },
      expression: "bus.Model"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('YEAR'),
      "prop": "Year",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "year",
      "placeholder": _vm.$t('PICKAYEAR'),
      "picker-options": _vm.yearDisable
    },
    model: {
      value: (_vm.bus.Year),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Year", $$v)
      },
      expression: "bus.Year"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MAKE'),
      "prop": "Make",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Make),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Make", $$v)
      },
      expression: "bus.Make"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('EXPENSES')
    }
  }, [_c('el-form', {
    ref: "expenseForm",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "model": _vm.bus,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEPRICE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Price",
      "rules": {
        type: 'string',
        required: false,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    on: {
      "change": function($event) {
        _vm.priceVal = (_vm.bus.Expenses.Price !== '')
      }
    },
    model: {
      value: (_vm.bus.Expenses.Price),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Price", $$v)
      },
      expression: "bus.Expenses.Price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEPERMIT') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Permit",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Permit),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Permit", $$v)
      },
      expression: "bus.Expenses.Permit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('REGISTRATION') + ' ' + _vm.$t('COST') + ' ' + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Registration",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Registration),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Registration", $$v)
      },
      expression: "bus.Expenses.Registration"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INSURANCE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Insurance",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Insurance),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Insurance", $$v)
      },
      expression: "bus.Expenses.Insurance"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INSPECTION') + ' ' + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Inspection",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Inspection),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Inspection", $$v)
      },
      expression: "bus.Expenses.Inspection"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEDEPRECIATION'),
      "prop": "Expenses.Depreciation",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Depreciation),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Depreciation", $$v)
      },
      expression: "bus.Expenses.Depreciation"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ %")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DRIVER') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Driver",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Driver),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Driver", $$v)
      },
      expression: "bus.Expenses.Driver"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SUPERVISOR') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Supervisor",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Supervisor),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Supervisor", $$v)
      },
      expression: "bus.Expenses.Supervisor"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FINANCIAL') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Finance",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Finance),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Finance", $$v)
      },
      expression: "bus.Expenses.Finance"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('WEARTEAR') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Wear_Tear",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Wear_Tear),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Wear_Tear", $$v)
      },
      expression: "bus.Expenses.Wear_Tear"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GASRATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Fuel",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Fuel),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Fuel", $$v)
      },
      expression: "bus.Expenses.Fuel"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('OILRATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Oil",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Oil),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Oil", $$v)
      },
      expression: "bus.Expenses.Oil"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('TIRERATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Tire",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Tire),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Tire", $$v)
      },
      expression: "bus.Expenses.Tire"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDLERATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Idling",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Idling),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Idling", $$v)
      },
      expression: "bus.Expenses.Idling"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Min")])], 2)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('DOCUMENTS')
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-docs",
    attrs: {
      "drag": "",
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploaded,
      "data": {
        folder: 'bus'
      },
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "action": _vm.URL + 'media/upload/documents',
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('DROPFILEHEREOR')) + " "), _c('em', [_vm._v(_vm._s(_vm.$t('CLICKTOUPLOAD')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('JPGPNGFILES')))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.bus.Documents,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-select', {
          staticClass: "form-control",
          attrs: {
            "title": _vm.$t('DOCUMENTTYPE')
          },
          model: {
            value: (props.row.label),
            callback: function($$v) {
              _vm.$set(props.row, "label", $$v)
            },
            expression: "props.row.label"
          }
        }, [_c('el-option', {
          attrs: {
            "label": _vm.$t('REGISTRATION'),
            "value": "Registration"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('INSURANCE'),
            "value": "Insurance"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('OTHER'),
            "value": ""
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file_name",
      "label": _vm.$t('File')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PREVIEW'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.openSlider(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sticky-note"
        }), _vm._v(" " + _vm._s(_vm.$t('VIEW')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEDOCUMENT'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              props.row.deleted = !props.row.deleted
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-2x",
          class: [props.row.deleted ? 'fa-undo' : 'fa-remove']
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-doc-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "document": _vm.document
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.bus.BusID != null) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ROUTES'),
      "name": "route"
    }
  }, [_c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.DriverPhoto, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverFullName_EN,
          NameAR: scope.row.DriverFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.MonitorPhoto, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.MonitorFullName_EN,
          NameAR: scope.row.MonitorFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "40",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('VIOLATIONS')
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATIONS')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    ref: "card",
    staticClass: "card-border",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "id": "report",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "page-403"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-5x"
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('NOTACESS')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('LOST')))]), _vm._v(" "), _c('p', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('GOHOME')))])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    ref: "card",
    staticClass: "card-border",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "id": "report",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "page-404"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-5x"
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('NOTFOUND')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('LOST')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('NOTEXIST')))]), _vm._v(" "), _c('p', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('GOHOME')))])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "route-manage"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEROUTE')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.saving || _vm.routing,
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [(!(_vm.saving || _vm.routing)) ? _c('i', {
    staticClass: "fa",
    class: _vm.submitIcon
  }) : _vm._e(), _vm._v(" \n           " + _vm._s(_vm.submissionText) + "\n           ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('INFORMATION')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: (_vm.cardHeight - 40) + 'px'
    })
  }, [_c('el-form', {
    ref: "infoForm",
    attrs: {
      "model": _vm.schedule,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DIRECTION'),
      "prop": "Direction",
      "rules": {
        type: 'number',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDIRECTION')
    },
    on: {
      "change": _vm.setDepature
    },
    model: {
      value: (_vm.schedule.Direction),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Direction", $$v)
      },
      expression: "schedule.Direction"
    }
  }, _vm._l((_vm.directions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.ServiceDate !== '0' ? _vm.$t('SELECTSERVICEDATE') : _vm.$t('SELECTTERM')
    }
  }, [(_vm.ServiceDate !== 0) ? _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTTYPE')
    },
    model: {
      value: (_vm.ServiceDate),
      callback: function($$v) {
        _vm.ServiceDate = $$v
      },
      expression: "ServiceDate"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('ACADEMICYEAR'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('CUSTOMDATE'),
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ServiceDate === 0) ? _c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.ServiceDate = null
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SELECTACADEMICTERM')
    },
    on: {
      "change": _vm.setTerm
    },
    model: {
      value: (_vm.route.TermID),
      callback: function($$v) {
        _vm.$set(_vm.route, "TermID", $$v)
      },
      expression: "route.TermID"
    }
  }, _vm._l((_vm.terms), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.year,
        "value": item.YearID
      }
    })
  }))], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SERVICESTARTENDDATE'),
      "prop": "StartDate",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.ServiceDate === 0,
      "type": "date",
      "format": _vm.date_format,
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.schedule.StartDate),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "StartDate", $$v)
      },
      expression: "schedule.StartDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SERVICESTARTENDDATE'),
      "prop": "EndDate",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.ServiceDate === 0,
      "type": "date",
      "format": _vm.date_format,
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.schedule.EndDate),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "EndDate", $$v)
      },
      expression: "schedule.EndDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DAYSINSERVICE')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHECKALL')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedDaysChange
    },
    model: {
      value: (_vm.schedule.ServiceDays),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "ServiceDays", $$v)
      },
      expression: "schedule.ServiceDays"
    }
  }, _vm._l((_vm.daysC), function(day, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": key.toString()
      }
    }, [_vm._v(_vm._s(day))])], 1)
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "timing"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('HOMETOSCHOOLSERVICETIME'),
      "prop": !_vm.schedule.Time_AM_In ? 'Time_AM_In' : 'Time_AM_Out',
      "rules": {
        required: (_vm.schedule.Direction == 1 || _vm.schedule.Direction == 3),
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 2,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.schedule.Time_AM_In),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_AM_In", $$v)
      },
      expression: "schedule.Time_AM_In"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 2,
      "picker-options": {
        start: _vm.schedule.Time_AM_In,
        step: '00:15',
        end: '16:00',
        minTime: _vm.schedule.Time_AM_In
      }
    },
    model: {
      value: (_vm.schedule.Time_AM_Out),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_AM_Out", $$v)
      },
      expression: "schedule.Time_AM_Out"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLTOHOMESERVICETIME'),
      "prop": !_vm.schedule.Time_PM_In ? 'Time_PM_In' : 'Time_PM_Out',
      "rules": {
        required: (_vm.schedule.Direction == 2 || _vm.schedule.Direction == 3),
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 1,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.schedule.Time_PM_In),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_PM_In", $$v)
      },
      expression: "schedule.Time_PM_In"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 1,
      "picker-options": {
        start: _vm.schedule.Time_PM_In,
        step: '00:15',
        end: '18:30',
        minTime: _vm.schedule.Time_PM_In
      }
    },
    model: {
      value: (_vm.schedule.Time_PM_Out),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_PM_Out", $$v)
      },
      expression: "schedule.Time_PM_Out"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-form', {
    ref: "routeForm",
    staticStyle: {
      "padding": "0px !important"
    },
    attrs: {
      "model": _vm.route,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME'),
      "prop": "TourName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }, {
        max: 15,
        message: _vm.$t('Maximum length should be 15 characters'),
        trigger: 'blur,change'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": _vm.$t('PLEASEINPUT')
    },
    model: {
      value: (_vm.route.TourName),
      callback: function($$v) {
        _vm.$set(_vm.route, "TourName", $$v)
      },
      expression: "route.TourName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DESCRIPTION')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": _vm.$t('PLEASEINPUT')
    },
    model: {
      value: (_vm.route.Description),
      callback: function($$v) {
        _vm.$set(_vm.route, "Description", $$v)
      },
      expression: "route.Description"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('STOPS'),
      "disabled": _vm.loading || _vm.stopTab
    }
  }, [_c('el-row', {
    staticClass: "only-bottom-border"
  }, [_c('el-autocomplete', {
    ref: "search",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('ADDSTUDENTTOASTOP'),
      "icon": "search",
      "trigger-on-focus": false,
      "autofocus": ""
    },
    on: {
      "select": _vm.addStudent
    },
    model: {
      value: (_vm.studentSearch),
      callback: function($$v) {
        _vm.studentSearch = $$v
      },
      expression: "studentSearch"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    ref: "config",
    staticClass: "stopConfig",
    staticStyle: {
      "border-bottom": "1px solid rgb(204, 204, 204)"
    }
  }, [_c('el-steps', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "space": 100,
      "direction": "vertical",
      "active": 1
    }
  }, [_c('div', {
    staticClass: "el-step is-vertical"
  }, [_c('div', {
    staticClass: "el-step__head is-finish is-text",
    style: ({
      'background-color': _vm.direction.RouteColor,
      'border-color': _vm.direction.RouteColor
    })
  }, [_c('div', {
    staticClass: "el-step__line is-vertical",
    staticStyle: {
      "margin-right": "0px"
    },
    style: ({
      'background-color': _vm.direction.RouteColor
    })
  }, [_c('i', {
    staticClass: "el-step__line-inner",
    staticStyle: {
      "transition-delay": "0ms",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "el-step__icon"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-university"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "el-step__main"
  }, [_c('div', {
    staticClass: "el-step__title is-finish"
  }, [_c('el-color-picker', {
    staticStyle: {
      "margin-top": "-5px"
    },
    on: {
      "change": _vm.setPathColor
    },
    model: {
      value: (_vm.direction.RouteColor),
      callback: function($$v) {
        _vm.$set(_vm.direction, "RouteColor", $$v)
      },
      expression: "direction.RouteColor"
    }
  }), _vm._v(" "), _c('el-button-group', {
    staticClass: "btn-steps"
  }, [_c('el-button', {
    staticClass: "manual-stops",
    attrs: {
      "type": !_vm.is_manual ? 'primary' : 'default'
    },
    domProps: {
      "textContent": _vm._s(!_vm.is_manual ? 'Disable optimization' : 'Enable optimization')
    },
    on: {
      "click": function($event) {
        _vm.route_ready(false)
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-csv",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "on-success": _vm.uploadedFile,
      "on-progress": _vm.processUpload,
      "disabled": _vm.progress_import
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.progress_import,
      "type": "default"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t("UPLOADCSVFILE")) + "\n                    ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "el-step__description is-finish"
  })])])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loaded || _vm.routing || _vm.progress_import),
      expression: "loaded || routing || progress_import"
    }],
    staticClass: "stop-steps",
    attrs: {
      "element-loading-text": _vm.loadingMessage
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ScrollbarStops",
    staticClass: "scrollbar",
    style: ({
      height: _vm.stepsHeight + 'px'
    })
  }, [_c('div', {
    ref: "stops"
  }, [_c('el-row', {
    ref: "stops"
  }, [_c('el-steps', {
    attrs: {
      "space": 200,
      "direction": "vertical",
      "active": 1
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moving_stop != null && _vm.moving_stop != 1),
      expression: "moving_stop!=null && moving_stop != 1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.moveStop(0)
      }
    }
  }, [_c('span', {
    attrs: {
      "transition": "bounce"
    }
  }, [_vm._v(" Move selected stop here! ")])])], 1), _vm._v(" "), _vm._l((_vm.listStops), function(stop, key) {
    return (key != 0) ? _c('div', {
      key: key,
      staticClass: "el-step is-vertical"
    }, [_c('div', {
      staticClass: "el-step__head is-finish is-text",
      style: ({
        'background-color': _vm.direction.RouteColor,
        'border-color': _vm.direction.RouteColor
      })
    }, [_c('div', {
      staticClass: "el-step__line is-vertical",
      style: ({
        'background-color': _vm.direction.RouteColor
      })
    }, [_c('i', {
      staticClass: "el-step__line-inner",
      staticStyle: {
        "transition-delay": "0ms",
        "height": "100%"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-step__icon"
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(key)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "el-step__main"
    }, [_c('div', {
      staticClass: "el-step__title is-finish"
    }, [_c('span', {
      style: ({
        'text-decoration': stop.deleted ? _vm.$t('LINE-THROUGH') : _vm.$t('NONE')
      })
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('STOP')) + " " + _vm._s((key)))])]), _vm._v(" "), (_vm.is_manual) ? _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.moving_stop == key || _vm.moving_stop == null),
        expression: "moving_stop == key || moving_stop == null"
      }],
      staticClass: "move-stop",
      attrs: {
        "size": "mini"
      },
      domProps: {
        "textContent": _vm._s(_vm.moving_stop == key ? 'Cancel moving' : 'Move stop')
      },
      on: {
        "click": function($event) {
          _vm.movingStop(key)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-popover', {
      staticClass: "stop-inputs",
      attrs: {
        "trigger": "manual",
        "placement": "right",
        "width": "400"
      },
      model: {
        value: (stop.inputs),
        callback: function($$v) {
          _vm.$set(stop, "inputs", $$v)
        },
        expression: "stop.inputs"
      }
    }, [_c('el-form', {
      ref: "form",
      refInFor: true,
      attrs: {
        "model": stop,
        "label-width": "120px",
        "label-position": "top"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GPSLATITUDE')
      }
    }, [_c('el-input', {
      model: {
        value: (stop.Lat),
        callback: function($$v) {
          _vm.$set(stop, "Lat", $$v)
        },
        expression: "stop.Lat"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GPSLONGITUDE')
      }
    }, [_c('el-input', {
      model: {
        value: (stop.Lng),
        callback: function($$v) {
          _vm.$set(stop, "Lng", $$v)
        },
        expression: "stop.Lng"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('USEGOOGLEMAPDURATION')
      }
    }, [_c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": 1
      },
      model: {
        value: (stop.mapDuration),
        callback: function($$v) {
          _vm.$set(stop, "mapDuration", $$v)
        },
        expression: "stop.mapDuration"
      }
    }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": 0
      },
      model: {
        value: (stop.mapDuration),
        callback: function($$v) {
          _vm.$set(stop, "mapDuration", $$v)
        },
        expression: "stop.mapDuration"
      }
    }, [_vm._v(_vm._s(_vm.$t('NO')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('PREVIOUSWAITING')
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": stop.mapDuration === 0
      },
      model: {
        value: (stop.DeltaT),
        callback: function($$v) {
          _vm.$set(stop, "DeltaT", $$v)
        },
        expression: "stop.DeltaT"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('STOPWAITING')
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": stop.mapDuration === 0
      },
      model: {
        value: (stop.WaitingTime),
        callback: function($$v) {
          _vm.$set(stop, "WaitingTime", $$v)
        },
        expression: "stop.WaitingTime"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "popover-btn"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "text"
      },
      on: {
        "click": function($event) {
          stop.inputs = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          stop.inputs = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference",
        "icon": "setting"
      },
      on: {
        "click": function($event) {
          stop.inputs = true
        }
      },
      slot: "reference"
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "type": "text",
        "disabled": !_vm.noDragging
      },
      on: {
        "click": function($event) {
          _vm.deleteAction(stop, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: [stop.deleted ? 'fa-undo' : 'fa-trash']
    })])], 1)], 1)], 1), _vm._v(" "), (!_vm.noDragging && _vm.dragged_list[key] == undefined) ? _c('div', {
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.dropList(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    }), _vm._v("\n                  Move selected student(s) to this stop\n                ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((stop.students), function(student, index) {
      return _c('el-row', {
        key: index,
        staticClass: "list",
        class: {
          'dragged': _vm.isDragged(student, true)
        }
      }, [_c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "text",
          "size": "large"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + "\n                          "), (!stop.deleted && !_vm.isDragged(student, true)) ? _c('i', {
        staticClass: "fa",
        class: [student.deleted ? 'fa-undo' : 'fa-remove'],
        on: {
          "click": function($event) {
            _vm.deleteAction(student, key)
          }
        }
      }) : _vm._e()]), _vm._v(" "), (_vm.is_manual) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.dragStudent(student)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-exchange",
        attrs: {
          "data-fa-transform": "rotate-180"
        }
      }), _vm._v(" \n                          " + _vm._s(_vm.isDragged(student, true) ? 'Cancel' : 'Change stop') + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
        staticClass: "mapPin",
        style: ({
          color: _vm.direction.RouteColor
        }),
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.pinStudentLocation(student)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-map-pin fa-2x"
      })])], 1)
    }), _vm._v(" "), (stop.students != undefined) ? _c('el-row', [(stop.students.length == 0) ? _c('el-col', {
      staticStyle: {
        "padding": "10px",
        "background-color": "rgb(209, 219, 229)",
        "color": "#4b4b4b"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSADDEDTOTHISSTOP')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticClass: "only-top-border"
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.moving_stop != null && _vm.moving_stop != key && _vm.moving_stop != key + 1),
        expression: "moving_stop!=null && moving_stop != key && moving_stop != key + 1"
      }],
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.moveStop(key)
        }
      }
    }, [_c('span', {
      attrs: {
        "transition": "bounce"
      }
    }, [_vm._v(" Move selected stop here! ")])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "el-step__description is-finish"
    })])]) : _vm._e()
  })], 2)], 1)], 1)])], 1)], 1), _vm._v(" "), (_vm.isAllowed('registration')) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('REGISTRATION'),
      "disabled": _vm.loaded || _vm.registrationTab
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.tabHeight - 3 + 'px'
    })
  }, [_c('el-row', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v("\n            " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "  "), _c('el-checkbox', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isAllowed('registration', 'transportation/supervisor'),
      "label": _vm.monitor.BusMonitorID
    },
    model: {
      value: (_vm.selectedMonitor),
      callback: function($$v) {
        _vm.selectedMonitor = $$v
      },
      expression: "selectedMonitor"
    }
  }, [_vm._v(" ")]), _c('br')], 1), _vm._v(" "), (_vm.driver.EMail) ? _c('h4', [_vm._v(_vm._s(_vm.$t('DRIVER')))]) : _vm._e(), _vm._v(" "), (_vm.driver.EMail) ? _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v("\n            " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "  "), _c('el-checkbox', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isAllowed('registration', 'transportation/driver'),
      "label": _vm.driver.BusDriverID
    },
    model: {
      value: (_vm.tickedDriver),
      callback: function($$v) {
        _vm.tickedDriver = $$v
      },
      expression: "tickedDriver"
    }
  }, [_vm._v(" ")]), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "padding-right": "10px"
    },
    model: {
      value: (_vm.selectedStudents),
      callback: function($$v) {
        _vm.selectedStudents = $$v
      },
      expression: "selectedStudents"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('STUDENTS')))]), _vm._v(" "), _vm._l((_vm.stops), function(stop, index) {
    return _c('div', {
      key: index
    }, _vm._l((stop.students), function(student, index) {
      return _c('el-row', {
        key: index,
        staticClass: "list"
      }, [_c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v("\n            " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + " \n            "), _c('el-checkbox', {
        staticStyle: {
          "float": "right"
        },
        attrs: {
          "label": student.StudentID
        }
      }, [_vm._v(" ")]), _c('br')], 1)
    }))
  })], 2)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "height": "40px",
      "display": "block",
      "width": "100%",
      "border-radius": "0"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.sending,
      "disabled": _vm.selectedStudents.length === 0 && !_vm.selectedMonitor && !_vm.tickedDriver
    },
    on: {
      "click": _vm.sendRegistration
    }
  }, [_vm._v(" " + _vm._s(_vm.sending ? _vm.$t('SENDING') : _vm.$t('SENDREGISTRATIONCODE')))])], 1) : _vm._e(), _vm._v(" "), (_vm.route.TourID) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('SETTINGS'),
      "disabled": _vm.loading
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATUS')
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": !_vm.isAllowed('status'),
      "on-value": "0",
      "off-value": "1",
      "on-text": _vm.$t('ACTIVE'),
      "off-text": _vm.$t('INACTIVE'),
      "width": 80
    },
    on: {
      "change": _vm.status
    },
    model: {
      value: (_vm.route.Deleted),
      callback: function($$v) {
        _vm.$set(_vm.route, "Deleted", $$v)
      },
      expression: "route.Deleted"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COPYROUTE')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('NAMEYOURROUTE'),
      "disabled": !_vm.isAllowed('clone')
    },
    model: {
      value: (_vm.clonedName),
      callback: function($$v) {
        _vm.clonedName = $$v
      },
      expression: "clonedName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": !_vm.clonedName && !_vm.isAllowed('clone'),
      "loading": _vm.cloning
    },
    on: {
      "click": _vm.cloneRoute
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.cloning ? _vm.$t('CLONING') : _vm.$t('MAKEACOPY')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DELAYEDTHRESHOLD')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "picker-options": {
        start: '00:05',
        step: '00:5',
        end: '00:30'
      },
      "format": "hh:mm"
    },
    model: {
      value: (_vm.schedule.DelayedThreshold),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "DelayedThreshold", $$v)
      },
      expression: "schedule.DelayedThreshold"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 16,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-tabs', {
    staticClass: "staff",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('OVERVIEW')
    }
  }, [_c('el-form', {
    ref: "OVForm",
    attrs: {
      "id": "OVForm",
      "model": _vm.route,
      "inline": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-3x"
  }), _vm._v(" "), _c('el-tag', [_vm._v("# " + _vm._s(_vm.bus.Label))])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getBuses
    }
  }, [_vm._v(_vm._s(_vm.$t('BUS')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border2",
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusMonitorID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "disabled": !_vm.ellipsis,
      "content": _vm._FullName({
        NameEN: _vm.monitor.FullName_EN,
        NameAR: _vm.monitor.FullName_AR
      }) === undefined ? '&zwnj;' : _vm._FullName({
        NameEN: _vm.monitor.FullName_EN,
        NameAR: _vm.monitor.FullName_AR
      })
    }
  }, [_c('span', {
    staticClass: "overflow-text",
    on: {
      "mouseover": _vm.isEllipsisActive
    }
  }, [_vm._v(_vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  }) === undefined ? '‌' : _vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })))])])], 1)]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getSupervisors
    }
  }, [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusDriverID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "disabled": !_vm.ellipsis,
      "content": _vm._FullName({
        NameEN: _vm.driver.FullName_EN,
        NameAR: _vm.driver.FullName_AR
      }) === undefined ? '&zwnj;' : _vm._FullName({
        NameEN: _vm.driver.FullName_EN,
        NameAR: _vm.driver.FullName_AR
      })
    }
  }, [_c('span', {
    staticClass: "overflow-text",
    on: {
      "mouseover": _vm.isEllipsisActive
    }
  }, [_vm._v(_vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  }) === undefined ? '‌' : _vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })))])])], 1)]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getDrivers
    }
  }, [_vm._v(_vm._s(_vm.$t('DRIVER')))])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "15px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "position": "relative",
      "margin": "0 -15px"
    }
  }, [_c('div', {
    style: ({
      height: _vm.cardHeight - 122 + 'px'
    }),
    attrs: {
      "id": "gmap-route"
    }
  })])], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Trips"
    }
  }, [_vm._v(_vm._s(_vm.$t('TRIPS')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Violations"
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATIONS')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Incidents"
    }
  }, [_vm._v(_vm._s(_vm.$t('INCIDENTS')))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTBUS'),
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showBuses),
      callback: function($$v) {
        _vm.showBuses = $$v
      },
      expression: "showBuses"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDBUS')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('el-tag', [_vm._v("# " + _vm._s(_vm.bus.Label))])], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLEBUSES')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuses),
      expression: "loadingBuses"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Label",
      "render-header": _vm.headerFilter,
      "min-width": "135",
      "label": _vm.$t('BUSNUMBER'),
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Model",
      "label": _vm.$t('MODEL'),
      "min-width": "95",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Year",
      "label": _vm.$t('YEAR'),
      "align": "center",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MaxSeats",
      "label": _vm.$t('SEATS'),
      "align": "center",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "align": "center",
      "prop": "RouteID",
      "min-width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusID !== _vm.route.BusID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusID],
            "type": _vm.selectedBus == scope.row.BusID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusID, scope.row.Label, 'Bus')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedBus == scope.row.BusID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showBuses = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedBus === _vm.route.BusID || _vm.selectedBus === null
    },
    on: {
      "click": _vm.setBus
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTDRIVER'),
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showDrivers),
      callback: function($$v) {
        _vm.showDrivers = $$v
      },
      expression: "showDrivers"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDDRIVER')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v("\n        " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "\n            ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLEDRIVERS')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingDrivers),
      expression: "loadingDrivers"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "render-header": _vm.headerFilter,
      "min-width": "150",
      "prop": "FullName_EN",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LicenseExpiration",
      "label": _vm.$t('LICENSEEXPIRATION'),
      "min-width": "145",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "102",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "108",
      "prop": "RouteID",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "95",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusDriverID !== _vm.route.BusDriverID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusDriverID],
            "type": _vm.selectedDriver == scope.row.BusDriverID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusDriverID, _vm._FullName({
                NameEN: scope.row.FullName_EN,
                NameAR: scope.row.FullName_AR
              }), 'Driver')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedDriver == scope.row.BusDriverID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusDriverID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDrivers = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedDriver === _vm.route.BusDriverID || _vm.selectedDriver === null
    },
    on: {
      "click": _vm.setDriver
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTSUPERVISOR'),
      "callback": _vm.clearEverything,
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showSupervisors),
      callback: function($$v) {
        _vm.showSupervisors = $$v
      },
      expression: "showSupervisors"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDSUPERVISOR')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v("\n        " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "\n            ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLESUPERVISORS')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSupervisors),
      expression: "loadingSupervisors"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "render-header": _vm.headerFilter,
      "min-width": "200",
      "prop": "FullName_EN",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "120",
      "prop": "RouteID",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusMonitorID !== _vm.route.BusMonitorID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusMonitorID],
            "type": _vm.selectedSupervisor == scope.row.BusMonitorID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusMonitorID, _vm._FullName({
                NameEN: scope.row.FullName_EN,
                NameAR: scope.row.FullName_AR
              }), 'Supervisor')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedSupervisor == scope.row.BusMonitorID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusMonitorID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSupervisors = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedSupervisor === _vm.route.BusMonitorID || _vm.selectedSupervisor === null
    },
    on: {
      "click": _vm.setSupervisor
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-dashboard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.AWS_ASSETS + 'logo.png'
    }
  })]), _vm._v(" "), _vm._l((_vm.summary), function(obj, key) {
    return _c('el-col', {
      key: key,
      staticStyle: {
        "padding": "8px"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-card', {
      attrs: {
        "align": "center",
        "body-style": {
          backgroundColor: 'rgb(89, 180, 170)',
          color: '#fff',
          'font-weight': 'bold'
        }
      }
    }, [_c('div', [_vm._v("\n                      " + _vm._s(_vm.$t('TOTAL') + ' ' + _vm.$t(key)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "padding": "0"
      },
      style: ({
        color: key === 'CENTERS' ? '#ACB225' : _vm.links[key].color
      }),
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h1', [_vm._v(_vm._s(obj) + " "), _c('br')])])])], 1)
  })], 2), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.schools), function(center, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 8
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.clickEvent(key)
        }
      }
    }, [_c('el-card', {
      attrs: {
        "align": "center",
        "body-style": {
          padding: '5px 20px'
        }
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, _vm._l((center), function(obj, index) {
      return (index != 'SCHOOL') ? _c('el-col', {
        key: index,
        attrs: {
          "span": 8
        }
      }, [_c('el-button', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickEvent(key, index)
          }
        }
      }, [_c('el-card', {
        attrs: {
          "align": "center",
          "body-style": {
            'font-weight': 'bold',
            padding: '10px 30px'
          }
        }
      }, [_c('div', {
        staticClass: "clearfix",
        style: ({
          color: _vm.links[index].color
        }),
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [_c('h1', [_vm._v(_vm._s(obj))])]), _vm._v(" "), _c('div', [_vm._v("\n                              " + _vm._s(_vm.$t(index)) + "\n                        ")])])], 1)], 1) : _vm._e()
    })), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h2', [_vm._v(_vm._s(_vm.center_name(center)))])])], 1)], 1)], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sessionDialog) ? _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ALERT'),
      "visible": _vm.sessionDialog,
      "size": "tiny",
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  }, [(_vm.sessionExpiration == null) ? _c('b', [_vm._v(_vm._s(_vm.$t('SESSIONHASBEENEXPIRED')))]) : _vm._e(), _vm._v(" "), (_vm.sessionExpiration != null) ? _c('el-form', {
    ref: "session",
    attrs: {
      "model": _vm.session,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t(_vm.message),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('PLEASEENTERYOURPASSWORD')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submitForm()
      }
    },
    model: {
      value: (_vm.session.pass),
      callback: function($$v) {
        _vm.$set(_vm.session, "pass", $$v)
      },
      expression: "session.pass"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showTimer()) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "time"
    }
  }, [_vm._v(_vm._s(_vm.timer))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.sessionDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), (_vm.sessionExpiration != null) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.loading ? _vm.$t('AUTHENTICATING') : _vm.$t('CONFIRM')))]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "log"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGELOG')))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('VuePerfectScrollbar', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "Scrollbar",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('div', {
    staticClass: "scroll-border",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, _vm._l((_vm.users), function(user, key) {
    return _c('el-button', {
      key: key,
      staticClass: "list",
      class: [user.PersonID == _vm.userID ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.loadUserLogs(user.PersonID)
        }
      }
    }, [_c('img', {
      staticClass: "img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(user.ImagePath, 'user')
      }
    }), _vm._v("\n                " + _vm._s(_vm._FullName({
      NameEN: user.FullName_EN,
      NameAR: user.FullName_AR
    })) + " "), (user.Role) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(user.Role))]) : _vm._e(), _c('br')], 1)
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'event') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "value-key": "controller",
      "placeholder": _vm.$t('FILTERBYEVENT'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getUserLogs(_vm.userID, true)
      }
    },
    model: {
      value: (_vm.Controller),
      callback: function($$v) {
        _vm.Controller = $$v
      },
      expression: "Controller"
    }
  }, _vm._l((_vm.events), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": _vm.$t(item.controller.toUpperCase()),
        "value": item
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.Controller.methods != undefined && _vm.active_filter == 'event') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYACTION'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getUserLogs(_vm.userID, true)
      }
    },
    model: {
      value: (_vm.Action),
      callback: function($$v) {
        _vm.Action = $$v
      },
      expression: "Action"
    }
  }, _vm._l((_vm.Controller.methods), function(item, key) {
    return (key != 'VIEW') ? _c('el-option', {
      key: key,
      attrs: {
        "label": _vm.$t(key.toUpperCase()),
        "value": item
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'date') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "change": function($event) {
        _vm.getUserLogs(_vm.userID, true)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading || _vm.new_page),
      expression: "loading || new_page"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listLogs,
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('PAGE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button",
          attrs: {
            "size": "mini",
            "disabled": !_vm.isAllowed(scope.row.Controller === 'configuration' ? 'index' : scope.row.Method, scope.row.Module + '/' + scope.row.Controller)
          },
          domProps: {
            "textContent": _vm._s(_vm.logPage(scope.row.Controller, scope.row.Method))
          },
          on: {
            "click": function($event) {
              _vm.logPath(scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timestamp",
      "label": _vm.$t('DATEANDTIME')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('IPADDRESS')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "[!IsBanned(scope.row) ? 'primary' : 'danger']",
            "disabled": scope.row.UserID == _vm.loggedInUserID
          },
          domProps: {
            "textContent": _vm._s(scope.row.IPAddress)
          },
          on: {
            "click": function($event) {
              _vm.IpBan(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary",
            "disabled": scope.row.UserID == _vm.loggedInUserID
          },
          on: {
            "click": function($event) {
              _vm.IpBan(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "13px"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalLogs
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEUSERS')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/admin/user/create'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWUSER')) + "\n        ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "data": _vm.import_data,
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('UPLOADCSVFILE')) + "\n      ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHUSERNAME'),
      "icon": _vm.fullName ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.fullName),
      callback: function($$v) {
        _vm.fullName = $$v
      },
      expression: "fullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'role') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticClass: "role",
    attrs: {
      "placeholder": _vm.$t('FILTERBYROLE'),
      "clearable": ""
    },
    model: {
      value: (_vm.level),
      callback: function($$v) {
        _vm.level = $$v
      },
      expression: "level"
    }
  }, _vm._l((_vm.roles), function(role, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": role.name,
        "value": role.id
      }
    }, [_c('span', [_vm._v(_vm._s(role.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.$t('LEVEL') + ' ' + role.id))])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHUSERID'),
      "icon": _vm.ExternalPersonID ? 'circle-close' : ''
    },
    on: {
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.ExternalPersonID),
      callback: function($$v) {
        _vm.ExternalPersonID = $$v
      },
      expression: "ExternalPersonID"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "overflow-y": "hidden"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredUsers,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalPersonID",
      "label": _vm.$t('USERID'),
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FullName_EN",
      "label": _vm.$t('NAME'),
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n        " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ROLE'),
      "prop": "Role",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('LEVEL'),
      "prop": "Level",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loggedin_id != scope.row.PersonID || !scope.row.UserID || _vm.isAllowed('registration')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDPASSWORDLINK'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.UserID === _vm.sending,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.sendPasswordLink(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.UserID !== _vm.sending ? 'fa-key' : 'fa-circle-o-notch fa-spin']
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITUSER'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/admin/user/' + scope.row.PersonID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.users[scope.$index].Status == 0 ? _vm.$t('DEACTIVATEUSER') : _vm.$t('ACTIVATEUSER'),
            "placement": "top"
          }
        }, [(_vm.loggedin_id != scope.row.PersonID) ? _c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.user = _vm.users[scope.$index]
            }
          },
          model: {
            value: (_vm.users[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.users[scope.$index], "Deleted", $$v)
            },
            expression: "users[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + " " + _vm._s(_vm.users[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISUSER') : _vm.$t('RESTORETHISUSER')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.users[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.users[scope.$index].Deleted = true
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.Status != 0 ? 'fa-undo' : 'fa-times']
        })])], 1) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('USERS'),
      "uri": "user/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.reCall,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "role"
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      },
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEROLES')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save'),
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.addRole({
          id: null,
          name: null,
          name_AR: null,
          status: '1',
          users: '0'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDNEWROLE')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar"
  }, [_c('div', {
    staticClass: "scroll-border",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, _vm._l((_vm.roles), function(role, key) {
    return _c('el-button', {
      key: key,
      staticClass: "list",
      class: [role.id == _vm.selectedRole.id ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.loadApplication(role)
        }
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.RoleName(role))
      }
    }), (role.users > 0) ? _c('el-badge', {
      attrs: {
        "value": role.users
      }
    }) : _vm._e(), (_vm.isAllowed('delete')) ? _c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.deleteRole(key, role)
        }
      }
    }) : _vm._e(), (_vm.isAllowed('save')) ? _c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.addRole(role)
        }
      }
    }) : _vm._e()], 1)
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listApplications,
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.$t(scope.row.controller.toUpperCase())) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIONS')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox-group', {
          attrs: {
            "fill": "#4b4b4b",
            "border-color": "#fff",
            "text-color": "#fff"
          },
          model: {
            value: (_vm.listApplications[scope.$index]['access']),
            callback: function($$v) {
              _vm.$set(_vm.listApplications[scope.$index], 'access', $$v)
            },
            expression: "listApplications[scope.$index]['access']"
          }
        }, _vm._l((scope.row.methods), function(item, key) {
          return _c('el-checkbox-button', {
            key: key,
            attrs: {
              "disabled": _vm.disableCheckBox(scope.$index, item),
              "label": item
            },
            on: {
              "change": function($event) {
                _vm.saveRole(scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t(key)))])
        }))]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-signin"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_logo),
      expression: "loading_logo"
    }],
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + _vm.loadingLogo() + ')'
    }),
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.lang == 'en' ? _vm.main_school.Name_EN : _vm.main_school.Name_AR))])]), _vm._v(" "), _c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.user,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [(_vm.show_dropdown) ? _c('el-row', {
    attrs: {
      "id": "school"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTSCHOOL'),
      "prop": "school",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSCHOOL')
    },
    on: {
      "change": _vm.selectSchool,
      "visible-change": _vm.getSchools
    },
    model: {
      value: (_vm.user.school),
      callback: function($$v) {
        _vm.$set(_vm.user, "school", $$v)
      },
      expression: "user.school"
    }
  }, _vm._l((_vm.schools), function(label, key) {
    return (key.split('_')[1] !== undefined) ? _c('el-option', {
      key: key,
      attrs: {
        "label": label.Name,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('USERNAME'),
      "prop": "username",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur,change'
      }]
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "size": "large",
      "autofocus": true
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.auth()
      }
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PASSWORD'),
      "prop": "password",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.auth()
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('div', {
    staticClass: "curve-down-area"
  }), _vm._v(" "), _c('div', {
    staticClass: "down-curve down-curve2"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-page-container"
  }, [_c('div', {
    staticClass: "form-signin"
  }, [_c('el-row', {
    staticClass: "submit_button"
  }, [_c('el-button', {
    staticClass: "btn-lg",
    staticStyle: {
      "margin-bottom": "10px",
      "width": "480px"
    },
    attrs: {
      "disabled": _vm.validateInput(),
      "size": "large"
    },
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('AUTHENTICATING') : _vm.$t('LOGIN'))
    },
    on: {
      "click": _vm.auth
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#4B4B4B"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.passwordReset
    }
  }, [_vm._v(_vm._s(_vm.$t('FORGOTPASSWORD')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("Gates")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "Loading...",
      "data": _vm.gates,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "FullName_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(scope.row.FullName_EN) + "  "), _c('br'), _vm._v("   " + _vm._s(scope.row.FullName_AR) + "\n\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Gate Name",
      "prop": "Name_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n            " + _vm._s(scope.row.Name_EN) + "  "), _c('br'), _vm._v("   " + _vm._s(scope.row.Name_AR) + "\n\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "First Reader Time",
      "prop": "FirstReaderTime",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Last Reader Time",
      "prop": "LastReaderTime",
      "align": "left",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    ref: "card",
    staticClass: "card-border",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "id": "report",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('REPORT')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "hide-on-click": _vm.hideOnClick
    },
    on: {
      "command": _vm.pushDataColumns
    }
  }, [_c('el-button', {
    staticClass: "first-radius",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('GETREPORT'))), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('div', [_c('el-switch', {
    attrs: {
      "width": 100,
      "on-text": _vm.$t('GROUPEDBY'),
      "off-text": _vm.$t('GROUPBY')
    },
    model: {
      value: (_vm.groupBy[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.groupBy, _vm.filterKey, $$v)
      },
      expression: "groupBy[filterKey]"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v(_vm._s(_vm.SelectAll[_vm.filterKey] ? _vm.$t('SELECTALL') : _vm.$t('DESELECTALL')))])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }), _vm._v(" "), _vm._l(((!_vm.groupBy[_vm.filterKey] ? _vm.makeList(_vm.dataColumns[_vm.filterKey], true) : _vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true))), function(item, key) {
    return _c('el-dropdown-item', {
      key: key,
      attrs: {
        "command": key
      }
    }, [_vm._v(_vm._s(item)), (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('span', {
      staticClass: "fa fa-check pull-right"
    }) : _vm._e()])
  }), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.onClickStatus()
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('SHOW')))])], 1)], 2)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "second-radius",
    staticStyle: {
      "border-left-color": "rgb(175, 185, 195)"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.filteredData[_vm.filterKey].length == 0 && _vm.filteredCountData[_vm.filterKey].length == 0
    },
    on: {
      "click": _vm.exportToCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" " + _vm._s(_vm.$t('EXPORT')))])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.changeFilterKey
    },
    model: {
      value: (_vm.filterKey),
      callback: function($$v) {
        _vm.filterKey = $$v
      },
      expression: "filterKey"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('TRIPS'),
      "name": "Trip"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('TourID', 'Route', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDIRECTION'),
      "clearable": _vm.filters[_vm.filterKey].Direction ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('Direction', 'Direction', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Direction),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Direction", $$v)
      },
      expression: "filters[filterKey].Direction"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('HOMETOSCHOOL')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('SCHOOLTOHOME')
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Trip') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOption,
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('dateRange', 'DateRange', 2, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Trip') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey],
      "align": "right"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('BUS', 1),
      "name": "Bus"
    },
    on: {
      "tab-click": _vm.changeFilterKey
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "busFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend buses"
  }, [_c('el-input', {
    staticClass: "need-radius",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('MINCAPACITY')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].minCapacity),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "minCapacity", $$v)
      },
      expression: "filters[filterKey].minCapacity"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('MAXCAPACITY')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].maxCapacity),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "maxCapacity", $$v)
      },
      expression: "filters[filterKey].maxCapacity"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend buses"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('MINYEAR'),
      "clearable": _vm.filters[_vm.filterKey].minYear ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minYear', 'maxYear'], 'Year', 1, true, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].minYear),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "minYear", $$v)
      },
      expression: "filters[filterKey].minYear"
    }
  }, _vm._l((_vm.range(_vm.initialYear, _vm.lastYear)), function(val, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": val,
        "value": val
      }
    })
  }))], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('MAXYEAR'),
      "clearable": _vm.filters[_vm.filterKey].maxYear ? true : false,
      "disabled": _vm.filters[_vm.filterKey].minYear == null
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minYear', 'maxYear'], 'Year', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].maxYear),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "maxYear", $$v)
      },
      expression: "filters[filterKey].maxYear"
    }
  }, _vm._l((_vm.range(_vm.initialYear, _vm.lastYear)), function(val, index) {
    return (val > _vm.filters[_vm.filterKey].minYear) ? _c('el-option', {
      key: index,
      attrs: {
        "label": val,
        "value": val
      }
    }) : _vm._e()
  }))], 1)])], 1), _vm._v(" "), (_vm.filterKey === 'Bus') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "popper-class": "el-date-editor",
      "type": "date",
      "placeholder": _vm.$t('PICKADATE')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('date', 'ExpirationDate', 3, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].date),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "date", $$v)
      },
      expression: "filters[filterKey].date"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Bus') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey],
      "align": "right"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('SUPERVISOR', 1),
      "name": "Supervisor"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSUPERVISOR'),
      "clearable": _vm.filterBy[_vm.filterKey][0] ? true : false
    },
    on: {
      "change": _vm.resetFiltersValue
    },
    model: {
      value: (_vm.filterBy[_vm.filterKey][0]),
      callback: function($$v) {
        _vm.$set(_vm.filterBy[_vm.filterKey], 0, $$v)
      },
      expression: "filterBy[filterKey][0]"
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "supervisorFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Nationality')),
      expression: "checkIndex('Nationality')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Nationality', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Nationality ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Nationality),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Nationality", $$v)
      },
      expression: "filters[filterKey].Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Route')),
      expression: "checkIndex('Route')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Route', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOption,
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Supervisor') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('DRIVER', 1),
      "name": "Driver"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYDRIVER'),
      "clearable": _vm.filterBy[_vm.filterKey][0] ? true : false
    },
    on: {
      "change": _vm.resetFiltersValue
    },
    model: {
      value: (_vm.filterBy[_vm.filterKey][0]),
      callback: function($$v) {
        _vm.$set(_vm.filterBy[_vm.filterKey], 0, $$v)
      },
      expression: "filterBy[filterKey][0]"
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "driverFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Nationality')),
      expression: "checkIndex('Nationality')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Nationality', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Nationality ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Nationality),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Nationality", $$v)
      },
      expression: "filters[filterKey].Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Route')),
      expression: "checkIndex('Route')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Route', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Violation')),
      expression: "checkIndex('Violation')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Violation', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTVIOLATION'),
      "clearable": _vm.filters[_vm.filterKey].ViolationTypeID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].ViolationTypeID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "ViolationTypeID", $$v)
      },
      expression: "filters[filterKey].ViolationTypeID"
    }
  }, _vm._l((_vm.violations), function(violation, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": violation,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Driver') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('INCIDENT'),
      "name": "Incident"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYINCIDENT'),
      "multiple": ""
    },
    on: {
      "change": _vm.resetFiltersValue,
      "handleOptionClick": _vm.handleGroupedOption,
      "remove-tag": _vm.removeTag
    },
    model: {
      value: (_vm.conditionalFilterBy),
      callback: function($$v) {
        _vm.conditionalFilterBy = $$v
      },
      expression: "conditionalFilterBy"
    }
  }, [_c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTONE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index < 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTMULTIPLE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index >= 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "incidentFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Driver')),
      expression: "checkIndex('Driver')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Driver', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDRIVER'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusDriverID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusDriverID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusDriverID", $$v)
      },
      expression: "filters[filterKey].BusDriverID"
    }
  }, _vm._l((_vm.drivers), function(driver, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: driver.FullName_EN,
          NameAR: driver.FullName_AR
        }),
        "value": driver.BusDriverID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Supervisor')),
      expression: "checkIndex('Supervisor')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Supervisor', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSUPERVISOR'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusMonitorID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusMonitorID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusMonitorID", $$v)
      },
      expression: "filters[filterKey].BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(monitor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: monitor.FullName_EN,
          NameAR: monitor.FullName_AR
        }),
        "value": monitor.BusMonitorID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Type')),
      expression: "checkIndex('Type')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Type', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTTYPE'),
      "clearable": _vm.filters[_vm.filterKey].IncidentTypeID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].IncidentTypeID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "IncidentTypeID", $$v)
      },
      expression: "filters[filterKey].IncidentTypeID"
    }
  }, _vm._l((_vm.incidents), function(incident, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": incident,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Status')),
      expression: "checkIndex('Status')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Status', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSTATUS'),
      "clearable": _vm.filters[_vm.filterKey].Status ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Status),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Status", $$v)
      },
      expression: "filters[filterKey].Status"
    }
  }, _vm._l((_vm.Statuses), function(status, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": status,
        "value": status
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Incident') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "name": "Student"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSTUDENT'),
      "multiple": ""
    },
    on: {
      "change": _vm.resetFiltersValue,
      "handleOptionClick": _vm.handleGroupedOption,
      "remove-tag": _vm.removeTag
    },
    model: {
      value: (_vm.conditionalFilterBy),
      callback: function($$v) {
        _vm.conditionalFilterBy = $$v
      },
      expression: "conditionalFilterBy"
    }
  }, [_c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTONE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index < 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTMULTIPLE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index >= 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "studentFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Absence')),
      expression: "checkIndex('Absence')"
    }],
    attrs: {
      "span": 16
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Absence', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTREASON'),
      "clearable": _vm.filters[_vm.filterKey].Reason ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Reason),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Reason", $$v)
      },
      expression: "filters[filterKey].Reason"
    }
  }, _vm._l((_vm.reasons), function(reason, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": reason,
        "value": reason
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Address')),
      expression: "checkIndex('Address')"
    }],
    attrs: {
      "span": 16
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Address', true)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Range",
      "step": 0.5
    },
    model: {
      value: (_vm.filters[_vm.filterKey].radius),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "radius", $$v)
      },
      expression: "filters[filterKey].radius"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('KM')))])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Grade')),
      expression: "checkIndex('Grade')"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Grade', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTGRADE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Grade ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Grade),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Grade", $$v)
      },
      expression: "filters[filterKey].Grade"
    }
  }, _vm._l((_vm.grades), function(grade, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": grade.Name,
        "value": grade.Name
      }
    })
  }))], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Student') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t(_vm.title),
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "arrow": _vm.document.length > 1 ? 'hover' : 'never',
      "height": _vm.height + 'px'
    },
    on: {
      "change": _vm.doResize
    }
  }, _vm._l((_vm.document), function(doc, index) {
    return _c('el-carousel-item', {
      key: index,
      ref: "caroItem",
      refInFor: true
    }, [_c('h3', [(_vm.filterExtension(doc.file_name)) ? _c('el-row', {
      staticStyle: {
        "position": "absolute",
        "top": "30%",
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('i', {
      class: ['fa', _vm.filterExtension(doc.file_name), 'fa-5x']
    }), _c('br'), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getAsset(doc.file_name)
      }
    }, [_c('i', {
      staticClass: "fa fa-cloud-download"
    }), _vm._v(" " + _vm._s(_vm.$t('DOWNLOADFILE')))])]) : _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.getAsset(doc.file_name)
      }
    }), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      },
      domProps: {
        "textContent": _vm._s(doc.label || _vm.$t('NOLABEL'))
      }
    })], 1)])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "printIncident",
    attrs: {
      "id": "incidentDialog"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        1
      }
    }
  }, [(_vm.dialogVisible) ? _c('el-dialog', {
    staticClass: "incident_dialog",
    attrs: {
      "show-close": false,
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('ROUTE') + ' ' + _vm.incident.TourName)
    },
    slot: "title"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "slot": "title",
      "type": "text"
    },
    on: {
      "click": _vm.deleteIncident
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon-close"
  })]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "slot": "title"
    },
    on: {
      "command": _vm.printIncident
    },
    slot: "title"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon-more rotate-90"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('PRINTINCIDENT')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    ref: "gmap",
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "gmap-incident"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "student",
    attrs: {
      "gutter": 10
    }
  }, [(_vm.total == 0) ? _c('div', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSINVOLVED')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.incident.students), function(student, index) {
    return (_vm.total != 0) ? _c('el-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.total
      }
    }, [_c('img', {
      staticClass: "img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(student.ImagePath, 'student')
      }
    }), _c('br'), _vm._v("\n          " + _vm._s(_vm._FullName({
      NameEN: student.FullName_EN,
      NameAR: student.FullName_AR
    })) + "\n        ")]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.alert ? 'Alert Type' : _vm.$t('INCIDENTTYPE')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v("  " + _vm._s(_vm.$t(_vm.incident.incident_type)) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" " + _vm._s(_vm.$t('BUSNUMBER')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.incident.bus.Label))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.$t('SUPERVISORMOBILE')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "height": "10px"
    }
  }), _vm._v("   " + _vm._s(_vm.incident.monitor.MobilePhone) + "\n          ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(!_vm.alert) ? _c('b', [_vm._v(_vm._s(_vm.$t('MESSAGEH')) + " ")]) : _vm._e(), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.incident.Text !== null ? _vm.incident.Text : _vm.$t('NOMESSAGE'))
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGE')))])]), _vm._v(" "), (_vm.isAllowed('save', 'report/incident') && !_vm.alert) ? _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-popover', {
    attrs: {
      "trigger": "manual",
      "placement": "top",
      "width": "300"
    },
    model: {
      value: (_vm.popperVisible),
      callback: function($$v) {
        _vm.popperVisible = $$v
      },
      expression: "popperVisible"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('RESOLUTION')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 256,
      "rows": 4,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.message.Text),
      callback: function($$v) {
        _vm.$set(_vm.message, "Text", $$v)
      },
      expression: "message.Text"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "5px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.popperVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.message.Text == '',
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.markResolved
    }
  }, [_vm._v(_vm._s(_vm.$t('SAVE')))])], 1), _vm._v(" "), _c('el-button-group', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.incident.statusColor == 0,
      "type": _vm.incident.statusColor == 0 ? 'success' : ''
    },
    on: {
      "click": function($event) {
        _vm.popperVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.incident.statusColor != 0 ? 'fa-square-o' : 'fa-check-square']
  }), _vm._v(" " + _vm._s(' ' + _vm.incident.statusColor == 0 ? _vm.$t('RESOLVED') : _vm.$t('MARKRESOLVED')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.incident.statusColor == 0 ? 'warning' : 'primary'
    },
    on: {
      "click": _vm.reportIncident
    }
  }, [_c('i', {
    class: [_vm.incident.statusColor == 0 ? 'fa fa-undo ' : '']
  }), _vm._v(" " + _vm._s(' ' + _vm.incident.statusColor == 0 ? _vm.$t('RE-OPEN') : _vm.$t('REPORTTO')))])], 1)], 1), _vm._v(" "), (_vm.incident.ImagePath) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "icon": "picture"
    },
    on: {
      "click": function($event) {
        _vm.imageVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWIMAGE')))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('REPORTINCIDENTTO'),
      "visible": _vm.sendReport,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.sendReport = $event
      }
    }
  }, [_c('span', [_c('el-radio-group', {
    model: {
      value: (_vm.message.Recipient),
      callback: function($$v) {
        _vm.$set(_vm.message, "Recipient", $$v)
      },
      expression: "message.Recipient"
    }
  }, [(_vm.hideParentsOption()) ? _c('el-radio-button', {
    attrs: {
      "label": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('PARENTS')))]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 7
    }
  }, [_vm._v(_vm._s(_vm.$t('POLICE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 8
    }
  }, [_vm._v(_vm._s(_vm.$t('BUSCOMPANY')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.message.Text),
      callback: function($$v) {
        _vm.$set(_vm.message, "Text", $$v)
      },
      expression: "message.Text"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sendReport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.message.Text == '' || _vm.message.Recipient == null,
      "type": "primary",
      "loading": _vm.loadingSend
    },
    on: {
      "click": _vm.reportTo
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('SENDMESSAGE')))])], 1)]), _vm._v(" "), (_vm.imageVisible) ? _c('el-dialog', {
    attrs: {
      "size": "tiny",
      "title": _vm.$t('INCIDENTIMAGE'),
      "visible": _vm.imageVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.imageVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getAsset(_vm.incident.ImagePath, 'incident')
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.imageVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-uploader"
  }, [_c('div', {
    staticClass: "el-upload el-upload--text"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.getAsset(_vm.imagePath, undefined, _vm.logo)
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['el-button', ' el-button--dark'],
    attrs: {
      "crop-ratio": "1:1",
      "crop": true,
      "max-file-size": 409600,
      "text": _vm.$t('UPLOADIMAGE'),
      "cropBtn": {
        'ok': _vm.$t('SAVEIMAGE'),
        'cancel': _vm.$t('CANCEL')
      },
      "url": _vm.URL + 'media/upload',
      "data": {
        folder: _vm.folder
      },
      "headers": {
        'X-API-KEY': _vm.API_KEY
      },
      "extensions": "png,gif,jpeg,jpg",
      "inputOfFile": "file"
    },
    on: {
      "errorhandle": _vm.imageError,
      "imageuploaded": _vm.imageUploaded
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "WIUpload",
      "size": "tiny",
      "visible": _vm.messageBox
    },
    on: {
      "close": _vm.resetUpload,
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, [_c('span', {
    staticClass: "el-alert__title is-bold"
  }, [_vm._v(_vm._s(_vm.message)), _c('br')])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.messageBox = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('TAGSCANNER'),
      "visible": _vm.RFID,
      "before-close": _vm.closeModal,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.RFID = $event
      }
    }
  }, [(_vm.message == 1) ? _c('el-alert', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "type": "warning",
      "description": _vm.$t('TAGIDALREADYASSIGNEDTOSOMEONEELSE'),
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message == 0) ? _c('el-alert', {
    attrs: {
      "title": _vm.$t('SUCCESS'),
      "type": "success",
      "description": _vm.$t('TAGHASBEENASSIGNED'),
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message == 3) ? _c('el-alert', {
    attrs: {
      "title": _vm.$t('SUCCESS'),
      "type": "success",
      "description": _vm.$t('TAGHASBEENSUCCESSFULLYDISABLED'),
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message == 4) ? _c('el-alert', {
    attrs: {
      "title": _vm.$t('INFO'),
      "type": "info",
      "description": _vm.$t('TAGISNOTASSIGNED'),
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message != 0 && _vm.message != 3 && _vm.message != 4) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.scannedRFID == '' && !_vm.error) ? _c('h1', {
    staticStyle: {
      "font-weight": "bold",
      "margin": "0",
      "font-size": "50px"
    },
    domProps: {
      "textContent": _vm._s(_vm.timer == 0 ? _vm.$t('SCANTAGNOW') : _vm.timer)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error && _vm.message != 1) ? _c('h1', {
    staticStyle: {
      "font-weight": "bold",
      "margin": "0",
      "font-size": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$t('FAILEDTOSCANTRYAGAIN')))]) : _vm._e(), _vm._v(" "), (_vm.scanning == 0 && _vm.scannedRFID != '') ? _c('div', [_c('p', [_c('img', {
    staticClass: "rounded-img",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.student.ImagePath, 'student')
    }
  }), _c('br')]), _c('h4', [_vm._v(_vm._s(_vm._FullName({
    NameEN: _vm.student.FullName_EN,
    NameAR: _vm.student.FullName_AR
  })))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('TAGID')))]), _vm._v(" "), _c('h1', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-weight": "bold",
      "margin": "0",
      "font-size": "50px",
      "text-transform": "uppercase"
    },
    domProps: {
      "textContent": _vm._s(_vm.base_convert(_vm.scannedRFID, 10, 16))
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.disableTag && _vm.student.AssignedTagID != null) ? _c('el-alert', {
    attrs: {
      "title": _vm.$t('DISABLETAG'),
      "type": "warning",
      "description": _vm.$t('CLICKONCONFIRMTODISABLEASSIGNEDTAG'),
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.disableTag || _vm.check) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeModal(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]) : _vm._e(), _vm._v(" "), (_vm.disable()) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.disableTag = !_vm.disableTag
      }
    }
  }, [_vm._v(_vm._s(_vm.disableTag ? _vm.$t('CANCEL') : _vm.$t('DISABLE')))]) : _vm._e(), _vm._v(" "), (_vm.reScan()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.scanRFID()
      }
    }
  }, [_vm._v(_vm._s(_vm.student.AssignedTagID == null ? _vm.$t('RE-SCAN') : _vm.$t('CHANGE')))]) : _vm._e(), _vm._v(" "), (_vm.confirmScan()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTagID
    }
  }, [_vm._v(_vm._s((_vm.student.StudentID == null && !_vm.disableTag) ? _vm.$t('ASSIGNTAG') : _vm.$t('CONFIRM')))]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-row",
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    ref: "header"
  }, [_c('el-row', {
    staticClass: "dark"
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "0 5px"
    },
    attrs: {
      "mode": "horizontal",
      "id": "day-info"
    }
  }, [_c('li', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.datenow)
    }
  })]), _vm._v(" "), (_vm.temp) ? _c('li', [_c('i', {
    staticClass: "fa fa-sun-o"
  }), _vm._v(" " + _vm._s(_vm.temp) + " " + _vm._s(_vm.$t('C')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "15px 0"
    },
    attrs: {
      "span": 4,
      "align": "center"
    }
  }, [(_vm.$route.name != 'Login' && _vm.$route.name != 'ResetPassword') ? _c('span', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.school_name))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.$route.name != 'Login' && _vm.$route.name != 'ResetPassword') ? _c('ul', {
    staticClass: "badges"
  }, [(_vm.hide_sidebar) ? _c('li', {
    staticClass: "badge_icon",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_messages()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('message')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x"
  })])], 1), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_incidents()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('incident')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-2x"
  })])], 1), _vm._v(" "), (_vm.wiot_box == 1) ? _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_violations()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('violation')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer fa-2x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.active_trips()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleCommand('trip')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bus fa-2x"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allowed_add.length != 0) ? _c('li', {
    staticClass: "entry"
  }, [(_vm.hide_sidebar) ? _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  " + _vm._s(_vm.$t('ADD')) + "\n       ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.allowed_add), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "divided": item.divide,
        "command": item.command
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "profile"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.profile_photo, 'user'),
      "alt": _vm.full_name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "profile-name"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v(" " + _vm._s(_vm.full_name) + " ")])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "command": "profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('MYPROFILE')))]) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save', 'school/configuration') && _vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "command": "school"
    }
  }, [_vm._v(_vm._s(_vm.$t('SCHOOLSETTINGS')))]) : _vm._e(), _vm._v(" "), (_vm.hide_sidebar) ? _c('el-dropdown-item', {
    attrs: {
      "disabled": "",
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LANGUAGES')))]) : _vm._e(), _vm._v(" "), (_vm.lang != 'en') ? _c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENGLISH')))]) : _vm._e(), _vm._v(" "), (_vm.lang != 'ar') ? _c('el-dropdown-item', {
    attrs: {
      "command": "ar"
    }
  }, [_vm._v(_vm._s(_vm.$t('ARABIC')))]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('LOGOUT')))])], 1)], 1)], 1)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide_sidebar),
      expression: "hide_sidebar"
    }],
    staticClass: "menu",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    ref: "logo",
    attrs: {
      "id": "logo"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(545)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('WIOT')) + " ")])])], 1), _vm._v(" "), (_vm.hide_sidebar) ? _c('el-scrollbar', {
    ref: "menuScroll",
    staticClass: "my-scrollbar",
    attrs: {
      "viewStyle": {
        height: _vm.sideBarHeight + 'px'
      }
    }
  }, [_c('div', [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "unique-opened": true,
      "router": true
    },
    on: {
      "open": _vm.openMenu
    }
  }, _vm._l((_vm.navigations), function(navigation, key) {
    return _c('div', {
      key: key
    }, [(navigation.menu.length != 0) ? _c('el-submenu', {
      class: [_vm.activeIndex == key && navigation.target != null ? 'activated is-opened' : (navigation.target != null ? 'hide-arrow' : '')],
      attrs: {
        "index": key.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navigation.icon
    }), _vm._v(" " + _vm._s(navigation.name))]), _vm._v(" "), _vm._l((navigation.menu), function(menu, _key) {
      return _c('el-menu-item', {
        key: _key,
        class: [_vm.subMenuActive == key + '' + _key ? 'sub-active' : ''],
        attrs: {
          "index": menu.target
        },
        on: {
          "click": function($event) {
            _vm.subMenuActive = key + '' + _key
          }
        }
      }, [_vm._v(_vm._s(menu.name))])
    })], 2) : _c('el-menu-item', {
      class: [_vm.subMenuActive == key ? 'sub-active' : ''],
      attrs: {
        "index": navigation.target
      },
      on: {
        "click": function($event) {
          _vm.subMenuActive = key.toString()
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navigation.icon
    }), _vm._v(" " + _vm._s(navigation.name))])], 2)], 1)
  }))], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.hide_sidebar) ? 21 : 24,
      "offset": (_vm.hide_sidebar) ? 3 : 0
    }
  }, [_c('router-view', {
    staticClass: "content"
  })], 1)], 1), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  }), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "search": true,
      "visible": _vm.absenceBox,
      "server-check": true
    },
    on: {
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-auth-dialog', {
    attrs: {
      "sessionExpiration": _vm.session_expiration,
      "visible": _vm.sessionDialog,
      "itSelf": true,
      "timer": _vm.timer
    },
    on: {
      "authBack": _vm.sessionExtended,
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "conversation"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')) + " ")]), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.newMessage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-2x"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monitorInput),
      expression: "monitorInput"
    }],
    staticClass: "padding1",
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    ref: "gmonitor",
    attrs: {
      "value-key": "BusMonitorID",
      "filterable": "",
      "multiple": "",
      "placeholder": _vm.$t('GROUPSUPERVISOR')
    },
    on: {
      "change": function($event) {
        _vm.handleSelect()
      }
    },
    model: {
      value: (_vm.selectedMonitors),
      callback: function($$v) {
        _vm.selectedMonitors = $$v
      },
      expression: "selectedMonitors"
    }
  }, _vm._l((_vm.supervisors), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": _vm._FullName({
          NameEN: item.FullName_EN,
          NameAR: item.FullName_AR
        }),
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-tabs', {
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    staticStyle: {
      "margin": "-15px",
      "margin-top": "-14px"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.messages), function(message, key) {
    return _c('el-button', {
      key: key,
      staticClass: "list",
      class: [key == _vm.conversation ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.loadConversation(key)
        }
      }
    }, [(key == 0 && _vm.selectedMonitors.length > 1) ? _c('div', {
      staticClass: "img-circle",
      staticStyle: {
        "overflow": "hidden"
      }
    }, _vm._l((_vm.selectedMonitors), function(item, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "pull-left",
        staticStyle: {
          "box-sizing": "border-box",
          "overflow": "hidden"
        },
        style: ({
          width: _vm.imageWidth / (_vm.selectedMonitors.length < 3 ? _vm.selectedMonitors.length : 3) + 'px'
        })
      }, [_c('img', {
        style: ({
          marginLeft: -24 / (_vm.selectedMonitors.length < 3 ? _vm.selectedMonitors.length : 3) + 'px'
        }),
        attrs: {
          "src": _vm.getAsset(item.ImagePath, 'supervisor'),
          "alt": "",
          "width": "50",
          "height": "50"
        }
      })]) : _vm._e()
    })) : _c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.getAsset(message.monitor.ImagePath, 'supervisor')
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "flex": "1 1 0%",
        "min-width": "0",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm._FullName({
      NameEN: message.monitor.FullName_EN,
      NameAR: message.monitor.FullName_AR
    })))]), _vm._v(" "), (_vm.messageCount(message) && key != 0) ? _c('el-badge', [_c('sup', {
      ref: "badge",
      refInFor: true,
      staticClass: "el-badge__content"
    }, [_vm._v(_vm._s(message.count))])]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteNewMessage()
        }
      }
    }) : _vm._e()], 1)])
  }))])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_board),
      expression: "loading_board"
    }],
    staticStyle: {
      "overflow": "hidden",
      "background": "#ddd"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "span": 18,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.boardHeight + 'px'
    })
  }, [_c('div', {
    ref: "messages",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMore(_vm.messages[_vm.conversation])),
      expression: "isMore(messages[conversation])"
    }],
    on: {
      "click": _vm.loadOlderMessages
    }
  }, [_vm._v(_vm._s(_vm.$t('LOADOLDERMESSAGES')) + " "), _c('i', {
    staticClass: "fa fa-angle-double-up"
  })])], 1), _vm._v(" "), _vm._l((_vm.orderedConversations()), function(item, index) {
    return _c('el-card', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px !important"
      }
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(item.ImagePath, item.FullName_EN == 'School' ? 'configuration' : 'supervisor', item.FullName_EN == 'School')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(_vm._FullName({
      NameEN: item.FullName_EN,
      NameAR: item.FullName_AR
    })) + " "), _c('small', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" " + _vm._s(item.datetime))])]), _vm._v("\n                " + _vm._s(item.Text) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "media-footer"
    }, [(item.FileName) ? _c('el-button', {
      staticClass: "pull-right fa fa-download",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.showAttachment(item.FileName, item.FileType)
        }
      }
    }) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('el-card', {
    ref: "formCard",
    staticStyle: {
      "border-width": "0",
      "border-top-width": "1px",
      "border-left-width": "1px"
    }
  }, [_c('el-input', {
    ref: "msgInput",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.compose.Text),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Text", $$v)
      },
      expression: "compose.Text"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    attrs: {
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.updateFile,
      "on-progress": _vm.limitFile,
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "action": _vm.URL + 'media/upload',
      "data": {
        folder: _vm.folder,
        type: 'attachment'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "size": "small",
      "type": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.$t('ATTACHEMENT')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('FILESWITHASIZELESSTHAN')) + " ")])], 1)], 1), _vm._v(" "), (_vm.compose.Attachment.Filename) ? _c('el-col', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.compose.Attachment.Filename))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.compose.Attachment.Filename ? 6 : 16
    }
  }, [_c('el-button', {
    staticClass: "reply",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.validateReply(),
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.replyConversation()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('REPLY')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-doc-dialog', {
    attrs: {
      "visible": _vm.imageVisible,
      "document": _vm.imageSrc,
      "title": "ATTACHEMENT",
      "subFolder": "messages"
    },
    on: {
      "update:visible": function($event) {
        _vm.imageVisible = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.errorMessage), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'contactForm'],
      "title": _vm.$t('MANAGESUPERVISOR'),
      "data": {
        person: this.person,
        monitor: this.supervisor,
        contact: this.contact
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.person,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDER'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.person.Gender),
      callback: function($$v) {
        _vm.$set(_vm.person, "Gender", $$v)
      },
      expression: "person.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_EN", $$v)
      },
      expression: "person.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_AR", $$v)
      },
      expression: "person.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName", $$v)
      },
      expression: "person.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName_AR", $$v)
      },
      expression: "person.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_EN", $$v)
      },
      expression: "person.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_AR", $$v)
      },
      expression: "person.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDNUMBER'),
      "prop": "ExternalPersonID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('IDNUMBER') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.ExternalPersonID),
      callback: function($$v) {
        _vm.$set(_vm.person, "ExternalPersonID", $$v)
      },
      expression: "person.ExternalPersonID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDEXPIRATIONDATE'),
      "prop": "IDExpiration",
      "rules": {
        required: true,
        type: 'date',
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": "dd/MM/yyyy",
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.person.IDExpiration),
      callback: function($$v) {
        _vm.$set(_vm.person, "IDExpiration", $$v)
      },
      expression: "person.IDExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.person.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.person, "Nationality", $$v)
      },
      expression: "person.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTINFO')
    }
  }, [_c('el-form', {
    ref: "contactForm",
    attrs: {
      "model": _vm.contact,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MOBILENO'),
      "prop": "MobilePhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "MobilePhone", $$v)
      },
      expression: "contact.MobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('EMAILADDRESS'),
      "prop": "EMail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('EMAILADDRESS') + ' ' + _vm.$t('ALREADYEXISTED')
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.EMail),
      callback: function($$v) {
        _vm.$set(_vm.contact, "EMail", $$v)
      },
      expression: "contact.EMail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LANDLINEPHONE'),
      "prop": "LandlinePhone",
      "rules": {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.LandlinePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "LandlinePhone", $$v)
      },
      expression: "contact.LandlinePhone"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('MESSAGES')
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')))]) : _vm._e(), _vm._v(" "), (_vm.person.PersonID != null) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ROUTES'),
      "name": "route"
    }
  }, [_c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BusNumber",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "120",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.DriverPhoto),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverFullName_EN,
          NameAR: scope.row.DriverFullName_AR
        })) + "            \n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "40",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "g-core-image-upload-btn"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImage),
      expression: "!hasImage"
    }],
    staticClass: "g-core-image-upload-form",
    staticStyle: {
      "display": "block",
      "cursor": "pointer",
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "1242px",
      "height": "61px",
      "opacity": "0",
      "margin": "0px",
      "padding": "0px",
      "overflow": "hidden"
    },
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api2/common_user/cropHeadUrl"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "disabled": _vm.uploading,
      "id": 'g-core-upload-input-' + _vm.formID,
      "name": _vm.name,
      "multiple": _vm.multiple,
      "type": "file",
      "accept": _vm.inputAccept
    },
    on: {
      "change": _vm.change,
      "dragover": _vm.dragover,
      "dragenter": _vm.dragover,
      "dragleave": _vm.dragleave,
      "dragend": _vm.dragleave,
      "drop": _vm.dragleave
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImage),
      expression: "hasImage"
    }],
    staticClass: "g-core-image-corp-container",
    attrs: {
      "id": 'vciu-modal-' + _vm.formID
    }
  }, [_c('crop', {
    ref: "cropBox",
    attrs: {
      "is-resize": _vm.resize && !_vm.crop,
      "ratio": _vm.cropRatio,
      "is-rotate": _vm.rotate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-aside"
  }, [_c('p', {
    staticClass: "btn-groups rotate-groups",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn btn-rotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doRotate
    }
  }, [_vm._v("↺")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reverserotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doReverseRotate
    }
  }, [_vm._v("↻")])]), _vm._v(" "), (_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doCrop
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.cancel))])]) : _vm._e(), _vm._v(" "), (_vm.resize && !_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doResize
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.cancel))])]) : _vm._e()])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "incident"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('INCIDENTS')))])]), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'monitor') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSUPERVISOR'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.BusMonitorID),
      callback: function($$v) {
        _vm.BusMonitorID = $$v
      },
      expression: "BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: item.FullName_EN,
          NameAR: item.FullName_AR
        }),
        "value": item.BusMonitorID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'bus') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYBUS'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.BusID),
      callback: function($$v) {
        _vm.BusID = $$v
      },
      expression: "BusID"
    }
  }, _vm._l((_vm.buses), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Label,
        "value": item.BusID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'type') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYTYPE'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.TypeIncidentID),
      callback: function($$v) {
        _vm.TypeIncidentID = $$v
      },
      expression: "TypeIncidentID"
    }
  }, _vm._l((_vm.incidentTypes), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'status') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSTATUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('OPEN'),
      "value": "Open"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "danger",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('OPEN')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('REPORTED'),
      "value": "Reported"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "warning",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('REPORTED')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('RESOLVED'),
      "value": "Resolved"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('RESOLVED')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.incidents[_vm.currentPage - 1],
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('BUSSUPERVISOR'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n           " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        })) + " "), _c('br'), _c('small', [_vm._v(_vm._s(scope.row.Timestamp))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('BUS'),
      "prop": "bus.Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.student_id.length) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.status[scope.row.statusColor]
          }
        }, [_vm._v("\n            " + _vm._s(_vm.reportStatus[scope.row.statusColor]) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "firstUpper",
      "label": _vm.$t('TYPE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.$t(scope.row.incident_type)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('VIEWINCIDENTDETAILS'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              _vm.showIncident(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" " + _vm._s(_vm.$t('DETAILS')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('flag', 'report/incident')) ? _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalIncidents
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wisave"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-row', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-button', {
    attrs: {
      "loading": _vm.saving,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.saving ? _vm.$t('SAVING') : _vm.$t('SAVE')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)]), _vm._v(" "), _c('el-auth-dialog', {
    attrs: {
      "visible": _vm.sessionDialog,
      "configuration": _vm.data,
      "message": "REQUIREDAUTHENTICATION"
    },
    on: {
      "authBack": _vm.success,
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'contactForm', 'LicenseForm'],
      "title": _vm.$t('MANAGEDRIVER'),
      "data": {
        person: this.person,
        driver: this.driver,
        contact: this.contact
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab tabs",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.person,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDER'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.person.Gender),
      callback: function($$v) {
        _vm.$set(_vm.person, "Gender", $$v)
      },
      expression: "person.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_EN", $$v)
      },
      expression: "person.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "FirstName_AR", $$v)
      },
      expression: "person.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName", $$v)
      },
      expression: "person.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "MiddleName_AR", $$v)
      },
      expression: "person.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_EN", $$v)
      },
      expression: "person.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.person, "LastName_AR", $$v)
      },
      expression: "person.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDNUMBER'),
      "prop": "ExternalPersonID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('IDNUMBER') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.person.ExternalPersonID),
      callback: function($$v) {
        _vm.$set(_vm.person, "ExternalPersonID", $$v)
      },
      expression: "person.ExternalPersonID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDEXPIRATIONDATE'),
      "prop": "IDExpiration",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": _vm.date_format,
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.person.IDExpiration),
      callback: function($$v) {
        _vm.$set(_vm.person, "IDExpiration", $$v)
      },
      expression: "person.IDExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.person.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.person, "Nationality", $$v)
      },
      expression: "person.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTINFO')
    }
  }, [_c('el-form', {
    ref: "contactForm",
    attrs: {
      "model": _vm.contact,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MOBILENO'),
      "prop": "MobilePhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "MobilePhone", $$v)
      },
      expression: "contact.MobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('EMAILADDRESS'),
      "prop": "EMail",
      "rules": [{
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('EMAILADDRESS') + ' ' + _vm.$t('ALREADYEXISTED')
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.EMail),
      callback: function($$v) {
        _vm.$set(_vm.contact, "EMail", $$v)
      },
      expression: "contact.EMail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LANDLINEPHONE'),
      "prop": "LandlinePhone",
      "rules": {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.contact.LandlinePhone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "LandlinePhone", $$v)
      },
      expression: "contact.LandlinePhone"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('DRIVERSLICENSE')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('el-form', {
    ref: "LicenseForm",
    attrs: {
      "model": _vm.driver,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-upload', {
    attrs: {
      "accept": "image/*",
      "before-upload": _vm.beforeUpload,
      "on-change": _vm.uploadValidation,
      "data": {
        folder: 'license'
      },
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "action": _vm.URL + 'media/upload',
      "on-success": _vm.uploadedFile
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LICENSEIMAGE'),
      "prop": "LicenseImage",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "label",
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.uploadValidation
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('CLICKTOUPLOAD')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('JPGPNGFILES')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.driver.LicenseImage != null) ? _c('img', {
    staticStyle: {
      "display": "block",
      "max-width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.LicenseImage, 'license')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.driver.LicenseImage == null) ? _c('i', {
    staticClass: "fa fa-id-card-o",
    staticStyle: {
      "font-size": "18em"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LICENSEEXPIRATIONDATE'),
      "prop": "LicenseExpiration",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": _vm.date_format,
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.driver.LicenseExpiration),
      callback: function($$v) {
        _vm.$set(_vm.driver, "LicenseExpiration", $$v)
      },
      expression: "driver.LicenseExpiration"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.person.PersonID != null) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ROUTES'),
      "name": "route"
    }
  }, [_c('el-row', {
    attrs: {
      "calss": "tab-table-margin"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BusNumber",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "120",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "200",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.MonitorPhoto),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.MonitorFullName_EN,
          NameAR: scope.row.MonitorFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "align": "right",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('VIOLATION')
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATION')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "tripMng"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('span', {
    staticClass: "el-col el-col-8"
  }, [_vm._v(_vm._s(_vm.$t('ROUTETRIP')) + " "), _c('b', [_vm._v(_vm._s(_vm.tripDate(_vm.trip.Db_Date)))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_stops),
      expression: "loading_stops"
    }],
    staticClass: "box-card",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "body-style": {
        padding: 0,
        height: _vm.cardHeight + 'px'
      }
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.tabHeight + 'px'
    })
  }, [_c('el-row', [_c('el-steps', {
    attrs: {
      "space": 200,
      "direction": "vertical",
      "active": 1
    }
  }, _vm._l((_vm.stops), function(stop, key) {
    return _c('div', {
      key: key,
      staticClass: "el-step is-vertical",
      staticStyle: {
        "margin-right": "0px",
        "min-height": "50px"
      }
    }, [_c('div', {
      staticClass: "el-step__head is-finish is-text"
    }, [_c('div', {
      staticClass: "el-step__line is-vertical",
      staticStyle: {
        "margin-right": "0px"
      }
    }, [_c('i', {
      staticClass: "el-step__line-inner",
      staticStyle: {
        "transition-delay": "0ms",
        "height": "100%"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-step__icon"
    }, [(key !== 0) ? _c('div', {
      domProps: {
        "textContent": _vm._s(key)
      }
    }) : _vm._e(), _vm._v(" "), (key === 0) ? _c('div', [_c('i', {
      staticClass: "fa fa-bus"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "el-step__main"
    }, [_c('div', {
      staticClass: "el-step__title is-finish"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(key !== 0 ? _vm.$t('STOP') : _vm.$t('TO') + ' ' + (_vm.trip.Direction == 1 ? _vm.$t('SCHOOL') : _vm.$t('HOME')))
      }
    }), _vm._v(" "), (key !== 0) ? _c('span', {
      domProps: {
        "textContent": _vm._s(key)
      }
    }) : _vm._e(), _vm._v(" "), (key == 0) ? _c('div', {
      staticClass: "pull-right"
    }, [(_vm.trip.Db_Date != null) ? _c('el-row', [_c('span', {
      staticStyle: {
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.$t('STARTEDAT') + ':')
      }
    }), _vm._v(" " + _vm._s(_vm.unixConverter(_vm.trip.timestamp)))]) : _vm._e(), _vm._v(" "), (_vm.trip.IsClosed == 1) ? _c('el-row', [_c('span', {
      staticStyle: {
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.$t('CLOSEDAT') + ':')
      }
    }), _vm._v(" " + _vm._s(_vm.unixConverter(_vm.trip.UpdatedAt)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (key !== 0) ? _c('el-card', {
      staticClass: "box-card students",
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('small', [_vm._v(_vm._s(_vm.$t('ESTIMATEDARRIVALTIME')) + " "), _c('span', {
      domProps: {
        "textContent": _vm._s(stop.DeltaT)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MIN')))])]), _vm._v(" "), _vm._l((stop.student), function(student, index) {
      return (key !== 0) ? _c('el-row', {
        key: index,
        staticClass: "list",
        style: ({
          'background-color': [(student.IsAbsent) ? '#CCCCCC' : 'unset']
        })
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-wifi fa-rotate-270 fa-2x",
        class: _vm.tagIcon(student)
      })]), _vm._v(" "), _c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v("\n                          " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + "             \n                          "), _c('el-button-group', {
        staticClass: "turn"
      }, [(student.CheckIn) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('CHECKEDINAT') + ' ' + _vm.tripTime(student.CheckIn),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "success",
          "icon": "arrow-up",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.CheckIn)))])], 1) : _vm._e(), _vm._v(" "), (student.IsMissing) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('ABSENTAT') + ' ' + _vm.tripTime(student.IsMissing),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "danger",
          "icon": "warning",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.IsMissing)))])], 1) : _vm._e(), _vm._v(" "), (student.CheckOut) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('CHECKEDOUTAT') + ' ' + _vm.tripTime(student.CheckOut),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "warning",
          "icon": "arrow-down",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.CheckOut)))])], 1) : _vm._e(), _vm._v(" "), (student.IsAbsent) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('REPORTEDBY') + ' ' + student.IsAbsent.ReportedBy,
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "danger",
          "icon": "warning",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.$t('ABSENT')))])], 1) : _vm._e()], 1)], 1) : _vm._e()
    }), _vm._v(" "), (stop.student.length === 0 && key !== 0) ? _c('el-row', {
      staticStyle: {
        "padding": "10px",
        "background-color": "rgb(209, 219, 229)",
        "color": "#4b4b4b"
      }
    }, [_c('el-col', {
      attrs: {
        "align": "center"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSADDEDTOTHISSTOP')))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticClass: "only-top-border"
    })], 2) : _vm._e()], 1)])])
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 16,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": function($event) {
        _vm.getExpense()
      }
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v(" " + _vm._s(_vm.$t('Map')))]), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "border-top": "0",
      "border-bottom": "0"
    },
    attrs: {
      "clasExpenditures": "bordred-card",
      "body-style": {
        padding: 0,
        height: _vm.cardHeight + 'px'
      }
    }
  }, [_c('el-row', {
    ref: "staff",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-road fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('ROUTE')))]), _c('br'), _vm._v(" "), _c('el-tag', {
    style: ('background-color:' + _vm.route.RouteColor)
  }, [_vm._v("# " + _vm._s(_vm.trip.TourName))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border2",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('DRIVER')))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "\n                ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "position": "relative",
      "border-top": "1px solid rgb(209, 219, 229)"
    },
    style: ({
      height: _vm.mapHeight + 'px'
    }),
    attrs: {
      "id": "trip-gmap-live"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCost(_vm.trip)),
      expression: "showCost(trip)"
    }],
    ref: "cost",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('FUELCOST')))]), _c('br'), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('IDLECOST')))]), _c('br'), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('TOTALCOST')))]), _c('br'), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showCost(_vm.trip)) ? _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" " + _vm._s(_vm.$t('EXPENDITURE')))]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('TRIPDISTANCE')) + " "), _c('b', [_vm._v(_vm._s(_vm.distance + ' ' + 'km'))])]), _vm._v(" "), _c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('TRIPIDLING')) + " "), _c('b', [_vm._v(_vm._s(_vm.idlingTime + ' ' + 'mins'))])]), _vm._v(" "), _c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('COMPLETEDTRIPS')) + " "), _c('b', [_vm._v(_vm._s(_vm.expense.doneTrips))])])]), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listExpenses,
      "highlight-current-row": "",
      "height": 620,
      "stripe": "",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('FACTORS'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.label)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('COST'),
      "prop": "cost"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.cost)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('TIME')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          class: [scope.row.time ? 'el-icon-time' : '']
        }), _vm._v("\n                  " + _vm._s(_vm.$t(scope.row.time)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('FORMULA'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(_vm.$t(scope.row.calc)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('RESULT'),
      "prop": "result"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.result)) + "\n                ")]
      }
    }])
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[351]);


// WEBPACK FOOTER //
// static/js/app.9bbeb565f91817c3fc92.js